import {
  Component,
  OnInit,
  AfterContentInit,
  ViewChild,
  AfterViewInit,
  ElementRef,
  HostListener,
} from "@angular/core";
import {
  FormGroup,
  FormBuilder,
  Validators,
  FormControl,
  NgForm,
} from "@angular/forms";
import { HttpClient } from "@angular/common/http";
import { EditlogbookformsService } from "./editlogbookforms.service";
import {
  MatTableDataSource,
  MatPaginator,
  MatSort,
  MAT_DATE_FORMATS,
  MatDialog,
  MatDialogRef,
  MAT_DIALOG_DATA,
  MatTooltip,
} from "@angular/material";
import { SwalComponent } from "@sweetalert2/ngx-sweetalert2";
import { of } from "rxjs";
import { delay } from "rxjs/operators";
import { NgxCarousel } from "ngx-carousel";
import { CospService } from "../cosp/cosp.service";
import { DatePipe } from "@angular/common";
import { SessionStorageService } from "angular-web-storage";
import { VesselsService } from "../vessels/vessels.service";
import { VoyagelistService } from "../voyagelist/voyagelist.service";
import { CompanyService } from "../company/company.service";
import domtoimage from "dom-to-image";
import * as jsPDF from "jspdf";
import { DomSanitizer, SafeUrl } from "@angular/platform-browser";
import { CookieService } from "ngx-cookie-service";
import { formatDate } from "@angular/common";
import * as _ from "lodash";
import { DialoglogbookformsComponent } from "../dialoglogbookforms/dialoglogbookforms.component";

import { ApiRootService } from "../apiroot.service";
import { DecklogdialogboxComponent } from "../decklogdialogbox/decklogdialogbox.component";
import { EditlogbookdialogComponent } from "../editlogbookdialog/editlogbookdialog.component";
import { EditdeckdialogComponent } from "../editdeckdialog/editdeckdialog.component";
import { timeStamp } from "console";
import { Key } from "protractor";
import { DatepickerChangeService } from "../shared/services/datepicker-change.service";

export interface DialogData {
  popupwatchhours: any;
}

export const APP_DATE_FORMATS = {
  parse: { dateInput: { day: "numeric", month: "short", year: "numeric" } },
  display: {
    dateInput: { day: "numeric", month: "short", year: "numeric" },
    monthYearLabel: { year: "numeric" },
  },
};

@Component({
  selector: 'app-editlogbookforms',
  templateUrl: './editlogbookforms.component.html',
  styleUrls: ['./editlogbookforms.component.scss'],
  providers: [
    {
      provide: MAT_DATE_FORMATS,
      useValue: APP_DATE_FORMATS,
    },
  ],
})
export class EditlogbookformsComponent implements OnInit {
  reasonText: string = '';
  showError: boolean = false;
  isDragging = false;
  offset = { x: 0, y: 0 };
  oldData: any = [];
  displayedColumns: string[] = ["id", "Date", "WatchHour", "UserName", "userSign", "edit"];
  dataSource = new MatTableDataSource()
  saveReason = false;
  fieldName: string = '';
  comment: string = '';
  edited_fields_reason_value: any = [];
  edited_field_id: string = '';
  edited_field_value: any = '';
  editedBookName: string = '';
  editedBookId: any = '';
  editedBookIndex: any = '';

  isLoading = true;
  myForm: FormGroup;
  afs: any;
  success: boolean;
  loading: boolean;
  data: any = [];
  watchHours: any = [];
  bookType: any = [];
  formBuilder: any = [];
  formData: any = [];
  formBuilderSections: any = [];
  formBuilderSectionList: any = [];
  formDetails: any = [];
  formSectionDetails: any = [];
  objcol: any = [];
  objcolsection: any = [];
  objcolcollection: any = [];
  fSection1: any = [];
  fSection2: any = [];
  fSection3: any = [];
  fSection4: any = [];
  fSection5: any = [];
  fSection6: any = [];
  fSection7: any = [];
  fSection8: any = [];
  formKeys: any = [];
  watchhr: any;
  logbookid: any;
  garbegForm1: any;
  garbegForm2: any;
  oilnozoneForm: any;
  auditform: any;
  deckLogBook: any;
  blstForm: any;
  orbForm: any;
  bookTypeId: any;
  watchId: any;
  numberSection: any;
  formId: any;
  formCount: any = [];
  createdAt: any = [];
  responseDetails: any = [];
  currentBook: any;
  currentBookName: any;
  createdDate: any;
  showpop: any;
  showpop1: any;
  showpop2: any;
  showpop3: any;
  showpop4: any;
  showpop5: any;
  showpop6: any;
  showpop7: any;
  showpop8: any;
  showpop9: any;

  orbpart2: any;
  voyageNo: any;
  voyageId: any;
  imoNo: any;
  shipName: any;
  shipFrom: any;
  shipTo: any;
  startDate: any;
  gmdss: any;
  getFormRecordsList: any = [];
  alphabets = [
    "a",
    "b",
    "c",
    "d",
    "e",
    "f",
    "g",
    "h",
    "i",
    "j",
    "k",
    "l",
    "m",
    "n",
    "o",
    "p",
    "q",
    "r",
    "s",
    "t",
    "u",
    "v",
    "w",
    "x",
    "y",
    "z",
  ];

  userSign: any = [];
  masterSignature: any = [];
  signdate: any;
  masterName: string;
  roleName: string;
  roleId: any;
  chiefOfficerSignature: any = [];
  chiefOfficersigndate: any;
  chiefOfficerName: string;
  chiefOfficerroleName: string;
  chiefOfficerroleId: any;
  id: any;
  formid: any;
  mmsi: any;
  calsign: any;
  mvsv: any;

  public cookieIp = "";
  selectedValue: string;
  watchHoursList: any = [];
  selectedValueWatch: string;
  allDeckLogBookGroupByDate: any = [];
  allNoonPositionGroupByDate: any = [];
  editedBy: string;
  timeZone: string;
  deckLogActionDate: any;

  userVesselData: any = [];
  userVoyageData: any = [];
  companyList: any = [];
  selectedVoyage: any;
  newVesselId: number;
  currentVessel: any;
  selectedCompany: string;
  popupwatchhours: any = []; //array for popup
  forms: any = []; //array for forms
  show: any = false; //property for togglling mat accordion
  showEngineBook: string = '';
  showid: any;
  ishidden: boolean = true; //property for hiding radio button
  isgears: boolean = true; //property for steering gears
  incinerator: boolean = true;
  firstname: string;
  lastname: string;
  userid: any;
  tanks: any = [];  //array for tanks
  crewrecordrank = []; //array for ranks
  alldropdown: any = [] //for all the dropdowns
  crewName: any = [];
  crewfullName: any = [];
  engine: any;
  formrecords: any = []; // storing api response of enginelogbook
  formrecords1: any = []; // storing api response of olb
  formrecords2: any = []; //storing api response of decklogbook
  maxDate: Date;

  formIdList: any = [];
  formbuilderres: any = [];
  formbuildersectionname = [];
  accordionforms: any = [];
  tableshow: boolean = false;
  tabletoggle: boolean = true;
  bookdata: any = false;
  olb: any;   // for toggling olb forms
  logbook: any; //for toggling logbook forms
  deckbook: any; // for toggling decklogbook forms
  audit: any;   // for toggling audit and crew forms logbook forms
  public Config: NgxCarousel = {
    grid: { xs: 2, sm: 3, md: 3, lg: 5, all: 0 },
    slide: 1,
    speed: 5,
    interval: 10000,
    point: {
      visible: true,
    },
    touch: true,
    loop: false,
    custom: "banner",
  };

  //@HostListener('click', ['$event']) //'click', ['$event.target']
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;
  @ViewChild("successbox", { static: true }) successbox: SwalComponent;
  @ViewChild("errorbox", { static: true }) errorbox: SwalComponent;

  @HostListener('document:change', ['$event'])
  handleChange(event: Event) {
    const target = event.target as HTMLElement;

    console.log("===decklogbook===", this.decklogbook, this.deckbook, this.audit, this.olb);
    if (this.olb!=8 && (this.decklogbook || this.deckbook || this.audit || this.olb) && (target && (target.tagName === 'INPUT' || target.tagName === 'TEXTAREA' || target.hasAttribute('contenteditable')))) {
      this.saveReason = true;
      if ((event.target as HTMLInputElement).id != 'user_comment') {
        this.edited_field_id = (event.target as HTMLInputElement).id;  // Get the field ID
        this.edited_field_value = (event.target as HTMLInputElement).value;  // Get the field I
      }
      console.log("===onKeyUp===", this.saveReason);
      console.log("===edited_field_id===", this.edited_field_id);
    }
  }

  modifiedData: any = {};
  selectedindex: any;
  mainformid: any;
  showpopreefer: any;
  showpopauxiliary: any;
  showpoptable: any;
  showpopaircondition: any;
  showpopaircompressor: any;
  showpopdeck: any;
  deck: any;
  reefer: any;
  auxiliary: any;
  aircondition: any;
  aircompressor: any;
  decklogbook: any;
  selectedOfficerRankId: any;
  renderer: any;
  constructor(
    private cookieService: CookieService,
    private domSanitizer: DomSanitizer,
    public cmps: CompanyService,
    public voyagelistService: VoyagelistService,
    public vs: VesselsService,
    public cs: CospService,
    public session: SessionStorageService,
    public fb: FormBuilder,
    public editlogbookformsService: EditlogbookformsService,
    public http: HttpClient,
    public datePipe: DatePipe,
    public dialog: MatDialog,
    public service: ApiRootService,
    private dateChangeService: DatepickerChangeService
  ) { this.maxDate = new Date(); }

  openDialog(book: any) {
    // console.log('===openDialog==',book);
    // console.log('==selectedVoyage==', this.selectedVoyage);

    if(!this.selectedVoyage) return;

      if (book == "Engine Log Book") {
        const dialogRef = this.dialog.open(EditlogbookdialogComponent, {
          width: "600px",
          height: "300px",
          data: { popupwatchhours: this.popupwatchhours },
        });
      }
      if (book !== "Engine Log Book") {
        this.logbook = "";
        this.showpoptable = 0;
        this.showpopreefer = 0;
        this.showpopaircondition = 0;
        this.showpopauxiliary = 0;
        this.reefer = 0;
        this.auxiliary = 0;
        this.aircondition = 0;
        this.showpopaircompressor = 0;
      }

      if (book !== "Official Log Book") {
        this.olb = "";
        this.showpoptable = 0;
      }

      if (book != "Deck Log Book Record") {
        this.showpopdeck = 0;
        this.decklogbook = 0;

      }

      if (this.showid !== 42 || this.showid !== 43)  //showid 42 is for audit and 43 is for crew
      {
        this.audit = "";
        this.showpoptable = 0;
        this.showpopdeck = 0;
      }
      this.bookdata = book;
  }

  // FOR DECKLOGBOOK POPUP AND API RESPONSE FOR TABLE OF ACCORDIONS
  openpanel(data: any, id: any, index) {
    console.log("===openpanel===", data, id, index);
    this.editedBookName=data;
    this.editedBookId=id;
    this.editedBookIndex=index;
    this.loading=true;
    if (data == "Deck Log Book Record" && this.popupwatchhours.length > 0) {
      const dialogRef = this.dialog.open(EditdeckdialogComponent, {
        width: "600px",
        height: "300px",
        data: { popupwatchhours: this.popupwatchhours },
      });
    }
    this.show = data;
    this.showid = id;
    let date;


    //ENGINE LOG BOOK
    if (data == 'Main Engine' || data == 'Auxiliary Engine' || data == 'Reefer' || data == 'Air Condition' || data == 'Air Compressor' || data == 'Control Air Dryers' || data == 'F W Generator' || data == 'Purifiers' || data == 'Incinerator' || data == 'Oily Water Separator' || data == 'Sewage Treatment Plant' || data == 'Boiler' || data == 'Steering Gears' || data == 'Running counters and Consumptions' || data == 'Noon Report Data') {
      date = this.datePipe.transform(this.session.get('editwatchHourDate'), 'dd-MMM-yyyy');
      // console.log("SESSION STORAGE DATE IS :" + "" + date);
      let formid = '';
      this.logbook = 0;
      if (data == 'Main Engine') {
        formid = '22';
        this.showpopreefer = 0; this.reefer = 0; this.showpopaircompressor = 0, this.aircompressor = 0, this.auxiliary = 0; this.showpopauxiliary = 0; this.aircondition = 0; this.showpopaircondition = 0;
      }
      else if (data == 'Auxiliary Engine') {
        formid = '1'
        this.showpopauxiliary = 1;
      }

      else if (data == 'Reefer') {
        formid = '2'
        this.showpopreefer = 1;
      }


      else if (data == 'Air Condition') {
        formid = '4'
        this.showpopaircondition = 1;
      }
      else if (data == 'Air Compressor') {
        formid = '8'
        this.showpopaircompressor = 1;
      }
      else if (data == 'Control Air Dryers') {
        formid = '12';
        this.showpopreefer = 0; this.reefer = 0; this.aircompressor = 0, this.showpopaircompressor = 0, this.auxiliary = 0; this.showpopauxiliary = 0; this.aircondition = 0; this.showpopaircondition = 0;
      }

      else if (data == 'F W Generator') {
        formid = '13';
        this.showpopreefer = 0; this.reefer = 0; this.aircompressor = 0, this.showpopaircompressor = 0, this.auxiliary = 0; this.showpopauxiliary = 0; this.aircondition = 0; this.showpopaircondition = 0;
      }
      else if (data == 'Purifiers') {
        formid = '14';
        this.showpopreefer = 0; this.reefer = 0; this.aircompressor = 0, this.showpopaircompressor = 0, this.auxiliary = 0; this.showpopauxiliary = 0; this.aircondition = 0; this.showpopaircondition = 0;
      }
      else if (data == 'Incinerator') {
        formid = '15';
        this.showpopreefer = 0; this.reefer = 0; this.aircompressor = 0, this.showpopaircompressor = 0, this.auxiliary = 0; this.showpopauxiliary = 0; this.aircondition = 0; this.showpopaircondition = 0;
      }
      else if (data == 'Incinerator') {
        formid = '15';
        this.showpopreefer = 0; this.reefer = 0; this.aircompressor = 0, this.showpopaircompressor = 0, this.auxiliary = 0; this.showpopauxiliary = 0; this.aircondition = 0; this.showpopaircondition = 0;
      }
      else if (data == 'Oily Water Separator') {
        formid = '16';
        this.showpopreefer = 0; this.reefer = 0; this.aircompressor = 0, this.showpopaircompressor = 0, this.auxiliary = 0; this.showpopauxiliary = 0; this.aircondition = 0; this.showpopaircondition = 0;
      }
      else if (data == 'Sewage Treatment Plant') {
        formid = '17';
        this.showpopreefer = 0; this.reefer = 0; this.aircompressor = 0, this.showpopaircompressor = 0, this.auxiliary = 0; this.showpopauxiliary = 0; this.aircondition = 0; this.showpopaircondition = 0;
      }
      else if (data == 'Boiler') {
        formid = '18';
        this.showpopreefer = 0; this.reefer = 0; this.aircompressor = 0, this.showpopaircompressor = 0, this.auxiliary = 0; this.showpopauxiliary = 0; this.aircondition = 0; this.showpopaircondition = 0;
      }
      else if (data == 'Steering Gears') {
        formid = '19';
        this.showpopreefer = 0; this.reefer = 0; this.aircompressor = 0, this.showpopaircompressor = 0, this.auxiliary = 0; this.showpopauxiliary = 0; this.aircondition = 0; this.showpopaircondition = 0;
      }
      else if (data == 'Running counters and Consumptions') {
        formid = '45';
        this.showpopreefer = 0; this.reefer = 0; this.aircompressor = 0, this.showpopaircompressor = 0, this.auxiliary = 0; this.showpopauxiliary = 0; this.aircondition = 0; this.showpopaircondition = 0;
      }
      else if (data == 'Noon Report Data') {
        formid = '46';
        this.showpopreefer = 0; this.reefer = 0; this.aircompressor = 0, this.showpopaircompressor = 0, this.auxiliary = 0; this.showpopauxiliary = 0; this.aircondition = 0; this.showpopaircondition = 0;
      } else {
        formid = this.session.get('englineformId');
      }
      console.log("data---" + data + "  " + formid+'++'+this.loading);
      // ENGINE LOG BOOK API's
      this.editlogbookformsService.getFormDataWithAllRecordsByVoyageNoWithActionDate(
        formid, this.voyageNo,
        date, (response) => {
          var combindResponse = [];
          for (let key in response) {
            for (let ky in response[key].data) {
              combindResponse.push(response[key].data[ky]);
            }
          }
          this.showpoptable = 1;
          if (data == 'Auxiliary Engine' || data == 'Reefer' || data == 'Air Condition' || data == 'Air Compressor' || data == 'Deck Log Book Record') {
            this.showpoptable = 0;
            if (data == 'Reefer') {
              this.reefer = 1;
              this.showpopaircompressor = 0; this.showpopaircondition = 0; this.showpopauxiliary = 0; this.showpoptable = 0; this.auxiliary = 0; this.aircondition = 0; this.aircompressor = 0;
            } else if (data == 'Auxiliary Engine') {
              this.auxiliary = 1;
              this.showpopaircompressor = 0; this.showpopaircondition = 0; this.showpopreefer = 0; this.reefer = 0; this.showpoptable = 0; this.aircondition = 0; this.aircompressor = 0;
            } else if (data == 'Air Condition') {
              this.aircondition = 1;
              this.showpopreefer = 0; this.showpopauxiliary = 0; this.showpopaircompressor = 0; this.reefer = 0; this.auxiliary = 0; this.aircompressor = 0; this.showpoptable = 0;
            } else if (data == 'Air Compressor') {
              this.aircompressor = 1;
              this.showpopreefer = 0; this.showpoptable = 0; this.showpopauxiliary = 0; this.showpopaircondition = 0; this.reefer = 0; this.aircondition = 0; this.auxiliary = 0;
            } else if (data == 'Deck Log Book Record') {
              this.decklogbook = 1;
              this.showpopreefer = 0; this.showpoptable = 0; this.showpopauxiliary = 0; this.showpopaircondition = 0; this.reefer = 0; this.aircondition = 0; this.auxiliary = 0;
            }
          }

          this.formrecords = combindResponse;
          //   console.log(this.formrecords);
          let order = [];
          order = _.orderBy(combindResponse, 'timeStamp', 'desc');
          //    console.log(order);
          let grouped = [];
          grouped = _.groupBy(order, 'rowId');
          console.log(grouped);
          var newformarray = []
          Object.keys(grouped).forEach(key => {
            // console.log(grouped[key][0]);
            newformarray.push(grouped[key][0])
          });
          //  console.log(Object.keys(grouped));

          this.dataSource = new MatTableDataSource(newformarray);
          this.dataSource.paginator = this.paginator;
          this.dataSource.sort = this.sort;
          this.loading=false;
        })
    }



    //****** API FOR CREW AND AUDITS  *******//
    if (data == 'Audits / Inspections / Drills / Draft' || data == 'Crew Record and Management' || data == 'OFFICIAL LOG BOOK' || data == 'EMPLOYED SEAMEN RECORD' || data == 'BIRTHS & DEATHS' || data == 'TRAINING & DRILLS MUSTERS' || data == 'TEST DRILLS & INSPECTIONS' || data == 'CREW ACCOMMODATION INSPECTIONS' || data == 'ILO ACCORDANCE' || data == 'LOADLINE' || data == 'DEPARTURES & ARRIVALS' || data == 'PART IV SCHEDULE OLB') {

      let formid = '';
      this.olb = 0;
      this.audit = 0;
      if (data == 'OFFICIAL LOG BOOK') {
        formid = '69';
      }
      else if (data == 'EMPLOYED SEAMEN RECORD') {
        formid = '70';
      }
      else if (data == 'BIRTHS & DEATHS') {
        formid = '71';
      }
      else if (data == 'TRAINING & DRILLS MUSTERS') {
        formid = '72';
      }
      else if (data == 'TEST DRILLS & INSPECTIONS') {
        formid = '73';
      }
      else if (data == 'CREW ACCOMMODATION INSPECTIONS') {
        formid = '74';
      }
      else if (data == 'ILO ACCORDANCE') {
        formid = '75';
      }
      else if (data == 'LOADLINE') {
        formid = '76';
      }
      else if (data == 'DEPARTURES & ARRIVALS') {
        formid = '77';
      }
      else if (data == 'PART IV SCHEDULE OLB') {
        formid = '78';
      }
      else if (data == 'Audits / Inspections / Drills / Draft') {
        formid = '40';
      }
      else if (data == 'Crew Record and Management') {
        formid = '41';
      }
      else {
        formid = this.session.get('englineformId');
      }

      this.editlogbookformsService.getFormDataWithAllRecordsByVoyageNo(
        formid,
        this.voyageNo, (response) => {
          var combindResponse = [];
          for (let key in response) {
            for (let ky in response[key].data) {
              combindResponse.push(response[key].data[ky]);
            }
          }
          this.showpoptable = 1;
          this.formrecords1 = combindResponse;
          // console.log("===DATA WITHOUT GROUPED AND ORDERED====")
          // console.log(this.formrecords1);
          let order = [];
          order = _.orderBy(combindResponse, 'timeStamp', 'desc');
          // console.log("=======DATA AFTER ORDERED====")
          // console.log(order);
          let grouped = [];
          grouped = _.groupBy(order, 'rowId');
          // console.log("=======DATA AFTER GROUPED AND ORDERED====")
          // console.log(grouped);
          var newformarray = []

          Object.keys(grouped).forEach(key => {

            // console.log(grouped[key][0]);
            newformarray.push(grouped[key][0])
          });
          // console.log(Object.keys(grouped));

          this.dataSource = new MatTableDataSource(newformarray);
          this.dataSource.paginator = this.paginator;
          this.dataSource.sort = this.sort;
          this.loading=false;


        })

    }




    if (data == 'Deck Log Book Record') {
      let formid = '';
      this.deckbook = 0;
      this.audit = 0;
      date = this.datePipe.transform(this.session.get('editdeckDate'), "dd-MMM-yyyy");
      if (data == 'Watch Entry') {
        formid = '43';
      }
      else {
        formid = this.session.get('englineformId');
      }
      // console.log("data---" + data + "  " + formid);
      //*****DECK LOG BOOK API FOR EDITLOGBOOK *******/
      this.editlogbookformsService.getFormDataWithAllRecordsByVoyageNoWithActionDate(
        43, this.voyageNo,
        date, (response) => {
          var combindResponse = [];
          for (let key in response) {
            for (let ky in response[key].data) {
              combindResponse.push(response[key].data[ky]);
            }
          }
          this.showpoptable = 0;
          this.showpopdeck = 1;
          this.formrecords2 = combindResponse;
          // console.log("===DATA WITHOUT GROUPED AND ORDERED====");
          // console.log(this.formrecords2);
          let order = [];
          order = _.orderBy(combindResponse, 'timeStamp', 'desc');
          // console.log("=======DATA AFTER ORDERED====")
          // console.log(order);
          let grouped = [];
          grouped = _.groupBy(order, 'rowId');
          // console.log("=======DATA AFTER GROUPED AND ORDERED====")
          // console.log(grouped);
          var newformarray = []

          Object.keys(grouped).forEach(key => {

            // console.log(grouped[key][0]);
            newformarray.push(grouped[key][0])
          });
          // console.log(Object.keys(grouped));

          this.dataSource = new MatTableDataSource(newformarray);
          this.dataSource.paginator = this.paginator;
          this.dataSource.sort = this.sort;
          this.loading=false;
        })
    }

  }

  public reefertab(event) {
    this.selectedindex = event.index
    let date;
    let formid;
    date = this.datePipe.transform(this.session.get('editwatchHourDate'), 'dd-MMM-yyyy');
    // console.log("SESSION STORAGE DATE IS reefertab :" + "" + date);


    if (this.show == 'Reefer' && this.selectedindex == '1') {
      formid == 3;
      this.editlogbookformsService.getFormDataWithAllRecordsByVoyageNoWithActionDate(
        3, this.voyageNo,
        date, (response) => {
          var combindResponse = [];
          for (let key in response) {
            for (let ky in response[key].data) {
              combindResponse.push(response[key].data[ky]);
            }
          }
          this.showpoptable = 0;
          this.showpopreefer = 1;
          this.show == '';
          this.formrecords = combindResponse;
          // console.log("===DATA WITHOUT GROUPED AND ORDERED====");
          // console.log(this.formrecords);
          let order = [];
          order = _.orderBy(combindResponse, 'timeStamp', 'desc');
          // console.log("=======DATA AFTER ORDERED====");
          // console.log(order);
          let grouped = [];
          grouped = _.groupBy(order, 'rowId');
          // console.log("=======DATA AFTER GROUPED AND ORDERED====");
          // console.log(grouped);
          var newformarray = []

          Object.keys(grouped).forEach(key => {

            // console.log(grouped[key][0]);
            newformarray.push(grouped[key][0])
          });
          // console.log(Object.keys(grouped));

          this.dataSource = new MatTableDataSource(newformarray);
          this.dataSource.paginator = this.paginator;
          this.dataSource.sort = this.sort;
        })
    } else {
      this.formid = this.session.get('englineformId');
    }
  }

  public auxilliarytab(event) {
    this.selectedindex = event.index
    let date;
    let formid;
    // console.log("===event== :", event, "===this.show==", this.show);
    date = this.datePipe.transform(this.session.get('editwatchHourDate'), 'dd-MMM-yyyy');
    // console.log("SESSION STORAGE DATE IS :" + "" + date);
    if (this.show == 'Auxiliary Engine' && (this.selectedindex == '0' || this.selectedindex == '1')) {
      if (this.selectedindex == '0') {
        formid = 1;
      } else {
        formid = 20;
      }
      this.editlogbookformsService.getFormDataWithAllRecordsByVoyageNoWithActionDate(
        formid, this.voyageNo,
        date, (response) => {
          var combindResponse = [];
          for (let key in response) {
            for (let ky in response[key].data) {
              combindResponse.push(response[key].data[ky]);
            }
          }
          this.showpoptable = 0;
          this.showpopauxiliary = 1;
          this.show == '';
          this.formrecords = combindResponse;
          // console.log("===DATA WITHOUT GROUPED AND ORDERED====");
          // console.log(this.formrecords);
          let order = [];
          order = _.orderBy(combindResponse, 'timeStamp', 'desc');
          // console.log("=======DATA AFTER ORDERED====");
          // console.log(order);
          let grouped = [];
          grouped = _.groupBy(order, 'rowId');
          // console.log("=======DATA AFTER GROUPED AND ORDERED====");
          // console.log(grouped);
          var newformarray = []

          Object.keys(grouped).forEach(key => {

            // console.log(grouped[key][0]);
            newformarray.push(grouped[key][0])
          });
          // console.log(Object.keys(grouped));

          this.dataSource = new MatTableDataSource(newformarray);
          this.dataSource.paginator = this.paginator;
          this.dataSource.sort = this.sort;
        })
    }
    else if (this.show == 'Auxiliary Engine' && this.selectedindex == '2') {
      formid == 21;
      this.editlogbookformsService.getFormDataWithAllRecordsByVoyageNoWithActionDate(
        21, this.voyageNo,
        date, (response) => {
          var combindResponse = [];
          for (let key in response) {
            for (let ky in response[key].data) {
              combindResponse.push(response[key].data[ky]);
            }
          }
          this.showpoptable = 0;
          this.showpopauxiliary = 1;
          this.formrecords = combindResponse;
          // console.log("===DATA WITHOUT GROUPED AND ORDERED====");
          // console.log(this.formrecords);
          let order = [];
          order = _.orderBy(combindResponse, 'timeStamp', 'desc');
          // console.log("=======DATA AFTER ORDERED====");
          // console.log(order);
          let grouped = [];
          grouped = _.groupBy(order, 'rowId');
          // console.log("=======DATA AFTER GROUPED AND ORDERED====");
          // console.log(grouped);
          var newformarray = []

          Object.keys(grouped).forEach(key => {

            // console.log(grouped[key][0]);
            newformarray.push(grouped[key][0])
          });
          // console.log(Object.keys(grouped));

          this.dataSource = new MatTableDataSource(newformarray);
          this.dataSource.paginator = this.paginator;
          this.dataSource.sort = this.sort;
        })
    }
    else {
      this.formid = this.session.get('englineformId');
    }
  }

  public airconditiontab(event) {
    this.selectedindex = event.index
    let date;
    let formid;
    date = this.datePipe.transform(this.session.get('editwatchHourDate'), 'dd-MMM-yyyy');
    // console.log("===this.selectedindex === :" + "" + this.selectedindex);
    if (this.show == 'Air Condition' && this.selectedindex == '0') {
      formid == 4;
      this.editlogbookformsService.getFormDataWithAllRecordsByVoyageNoWithActionDate(
        4, this.voyageNo,
        date, (response) => {
          var combindResponse = [];
          for (let key in response) {
            for (let ky in response[key].data) {
              combindResponse.push(response[key].data[ky]);
            }
          }
          this.showpoptable = 0;
          this.showpopaircondition = 1;
          this.show == '';
          this.formrecords = combindResponse;
          // console.log("===DATA WITHOUT GROUPED AND ORDERED====")
          // console.log(this.formrecords);
          let order = [];
          order = _.orderBy(combindResponse, 'timeStamp', 'desc');
          // console.log("=======DATA AFTER ORDERED====")
          // console.log(order);
          let grouped = [];
          grouped = _.groupBy(order, 'rowId');
          // console.log("=======DATA AFTER GROUPED AND ORDERED====")
          // console.log(grouped);
          var newformarray = []

          Object.keys(grouped).forEach(key => {

            // console.log(grouped[key][0]);
            newformarray.push(grouped[key][0])
          });
          // console.log(Object.keys(grouped));

          this.dataSource = new MatTableDataSource(newformarray);
          this.dataSource.paginator = this.paginator;
          this.dataSource.sort = this.sort;
        })

    }
    else if (this.show == 'Air Condition' && this.selectedindex == '1') {
      formid == 5;
      this.editlogbookformsService.getFormDataWithAllRecordsByVoyageNoWithActionDate(
        5, this.voyageNo,
        date, (response) => {
          var combindResponse = [];
          for (let key in response) {
            for (let ky in response[key].data) {
              combindResponse.push(response[key].data[ky]);
            }
          }
          this.showpoptable = 0;
          this.showpopaircondition = 1;
          this.show == '';
          this.formrecords = combindResponse;
          // console.log("===DATA WITHOUT GROUPED AND ORDERED====")
          // console.log(this.formrecords);
          let order = [];
          order = _.orderBy(combindResponse, 'timeStamp', 'desc');
          // console.log("=======DATA AFTER ORDERED====")
          // console.log(order);
          let grouped = [];
          grouped = _.groupBy(order, 'rowId');
          // console.log("=======DATA AFTER GROUPED AND ORDERED====")
          // console.log(grouped);
          var newformarray = []

          Object.keys(grouped).forEach(key => {

            // console.log(grouped[key][0]);
            newformarray.push(grouped[key][0])
          });
          // console.log(Object.keys(grouped));

          this.dataSource = new MatTableDataSource(newformarray);
          this.dataSource.paginator = this.paginator;
          this.dataSource.sort = this.sort;
        })

    }
    else if (this.show == 'Air Condition' && this.selectedindex == '2') {
      formid == 6;
      this.editlogbookformsService.getFormDataWithAllRecordsByVoyageNoWithActionDate(
        6, this.voyageNo,
        date, (response) => {
          var combindResponse = [];
          for (let key in response) {
            for (let ky in response[key].data) {
              combindResponse.push(response[key].data[ky]);
            }
          }
          this.showpoptable = 0;
          this.showpopaircondition = 1;
          this.formrecords = combindResponse;
          // console.log("===DATA WITHOUT GROUPED AND ORDERED====")
          // console.log(this.formrecords);
          let order = [];
          order = _.orderBy(combindResponse, 'timeStamp', 'desc');
          // console.log("=======DATA AFTER ORDERED====")
          // console.log(order);
          let grouped = [];
          grouped = _.groupBy(order, 'rowId');
          // console.log("=======DATA AFTER GROUPED AND ORDERED====")
          // console.log(grouped);
          var newformarray = []

          Object.keys(grouped).forEach(key => {

            // console.log(grouped[key][0]);
            newformarray.push(grouped[key][0])
          });
          // console.log(Object.keys(grouped));

          this.dataSource = new MatTableDataSource(newformarray);
          this.dataSource.paginator = this.paginator;
          this.dataSource.sort = this.sort;
        })
    }
    else if (this.show == 'Air Condition' && this.selectedindex == '3') {
      formid == 7;
      this.editlogbookformsService.getFormDataWithAllRecordsByVoyageNoWithActionDate(
        7, this.voyageNo,
        date, (response) => {
          var combindResponse = [];
          for (let key in response) {
            for (let ky in response[key].data) {
              combindResponse.push(response[key].data[ky]);
            }
          }
          this.showpoptable = 0;
          this.showpopaircondition = 1;
          this.formrecords = combindResponse;
          // console.log("===DATA WITHOUT GROUPED AND ORDERED====")
          // console.log(this.formrecords);
          let order = [];
          order = _.orderBy(combindResponse, 'timeStamp', 'desc');
          // console.log("=======DATA AFTER ORDERED====")
          // console.log(order);
          let grouped = [];
          grouped = _.groupBy(order, 'rowId');
          // console.log("=======DATA AFTER GROUPED AND ORDERED====")
          // console.log(grouped);
          var newformarray = []

          Object.keys(grouped).forEach(key => {

            console.log(grouped[key][0]);
            newformarray.push(grouped[key][0])
          });
          // console.log(Object.keys(grouped));

          this.dataSource = new MatTableDataSource(newformarray);
          this.dataSource.paginator = this.paginator;
          this.dataSource.sort = this.sort;
        })
    }
    else {
      this.formid = this.session.get('englineformId');
    }
  }

  public aircompressortab(event) {
    this.selectedindex = event.index
    let date;
    let formid;
    date = this.datePipe.transform(this.session.get('editwatchHourDate'), 'dd-MMM-yyyy');
    //  console.log("SESSION STORAGE DATE IS :" + "" +date);
    if (this.show == 'Air Compressor' && this.selectedindex == '1') {
      formid == 9;
      this.editlogbookformsService.getFormDataWithAllRecordsByVoyageNoWithActionDate(
        9, this.voyageNo,
        date, (response) => {
          var combindResponse = [];
          for (let key in response) {
            for (let ky in response[key].data) {
              combindResponse.push(response[key].data[ky]);
            }
          }
          this.showpoptable = 0;
          this.showpopaircompressor = 1
          this.show == '';
          this.formrecords = combindResponse;
          // console.log("===DATA WITHOUT GROUPED AND ORDERED====")
          // console.log(this.formrecords);
          let order = [];
          order = _.orderBy(combindResponse, 'timeStamp', 'desc');
          // console.log("=======DATA AFTER ORDERED====")
          // console.log(order);
          let grouped = [];
          grouped = _.groupBy(order, 'rowId');
          // console.log("=======DATA AFTER GROUPED AND ORDERED====")
          // console.log(grouped);
          var newformarray = []

          Object.keys(grouped).forEach(key => {

            // console.log(grouped[key][0]);
            newformarray.push(grouped[key][0])
          });
          // console.log(Object.keys(grouped));

          this.dataSource = new MatTableDataSource(newformarray);
          this.dataSource.paginator = this.paginator;
          this.dataSource.sort = this.sort;
        })
    }
    else if (this.show == 'Air Compressor' && this.selectedindex == '2') {
      formid == 10;
      this.editlogbookformsService.getFormDataWithAllRecordsByVoyageNoWithActionDate(
        10, this.voyageNo,
        date, (response) => {
          var combindResponse = [];
          for (let key in response) {
            for (let ky in response[key].data) {
              combindResponse.push(response[key].data[ky]);
            }
          }
          this.showpoptable = 0;
          this.showpopaircompressor = 1
          this.formrecords = combindResponse;
          // console.log("===DATA WITHOUT GROUPED AND ORDERED====")
          // console.log(this.formrecords);
          let order = [];
          order = _.orderBy(combindResponse, 'timeStamp', 'desc');
          // console.log("=======DATA AFTER ORDERED====")
          // console.log(order);
          let grouped = [];
          grouped = _.groupBy(order, 'rowId');
          // console.log("=======DATA AFTER GROUPED AND ORDERED====")
          // console.log(grouped);
          var newformarray = []

          Object.keys(grouped).forEach(key => {

            console.log(grouped[key][0]);
            newformarray.push(grouped[key][0])
          });
          console.log(Object.keys(grouped));

          this.dataSource = new MatTableDataSource(newformarray);
          this.dataSource.paginator = this.paginator;
          this.dataSource.sort = this.sort;
        })
    }
    else if (this.show == 'Air Compressor' && this.selectedindex == '3') {
      formid == 11;
      this.editlogbookformsService.getFormDataWithAllRecordsByVoyageNoWithActionDate(
        11, this.voyageNo,
        date, (response) => {
          var combindResponse = [];
          for (let key in response) {
            for (let ky in response[key].data) {
              combindResponse.push(response[key].data[ky]);
            }
          }
          this.showpoptable = 0;
          this.showpopaircompressor = 1
          this.formrecords = combindResponse;
          // console.log("===DATA WITHOUT GROUPED AND ORDERED====")
          // console.log(this.formrecords);
          let order = [];
          order = _.orderBy(combindResponse, 'timeStamp', 'desc');
          // console.log("=======DATA AFTER ORDERED====")
          // console.log(order);
          let grouped = [];
          grouped = _.groupBy(order, 'rowId');
          // console.log("=======DATA AFTER GROUPED AND ORDERED====")
          // console.log(grouped);
          var newformarray = []

          Object.keys(grouped).forEach(key => {

            // console.log(grouped[key][0]);
            newformarray.push(grouped[key][0])
          });
          // console.log(Object.keys(grouped));

          this.dataSource = new MatTableDataSource(newformarray);
          this.dataSource.paginator = this.paginator;
          this.dataSource.sort = this.sort;
        })
    }
    else {
      this.formid = this.session.get('englineformId');
    }
  }
  public decktab(event) {
    this.selectedindex = event.index
    let date;
    let formid;
    date = this.datePipe.transform(this.session.get('editdeckDate'), 'dd-MMM-yyyy');
    console.log("SESSION STORAGE DATE IS :" + "" + date);
    console.log(this.session.get('deckwatchHourTime'));
    if (this.show == 'Deck Log Book Record' && this.selectedindex == '0') {
      formid == 43;
      this.editlogbookformsService.getFormDataWithAllRecordsByVoyageNoWithActionDate(
        43, this.voyageNo,
        date, (response) => {
          var combindResponse = [];
          for (let key in response) {
            for (let ky in response[key].data) {
              combindResponse.push(response[key].data[ky]);
            }
          }
          this.showpoptable = 0;
          this.showpopdeck = 1;
          this.show == '';
          this.formrecords = combindResponse;
          // console.log("===DATA WITHOUT GROUPED AND ORDERED====")
          // console.log(this.formrecords);
          let order = [];
          order = _.orderBy(combindResponse, 'timeStamp', 'desc');
          // console.log("=======DATA AFTER ORDERED====")
          // console.log(order);
          let grouped = [];
          grouped = _.groupBy(order, 'rowId');
          // console.log("=======DATA AFTER GROUPED AND ORDERED====")
          // console.log(grouped);
          var newformarray = []

          Object.keys(grouped).forEach(key => {

            // console.log(grouped[key][0]);
            newformarray.push(grouped[key][0])
          });
          // console.log(Object.keys(grouped));

          this.dataSource = new MatTableDataSource(newformarray);
          this.dataSource.paginator = this.paginator;
          this.dataSource.sort = this.sort;
        })
    }

    else if (this.show == 'Deck Log Book Record' && this.selectedindex == '1') {
      formid == 44;
      this.editlogbookformsService.getFormDataWithAllRecordsByVoyageNoWithActionDate(
        44, this.voyageNo,
        date, (response) => {
          var combindResponse = [];
          for (let key in response) {
            for (let ky in response[key].data) {
              combindResponse.push(response[key].data[ky]);
            }
          }
          this.showpoptable = 0;
          this.showpopdeck = 1;
          this.show == '';
          this.formrecords = combindResponse;
          // console.log("===DATA WITHOUT GROUPED AND ORDERED====")
          // console.log(this.formrecords);
          let order = [];
          order = _.orderBy(combindResponse, 'timeStamp', 'desc');
          // console.log("=======DATA AFTER ORDERED====")
          // console.log(order);
          let grouped = [];
          grouped = _.groupBy(order, 'rowId');
          // console.log("=======DATA AFTER GROUPED AND ORDERED====")
          // console.log(grouped);
          var newformarray = []

          Object.keys(grouped).forEach(key => {

            // console.log(grouped[key][0]);
            newformarray.push(grouped[key][0])
          });
          // console.log(Object.keys(grouped));

          this.dataSource = new MatTableDataSource(newformarray);
          this.dataSource.paginator = this.paginator;
          this.dataSource.sort = this.sort;
        })
    } else {
      this.formid = this.session.get('englineformId');
    }
  }

  //******SUBMIT FUNCTION *****/
  public onSubmit(formdata, formId) {

    this.firstname = this.session.get('firstname')
    this.lastname = this.session.get('lastname')
    this.userid = this.session.get('userid')
    // console.log(this.firstname)
    // console.log(this.lastname)
    // console.log(formId);
    // console.log(formdata);
    let parameterdata;
    let changefields;
    this.session.set('englineformId', formId);



    if (formId == 22) {
      //main engine M/E1
      var Gov_Index_186 = (document.getElementById("Gov_Index_186") as HTMLInputElement).value
      var Load_187 = (document.getElementById("Load_187") as HTMLInputElement).value
      var Rev_Counter_188 = (document.getElementById("Rev_Counter_188") as HTMLInputElement).value
      var RPM_189 = (document.getElementById("RPM_189") as HTMLInputElement).value
      var Sump_Level_825 = (document.getElementById("Sump_Level_825") as HTMLInputElement).value
      var TCh_RPM_10 = (document.getElementById("TCh_RPM_10") as HTMLInputElement).value
      //main engine  M/E LUBE OIL PRESSURE
      var ME_Lo_Pr_In_194 = (document.getElementById("ME_Lo_Pr_In_194") as HTMLInputElement).value
      var ME_Lo_Filter_Before_195 = (document.getElementById("ME_Lo_Filter_Before_195") as HTMLInputElement).value
      var ME_Lo_Filter_After_196 = (document.getElementById("ME_Lo_Filter_After_196") as HTMLInputElement).value
      var ME_Pist_Cool_In_197 = (document.getElementById("ME_Pist_Cool_In_197") as HTMLInputElement).value
      var ME_Thrust_Brg_198 = (document.getElementById("ME_Thrust_Brg_198") as HTMLInputElement).value
      var ME_TCH_Pr_199 = (document.getElementById("ME_TCH_Pr_199") as HTMLInputElement).value
      var ME_ST_Lo_Pr_208 = (document.getElementById("ME_ST_Lo_Pr_208") as HTMLInputElement).value
      //M/E LUBE OIL TEMPERATURE
      var ME_ST_Lo_Temp_209 = (document.getElementById("ME_ST_Lo_Temp_209") as HTMLInputElement).value
      var Water_Content_210 = (document.getElementById("Water_Content_210") as HTMLInputElement).value
      var Eng_Brg_Temp_01_211 = (document.getElementById("Eng_Brg_Temp_01_211") as HTMLInputElement).value
      var Eng_Brg_Temp_02_212 = (document.getElementById("Eng_Brg_Temp_02_212") as HTMLInputElement).value
      var Eng_Brg_Temp_03_213 = (document.getElementById("Eng_Brg_Temp_03_213") as HTMLInputElement).value
      var Eng_Brg_Temp_04_214 = (document.getElementById("Eng_Brg_Temp_04_214") as HTMLInputElement).value
      var Eng_Brg_Temp_05_215 = (document.getElementById("Eng_Brg_Temp_05_215") as HTMLInputElement).value
      var Eng_Brg_Temp_06_224 = (document.getElementById("Eng_Brg_Temp_06_224") as HTMLInputElement).value
      var Eng_Brg_Temp_07_225 = (document.getElementById("Eng_Brg_Temp_07_225") as HTMLInputElement).value
      var Eng_Brg_Temp_08_226 = (document.getElementById("Eng_Brg_Temp_08_226") as HTMLInputElement).value
      var Piston_Cooling_Put_01_227 = (document.getElementById("Piston_Cooling_Put_01_227") as HTMLInputElement).value
      var Piston_Cooling_Put_02_228 = (document.getElementById("Piston_Cooling_Put_02_228") as HTMLInputElement).value
      var Piston_Cooling_Put_03_230 = (document.getElementById("Piston_Cooling_Put_03_230") as HTMLInputElement).value
      var Piston_Cooling_Put_04_232 = (document.getElementById("Piston_Cooling_Put_04_232") as HTMLInputElement).value
      var Piston_Cooling_Put_05_233 = (document.getElementById("Piston_Cooling_Put_05_233") as HTMLInputElement).value
      var Piston_Cooling_Put_06_234 = (document.getElementById("Piston_Cooling_Put_06_234") as HTMLInputElement).value
      var Piston_Cooling_Put_07_235 = (document.getElementById("Piston_Cooling_Put_07_235") as HTMLInputElement).value
      var Piston_Cooling_Put_08_236 = (document.getElementById("Piston_Cooling_Put_08_236") as HTMLInputElement).value
      var ME_Thrust_Pad_Temp_237 = (document.getElementById("ME_Thrust_Pad_Temp_237") as HTMLInputElement).value
      var ME_Int_Shaft_Brg_Temp_238 = (document.getElementById("ME_Int_Shaft_Brg_Temp_238") as HTMLInputElement).value
      var ME_LO_Cooler_In_244 = (document.getElementById("ME_LO_Cooler_In_244") as HTMLInputElement).value
      var ME_LO_Cooler_Out_245 = (document.getElementById("ME_LO_Cooler_Out_245") as HTMLInputElement).value
      var ME_TCh_LO_In_246 = (document.getElementById("ME_TCh_LO_In_246") as HTMLInputElement).value
      var ME_TCh_LO_Out_247 = (document.getElementById("ME_TCh_LO_Out_247") as HTMLInputElement).value
      //M/E CW
      var ME_CW_HT_IN_Pr_264 = (document.getElementById("ME_CW_HT_IN_Pr_264") as HTMLInputElement).value
      var ME_CW_LT_IN_Pr_273 = (document.getElementById("ME_CW_LT_IN_Pr_273") as HTMLInputElement).value
      var CFW_Cooler1_In_274 = (document.getElementById("CFW_Cooler1_In_274") as HTMLInputElement).value
      var CFW_Cooler1_Out_284 = (document.getElementById("CFW_Cooler1_Out_284") as HTMLInputElement).value
      var CFW_Cooler2_In_285 = (document.getElementById("CFW_Cooler2_In_285") as HTMLInputElement).value
      var CFW_Cooler2_Out_288 = (document.getElementById("CFW_Cooler2_Out_288") as HTMLInputElement).value
      var CSW_Cooler1_In_294 = (document.getElementById("CSW_Cooler1_In_294") as HTMLInputElement).value
      var CSW_Cooler1_Out_295 = (document.getElementById("CSW_Cooler1_Out_295") as HTMLInputElement).value
      var CSW_Cooler2_In_296 = (document.getElementById("CSW_Cooler2_In_296") as HTMLInputElement).value
      var CSW_Cooler2_Out_297 = (document.getElementById("CSW_Cooler2_Out_297") as HTMLInputElement).value
      var CFW_To_Eng_T_298 = (document.getElementById("CFW_To_Eng_T_298") as HTMLInputElement).value
      var CFW_Cyl_Outlet_01_299 = (document.getElementById("CFW_Cyl_Outlet_01_299") as HTMLInputElement).value
      var CFW_Cyl_Outlet_02_300 = (document.getElementById("CFW_Cyl_Outlet_02_300") as HTMLInputElement).value
      var CFW_Cyl_Outlet_03_301 = (document.getElementById("CFW_Cyl_Outlet_03_301") as HTMLInputElement).value
      var CFW_Cyl_Outlet_04_302 = (document.getElementById("CFW_Cyl_Outlet_04_302") as HTMLInputElement).value
      var CFW_Cyl_Outlet_05_303 = (document.getElementById("CFW_Cyl_Outlet_05_303") as HTMLInputElement).value
      var CFW_Cyl_Outlet_06_304 = (document.getElementById("CFW_Cyl_Outlet_06_304") as HTMLInputElement).value
      var CFW_Cyl_Outlet_07_305 = (document.getElementById("CFW_Cyl_Outlet_07_305") as HTMLInputElement).value
      var CFW_Cyl_Outlet_08_306 = (document.getElementById("CFW_Cyl_Outlet_08_306") as HTMLInputElement).value
      //"M/E FUEL OIL PRESSURE"
      var ME_Fuel_Index_307 = (document.getElementById("ME_Fuel_Index_307") as HTMLInputElement).value
      var ME_Fuel_Oil_In_Pr_308 = (document.getElementById("ME_Fuel_Oil_In_Pr_308") as HTMLInputElement).value
      var ME_Fuel_Oil_Filter_In_309 = (document.getElementById("ME_Fuel_Oil_Filter_In_309") as HTMLInputElement).value
      var ME_Fuel_Oil_Filter_Out_310 = (document.getElementById("ME_Fuel_Oil_Filter_Out_310") as HTMLInputElement).value
      var ME_Fuel_Oil_Viscosity_Set_311 = (document.getElementById("ME_Fuel_Oil_Viscosity_Set_311") as HTMLInputElement).value
      var ME_Fuel_Oil_Viscosity_PV_312 = (document.getElementById("ME_Fuel_Oil_Viscosity_PV_312") as HTMLInputElement).value
      //M/E FUEL OIL TEMPERATURE
      var ME_Fuel_Oil_Temp_In_313 = (document.getElementById("ME_Fuel_Oil_Temp_In_313") as HTMLInputElement).value
      var ME_Fuel_Rack_01_314 = (document.getElementById("ME_Fuel_Rack_01_314") as HTMLInputElement).value
      var ME_Fuel_Rack_02_315 = (document.getElementById("ME_Fuel_Rack_02_315") as HTMLInputElement).value
      var ME_Fuel_Rack_03_316 = (document.getElementById("ME_Fuel_Rack_03_316") as HTMLInputElement).value
      var ME_Fuel_Rack_04_317 = (document.getElementById("ME_Fuel_Rack_04_317") as HTMLInputElement).value
      var ME_Fuel_Rack_05_318 = (document.getElementById("ME_Fuel_Rack_05_318") as HTMLInputElement).value
      var ME_Fuel_Rack_06_319 = (document.getElementById("ME_Fuel_Rack_06_319") as HTMLInputElement).value
      var ME_Fuel_Rack_07_320 = (document.getElementById("ME_Fuel_Rack_07_320") as HTMLInputElement).value
      var ME_Fuel_Rack_08_321 = (document.getElementById("ME_Fuel_Rack_08_321") as HTMLInputElement).value
      var ME_VIT_Rack_01_322 = (document.getElementById("ME_VIT_Rack_01_322") as HTMLInputElement).value
      var ME_VIT_Rack_02_323 = (document.getElementById("ME_VIT_Rack_02_323") as HTMLInputElement).value
      var ME_VIT_Rack_03_324 = (document.getElementById("ME_VIT_Rack_03_324") as HTMLInputElement).value
      var ME_VIT_Rack_04_325 = (document.getElementById("ME_VIT_Rack_04_325") as HTMLInputElement).value
      var ME_VIT_Rack_05_326 = (document.getElementById("ME_VIT_Rack_05_326") as HTMLInputElement).value
      var ME_VIT_Rack_06_327 = (document.getElementById("ME_VIT_Rack_06_327") as HTMLInputElement).value
      var ME_VIT_Rack_07_328 = (document.getElementById("ME_VIT_Rack_07_328") as HTMLInputElement).value
      var ME_VIT_Rack_08_329 = (document.getElementById("ME_VIT_Rack_08_329") as HTMLInputElement).value
      //M/E/T/C AIR COOLER
      var Atm_Pr_330 = (document.getElementById("Atm_Pr_330") as HTMLInputElement).value
      var ME_Scav_Pr_331 = (document.getElementById("ME_Scav_Pr_331") as HTMLInputElement).value
      var ME_Exh_Gas_Receiver_332 = (document.getElementById("ME_Exh_Gas_Receiver_332") as HTMLInputElement).value
      var Pr_Drop_Accross_TCh_Filter_333 = (document.getElementById("Pr_Drop_Accross_TCh_Filter_333") as HTMLInputElement).value
      var Pr_Drop_Accross_Air_Cooler_334 = (document.getElementById("Pr_Drop_Accross_Air_Cooler_334") as HTMLInputElement).value
      var Pr_Drop_Accross_EGE_335 = (document.getElementById("Pr_Drop_Accross_EGE_335") as HTMLInputElement).value
      var Air_Cooler_Temp_In_336 = (document.getElementById("Air_Cooler_Temp_In_336") as HTMLInputElement).value
      var Air_Cooler_Temp_Out_337 = (document.getElementById("Air_Cooler_Temp_Out_337") as HTMLInputElement).value
      var TCh_Exh_Gas_Temp_In_338 = (document.getElementById("TCh_Exh_Gas_Temp_In_338") as HTMLInputElement).value
      var TCh_Exh_Gas_Temp_Out_339 = (document.getElementById("TCh_Exh_Gas_Temp_Out_339") as HTMLInputElement).value
      var Exh_Gas_Temp_01_340 = (document.getElementById("Exh_Gas_Temp_01_340") as HTMLInputElement).value
      var Exh_Gas_Temp_02_341 = (document.getElementById("Exh_Gas_Temp_02_341") as HTMLInputElement).value
      var Exh_Gas_Temp_03_342 = (document.getElementById("Exh_Gas_Temp_03_342") as HTMLInputElement).value
      var Exh_Gas_Temp_04_343 = (document.getElementById("Exh_Gas_Temp_04_343") as HTMLInputElement).value
      var Exh_Gas_Temp_05_344 = (document.getElementById("Exh_Gas_Temp_05_344") as HTMLInputElement).value
      var Exh_Gas_Temp_06_345 = (document.getElementById("Exh_Gas_Temp_06_345") as HTMLInputElement).value
      var Exh_Gas_Temp_07_346 = (document.getElementById("Exh_Gas_Temp_07_346") as HTMLInputElement).value
      var Exh_Gas_Temp_08_347 = (document.getElementById("Exh_Gas_Temp_08_347") as HTMLInputElement).value
      var EGE_Temp_In_348 = (document.getElementById("EGE_Temp_In_348") as HTMLInputElement).value
      var EGE_Temp_Out_349 = (document.getElementById("EGE_Temp_Out_349") as HTMLInputElement).value
      //M/E Scav AND Exh
      var Pressures_Scav_Air_Pr_826 = (document.getElementById("Pressures_Scav_Air_Pr_826") as HTMLInputElement).value
      var Temperatures_Scav_Temp_827 = (document.getElementById("Temperatures_Scav_Temp_827") as HTMLInputElement).value
      var Exh_Temp_Out_01_828 = (document.getElementById("Exh_Temp_Out_01_828") as HTMLInputElement).value
      var Exh_Temp_Out_02_829 = (document.getElementById("Exh_Temp_Out_02_829") as HTMLInputElement).value
      var Exh_Temp_Out_03_830 = (document.getElementById("Exh_Temp_Out_03_830") as HTMLInputElement).value
      var Exh_Temp_Out_04_831 = (document.getElementById("Exh_Temp_Out_04_831") as HTMLInputElement).value
      var Exh_Temp_Out_05_832 = (document.getElementById("Exh_Temp_Out_05_832") as HTMLInputElement).value
      var Exh_Temp_Out_06_833 = (document.getElementById("Exh_Temp_Out_06_833") as HTMLInputElement).value
      var TCH_Temp_In_834 = (document.getElementById("TCH_Temp_In_834") as HTMLInputElement).value
      var TCH_Temp_Out_835 = (document.getElementById("TCH_Temp_Out_835") as HTMLInputElement).value



      console.log(formId)
      parameterdata = {
        "Gov_Index_186": Gov_Index_186, "Load_187": Load_187, "Rev_Counter_188": Rev_Counter_188, "RPM_189": RPM_189, "Sump_Level_825": Sump_Level_825, "TCh_RPM_10": TCh_RPM_10,
        "ME_Lo_Pr_In_194": ME_Lo_Pr_In_194, "ME_Lo_Filter_Before_195": ME_Lo_Filter_Before_195, "ME_Lo_Filter_After_196": ME_Lo_Filter_After_196,
        "ME_Pist_Cool_In_197": ME_Pist_Cool_In_197, "ME_Thrust_Brg_198": ME_Thrust_Brg_198, "ME_TCH_Pr_199": ME_TCH_Pr_199,
        "ME_ST_Lo_Pr_208": ME_ST_Lo_Pr_208,
        "ME_ST_Lo_Temp_209": ME_ST_Lo_Temp_209, "Water_Content_210": Water_Content_210, "Eng_Brg_Temp_01_211": Eng_Brg_Temp_01_211, "Eng_Brg_Temp_02_212": Eng_Brg_Temp_02_212, "Eng_Brg_Temp_03_213": Eng_Brg_Temp_03_213, "Eng_Brg_Temp_04_214": Eng_Brg_Temp_04_214,
        "Eng_Brg_Temp_05_215": Eng_Brg_Temp_05_215, "Eng_Brg_Temp_06_224": Eng_Brg_Temp_06_224, "Eng_Brg_Temp_07_225": Eng_Brg_Temp_07_225, "Eng_Brg_Temp_08_226": Eng_Brg_Temp_08_226, "Piston_Cooling_Put_01_227": Piston_Cooling_Put_01_227, "Piston_Cooling_Put_02_228": Piston_Cooling_Put_02_228,
        "Piston_Cooling_Put_03_230": Piston_Cooling_Put_03_230, "Piston_Cooling_Put_04_232": Piston_Cooling_Put_04_232, "Piston_Cooling_Put_05_233": Piston_Cooling_Put_05_233, "Piston_Cooling_Put_06_234": Piston_Cooling_Put_06_234, "Piston_Cooling_Put_07_235": Piston_Cooling_Put_07_235, "Piston_Cooling_Put_08_236": Piston_Cooling_Put_08_236,
        "ME_Thrust_Pad_Temp_237": ME_Thrust_Pad_Temp_237, "ME_Int_Shaft_Brg_Temp_238": ME_Int_Shaft_Brg_Temp_238, "ME_LO_Cooler_In_244": ME_LO_Cooler_In_244, "ME_LO_Cooler_Out_245": ME_LO_Cooler_Out_245, "ME_TCh_LO_In_246": ME_TCh_LO_In_246, "ME_TCh_LO_Out_247": ME_TCh_LO_Out_247,
        "ME_CW_HT_IN_Pr_264": ME_CW_HT_IN_Pr_264, "ME_CW_LT_IN_Pr_273": ME_CW_LT_IN_Pr_273, "CFW_Cooler1_In_274": CFW_Cooler1_In_274, "CFW_Cooler1_Out_284": CFW_Cooler1_Out_284, "CFW_Cooler2_In_285": CFW_Cooler2_In_285, "CFW_Cooler2_Out_288": CFW_Cooler2_Out_288, "CSW_Cooler1_In_294": CSW_Cooler1_In_294,
        "CSW_Cooler1_Out_295": CSW_Cooler1_Out_295, "CSW_Cooler2_In_296": CSW_Cooler2_In_296, "CSW_Cooler2_Out_297": CSW_Cooler2_Out_297, "CFW_To_Eng_T_298": CFW_To_Eng_T_298, "CFW_Cyl_Outlet_01_299": CFW_Cyl_Outlet_01_299, "CFW_Cyl_Outlet_02_300": CFW_Cyl_Outlet_02_300, "CFW_Cyl_Outlet_03_301": CFW_Cyl_Outlet_03_301, "CFW_Cyl_Outlet_04_302": CFW_Cyl_Outlet_04_302, "CFW_Cyl_Outlet_05_303": CFW_Cyl_Outlet_05_303, "CFW_Cyl_Outlet_06_304": CFW_Cyl_Outlet_06_304, "CFW_Cyl_Outlet_07_305": CFW_Cyl_Outlet_07_305, "CFW_Cyl_Outlet_08_306": CFW_Cyl_Outlet_08_306,
        "ME_Fuel_Index_307": ME_Fuel_Index_307, "ME_Fuel_Oil_In_Pr_308": ME_Fuel_Oil_In_Pr_308, "ME_Fuel_Oil_Filter_In_309": ME_Fuel_Oil_Filter_In_309, "ME_Fuel_Oil_Filter_Out_310": ME_Fuel_Oil_Filter_Out_310, "ME_Fuel_Oil_Viscosity_Set_311": ME_Fuel_Oil_Viscosity_Set_311, "ME_Fuel_Oil_Viscosity_PV_312": ME_Fuel_Oil_Viscosity_PV_312,
        "ME_Fuel_Oil_Temp_In_313": ME_Fuel_Oil_Temp_In_313, "ME_Fuel_Rack_01_314": ME_Fuel_Rack_01_314, "ME_Fuel_Rack_02_315": ME_Fuel_Rack_02_315, "ME_Fuel_Rack_03_316": ME_Fuel_Rack_03_316, "ME_Fuel_Rack_04_317": ME_Fuel_Rack_04_317, "ME_Fuel_Rack_05_318": ME_Fuel_Rack_05_318, "ME_Fuel_Rack_06_319": ME_Fuel_Rack_06_319, "ME_Fuel_Rack_07_320": ME_Fuel_Rack_07_320, "ME_Fuel_Rack_08_321": ME_Fuel_Rack_08_321,
        "ME_VIT_Rack_01_322": ME_VIT_Rack_01_322, "ME_VIT_Rack_02_323": ME_VIT_Rack_02_323, "ME_VIT_Rack_03_324": ME_VIT_Rack_03_324, "ME_VIT_Rack_04_325": ME_VIT_Rack_04_325, "ME_VIT_Rack_05_326": ME_VIT_Rack_05_326, "ME_VIT_Rack_06_327": ME_VIT_Rack_06_327, "ME_VIT_Rack_07_328": ME_VIT_Rack_07_328, "ME_VIT_Rack_08_329": ME_VIT_Rack_08_329,
        "Atm_Pr_330": Atm_Pr_330, "ME_Scav_Pr_331": ME_Scav_Pr_331, "ME_Exh_Gas_Receiver_332": ME_Exh_Gas_Receiver_332, "Pr_Drop_Accross_TCh_Filter_333": Pr_Drop_Accross_TCh_Filter_333, "Pr_Drop_Accross_Air_Cooler_334": Pr_Drop_Accross_Air_Cooler_334, "Pr_Drop_Accross_EGE_335": Pr_Drop_Accross_EGE_335, "Air_Cooler_Temp_In_336": Air_Cooler_Temp_In_336, "Air_Cooler_Temp_Out_337": Air_Cooler_Temp_Out_337, "TCh_Exh_Gas_Temp_In_338": TCh_Exh_Gas_Temp_In_338, "TCh_Exh_Gas_Temp_Out_339": TCh_Exh_Gas_Temp_Out_339,
        "Exh_Gas_Temp_01_340": Exh_Gas_Temp_01_340, "Exh_Gas_Temp_02_341": Exh_Gas_Temp_02_341, "Exh_Gas_Temp_03_342": Exh_Gas_Temp_03_342, "Exh_Gas_Temp_04_343": Exh_Gas_Temp_04_343, "Exh_Gas_Temp_05_344": Exh_Gas_Temp_05_344, "Exh_Gas_Temp_06_345": Exh_Gas_Temp_06_345, "Exh_Gas_Temp_07_346": Exh_Gas_Temp_07_346, "Exh_Gas_Temp_08_347": Exh_Gas_Temp_08_347,
        "EGE_Temp_In_348": EGE_Temp_In_348, "EGE_Temp_Out_349": EGE_Temp_Out_349,
        "Pressures_Scav_Air_Pr_826": Pressures_Scav_Air_Pr_826, "Temperatures_Scav_Temp_827": Temperatures_Scav_Temp_827, "Exh_Temp_Out_01_828": Exh_Temp_Out_01_828, "Exh_Temp_Out_02_829": Exh_Temp_Out_02_829, "Exh_Temp_Out_03_830": Exh_Temp_Out_03_830, "Exh_Temp_Out_04_831": Exh_Temp_Out_04_831, "Exh_Temp_Out_05_832": Exh_Temp_Out_05_832, "Exh_Temp_Out_06_833": Exh_Temp_Out_06_833,
        "TCH_Temp_In_834": TCH_Temp_In_834, "TCH_Temp_Out_835": TCH_Temp_Out_835
      }
    }
    // AUXILIARY ENGINE Engine1 PORT
    if (formId == 1) {

      //None
      var Load_1 = (document.getElementById("Load_1") as HTMLInputElement).value
      var Amps_2 = (document.getElementById("Amps_2") as HTMLInputElement).value
      var Power_Factor_3 = (document.getElementById("Power_Factor_3") as HTMLInputElement).value
      var Voltage_4 = (document.getElementById("Voltage_4") as HTMLInputElement).value
      var Hours_Run_6 = (document.getElementById("Hours_Run_6") as HTMLInputElement).value
      var Gov_Index_7 = (document.getElementById("Gov_Index_7") as HTMLInputElement).value
      var Sump_Level_8 = (document.getElementById("Sump_Level_8") as HTMLInputElement).value
      var TCh_RPM_10 = (document.getElementById("TCh_RPM_10") as HTMLInputElement).value
      //Pressures
      var LO_Pressure_13 = (document.getElementById("LO_Pressure_13") as HTMLInputElement).value
      var Filter_LO_Pr_In_15 = (document.getElementById("Filter_LO_Pr_In_15") as HTMLInputElement).value
      var Filter_LO_Pr_Out_17 = (document.getElementById("Filter_LO_Pr_Out_17") as HTMLInputElement).value
      var TCh_LO_Pr_In_19 = (document.getElementById("TCh_LO_Pr_In_19") as HTMLInputElement).value
      //TEMPERATURES
      var LO_Inlet_Temp_20 = (document.getElementById("LO_Inlet_Temp_20") as HTMLInputElement).value
      var LO_Cooler_Temp_In_22 = (document.getElementById("LO_Cooler_Temp_In_22") as HTMLInputElement).value
      var LO_Cooler_Temp_Out_24 = (document.getElementById("LO_Cooler_Temp_Out_24") as HTMLInputElement).value
      var LO_TCh_Temp_In_26 = (document.getElementById("LO_TCh_Temp_In_26") as HTMLInputElement).value
      //FRESH WATER
      var Ht_Pr_In_28 = (document.getElementById("Ht_Pr_In_28") as HTMLInputElement).value
      var Lt_Pr_In_30 = (document.getElementById("Lt_Pr_In_30") as HTMLInputElement).value
      var Cooling_Water_Out_1_32 = (document.getElementById("Cooling_Water_Out_1_32") as HTMLInputElement).value
      var Cooling_Water_Out_2_33 = (document.getElementById("Cooling_Water_Out_2_33") as HTMLInputElement).value
      var Cooling_Water_Out_3_34 = (document.getElementById("Cooling_Water_Out_3_34") as HTMLInputElement).value
      var Cooling_Water_Out_4_36 = (document.getElementById("Cooling_Water_Out_4_36") as HTMLInputElement).value
      var Cooling_Water_Out_5_37 = (document.getElementById("Cooling_Water_Out_5_37") as HTMLInputElement).value
      var Cooling_Water_Out_6_39 = (document.getElementById("Cooling_Water_Out_6_39") as HTMLInputElement).value
      //SCAV AND EXH
      var Pressures_Scav_Air_Pr_35 = (document.getElementById("Pressures_Scav_Air_Pr_35") as HTMLInputElement).value
      var Temperatures_Scav_Temp_44 = (document.getElementById("Temperatures_Scav_Temp_44") as HTMLInputElement).value
      var Exh_Temp_Out_01_45 = (document.getElementById("Exh_Temp_Out_01_45") as HTMLInputElement).value
      var Exh_Temp_Out_02_46 = (document.getElementById("Exh_Temp_Out_02_46") as HTMLInputElement).value
      var Exh_Temp_Out_03_47 = (document.getElementById("Exh_Temp_Out_03_47") as HTMLInputElement).value
      var Exh_Temp_Out_04_48 = (document.getElementById("Exh_Temp_Out_04_48") as HTMLInputElement).value
      var Exh_Temp_Out_05_49 = (document.getElementById("Exh_Temp_Out_05_49") as HTMLInputElement).value
      var Exh_Temp_Out_06_50 = (document.getElementById("Exh_Temp_Out_06_50") as HTMLInputElement).value
      var TCH_Temp_In_51 = (document.getElementById("TCH_Temp_In_51") as HTMLInputElement).value
      var TCH_Temp_Out_52 = (document.getElementById("TCH_Temp_Out_52") as HTMLInputElement).value
      //ALTERNATOR
      var Bearing_1_Temp_38 = (document.getElementById("Bearing_1_Temp_38") as HTMLInputElement).value
      var Bearing_2_Temp_40 = (document.getElementById("Bearing_2_Temp_40") as HTMLInputElement).value
      var Winding_Temp_R_S_41 = (document.getElementById("Winding_Temp_R_S_41") as HTMLInputElement).value
      var Winding_Temp_S_T_42 = (document.getElementById("Winding_Temp_S_T_42") as HTMLInputElement).value
      var Winding_Temp_R_T_43 = (document.getElementById("Winding_Temp_R_T_43") as HTMLInputElement).value

      parameterdata = {
        "Load_1": Load_1, "Amps_2": Amps_2, "Power_Factor_3": Power_Factor_3, "Voltage_4": Voltage_4, "Hours_Run_6": Hours_Run_6, "Gov_Index_7": Gov_Index_7, "Sump_Level_8": Sump_Level_8, "TCh_RPM_10": TCh_RPM_10,
        "LO_Pressure_13": LO_Pressure_13, "Filter_LO_Pr_In_15": Filter_LO_Pr_In_15, "Filter_LO_Pr_Out_17": Filter_LO_Pr_Out_17, "TCh_LO_Pr_In_19": TCh_LO_Pr_In_19,
        "LO_Inlet_Temp_20": LO_Inlet_Temp_20, "LO_Cooler_Temp_In_22": LO_Cooler_Temp_In_22, "LO_Cooler_Temp_Out_24": LO_Cooler_Temp_Out_24, "LO_TCh_Temp_In_26": LO_TCh_Temp_In_26,
        "Ht_Pr_In_28": Ht_Pr_In_28, "Lt_Pr_In_30": Lt_Pr_In_30, "Cooling_Water_Out_1_32": Cooling_Water_Out_1_32, "Cooling_Water_Out_2_33": Cooling_Water_Out_2_33, "Cooling_Water_Out_3_34": Cooling_Water_Out_3_34, "Cooling_Water_Out_4_36": Cooling_Water_Out_4_36, "Cooling_Water_Out_5_37": Cooling_Water_Out_5_37, "Cooling_Water_Out_6_39": Cooling_Water_Out_6_39,
        "Pressures_Scav_Air_Pr_35": Pressures_Scav_Air_Pr_35, "Temperatures_Scav_Temp_44": Temperatures_Scav_Temp_44, "Exh_Temp_Out_01_45": Exh_Temp_Out_01_45, "Exh_Temp_Out_02_46": Exh_Temp_Out_02_46, "Exh_Temp_Out_03_47": Exh_Temp_Out_03_47, "Exh_Temp_Out_04_48": Exh_Temp_Out_04_48, "Exh_Temp_Out_05_49": Exh_Temp_Out_05_49, "Exh_Temp_Out_06_50": Exh_Temp_Out_06_50,
        "TCH_Temp_In_51": TCH_Temp_In_51, "TCH_Temp_Out_52": TCH_Temp_Out_52, "Bearing_1_Temp_38": Bearing_1_Temp_38, "Bearing_2_Temp_40": Bearing_2_Temp_40, "Winding_Temp_R_S_41": Winding_Temp_R_S_41, "Winding_Temp_S_T_42": Winding_Temp_S_T_42, "Winding_Temp_R_T_43": Winding_Temp_R_T_43
      }
    }

    // AUXILIARY ENGINE Engine2 (CENTER)
    if (formId == 20) {
      //None
      var Load_166 = (document.getElementById("Load_166") as HTMLInputElement).value
      var Amps_167 = (document.getElementById("Amps_167") as HTMLInputElement).value
      var Power_Factor_168 = (document.getElementById("Power_Factor_168") as HTMLInputElement).value
      var Voltage_169 = (document.getElementById("Voltage_169") as HTMLInputElement).value
      var Hours_Run_170 = (document.getElementById("Hours_Run_170") as HTMLInputElement).value
      var Gov_Index_171 = (document.getElementById("Gov_Index_171") as HTMLInputElement).value
      var Sump_Level_172 = (document.getElementById("Sump_Level_172") as HTMLInputElement).value
      var TCh_RPM_173 = (document.getElementById("TCh_RPM_173") as HTMLInputElement).value
      //Pressures
      var LO_Pressure_178 = (document.getElementById("LO_Pressure_178") as HTMLInputElement).value
      var Filter_LO_Pr_In_179 = (document.getElementById("Filter_LO_Pr_In_179") as HTMLInputElement).value
      var Filter_LO_Pr_Out_180 = (document.getElementById("Filter_LO_Pr_Out_180") as HTMLInputElement).value
      var TCh_LO_Pr_In_181 = (document.getElementById("TCh_LO_Pr_In_181") as HTMLInputElement).value
      //TEMPERATURES
      var LO_Inlet_Temp_190 = (document.getElementById("LO_Inlet_Temp_190") as HTMLInputElement).value
      var LO_Cooler_Temp_In_191 = (document.getElementById("LO_Cooler_Temp_In_191") as HTMLInputElement).value
      var LO_Cooler_Temp_Out_192 = (document.getElementById("LO_Cooler_Temp_Out_192") as HTMLInputElement).value
      var LO_TCh_Temp_In_193 = (document.getElementById("LO_TCh_Temp_In_193") as HTMLInputElement).value
      //FRESH WATER
      var Ht_Pr_In_200 = (document.getElementById("Ht_Pr_In_200") as HTMLInputElement).value
      var Lt_Pr_In_201 = (document.getElementById("Lt_Pr_In_201") as HTMLInputElement).value
      var Cooling_Water_Out_1_202 = (document.getElementById("Cooling_Water_Out_1_202") as HTMLInputElement).value
      var Cooling_Water_Out_2_203 = (document.getElementById("Cooling_Water_Out_2_203") as HTMLInputElement).value
      var Cooling_Water_Out_3_204 = (document.getElementById("Cooling_Water_Out_3_204") as HTMLInputElement).value
      var Cooling_Water_Out_4_205 = (document.getElementById("Cooling_Water_Out_4_205") as HTMLInputElement).value
      var Cooling_Water_Out_5_206 = (document.getElementById("Cooling_Water_Out_5_206") as HTMLInputElement).value
      var Cooling_Water_Out_6_207 = (document.getElementById("Cooling_Water_Out_6_207") as HTMLInputElement).value
      //SCAV AND EXH
      var Pressures_Scav_Air_Pr_216 = (document.getElementById("Pressures_Scav_Air_Pr_216") as HTMLInputElement).value
      var Temperatures_Scav_Temp_217 = (document.getElementById("Temperatures_Scav_Temp_217") as HTMLInputElement).value
      var Exh_Temp_Out_01_218 = (document.getElementById("Exh_Temp_Out_01_218") as HTMLInputElement).value
      var Exh_Temp_Out_02_219 = (document.getElementById("Exh_Temp_Out_02_219") as HTMLInputElement).value
      var Exh_Temp_Out_03_220 = (document.getElementById("Exh_Temp_Out_03_220") as HTMLInputElement).value
      var Exh_Temp_Out_04_221 = (document.getElementById("Exh_Temp_Out_04_221") as HTMLInputElement).value
      var Exh_Temp_Out_05_222 = (document.getElementById("Exh_Temp_Out_05_222") as HTMLInputElement).value
      var Exh_Temp_Out_06_223 = (document.getElementById("Exh_Temp_Out_06_223") as HTMLInputElement).value
      var TCH_Temp_In_229 = (document.getElementById("TCH_Temp_In_229") as HTMLInputElement).value
      var TCH_Temp_Out_231 = (document.getElementById("TCH_Temp_Out_231") as HTMLInputElement).value
      //ALTERNATOR
      var Bearing_1_Temp_239 = (document.getElementById("Bearing_1_Temp_239") as HTMLInputElement).value
      var Bearing_2_Temp_240 = (document.getElementById("Bearing_2_Temp_240") as HTMLInputElement).value
      var Winding_Temp_R_S_241 = (document.getElementById("Winding_Temp_R_S_241") as HTMLInputElement).value
      var Winding_Temp_S_T_242 = (document.getElementById("Winding_Temp_S_T_242") as HTMLInputElement).value
      var Winding_Temp_R_T_243 = (document.getElementById("Winding_Temp_R_T_243") as HTMLInputElement).value

      parameterdata = {
        "Load_166": Load_166, "Amps_167": Amps_167, "Power_Factor_168": Power_Factor_168, "Voltage_169": Voltage_169, "Hours_Run_170": Hours_Run_170, "Gov_Index_171": Gov_Index_171, "Sump_Level_172": Sump_Level_172, "TCh_RPM_173": TCh_RPM_173,
        "LO_Pressure_178": LO_Pressure_178, "Filter_LO_Pr_In_179": Filter_LO_Pr_In_179, "Filter_LO_Pr_Out_180": Filter_LO_Pr_Out_180, "TCh_LO_Pr_In_181": TCh_LO_Pr_In_181,
        "LO_Inlet_Temp_190": LO_Inlet_Temp_190, "LO_Cooler_Temp_In_191": LO_Cooler_Temp_In_191, "LO_Cooler_Temp_Out_192": LO_Cooler_Temp_Out_192, "LO_TCh_Temp_In_193": LO_TCh_Temp_In_193,
        "Ht_Pr_In_200": Ht_Pr_In_200, "Lt_Pr_In_201": Lt_Pr_In_201, "Cooling_Water_Out_1_202": Cooling_Water_Out_1_202, "Cooling_Water_Out_2_203": Cooling_Water_Out_2_203, "Cooling_Water_Out_3_204": Cooling_Water_Out_3_204, "Cooling_Water_Out_4_205": Cooling_Water_Out_4_205, "Cooling_Water_Out_5_206": Cooling_Water_Out_5_206, "Cooling_Water_Out_6_207": Cooling_Water_Out_6_207,
        "Pressures_Scav_Air_Pr_216": Pressures_Scav_Air_Pr_216, "Temperatures_Scav_Temp_217": Temperatures_Scav_Temp_217, "Exh_Temp_Out_01_218": Exh_Temp_Out_01_218, "Exh_Temp_Out_02_219": Exh_Temp_Out_02_219, "Exh_Temp_Out_03_220": Exh_Temp_Out_03_220, "Exh_Temp_Out_04_221": Exh_Temp_Out_04_221, "Exh_Temp_Out_05_222": Exh_Temp_Out_05_222, "Exh_Temp_Out_06_223": Exh_Temp_Out_06_223,
        "TCH_Temp_In_229": TCH_Temp_In_229, "TCH_Temp_Out_231": TCH_Temp_Out_231, "Bearing_1_Temp_239": Bearing_1_Temp_239, "Bearing_2_Temp_240": Bearing_2_Temp_240, "Winding_Temp_R_S_241": Winding_Temp_R_S_241, "Winding_Temp_S_T_242": Winding_Temp_S_T_242, "Winding_Temp_R_T_243": Winding_Temp_R_T_243
      }
    }

    // AUXILIARY ENGINE Engine3(STBD)
    if (formId == 21) {
      //None
      var Load_248 = (document.getElementById("Load_248") as HTMLInputElement).value
      var Amps_249 = (document.getElementById("Amps_249") as HTMLInputElement).value
      var Power_Factor_250 = (document.getElementById("Power_Factor_250") as HTMLInputElement).value
      var Voltage_251 = (document.getElementById("Voltage_251") as HTMLInputElement).value
      var Hours_Run_252 = (document.getElementById("Hours_Run_252") as HTMLInputElement).value
      var Gov_Index_253 = (document.getElementById("Gov_Index_253") as HTMLInputElement).value
      var Sump_Level_254 = (document.getElementById("Sump_Level_254") as HTMLInputElement).value
      var TCh_RPM_255 = (document.getElementById("TCh_RPM_255") as HTMLInputElement).value
      //Pressures
      var LO_Pressure_256 = (document.getElementById("LO_Pressure_256") as HTMLInputElement).value
      var Filter_LO_Pr_In_257 = (document.getElementById("Filter_LO_Pr_In_257") as HTMLInputElement).value
      var Filter_LO_Pr_Out_258 = (document.getElementById("Filter_LO_Pr_Out_258") as HTMLInputElement).value
      var TCh_LO_Pr_In_259 = (document.getElementById("TCh_LO_Pr_In_259") as HTMLInputElement).value
      //TEMPERATURES
      var LO_Inlet_Temp_260 = (document.getElementById("LO_Inlet_Temp_260") as HTMLInputElement).value
      var LO_Cooler_Temp_In_261 = (document.getElementById("LO_Cooler_Temp_In_261") as HTMLInputElement).value
      var LO_Cooler_Temp_Out_262 = (document.getElementById("LO_Cooler_Temp_Out_262") as HTMLInputElement).value
      var LO_TCh_Temp_In_263 = (document.getElementById("LO_TCh_Temp_In_263") as HTMLInputElement).value
      //FRESH WATER
      var Ht_Pr_In_265 = (document.getElementById("Ht_Pr_In_265") as HTMLInputElement).value
      var Lt_Pr_In_266 = (document.getElementById("Lt_Pr_In_266") as HTMLInputElement).value
      var Cooling_Water_Out_1_267 = (document.getElementById("Cooling_Water_Out_1_267") as HTMLInputElement).value
      var Cooling_Water_Out_2_268 = (document.getElementById("Cooling_Water_Out_2_268") as HTMLInputElement).value
      var Cooling_Water_Out_3_269 = (document.getElementById("Cooling_Water_Out_3_269") as HTMLInputElement).value
      var Cooling_Water_Out_4_270 = (document.getElementById("Cooling_Water_Out_4_270") as HTMLInputElement).value
      var Cooling_Water_Out_5_271 = (document.getElementById("Cooling_Water_Out_5_271") as HTMLInputElement).value
      var Cooling_Water_Out_6_272 = (document.getElementById("Cooling_Water_Out_6_272") as HTMLInputElement).value
      //SCAV AND EXH
      var Pressures_Scav_Air_Pr_275 = (document.getElementById("Pressures_Scav_Air_Pr_275") as HTMLInputElement).value
      var Temperatures_Scav_Temp_276 = (document.getElementById("Temperatures_Scav_Temp_276") as HTMLInputElement).value
      var Exh_Temp_Out_01_278 = (document.getElementById("Exh_Temp_Out_01_278") as HTMLInputElement).value
      var Exh_Temp_Out_02_279 = (document.getElementById("Exh_Temp_Out_02_279") as HTMLInputElement).value
      var Exh_Temp_Out_03_280 = (document.getElementById("Exh_Temp_Out_03_280") as HTMLInputElement).value
      var Exh_Temp_Out_04_281 = (document.getElementById("Exh_Temp_Out_04_281") as HTMLInputElement).value
      var Exh_Temp_Out_05_282 = (document.getElementById("Exh_Temp_Out_05_282") as HTMLInputElement).value
      var Exh_Temp_Out_06_283 = (document.getElementById("Exh_Temp_Out_06_283") as HTMLInputElement).value
      var TCH_Temp_In_286 = (document.getElementById("TCH_Temp_In_286") as HTMLInputElement).value
      var TCH_Temp_Out_287 = (document.getElementById("TCH_Temp_Out_287") as HTMLInputElement).value
      //ALTERNATOR
      var Bearing_1_Temp_289 = (document.getElementById("Bearing_1_Temp_289") as HTMLInputElement).value
      var Bearing_2_Temp_290 = (document.getElementById("Bearing_2_Temp_290") as HTMLInputElement).value
      var Winding_Temp_R_S_291 = (document.getElementById("Winding_Temp_R_S_291") as HTMLInputElement).value
      var Winding_Temp_S_T_292 = (document.getElementById("Winding_Temp_S_T_292") as HTMLInputElement).value
      var Winding_Temp_R_T_293 = (document.getElementById("Winding_Temp_R_T_293") as HTMLInputElement).value

      parameterdata = {
        "Load_248": Load_248, "Amps_249": Amps_249, "Power_Factor_250": Power_Factor_250, "Voltage_251": Voltage_251, "Hours_Run_252": Hours_Run_252, "Gov_Index_253": Gov_Index_253, "Sump_Level_254": Sump_Level_254, "TCh_RPM_255": TCh_RPM_255,
        "LO_Pressure_256": LO_Pressure_256, "Filter_LO_Pr_In_257": Filter_LO_Pr_In_257, "Filter_LO_Pr_Out_258": Filter_LO_Pr_Out_258, "TCh_LO_Pr_In_259": TCh_LO_Pr_In_259,
        "LO_Inlet_Temp_260": LO_Inlet_Temp_260, "LO_Cooler_Temp_In_261": LO_Cooler_Temp_In_261, "LO_Cooler_Temp_Out_262": LO_Cooler_Temp_Out_262, "LO_TCh_Temp_In_263": LO_TCh_Temp_In_263,
        "Ht_Pr_In_265": Ht_Pr_In_265, "Lt_Pr_In_266": Lt_Pr_In_266, "Cooling_Water_Out_1_267": Cooling_Water_Out_1_267, "Cooling_Water_Out_2_268": Cooling_Water_Out_2_268, "Cooling_Water_Out_3_269": Cooling_Water_Out_3_269, "Cooling_Water_Out_4_270": Cooling_Water_Out_4_270, "Cooling_Water_Out_5_271": Cooling_Water_Out_5_271, "Cooling_Water_Out_6_272": Cooling_Water_Out_6_272,
        "Pressures_Scav_Air_Pr_275": Pressures_Scav_Air_Pr_275, "Temperatures_Scav_Temp_276": Temperatures_Scav_Temp_276, "Exh_Temp_Out_01_278": Exh_Temp_Out_01_278, "Exh_Temp_Out_02_279": Exh_Temp_Out_02_279, "Exh_Temp_Out_03_280": Exh_Temp_Out_03_280, "Exh_Temp_Out_04_281": Exh_Temp_Out_04_281, "Exh_Temp_Out_05_282": Exh_Temp_Out_05_282, "Exh_Temp_Out_06_283": Exh_Temp_Out_06_283,
        "TCH_Temp_In_286": TCH_Temp_In_286, "TCH_Temp_Out_287": TCH_Temp_Out_287, "Bearing_1_Temp_289": Bearing_1_Temp_289, "Bearing_2_Temp_290": Bearing_2_Temp_290, "Winding_Temp_R_S_291": Winding_Temp_R_S_291, "Winding_Temp_S_T_292": Winding_Temp_S_T_292, "Winding_Temp_R_T_293": Winding_Temp_R_T_293
      }
    }
    //Reefer Equipment1
    if (formId == 2) {
      var Suction_Pr_5 = (document.getElementById("Suction_Pr_5") as HTMLInputElement).value
      var Discharge_Pr_9 = (document.getElementById("Discharge_Pr_9") as HTMLInputElement).value
      var Oil_Pr_11 = (document.getElementById("Oil_Pr_11") as HTMLInputElement).value
      var Sump_Level_12 = (document.getElementById("Sump_Level_12") as HTMLInputElement).value
      var Meat_Room_14 = (document.getElementById("Meat_Room_14") as HTMLInputElement).value
      var Fish_Room_16 = (document.getElementById("Fish_Room_16") as HTMLInputElement).value
      var Veg_Room_18 = (document.getElementById("Veg_Room_18") as HTMLInputElement).value
      var Lobby_Room_21 = (document.getElementById("Lobby_Room_21") as HTMLInputElement).value
      var Dairy_Room_23 = (document.getElementById("Dairy_Room_23") as HTMLInputElement).value
      var Misc_Space_25 = (document.getElementById("Misc_Space_25") as HTMLInputElement).value
      var Condensor_Cooling_Water_In_27 = (document.getElementById("Condensor_Cooling_Water_In_27") as HTMLInputElement).value
      var Condensor_Cooling_Water_out_29 = (document.getElementById("Condensor_Cooling_Water_out_29") as HTMLInputElement).value
      var Refrigerant_Level_31 = (document.getElementById("Refrigerant_Level_31") as HTMLInputElement).value
      parameterdata = {
        "Suction_Pr_5": Suction_Pr_5, "Discharge_Pr_9": Discharge_Pr_9, "Oil_Pr_11": Oil_Pr_11, "Sump_Level_12": Sump_Level_12, "Meat_Room_14": Meat_Room_14,
        "Fish_Room_16": Fish_Room_16, "Veg_Room_18": Veg_Room_18, "Lobby_Room_21": Lobby_Room_21, "Dairy_Room_23": Dairy_Room_23, "Misc_Space_25": Misc_Space_25, "Condensor_Cooling_Water_In_27": Condensor_Cooling_Water_In_27,
        "Condensor_Cooling_Water_out_29": Condensor_Cooling_Water_out_29, "Refrigerant_Level_31": Refrigerant_Level_31
      }
    }

    //Reefer Equipment 2
    if (formId == 3) {
      var Suction_Pr_53 = (document.getElementById("Suction_Pr_53") as HTMLInputElement).value
      var Discharge_Pr_54 = (document.getElementById("Discharge_Pr_54") as HTMLInputElement).value
      var Oil_Pr_55 = (document.getElementById("Oil_Pr_55") as HTMLInputElement).value
      var Sump_Level_56 = (document.getElementById("Sump_Level_56") as HTMLInputElement).value
      var Meat_Room_57 = (document.getElementById("Meat_Room_57") as HTMLInputElement).value
      var Fish_Room_58 = (document.getElementById("Fish_Room_58") as HTMLInputElement).value
      var Veg_Room_59 = (document.getElementById("Veg_Room_59") as HTMLInputElement).value
      var Lobby_Room_60 = (document.getElementById("Lobby_Room_60") as HTMLInputElement).value
      var Dairy_Room_61 = (document.getElementById("Dairy_Room_61") as HTMLInputElement).value
      var Misc_Space_62 = (document.getElementById("Misc_Space_62") as HTMLInputElement).value
      var Condensor_Cooling_Water_In_63 = (document.getElementById("Condensor_Cooling_Water_In_63") as HTMLInputElement).value
      var Condensor_Cooling_Water_out_64 = (document.getElementById("Condensor_Cooling_Water_out_64") as HTMLInputElement).value
      var Refrigerant_Level_65 = (document.getElementById("Refrigerant_Level_65") as HTMLInputElement).value
      parameterdata = {
        "Suction_Pr_53": Suction_Pr_53, "Discharge_Pr_54": Discharge_Pr_54, "Oil_Pr_55": Oil_Pr_55, "Sump_Level_56": Sump_Level_56, "Meat_Room_57": Meat_Room_57,
        "Fish_Room_58": Fish_Room_58, "Veg_Room_59": Veg_Room_59, "Lobby_Room_60": Lobby_Room_60, "Dairy_Room_61": Dairy_Room_61, "Misc_Space_62": Misc_Space_62, "Condensor_Cooling_Water_In_63": Condensor_Cooling_Water_In_63,
        "Condensor_Cooling_Water_out_64": Condensor_Cooling_Water_out_64, "Refrigerant_Level_65": Refrigerant_Level_65
      }
    }

    //Air Condition 1
    if (formId == 4) {
      var Suction_Pr_66 = (document.getElementById("Suction_Pr_66") as HTMLInputElement).value
      var Discharge_Pr_67 = (document.getElementById("Discharge_Pr_67") as HTMLInputElement).value
      var Oil_Pr_68 = (document.getElementById("Oil_Pr_68") as HTMLInputElement).value
      var Sump_Level_69 = (document.getElementById("Sump_Level_69") as HTMLInputElement).value
      var Refrigerant_Level_70 = (document.getElementById("Refrigerant_Level_70") as HTMLInputElement).value
      var Compressor_Amps_71 = (document.getElementById("Compressor_Amps_71") as HTMLInputElement).value
      parameterdata = {
        "Suction_Pr_66": Suction_Pr_66, "Discharge_Pr_67": Discharge_Pr_67, "Oil_Pr_68": Oil_Pr_68, "Sump_Level_69": Sump_Level_69, "Refrigerant_Level_70": Refrigerant_Level_70,
        "Compressor_Amps_71": Compressor_Amps_71
      }
    }
    //Air Condition 2
    if (formId == 5) {
      var Suction_Pr_72 = (document.getElementById("Suction_Pr_72") as HTMLInputElement).value
      var Discharge_Pr_73 = (document.getElementById("Discharge_Pr_73") as HTMLInputElement).value
      var Oil_Pr_74 = (document.getElementById("Oil_Pr_74") as HTMLInputElement).value
      var Sump_Level_75 = (document.getElementById("Sump_Level_75") as HTMLInputElement).value
      var Refrigerant_Level_76 = (document.getElementById("Refrigerant_Level_76") as HTMLInputElement).value
      var Compressor_Amps_77 = (document.getElementById("Compressor_Amps_77") as HTMLInputElement).value
      parameterdata = {
        "Suction_Pr_72": Suction_Pr_72, "Discharge_Pr_73": Discharge_Pr_73, "Oil_Pr_74": Oil_Pr_74, "Sump_Level_75": Sump_Level_75, "Refrigerant_Level_76": Refrigerant_Level_76,
        "Compressor_Amps_77": Compressor_Amps_77
      }
    }
    //AIR CONDITION AHU 1
    if (formId == 6) {
      var AHU_IN_78 = (document.getElementById("AHU_IN_78") as HTMLInputElement).value
      var AHU_Out_79 = (document.getElementById("AHU_Out_79") as HTMLInputElement).value
      var Blower_AMPS_80 = (document.getElementById("Blower_AMPS_80") as HTMLInputElement).value
      parameterdata = { "AHU_IN_78": AHU_IN_78, "AHU_Out_79": AHU_Out_79, "Blower_AMPS_80": Blower_AMPS_80 }
    }

    //AIR CONDITION AHU 2
    if (formId == 7) {
      var AHU_IN_81 = (document.getElementById("AHU_IN_81") as HTMLInputElement).value
      var AHU_Out_82 = (document.getElementById("AHU_Out_82") as HTMLInputElement).value
      var Blower_AMPS_83 = (document.getElementById("Blower_AMPS_83") as HTMLInputElement).value
      parameterdata = { "AHU_IN_81": AHU_IN_81, "AHU_Out_82": AHU_Out_82, "Blower_AMPS_83": Blower_AMPS_83 }
    }

    //"Main Air Compr 1"
    if (formId == 8) {
      var Suction_Pr_84 = (document.getElementById("Suction_Pr_84") as HTMLInputElement).value
      var Discharge_Pr_85 = (document.getElementById("Discharge_Pr_85") as HTMLInputElement).value
      var Lube_Oil_Pr_86 = (document.getElementById("Lube_Oil_Pr_86") as HTMLInputElement).value
      var Cooling_Water_Pr_87 = (document.getElementById("Cooling_Water_Pr_87") as HTMLInputElement).value
      var Air_Temp_88 = (document.getElementById("Air_Temp_88") as HTMLInputElement).value
      var Compressor_Amps_89 = (document.getElementById("Compressor_Amps_89") as HTMLInputElement).value
      var Oil_Level_90 = (document.getElementById("Oil_Level_90") as HTMLInputElement).value
      parameterdata = {
        "Suction_Pr_84": Suction_Pr_84, "Discharge_Pr_85": Discharge_Pr_85, "Lube_Oil_Pr_86": Lube_Oil_Pr_86, "Cooling_Water_Pr_87": Cooling_Water_Pr_87,
        "Air_Temp_88": Air_Temp_88, "Compressor_Amps_89": Compressor_Amps_89, "Oil_Level_90": Oil_Level_90
      }
    }
    //"Main Air Compr 2"
    if (formId == 9) {
      var Suction_Pr_91 = (document.getElementById("Suction_Pr_91") as HTMLInputElement).value
      var Discharge_Pr_92 = (document.getElementById("Discharge_Pr_92") as HTMLInputElement).value
      var Lube_Oil_Pr_93 = (document.getElementById("Lube_Oil_Pr_93") as HTMLInputElement).value
      var Cooling_Water_Pr_94 = (document.getElementById("Cooling_Water_Pr_94") as HTMLInputElement).value
      var Air_Temp_95 = (document.getElementById("Air_Temp_95") as HTMLInputElement).value
      var Compressor_Amps_97 = (document.getElementById("Compressor_Amps_97") as HTMLInputElement).value
      var Oil_Level_99 = (document.getElementById("Oil_Level_99") as HTMLInputElement).value
      parameterdata = {
        "Suction_Pr_91": Suction_Pr_91, "Discharge_Pr_92": Discharge_Pr_92, "Lube_Oil_Pr_93": Lube_Oil_Pr_93, "Cooling_Water_Pr_94": Cooling_Water_Pr_94,
        "Air_Temp_95": Air_Temp_95, "Compressor_Amps_97": Compressor_Amps_97, "Oil_Level_99": Oil_Level_99
      }
    }

    //Control Air Compr
    if (formId == 10) {
      var Suction_Pr_96 = (document.getElementById("Suction_Pr_96") as HTMLInputElement).value
      var Discharge_Pr_98 = (document.getElementById("Discharge_Pr_98") as HTMLInputElement).value
      var Lube_Oil_Pr_100 = (document.getElementById("Lube_Oil_Pr_100") as HTMLInputElement).value
      var Cooling_Water_Pr_101 = (document.getElementById("Cooling_Water_Pr_101") as HTMLInputElement).value
      var Air_Temp_103 = (document.getElementById("Air_Temp_103") as HTMLInputElement).value
      var Compressor_Amps_104 = (document.getElementById("Compressor_Amps_104") as HTMLInputElement).value
      var Oil_Level_107 = (document.getElementById("Oil_Level_107") as HTMLInputElement).value
      parameterdata = {
        "Suction_Pr_96": Suction_Pr_96, "Discharge_Pr_98": Discharge_Pr_98, "Lube_Oil_Pr_100": Lube_Oil_Pr_100, "Cooling_Water_Pr_101": Cooling_Water_Pr_101,
        "Air_Temp_103": Air_Temp_103, "Compressor_Amps_104": Compressor_Amps_104, "Oil_Level_107": Oil_Level_107
      }
    }

    //"Service Air Compr"
    if (formId == 11) {
      var Suction_Pr_102 = (document.getElementById("Suction_Pr_102") as HTMLInputElement).value
      var Discharge_Pr_105 = (document.getElementById("Discharge_Pr_105") as HTMLInputElement).value
      var Lube_Oil_Pr_106 = (document.getElementById("Lube_Oil_Pr_106") as HTMLInputElement).value
      var Cooling_Water_Pr_108 = (document.getElementById("Cooling_Water_Pr_108") as HTMLInputElement).value
      var Air_Temp_109 = (document.getElementById("Air_Temp_109") as HTMLInputElement).value
      var Compressor_Amps_110 = (document.getElementById("Compressor_Amps_110") as HTMLInputElement).value
      var Oil_Level_111 = (document.getElementById("Oil_Level_111") as HTMLInputElement).value
      parameterdata = {
        "Suction_Pr_102": Suction_Pr_102, "Discharge_Pr_105": Discharge_Pr_105, "Lube_Oil_Pr_106": Lube_Oil_Pr_106, "Cooling_Water_Pr_108": Cooling_Water_Pr_108,
        "Air_Temp_109": Air_Temp_109, "Compressor_Amps_110": Compressor_Amps_110, "Oil_Level_111": Oil_Level_111
      }
    }

    //Control Air Dryers
    if (formId == 12) {
      var Suction_Pr_112 = (document.getElementById("Suction_Pr_112") as HTMLInputElement).value
      var Discharge_Pr_113 = (document.getElementById("Discharge_Pr_113") as HTMLInputElement).value
      var Air_Temp_114 = (document.getElementById("Air_Temp_114") as HTMLInputElement).value
      parameterdata = { "Suction_Pr_112": Suction_Pr_112, "Discharge_Pr_113": Discharge_Pr_113, "Air_Temp_114": Air_Temp_114 }
    }

    //FRESH WATER GENERATOR
    if (formId == 13) {
      var Ejector_Pump_Pr_115 = (document.getElementById("Ejector_Pump_Pr_115") as HTMLInputElement).value
      var JCW_Temp_In_In_116 = (document.getElementById("JCW_Temp_In_In_116") as HTMLInputElement).value
      var JCW_Temp_In_Out_117 = (document.getElementById("JCW_Temp_In_Out_117") as HTMLInputElement).value
      var Shell_Temp_118 = (document.getElementById("Shell_Temp_118") as HTMLInputElement).value
      var Vaccum_119 = (document.getElementById("Vaccum_119") as HTMLInputElement).value
      var Water_Made_120 = (document.getElementById("Water_Made_120") as HTMLInputElement).value
      var Salinity_121 = (document.getElementById("Salinity_121") as HTMLInputElement).value
      parameterdata = { "Ejector_Pump_Pr_115": Ejector_Pump_Pr_115, "JCW_Temp_In_In_116": JCW_Temp_In_In_116, "JCW_Temp_In_Out_117": JCW_Temp_In_Out_117, "Shell_Temp_118": Shell_Temp_118, "Vaccum_119": Vaccum_119, "Water_Made_120": Water_Made_120, "Salinity_121": Salinity_121 }
    }
    //Purifiers
    if (formId == 14) {
      var Inlet_Temp_122 = (document.getElementById("Inlet_Temp_122") as HTMLInputElement).value
      var Amps_123 = (document.getElementById("Amps_123") as HTMLInputElement).value
      var Pressure_124 = (document.getElementById("Pressure_124") as HTMLInputElement).value
      var Running_Hour_Counter_125 = (document.getElementById("Running_Hour_Counter_125") as HTMLInputElement).value
      var Inlet_Temp_127 = (document.getElementById("Inlet_Temp_127") as HTMLInputElement).value
      var Amps_128 = (document.getElementById("Amps_128") as HTMLInputElement).value
      var Pressure_129 = (document.getElementById("Pressure_129") as HTMLInputElement).value
      var Running_Hour_Counter_130 = (document.getElementById("Running_Hour_Counter_130") as HTMLInputElement).value
      var Inlet_Temp_131 = (document.getElementById("Inlet_Temp_131") as HTMLInputElement).value
      var Amps_132 = (document.getElementById("Amps_132") as HTMLInputElement).value
      var Pressure_133 = (document.getElementById("Pressure_133") as HTMLInputElement).value
      var Running_Hour_Counter_134 = (document.getElementById("Running_Hour_Counter_134") as HTMLInputElement).value
      var Inlet_Temp_135 = (document.getElementById("Inlet_Temp_135") as HTMLInputElement).value
      var Amps_136 = (document.getElementById("Amps_136") as HTMLInputElement).value
      var Pressure_137 = (document.getElementById("Pressure_137") as HTMLInputElement).value
      var Running_Hour_Counter_138 = (document.getElementById("Running_Hour_Counter_138") as HTMLInputElement).value
      var Inlet_Temp_139 = (document.getElementById("Inlet_Temp_139") as HTMLInputElement).value
      var Amps_140 = (document.getElementById("Amps_140") as HTMLInputElement).value
      var Pressure_141 = (document.getElementById("Pressure_141") as HTMLInputElement).value
      var Running_Hour_Counter_142 = (document.getElementById("Running_Hour_Counter_142") as HTMLInputElement).value

      parameterdata = {
        "Inlet_Temp_122": Inlet_Temp_122, "Amps_123": Amps_123, "Pressure_124": Pressure_124, "Running_Hour_Counter_125": Running_Hour_Counter_125,
        "Inlet_Temp_127": Inlet_Temp_127, "Amps_128": Amps_128, "Pressure_129": Pressure_129, "Running_Hour_Counter_130": Running_Hour_Counter_130,
        "Inlet_Temp_131": Inlet_Temp_131, "Amps_132": Amps_132, "Pressure_133": Pressure_133, "Running_Hour_Counter_134": Running_Hour_Counter_134,
        "Inlet_Temp_135": Inlet_Temp_135, "Amps_136": Amps_136, "Pressure_137": Pressure_137, "Running_Hour_Counter_138": Running_Hour_Counter_138,
        "Inlet_Temp_139": Inlet_Temp_139, "Amps_140": Amps_140, "Pressure_141": Pressure_141, "Running_Hour_Counter_142": Running_Hour_Counter_142
      }
    }
    //Incinerator
    if (formId == 15) {
      var el1 = document.getElementById("Running_126") as HTMLInputElement;
      var Running_126 = el1 ? el1.value : '';

      var el2 = document.getElementById("Furnace_Pr_144") as HTMLInputElement;
      var Furnace_Pr_144 = el2 ? el2.value : '';

      var el3 = document.getElementById("Uptake_Temp_146") as HTMLInputElement;
      var Uptake_Temp_146 = el3 ? el3.value : '';

      var el4 = document.getElementById("Waste_Oil_Tank_Temp_147") as HTMLInputElement;
      var Waste_Oil_Tank_Temp_147 = el4 ? el4.value : '';

      var el5 = document.getElementById("Running_Hours_149") as HTMLInputElement;
      var Running_Hours_149 = el5 ? el5.value : '';

      parameterdata = {
        "Running_126": Running_126,
        "Furnace_Pr_144": Furnace_Pr_144,
        "Uptake_Temp_146": Uptake_Temp_146,
        "Waste_Oil_Tank_Temp_147": Waste_Oil_Tank_Temp_147,
        "Running_Hours_149": Running_Hours_149
      };
    }

    //Oily Water Seperator
    if (formId == 16) {
      var el1 = document.getElementById("Running_143") as HTMLInputElement;
      var Running_143 = el1 ? el1.value : '';

      var el2 = document.getElementById("System_Pressure_145") as HTMLInputElement;
      var System_Pressure_145 = el2 ? el2.value : '';

      var el3 = document.getElementById("PPM_Outlet_148") as HTMLInputElement;
      var PPM_Outlet_148 = el3 ? el3.value : '';

      parameterdata = {
        "Running_143": Running_143,
        "System_Pressure_145": System_Pressure_145,
        "PPM_Outlet_148": PPM_Outlet_148
      };
    }

    //Sewage Treatment Plan
    if (formId == 17) {
      var Running_Hrs_150 = (document.getElementById("Running_Hrs_150") as HTMLInputElement).value
      var Blower_Pr_152 = (document.getElementById("Blower_Pr_152") as HTMLInputElement).value
      var Dosing_Pumps_Run_153 = (document.getElementById("Dosing_Pumps_Run_153") as HTMLInputElement).value
      parameterdata = { "Running_Hrs_150": Running_Hrs_150, "Blower_Pr_152": Blower_Pr_152, "Dosing_Pumps_Run_153": Dosing_Pumps_Run_153 }
    }

    //Boiler
    if (formId == 18) {
      var el1 = document.getElementById("Running_151") as HTMLInputElement;
      var Running_151 = el1 ? el1.value : '';

      var el2 = document.getElementById("Fuel_Oil_Pr_154") as HTMLInputElement;
      var Fuel_Oil_Pr_154 = el2 ? el2.value : '';

      var el3 = document.getElementById("Furnace_Draft_155") as HTMLInputElement;
      var Furnace_Draft_155 = el3 ? el3.value : '';

      var el4 = document.getElementById("Steam_Pr_158") as HTMLInputElement;
      var Steam_Pr_158 = el4 ? el4.value : '';

      var el5 = document.getElementById("Water_Level_160") as HTMLInputElement;
      var Water_Level_160 = el5 ? el5.value : '';

      var el6 = document.getElementById("Hot_Well_Temp_162") as HTMLInputElement;
      var Hot_Well_Temp_162 = el6 ? el6.value : '';

      var el7 = document.getElementById("Salinity_164") as HTMLInputElement;
      var Salinity_164 = el7 ? el7.value : '';

      var el8 = document.getElementById("Oil_Content_165") as HTMLInputElement;
      var Oil_Content_165 = el8 ? el8.value : '';

      parameterdata = {
        "Running_151": Running_151,
        "Fuel_Oil_Pr_154": Fuel_Oil_Pr_154,
        "Furnace_Draft_155": Furnace_Draft_155,
        "Steam_Pr_158": Steam_Pr_158,
        "Water_Level_160": Water_Level_160,
        "Hot_Well_Temp_162": Hot_Well_Temp_162,
        "Salinity_164": Salinity_164,
        "Oil_Content_165": Oil_Content_165
      };
    }

    //Steering Gears
    if (formId == 19) {
      var el1 = document.getElementById("1_Run_156") as HTMLInputElement;
      var Run_156_1 = el1 ? el1.value : '';

      var el2 = document.getElementById("Oil_Level_157") as HTMLInputElement;
      var Oil_Level_157 = el2 ? el2.value : '';

      var el3 = document.getElementById("Oil_Temp_159") as HTMLInputElement;
      var Oil_Temp_159 = el3 ? el3.value : '';

      var el4 = document.getElementById("Motor_Amps_161") as HTMLInputElement;
      var Motor_Amps_161 = el4 ? el4.value : '';

      var el5 = document.getElementById("2_Run_163") as HTMLInputElement;
      var Run_163_2 = el5 ? el5.value : '';

      var el6 = document.getElementById("Oil_Level_352") as HTMLInputElement;
      var Oil_Level_352 = el6 ? el6.value : '';

      var el7 = document.getElementById("Oil_Temp_353") as HTMLInputElement;
      var Oil_Temp_353 = el7 ? el7.value : '';

      var el8 = document.getElementById("Motor_Amps_354") as HTMLInputElement;
      var Motor_Amps_354 = el8 ? el8.value : '';

      parameterdata = {
        "1_Run_156": Run_156_1,
        "Oil_Level_157": Oil_Level_157,
        "Oil_Temp_159": Oil_Temp_159,
        "Motor_Amps_161": Motor_Amps_161,
        "2_Run_163": Run_163_2,
        "Oil_Level_352": Oil_Level_352,
        "Oil_Temp_353": Oil_Temp_353,
        "Motor_Amps_354": Motor_Amps_354
      };
    }

    //Running Hours and consumptions
    if (formId == 45) {
      var Main_Engine_836 = (document.getElementById("Main_Engine_836") as HTMLInputElement).value
      var Running_Hours_1_837 = (document.getElementById("Running_Hours_1_837") as HTMLInputElement).value
      var Aux_Engine_1_840 = (document.getElementById("Aux_Engine_1_840") as HTMLInputElement).value
      var Running_Hours_2_842 = (document.getElementById("Running_Hours_2_842") as HTMLInputElement).value
      var Aux_Engine_2_844 = (document.getElementById("Aux_Engine_2_844") as HTMLInputElement).value
      var Running_Hours_3_847 = (document.getElementById("Running_Hours_3_847") as HTMLInputElement).value
      var Aux_Engine_3_849 = (document.getElementById("Aux_Engine_3_849") as HTMLInputElement).value
      var Running_Hours_4_852 = (document.getElementById("Running_Hours_4_852") as HTMLInputElement).value
      var Fresh_water_generator_854 = (document.getElementById("Fresh_water_generator_854") as HTMLInputElement).value
      var Running_Hours_5_857 = (document.getElementById("Running_Hours_5_857") as HTMLInputElement).value
      //WORK DONE
      var Work_done_863 = (document.getElementById("Work_done_863") as HTMLInputElement).value
      //TANK ROBS
      var Tank_Name_1_864 = this.session.get('tank1');//(document.getElementById("Tank_Name_1_864") as HTMLInputElement).value
      var ROB_1_866 = (document.getElementById("ROB_1_866") as HTMLInputElement).value
      var MT_1_867 = (document.getElementById("MT_1_867") as HTMLInputElement).value
      var Tank_Name_2_868 = this.session.get('tank2');//(document.getElementById("Tank_Name_2_868") as HTMLInputElement).value
      var ROB_2_869 = (document.getElementById("ROB_2_869") as HTMLInputElement).value
      var MT_2_870 = (document.getElementById("MT_2_870") as HTMLInputElement).value
      var Tank_Name_3_871 = this.session.get('tank3');//(document.getElementById("Tank_Name_3_871") as HTMLInputElement).value
      var ROB_3_875 = (document.getElementById("ROB_3_875") as HTMLInputElement).value
      var MT_3_876 = (document.getElementById("MT_3_876") as HTMLInputElement).value
      var Tank_Name_4_878 = this.session.get('tank4');//(document.getElementById("Tank_Name_4_878") as HTMLInputElement).value
      var ROB_4_879 = (document.getElementById("ROB_4_879") as HTMLInputElement).value
      var MT_4_881 = (document.getElementById("MT_4_881") as HTMLInputElement).value
      var Tank_Name_5_882 = this.session.get('tank5');//this.session.get('tank5');//(document.getElementById("Tank_Name_5_882") as HTMLInputElement).value
      var ROB_5_884 = (document.getElementById("ROB_5_884") as HTMLInputElement).value
      var MT_5_885 = (document.getElementById("MT_5_885") as HTMLInputElement).value
      var Tank_Name_6_886 = this.session.get('tank6');//(document.getElementById("Tank_Name_6_886") as HTMLInputElement).value
      var ROB_6_887 = (document.getElementById("ROB_6_887") as HTMLInputElement).value
      var MT_6_888 = (document.getElementById("MT_6_888") as HTMLInputElement).value

      var HFO_1080 = (document.getElementById("HFO_1080") as HTMLInputElement).innerText
      var LSMGO_1081 = (document.getElementById("LSMGO_1081") as HTMLInputElement).value
      var ME_FO_1082 = (document.getElementById("ME_FO_1082") as HTMLInputElement).value
      var consumption1_1083 = (document.getElementById("consumption1_1083") as HTMLInputElement).value
      var consumption2_1084 = (document.getElementById("consumption2_1084") as HTMLInputElement).value
      var Aux_Engine_1085 = (document.getElementById("Aux_Engine_1085") as HTMLInputElement).value
      var consumption3_1086 = (document.getElementById("consumption3_1086") as HTMLInputElement).value
      var consumption4_1087 = (document.getElementById("consumption4_1087") as HTMLInputElement).value
      var Boiler_1088 = (document.getElementById("Boiler_1088") as HTMLInputElement).value
      var consumption5_1089 = (document.getElementById("consumption5_1089") as HTMLInputElement).value
      var consumption6_1090 = (document.getElementById("consumption6_1090") as HTMLInputElement).value

      parameterdata = {
        "Main_Engine_836": Main_Engine_836, "Running_Hours_1_837": Running_Hours_1_837, "Aux_Engine_1_840": Aux_Engine_1_840,
        "Running_Hours_2_842": Running_Hours_2_842, "Aux_Engine_2_844": Aux_Engine_2_844, "Running_Hours_3_847": Running_Hours_3_847, "Aux_Engine_3_849": Aux_Engine_3_849,
        "Running_Hours_4_852": Running_Hours_4_852, "Fresh_water_generator_854": Fresh_water_generator_854, "Running_Hours_5_857": Running_Hours_5_857,
        "Work_done_863": Work_done_863,
        "Tank_Name_1_864": Tank_Name_1_864, "ROB_1_866": ROB_1_866, "MT_1_867": MT_1_867,
        "Tank_Name_2_868": Tank_Name_2_868, "ROB_2_869": ROB_2_869, "MT_2_870": MT_2_870,
        "Tank_Name_3_871": Tank_Name_3_871, "ROB_3_875": ROB_3_875, "MT_3_876": MT_3_876,
        "Tank_Name_4_878": Tank_Name_4_878, "ROB_4_879": ROB_4_879, "MT_4_881": MT_4_881,
        "Tank_Name_5_882": Tank_Name_5_882, "ROB_5_884": ROB_5_884, "MT_5_885": MT_5_885,
        "Tank_Name_6_886": Tank_Name_6_886, "ROB_6_887": ROB_6_887, "MT_6_888": MT_6_888,
        "HFO_1080": HFO_1080, "LSMGO_1081": LSMGO_1081, "ME_FO_1082": ME_FO_1082, "consumption1_1083": consumption1_1083,
        "consumption2_1084": consumption2_1084, "Aux_Engine_1085": Aux_Engine_1085, "consumption3_1086": consumption3_1086,
        "consumption4_1087": consumption4_1087, "Boiler_1088": Boiler_1088, "consumption5_1089": consumption5_1089, "consumption6_1090": consumption6_1090
      }
    }

    //noon report data
    if (formId == 46) {
      var Average_RPM_2_846 = (document.getElementById("Average_RPM_2_846") as HTMLInputElement).value
      var Distance_by_Engine_2_850 = (document.getElementById("Distance_by_Engine_2_850") as HTMLInputElement).value
      var distance_by_observation = (document.getElementById("Distance_by_Observation_2_853") as HTMLInputElement).value
      var Distance_to_go_2_865 = (document.getElementById("Distance_to_go_2_865") as HTMLInputElement).value
      var Hours_Full_Speed_2_843 = (document.getElementById("Hours_Full_Speed_2_843") as HTMLInputElement).value
      var Hours_Underway_2_839 = (document.getElementById("Hours_Underway_2_839") as HTMLInputElement).value
      var Propeller_slip_2_859 = (document.getElementById("Propeller_slip_2_859") as HTMLInputElement).value
      var Speed_kts_2_856 = (document.getElementById("Speed_kts_2_856") as HTMLInputElement).value
      var Total_Distance_Run_2_861 = (document.getElementById("Total_Distance_Run_2_861") as HTMLInputElement).value
      parameterdata = {
        "Average_RPM_2_846": Average_RPM_2_846, "Distance_by_Engine_2_850": Distance_by_Engine_2_850, "Distance_by_Observation_2_853": distance_by_observation,
        "Distance_to_go_2_865": Distance_to_go_2_865, "Hours_Full_Speed_2_843": Hours_Full_Speed_2_843,
        "Hours_Underway_2_839": Hours_Underway_2_839, "Propeller_slip_2_859": Propeller_slip_2_859,
        "Speed_kts_2_856": Speed_kts_2_856, "Total_Distance_Run_2_861": Total_Distance_Run_2_861,
      }

      //  changefields = parameterdata.toString().split(",");
      //  console.log(changefields);
      var Average_RPM_1_845toStr = Average_RPM_2_846.toString();
      var Distance_by_Engine_1_848toStr = Distance_by_Engine_2_850.toString();
      console.log(Average_RPM_1_845toStr);
      console.log(Distance_by_Engine_1_848toStr);
    }

    //Audits / Inspections / Drills / Drafts
    if (formId == 40) {

      var Date_of_Drill_701 = (document.getElementById("Date_of_Drill_701") as HTMLInputElement).innerHTML
      var Drill_Date_702 = (document.getElementById("Drill_Date_702") as HTMLInputElement).value
      var Drill_Description_703 = (document.getElementById("Drill_Description_703") as HTMLInputElement).value
      var Participants_704 = (document.getElementById("Participants_704") as HTMLInputElement).value
      var Date_Time_of_Departure_705 = (document.getElementById("Date_Time_of_Departure_705") as HTMLInputElement).value
      var Date_of_Departure_706 = (document.getElementById("Date_of_Departure_706") as HTMLInputElement).value
      var Time_of_departure_707 = (document.getElementById("Time_of_departure_707") as HTMLInputElement).value
      var Port_708 = (document.getElementById("Port_708") as HTMLInputElement).value
      //   var Name_of_Port_709 = (document.getElementById("Name_of_Port_709") as HTMLInputElement).value //,"Name_of_Port_709":Name_of_Port_709
      var Draft_710 = (document.getElementById("Draft_710") as HTMLInputElement).value
      var Draft_Fwd_711 = (document.getElementById("Draft_Fwd_711") as HTMLInputElement).value
      var Draft_Alt_712 = (document.getElementById("Draft_Alt_712") as HTMLInputElement).value
      var Actual_Freeboard_Amidships_713 = (document.getElementById("Actual_Freeboard_Amidships_713") as HTMLInputElement).value
      var Amidship_port_714 = (document.getElementById("Amidship_port_714") as HTMLInputElement).value
      var Amidship_stbd_715 = (document.getElementById("Amidship_stbd_715") as HTMLInputElement).value
      var Amidships_mean_716 = (document.getElementById("Amidships_mean_716") as HTMLInputElement).value
      var Density_of_water_717 = (document.getElementById("Density_of_water_717") as HTMLInputElement).value
      var Allowance_for_density_718 = (document.getElementById("Allowance_for_density_718") as HTMLInputElement).value
      var Inspections_have_been_carried_out_719 = (document.getElementById("Inspections_have_been_carried_out_719") as HTMLInputElement).innerHTML
      var Equipment_720 = (document.getElementById("Equipment_720") as HTMLInputElement).innerHTML
      var Date_of_equipment_721 = (document.getElementById("Date_of_equipment_721") as HTMLInputElement).value
      var Firemens_outfits_722 = (document.getElementById("Firemens_outfits_722") as HTMLInputElement).innerHTML
      var Fire_extinguishers_723 = (document.getElementById("Fire_extinguishers_723") as HTMLInputElement).innerHTML
      var Fire_hydrants_724 = (document.getElementById("Fire_hydrants_724") as HTMLInputElement).innerHTML
      var Hoses_and_nozzles_725 = (document.getElementById("Hoses_and_nozzles_725") as HTMLInputElement).innerHTML
      var correct_position_726 = (document.getElementById("correct_position_726") as HTMLInputElement).innerHTML
      var position_date_727 = (document.getElementById("position_date_727") as HTMLInputElement).value
      var fire_pumps_operated_728 = (document.getElementById("fire_pumps_operated_728") as HTMLInputElement).innerHTML
      var pumps_729 = (document.getElementById("pumps_729") as HTMLInputElement).value
      var free_from_leakage_730 = (document.getElementById("free_from_leakage_730") as HTMLInputElement).innerHTML
      var fire_extinguishing_installation_731 = (document.getElementById("fire_extinguishing_installation_731") as HTMLInputElement).value
      var General_Remarks_732 = (document.getElementById("General_Remarks_732") as HTMLInputElement).value
      var test_and_inspections_733 = (document.getElementById("test_and_inspections_733") as HTMLInputElement).innerHTML
      var survival_craft_734 = (document.getElementById("survival_craft_734") as HTMLInputElement).innerHTML
      var survival_craft_date_735 = (document.getElementById("survival_craft_date_735") as HTMLInputElement).value
      var lifeboats_and_rescue_boats_736 = (document.getElementById("lifeboats_and_rescue_boats_736") as HTMLInputElement).innerHTML
      var lifeboats_and_rescue_boats_date_737 = (document.getElementById("lifeboats_and_rescue_boats_date_737") as HTMLInputElement).value
      var Lifeboats_moved_738 = (document.getElementById("Lifeboats_moved_738") as HTMLInputElement).innerHTML
      var Lifeboats_moved_date_739 = (document.getElementById("Lifeboats_moved_date_739") as HTMLInputElement).value
      var emergency_alarm_740 = (document.getElementById("emergency_alarm_740") as HTMLInputElement).innerHTML
      var emergency_alarm_date_741 = (document.getElementById("emergency_alarm_date_741") as HTMLInputElement).value
      var General_Remarks_742 = (document.getElementById("General_Remarks_742") as HTMLInputElement).value
      var test_and_inspections_743 = (document.getElementById("test_and_inspections_743") as HTMLInputElement).innerHTML
      var lifeboats_turned_744 = (document.getElementById("lifeboats_turned_744") as HTMLInputElement).innerHTML
      var lifeboats_turned_date_745 = (document.getElementById("lifeboats_turned_date_745") as HTMLInputElement).value
      var ispection_of_immersion_746 = (document.getElementById("ispection_of_immersion_746") as HTMLInputElement).innerHTML
      var ispection_of_immersion_date_747 = (document.getElementById("ispection_of_immersion_date_747") as HTMLInputElement).value
      var General_Remarks_748 = (document.getElementById("General_Remarks_748") as HTMLInputElement).value
      var inspections_examinations_749 = (document.getElementById("inspections_examinations_749") as HTMLInputElement).innerHTML
      var Internation_shore_connection_750 = (document.getElementById("Internation_shore_connection_750") as HTMLInputElement).innerHTML
      var shore_connection_date_751 = (document.getElementById("shore_connection_date_751") as HTMLInputElement).value
      var fire_fighting_equipment_752 = (document.getElementById("fire_fighting_equipment_752") as HTMLInputElement).innerHTML
      var fire_fighting_equipment_date_753 = (document.getElementById("fire_fighting_equipment_date_753") as HTMLInputElement).value
      var fire_doors_and_dampers_754 = (document.getElementById("fire_doors_and_dampers_754") as HTMLInputElement).innerHTML
      var doors_dampers_date_755 = (document.getElementById("doors_dampers_date_755") as HTMLInputElement).value
      var Bottle_connections_756 = (document.getElementById("Bottle_connections_756") as HTMLInputElement).innerHTML
      var Bottle_connections_date_757 = (document.getElementById("Bottle_connections_date_757") as HTMLInputElement).value
      var examination_and_inspection_remarks_758 = (document.getElementById("examination_and_inspection_remarks_758") as HTMLInputElement).value

      parameterdata = {
        "Date_of_Drill_701": Date_of_Drill_701, "Drill_Date_702": Drill_Date_702, "Drill_Description_703": Drill_Description_703, "Participants_704": Participants_704,
        "Date_Time_of_Departure_705": Date_Time_of_Departure_705, "Date_of_Departure_706": Date_of_Departure_706, "Time_of_departure_707": Time_of_departure_707, "Port_708": Port_708, "Draft_710": Draft_710, "Draft_Fwd_711": Draft_Fwd_711, "Draft_Alt_712": Draft_Alt_712,
        "Actual_Freeboard_Amidships_713": Actual_Freeboard_Amidships_713, "Amidship_port_714": Amidship_port_714, "Amidship_stbd_715": Amidship_stbd_715, "Amidships_mean_716": Amidships_mean_716, "Density_of_water_717": Density_of_water_717, "Allowance_for_density_718": Allowance_for_density_718,
        "Inspections_have_been_carried_out_719": Inspections_have_been_carried_out_719, "Equipment_720": Equipment_720, "Date_of_equipment_721": Date_of_equipment_721, "Firemens_outfits_722": Firemens_outfits_722, "Fire_extinguishers_723": Fire_extinguishers_723, "Fire_hydrants_724": Fire_hydrants_724, "Hoses_and_nozzles_725": Hoses_and_nozzles_725,
        "correct_position_726": correct_position_726, "position_date_727": position_date_727, "fire_pumps_operated_728": fire_pumps_operated_728, "pumps_729": pumps_729, "free_from_leakage_730": free_from_leakage_730, "fire_extinguishing_installation_731": fire_extinguishing_installation_731, "General_Remarks_732": General_Remarks_732,
        "test_and_inspections_733": test_and_inspections_733, "survival_craft_734": survival_craft_734, "survival_craft_date_735": survival_craft_date_735, "lifeboats_and_rescue_boats_736": lifeboats_and_rescue_boats_736, "lifeboats_and_rescue_boats_date_737": lifeboats_and_rescue_boats_date_737, "Lifeboats_moved_738": Lifeboats_moved_738,
        "Lifeboats_moved_date_739": Lifeboats_moved_date_739, "emergency_alarm_740": emergency_alarm_740, "emergency_alarm_date_741": emergency_alarm_date_741, "General_Remarks_742": General_Remarks_742,
        "test_and_inspections_743": test_and_inspections_743, "lifeboats_turned_744": lifeboats_turned_744, "lifeboats_turned_date_745": lifeboats_turned_date_745, "ispection_of_immersion_746": ispection_of_immersion_746, "ispection_of_immersion_date_747": ispection_of_immersion_date_747, "General_Remarks_748": General_Remarks_748,
        "inspections_examinations_749": inspections_examinations_749, "Internation_shore_connection_750": Internation_shore_connection_750, "shore_connection_date_751": shore_connection_date_751, "fire_fighting_equipment_752": fire_fighting_equipment_752, "fire_fighting_equipment_date_753": fire_fighting_equipment_date_753,
        "fire_doors_and_dampers_754": fire_doors_and_dampers_754, "doors_dampers_date_755": doors_dampers_date_755, "Bottle_connections_756": Bottle_connections_756, "Bottle_connections_date_757": Bottle_connections_date_757, "examination_and_inspection_remarks_758": examination_and_inspection_remarks_758
      }
    }

    //CREW RECORD AND MANAGEMENT
    if (formId == 41) {
      var Rank_759 = (document.getElementById("Rank_759") as HTMLInputElement).value
      var Name_of_officer_760 = (document.getElementById("Name_of_officer_760") as HTMLInputElement).value
      var Certificate_761 = (document.getElementById("Certificate_761") as HTMLInputElement).value
      var Date_of_joining_762 = (document.getElementById("Date_of_joining_762") as HTMLInputElement).value
      var officers_date_of_joining_763 = (document.getElementById("officers_date_of_joining_763") as HTMLInputElement).value
      var code_no_764 = (document.getElementById("code_no_764") as HTMLInputElement).value
      var name_765 = (document.getElementById("name_765") as HTMLInputElement).value
      var SIB_No_766 = (document.getElementById("SIB_No_766") as HTMLInputElement).value
      var crew_name_767 = (document.getElementById("crew_name_767") as HTMLInputElement).value
      var crew_rank_768 = (document.getElementById("crew_rank_768") as HTMLInputElement).value
      var crew_place_769 = (document.getElementById("crew_place_769") as HTMLInputElement).value
      var crew_date_770 = (document.getElementById("crew_date_770") as HTMLInputElement).value
      var crew_reason_771 = (document.getElementById("crew_reason_771") as HTMLInputElement).value

      parameterdata = {
        "Rank_759": Rank_759, "Name_of_officer_760": Name_of_officer_760, "Certificate_761": Certificate_761, "Date_of_joining_762": Date_of_joining_762, "officers_date_of_joining_763": officers_date_of_joining_763,
        "code_no_764": code_no_764, "name_765": name_765, "SIB_No_766": SIB_No_766,
        "crew_name_767": crew_name_767, "crew_rank_768": crew_rank_768, "crew_place_769": crew_place_769, "crew_date_770": crew_date_770, "crew_reason_771": crew_reason_771
      }
    }

    //Watch Entry
    if (formId == 43) {
      var Log_Reading_772 = (document.getElementById("Log_Reading_772") as HTMLInputElement).value
      var Course_773 = (document.getElementById("Course_773") as HTMLInputElement).value
      var Course_True_774 = (document.getElementById("Course_True_774") as HTMLInputElement).value
      var Course_Gyro_775 = (document.getElementById("Course_Gyro_775") as HTMLInputElement).value
      var Course_Standard_776 = (document.getElementById("Course_Standard_776") as HTMLInputElement).value
      var Gyro_Error_777 = (document.getElementById("Gyro_Error_777") as HTMLInputElement).value
      var Wind_778 = (document.getElementById("Wind_778") as HTMLInputElement).value
      var Wind_Direction_779 = (document.getElementById("Wind_Direction_779") as HTMLInputElement).value
      var Wind_Force_780 = (document.getElementById("Wind_Force_780") as HTMLInputElement).value
      var Sea_Height_781 = (document.getElementById("Sea_Height_781") as HTMLInputElement).value
      var Weather_and_visibility_782 = (document.getElementById("Weather_and_visibility_782") as HTMLInputElement).value
      var Baro_Meter_783 = (document.getElementById("Baro_Meter_783") as HTMLInputElement).value
      var Temperature_784 = (document.getElementById("Temperature_784") as HTMLInputElement).value
      var Temerature_Dry_785 = (document.getElementById("Temerature_Dry_785") as HTMLInputElement).value
      var Temperature_Wet_786 = (document.getElementById("Temperature_Wet_786") as HTMLInputElement).value
      var Temperature_Sea_787 = (document.getElementById("Temperature_Sea_787") as HTMLInputElement).value
      var IG_Press_788 = (document.getElementById("IG_Press_788") as HTMLInputElement).value
      var Look_Out_789 = (document.getElementById("Look_Out_789") as HTMLInputElement).value
      var Watch_Entry_Remarks_790 = (document.getElementById("Watch_Entry_Remarks_790") as HTMLInputElement).value
      var Watch_Entry_General_Comments_791 = (document.getElementById("Watch_Entry_General_Comments_791") as HTMLInputElement).value
      var Watch_Entry_Crew_Work_792 = (document.getElementById("Watch_Entry_Crew_Work_792") as HTMLInputElement).value

      parameterdata = {
        "Log_Reading_772": Log_Reading_772, "Course_773": Course_773, "Course_True_774": Course_True_774, "Course_Gyro_775": Course_Gyro_775, "Course_Standard_776": Course_Standard_776, "Gyro_Error_777": Gyro_Error_777,
        "Wind_778": Wind_778, "Wind_Direction_779": Wind_Direction_779, "Wind_Force_780": Wind_Force_780, "Sea_Height_781": Sea_Height_781, "Weather_and_visibility_782": Weather_and_visibility_782, "Baro_Meter_783": Baro_Meter_783, "Temperature_784": Temperature_784,
        "Temerature_Dry_785": Temerature_Dry_785, "Temperature_Wet_786": Temperature_Wet_786, "Temperature_Sea_787": Temperature_Sea_787, "IG_Press_788": IG_Press_788, "Look_Out_789": Look_Out_789, "Watch_Entry_Remarks_790": Watch_Entry_Remarks_790,
        "Watch_Entry_General_Comments_791": Watch_Entry_General_Comments_791, "Watch_Entry_Crew_Work_792": Watch_Entry_Crew_Work_792
      }
    }

    //Noon Entry
    if (formId == 44) {
      var Noon_Position_793 = (document.getElementById("Noon_Position_793") as HTMLInputElement).innerHTML
      var Noon_LAT_794 = (document.getElementById("Noon_LAT_794") as HTMLInputElement).value
      var Noon_LONG_795 = (document.getElementById("Noon_LONG_795") as HTMLInputElement).value
      var Next_Port_796 = (document.getElementById("Next_Port_796") as HTMLInputElement).value
      var ETA_797 = (document.getElementById("ETA_797") as HTMLInputElement).value
      var miles_run_in_last_24_hrs_798 = (document.getElementById("miles_run_in_last_24_hrs_798") as HTMLInputElement).value
      var HRS_STMG_799 = (document.getElementById("HRS_STMG_799") as HTMLInputElement).value
      var AV_SPD_800 = (document.getElementById("AV_SPD_800") as HTMLInputElement).value
      var Wind_Force_801 = (document.getElementById("Wind_Force_801") as HTMLInputElement).value
      var Consumption_For_Propulsion_802 = (document.getElementById("Consumption_For_Propulsion_802") as HTMLInputElement).value
      var propulsion_HFO_803 = (document.getElementById("propulsion_HFO_803") as HTMLInputElement).value
      var propulsion_MDO_804 = (document.getElementById("propulsion_MDO_804") as HTMLInputElement).value
      var Cosumption_for_heating_805 = (document.getElementById("Cosumption_for_heating_805") as HTMLInputElement).value
      var heating_HFO_806 = (document.getElementById("heating_HFO_806") as HTMLInputElement).value
      var heating_MDO_807 = (document.getElementById("heating_MDO_807") as HTMLInputElement).value
      var Consumption_for_cleaning_808 = (document.getElementById("Consumption_for_cleaning_808") as HTMLInputElement).value
      var Cleaning_HFO_809 = (document.getElementById("Cleaning_HFO_809") as HTMLInputElement).value
      var Cleaning_MDO_810 = (document.getElementById("Cleaning_MDO_810") as HTMLInputElement).value
      var Slow_Speed_811 = (document.getElementById("Slow_Speed_811") as HTMLInputElement).value
      var N_Miles_812 = (document.getElementById("N_Miles_812") as HTMLInputElement).value
      var speed_hrs_813 = (document.getElementById("speed_hrs_813") as HTMLInputElement).value
      var AV_RPM_814 = (document.getElementById("AV_RPM_814") as HTMLInputElement).value
      var Slip_815 = (document.getElementById("Slip_815") as HTMLInputElement).value
      var Sea_Conditions_816 = (document.getElementById("Sea_Conditions_816") as HTMLInputElement).value
      var ROB_817 = (document.getElementById("ROB_817") as HTMLInputElement).value
      var ROB_HFO_818 = (document.getElementById("ROB_HFO_818") as HTMLInputElement).value
      var ROB_MDO_819 = (document.getElementById("ROB_MDO_819") as HTMLInputElement).value
      var ROB_LSFO_820 = (document.getElementById("ROB_LSFO_820") as HTMLInputElement).value
      var ROB_MGO_821 = (document.getElementById("ROB_MGO_821") as HTMLInputElement).value
      var ROB_FW_822 = (document.getElementById("ROB_FW_822") as HTMLInputElement).value
      var General_Comments_823 = (document.getElementById("General_Comments_823") as HTMLInputElement).value
      var Crew_Work_824 = (document.getElementById("Crew_Work_824") as HTMLInputElement).value

      parameterdata = {
        "Noon_Position_793": Noon_Position_793, "Noon_LAT_794": Noon_LAT_794, "Noon_LONG_795": Noon_LONG_795, "Next_Port_796": Next_Port_796, "ETA_797": ETA_797, "miles_run_in_last_24_hrs_798": miles_run_in_last_24_hrs_798,
        "HRS_STMG_799": HRS_STMG_799, "AV_SPD_800": AV_SPD_800, "Wind_Force_801": Wind_Force_801, "Consumption_For_Propulsion_802": Consumption_For_Propulsion_802, "propulsion_HFO_803": propulsion_HFO_803, "propulsion_MDO_804": propulsion_MDO_804,
        "Cosumption_for_heating_805": Cosumption_for_heating_805, "heating_HFO_806": heating_HFO_806, "heating_MDO_807": heating_MDO_807, "Consumption_for_cleaning_808": Consumption_for_cleaning_808, "Cleaning_HFO_809": Cleaning_HFO_809, "Cleaning_MDO_810": Cleaning_MDO_810, "Slow_Speed_811": Slow_Speed_811, "N_Miles_812": N_Miles_812, "speed_hrs_813": speed_hrs_813,
        "AV_RPM_814": AV_RPM_814, "Slip_815": Slip_815, "Sea_Conditions_816": Sea_Conditions_816, "ROB_817": ROB_817, "ROB_HFO_818": ROB_HFO_818, "ROB_MDO_819": ROB_MDO_819, "ROB_LSFO_820": ROB_LSFO_820, "ROB_MGO_821": ROB_MGO_821, "ROB_FW_822": ROB_FW_822, "General_Comments_823": General_Comments_823,
        "Crew_Work_824": Crew_Work_824
      }
    }

    //olb-1
    if (formId == 69) {
      var Name_of_Ship = (document.getElementById("Name_of_Ship") as HTMLInputElement).innerHTML
      var Name_of_Ship_1 = (document.getElementById("Name_of_Ship_1") as HTMLInputElement).value
      var Port_of_registry = (document.getElementById("Port_of_registry") as HTMLInputElement).innerHTML
      var Port_of_registry_2 = (document.getElementById("Port_of_registry_2") as HTMLInputElement).value
      var Official_number = (document.getElementById("Official_number") as HTMLInputElement).innerHTML
      var Official_number_2 = (document.getElementById("Official_number_2") as HTMLInputElement).value
      var Gross_tonnage = (document.getElementById("Gross_tonnage") as HTMLInputElement).innerHTML
      var Gross_tonnage_2 = (document.getElementById("Gross_tonnage_2") as HTMLInputElement).value
      var Register_1 = (document.getElementById("Register_(net)_tonnage") as HTMLInputElement).innerHTML
      var Register_2 = (document.getElementById("Register_net_tonnage_2") as HTMLInputElement).value
      var Name_of_masters = (document.getElementById("Name_of_masters") as HTMLInputElement).innerHTML
      var Name_of_masters_2 = (document.getElementById("Name_of_masters_2") as HTMLInputElement).value
      var Certificate_of_competency_1 = (document.getElementById("Certificate_of_competency_1") as HTMLInputElement).innerHTML
      var Certificate_of_competency_2 = (document.getElementById("Certificate_of_competency_2") as HTMLInputElement).value
      var Name_of_the_registered_owner_1 = (document.getElementById("Name_of_the_registered_owner_1") as HTMLInputElement).innerHTML
      var Name_of_the_registered_owner_2 = (document.getElementById("Name_of_the_registered_owner_2") as HTMLInputElement).value
      var address_of_the_registered_owner_1 = (document.getElementById("address_of_the_registered_owner_1") as HTMLInputElement).innerHTML
      var address_of_the_registered_owner_2 = (document.getElementById("address_of_the_registered_owner_2") as HTMLInputElement).value
      var Date_at_which_log_book_opened_1 = (document.getElementById("Date_at_which_log_book_opened_1") as HTMLInputElement).innerHTML
      var Date_at_which_log_book_opened_2 = (this.datePipe.transform((document.getElementById("Date_at_which_log_book_opened_2") as HTMLInputElement).value, 'dd-MMM-yyyy'));
      var place_at_which_log_book_opened = (document.getElementById("place_at_which_log_book_opened") as HTMLInputElement).innerHTML
      var place_at_which_log_book_opened_1 = (document.getElementById("place_at_which_log_book_opened_1") as HTMLInputElement).value
      var Date_at_which_log_book_closed_1 = (document.getElementById("Date_at_which_log_book_closed_1") as HTMLInputElement).innerHTML
      var Date_at_which_log_book_closed_2 = (this.datePipe.transform((document.getElementById("Date_at_which_log_book_closed_2") as HTMLInputElement).value, 'dd-MMM-yyyy'));
      var place_at_which_log_book_closed_1 = (document.getElementById("place_at_which_log_book_closed_1") as HTMLInputElement).innerHTML
      var place_at_which_log_book_closed_2 = (document.getElementById("place_at_which_log_book_closed_2") as HTMLInputElement).value
      var Delivered_to_the_superintendent = (document.getElementById("Delivered_to_the_superintendent") as HTMLInputElement).innerHTML
      var Delivered_to_the_superintendent_1 = (document.getElementById("Delivered_to_the_superintendent_1") as HTMLInputElement).value
      var on_Office_Stamp = (document.getElementById("on_Office_Stamp") as HTMLInputElement).innerHTML
      //var on_Office_Stamp_1 = (document.getElementById("on_Office_Stamp_1") as HTMLInputElement).value
      var Date_1 = (document.getElementById("Date_1") as HTMLInputElement).innerHTML
      var Date_2 = (this.datePipe.transform((document.getElementById("Date_2") as HTMLInputElement).value, 'dd-MMM-yyyy'));

      parameterdata = {
        "Name_of_Ship": Name_of_Ship, "Name_of_Ship_1": Name_of_Ship_1, "Port_of_registry": Port_of_registry, "Port_of_registry_2": Port_of_registry_2,
        "Official_number": Official_number, "Official_number_2": Official_number_2, "Gross_tonnage": Gross_tonnage, "Gross_tonnage_2": Gross_tonnage_2, "Register_net_tonnage": Register_1, "Register_net_tonnage_2": Register_2,
        "Name_of_masters": Name_of_masters, "Name_of_masters_2": Name_of_masters_2, "Certificate_of_competency_1": Certificate_of_competency_1, "Certificate_of_competency_2": Certificate_of_competency_2,
        "Name_of_the_registered_owner_1": Name_of_the_registered_owner_1, "Name_of_the_registered_owner_2": Name_of_the_registered_owner_2, "address_of_the_registered_owner_1": address_of_the_registered_owner_1, "address_of_the_registered_owner_2": address_of_the_registered_owner_2,
        "Date_at_which_log_book_opened_1": Date_at_which_log_book_opened_1, "Date_at_which_log_book_opened_2": Date_at_which_log_book_opened_2, "place_at_which_log_book_opened": place_at_which_log_book_opened,
        "place_at_which_log_book_opened_1": place_at_which_log_book_opened_1, "Date_at_which_log_book_closed_1": Date_at_which_log_book_closed_1, "Date_at_which_log_book_closed_2": Date_at_which_log_book_closed_2,
        "place_at_which_log_book_closed_1": place_at_which_log_book_closed_1, "place_at_which_log_book_closed_2": place_at_which_log_book_closed_2, "Delivered_to_the_superintendent": Delivered_to_the_superintendent,
        "Delivered_to_the_superintendent_1": Delivered_to_the_superintendent_1, "on_Office_Stamp": on_Office_Stamp, "Date_1": Date_1, "Date_2": Date_2
      }

      console.log('==parameterdata-olb-1', parameterdata);
    }

    //olb-2
    if (formId == 70) {

      var Reference_number_in_list_of_crew = (document.getElementById("Reference_number_in_list_of_crew") as HTMLInputElement).innerHTML
      var Reference_number = (document.getElementById("Reference_number") as HTMLInputElement).value
      var Name_of_seamen_1 = (document.getElementById("Name_of_seamen_1") as HTMLInputElement).innerHTML
      var Name_of_seamen_2 = (document.getElementById("Name_of_seamen_2") as HTMLInputElement).value
      var Capacity_in_which_employed_1 = (document.getElementById("Capacity_in_which_employed_1") as HTMLInputElement).innerHTML
      var Capacity_in_which_employed = (document.getElementById("Capacity_in_which_employed") as HTMLInputElement).value
      var If_entry_made_1 = (document.getElementById("If_entry_made_1") as HTMLInputElement).innerHTML
      var If_entry_made_2 = (document.getElementById("If_entry_made_2") as HTMLInputElement).value
      parameterdata = {
        "Reference_number_in_list_of_crew": Reference_number_in_list_of_crew, "Reference_number": Reference_number, "Name_of_seamen_1": Name_of_seamen_1, "Name_of_seamen_2": Name_of_seamen_2, "Capacity_in_which_employed_1": Capacity_in_which_employed_1, "Capacity_in_which_employed": Capacity_in_which_employed,
        "If_entry_made_1": If_entry_made_1, "If_entry_made_2": If_entry_made_2
      }
    }

    //olb-3
    if (formId == 71) {
      //BIRTHS
      var DATE_OF_BIRTH_1 = (document.getElementById("DATE_OF_BIRTH_1") as HTMLInputElement).innerHTML
      var DATE_OF_BIRTH_2 = (this.datePipe.transform((document.getElementById("DATE_OF_BIRTH_2") as HTMLInputElement).value, 'dd-MMM-yyyy'));
      var PLACE_OF_BIRTH_1 = (document.getElementById("PLACE_OF_BIRTH(Port_or_latitude_and_longitude_if_at_sea)_1") as HTMLInputElement).innerHTML
      var PLACE_OF_BIRTH_2 = (document.getElementById("PLACE_OF_BIRTH_Port_or_latitude_and_longitude_if_at_sea_2") as HTMLInputElement).value
      var SURNAME_OF_CHILD_1 = (document.getElementById("NAMES(if_any)_AND_SURNAME_OF_CHILD_1") as HTMLInputElement).innerHTML
      var SURNAME_OF_CHILD_2 = (document.getElementById("NAMES_if_any_AND_SURNAME_OF_CHILD_2") as HTMLInputElement).value
      var SEX_1 = (document.getElementById("SEX_1") as HTMLInputElement).innerHTML
      var SEX_2 = (document.getElementById("SEX_2") as HTMLInputElement).value
      var FATHER = (document.getElementById("FATHER") as HTMLInputElement).innerText
      var Name_1 = (document.getElementById("Name_1") as HTMLInputElement).innerHTML
      var Name_2 = (document.getElementById("Name_2") as HTMLInputElement).value
      var Surname_1 = (document.getElementById("Surname_1") as HTMLInputElement).innerHTML
      var Surname_2 = (document.getElementById("Surname_2") as HTMLInputElement).value
      var Nationality_1 = (document.getElementById("Nationality_1") as HTMLInputElement).innerHTML
      var Nationality_2 = (document.getElementById("Nationality_2") as HTMLInputElement).value
      var Occupation_1 = (document.getElementById("Occupation_1") as HTMLInputElement).innerHTML
      var Occupation_2 = (document.getElementById("Occupation_2") as HTMLInputElement).value
      var rank_1 = (document.getElementById("rank_1") as HTMLInputElement).innerHTML
      var rank_2 = (document.getElementById("rank_2") as HTMLInputElement).value
      var profession_1 = (document.getElementById("profession_1") as HTMLInputElement).innerHTML
      var profession_2 = (document.getElementById("profession_2") as HTMLInputElement).value
      var usual_residence_1 = (document.getElementById("usual_residence_1") as HTMLInputElement).innerHTML
      var usual_residence_2 = (document.getElementById("usual_residence_2") as HTMLInputElement).value
      var MOTHER = (document.getElementById("MOTHER") as HTMLInputElement).innerHTML
      var Name_3 = (document.getElementById("Name_3") as HTMLInputElement).innerHTML
      var Name_4 = (document.getElementById("Name_4") as HTMLInputElement).value
      var Surname_3 = (document.getElementById("Surname_3") as HTMLInputElement).innerHTML
      var Surname_4 = (document.getElementById("Surname_4") as HTMLInputElement).value
      var Nationality_3 = (document.getElementById("Nationality_3") as HTMLInputElement).innerHTML
      var Nationality_4 = (document.getElementById("Nationality_4") as HTMLInputElement).value
      var Maiden_surname_3 = (document.getElementById("Maiden_surname_3") as HTMLInputElement).innerHTML
      var Maiden_surname_4 = (document.getElementById("Maiden_surname_4") as HTMLInputElement).value
      var surname_at_marriage_if_different_3 = (document.getElementById("surname_at_marriage_if_different_3") as HTMLInputElement).innerHTML
      var surname_at_marriage_if_different_4 = (document.getElementById("surname_at_marriage_if_different_4") as HTMLInputElement).value
      var Usual_residence_3 = (document.getElementById("Usual_residence_3") as HTMLInputElement).innerHTML
      var Usual_residence_4 = (document.getElementById("Usual_residence_4") as HTMLInputElement).value
      var Signature_of_the_mother_of_the_child_1 = (document.getElementById("Signature_of_the_mother_of_the_child_1") as HTMLInputElement).innerHTML
      var Signature_of_the_mother_of_the_child_2 = (document.getElementById("Signature_of_the_mother_of_the_child_2") as HTMLInputElement).value
      var Port_at_which_return_is_made_1 = (document.getElementById("Port_at_which_return_is_made_1") as HTMLInputElement).value
      var Port_at_which_return_is_made_2 = (document.getElementById("Port_at_which_return_is_made_2") as HTMLInputElement).value
      var date_1 = (document.getElementById("date_1") as HTMLInputElement).innerHTML
      var date_2 = (this.datePipe.transform((document.getElementById("date_2") as HTMLInputElement).value, 'dd-MMM-yyyy'));
      var Title_of_officer_to_whom_return_is_made_1 = (document.getElementById("Title_of_officer_to_whom_return_is_made_1") as HTMLInputElement).innerHTML
      var Title_of_officer_to_whom_return_is_made_2 = (document.getElementById("Title_of_officer_to_whom_return_is_made_2") as HTMLInputElement).value
      //DEATHS

      var Date_of_Death_or_Loss_1 = (document.getElementById("Date_of_Death_or_Loss_1") as HTMLInputElement).innerHTML
      var Date_of_Death_or_Loss_2 = (this.datePipe.transform((document.getElementById("Date_of_Death_or_Loss_2") as HTMLInputElement).value, 'dd-MMM-yyyy'));
      var Place_of_Death_or_Loss = (document.getElementById("Place_of_Death_or_Loss(latitude_or_longitude_if_at_sea)_1") as HTMLInputElement).innerHTML
      var Place_of_Death_or_Loss_1 = (document.getElementById("Place_of_Death_or_Los_latitude_or_longitude_if_at_sea_2") as HTMLInputElement).value
      var Name_of_deceased_1 = (document.getElementById("Name_of_deceased_1") as HTMLInputElement).innerHTML
      var Name_of_deceased_2 = (document.getElementById("Name_of_deceased_2") as HTMLInputElement).value
      var Surname_of_deceased_1 = (document.getElementById("Surname_of_deceased_1") as HTMLInputElement).innerHTML
      var Surname_of_deceased_2 = (document.getElementById("Surname_of_deceased_2") as HTMLInputElement).value
      var maiden_surname_if_known_of_deceased_2 = (document.getElementById("if_married_woman_maiden_surname_if_known_of_deceased_2") as HTMLInputElement).value
      var SEX_3 = (document.getElementById("SEX_3") as HTMLInputElement).innerHTML
      var SEX_4 = (document.getElementById("SEX_4") as HTMLInputElement).value
      var Date_of_birth_5 = (document.getElementById("Date_of_birth_(if_known_or_age)_5") as HTMLInputElement).innerHTML
      var Date_of_birth_6 = (document.getElementById("Date_of_birth_if_known_or_age_6") as HTMLInputElement).value;
      var Occupation_5 = (document.getElementById("Occupation_5") as HTMLInputElement).innerHTML
      var Occupation_6 = (document.getElementById("Occupation_6") as HTMLInputElement).value
      var rank_5 = (document.getElementById("rank_5") as HTMLInputElement).innerHTML
      var rank_6 = (document.getElementById("rank_6") as HTMLInputElement).value
      var profession_5 = (document.getElementById("profession_5") as HTMLInputElement).innerHTML
      var profession_6 = (document.getElementById("profession_6") as HTMLInputElement).value
      var Usual_residence_at_time_of_death_or_loss_5 = (document.getElementById("Usual_residence_at_time_of_death_or_loss_5") as HTMLInputElement).innerHTML
      var Usual_residence_at_time_of_death_or_loss_6 = (document.getElementById("Usual_residence_at_time_of_death_or_loss_6") as HTMLInputElement).value
      var Nationality_5 = (document.getElementById("Nationality_5") as HTMLInputElement).innerHTML
      var Nationality_6 = (document.getElementById("Nationality_6") as HTMLInputElement).value
      var Cause_of_death_or_loss_5 = (document.getElementById("Cause_of_death_or_loss_5") as HTMLInputElement).innerHTML
      var Cause_of_death_or_loss_6 = (document.getElementById("Cause_of_death_or_loss_6") as HTMLInputElement).value
      var Signature_of_master_5 = (document.getElementById("Signature_of_master_5") as HTMLInputElement).innerHTML
      var Signature_of_master_6 = (document.getElementById("Signature_of_master_6") as HTMLInputElement).value
      var Signature_of_a_member_of_the_crew_5 = (document.getElementById("Signature_of_a_member_of_the_crew_5") as HTMLInputElement).innerHTML
      var Signature_of_a_member_of_the_crew_6 = (document.getElementById("Signature_of_a_member_of_the_crew_6") as HTMLInputElement).value
      var Port_at_which_return_is_made_5 = (document.getElementById("Port_at_which_return_is_made_5") as HTMLInputElement).innerHTML
      var Port_at_which_return_is_made_6 = (document.getElementById("Port_at_which_return_is_made_6") as HTMLInputElement).value
      var Date_3 = (document.getElementById("Date_3") as HTMLInputElement).innerHTML
      var Date_4 = (this.datePipe.transform((document.getElementById("Date_4") as HTMLInputElement).value, 'dd-MMM-yyyy'));
      var Title_of_officer_to_whom_return_is_made_3 = (document.getElementById("Title_of_officer_to_whom_return_is_made_3") as HTMLInputElement).innerHTML
      var Title_of_officer_to_whom_return_is_made_4 = (document.getElementById("Title_of_officer_to_whom_return_is_made_4") as HTMLInputElement).value

      parameterdata = {
        "DATE_OF_BIRTH_1": DATE_OF_BIRTH_1, "DATE_OF_BIRTH_2": DATE_OF_BIRTH_2, "PLACE_OF_BIRTH_Port_or_latitude_and_longitude_if_at_sea_1": PLACE_OF_BIRTH_1,
        "PLACE_OF_BIRTH_Port_or_latitude_and_longitude_if_at_sea_2": PLACE_OF_BIRTH_2,
        "NAMES_if_any_AND_SURNAME_OF_CHILD_1": SURNAME_OF_CHILD_1, "NAMES_if_any_AND_SURNAME_OF_CHILD_2": SURNAME_OF_CHILD_2,
        "SEX_1": SEX_1, "SEX_2": SEX_2, "FATHER": FATHER, "Name_1": Name_1, "Name_2": Name_2, "Surname_1": Surname_1, "Surname_2": Surname_2, "Nationality_1": Nationality_1, "Nationality_2": Nationality_2, "Occupation_1": Occupation_1, "Occupation_2": Occupation_2, "rank_1": rank_1, "rank_2": rank_2, "profession_1": profession_1, "profession_2": profession_2, "usual_residence_1": usual_residence_1, "usual_residence_2": usual_residence_2,
        "MOTHER": MOTHER, "Name_3": Name_3, "Name_4": Name_4, "Surname_3": Surname_3, "Surname_4": Surname_4, "Nationality_3": Nationality_3, "Nationality_4": Nationality_4, "Maiden_surname_3": Maiden_surname_3, "Maiden_surname_4": Maiden_surname_4,
        "surname_at_marriage_if_different_3": surname_at_marriage_if_different_3, "surname_at_marriage_if_different_4": surname_at_marriage_if_different_4, "Usual_residence_3": Usual_residence_3, "Usual_residence_4": Usual_residence_4,
        "Signature_of_the_mother_of_the_child_1": Signature_of_the_mother_of_the_child_1, "Signature_of_the_mother_of_the_child_2": Signature_of_the_mother_of_the_child_2,
        "Port_at_which_return_is_made_1": Port_at_which_return_is_made_1, "Port_at_which_return_is_made_2": Port_at_which_return_is_made_2, "date_1": date_1, "date_2": date_2, "Title_of_officer_to_whom_return_is_made_1": Title_of_officer_to_whom_return_is_made_1, "Title_of_officer_to_whom_return_is_made_2": Title_of_officer_to_whom_return_is_made_2,
        "Date_of_Death_or_Loss_1": Date_of_Death_or_Loss_1, "Date_of_Death_or_Loss_2": Date_of_Death_or_Loss_2, "Place_of_Death_or_Loss_latitude_or_longitude_if_at_sea_1": Place_of_Death_or_Loss, "Place_of_Death_or_Los_latitude_or_longitude_if_at_sea_2": Place_of_Death_or_Loss_1,
        "Name_of_deceased_1": Name_of_deceased_1, "Name_of_deceased_2": Name_of_deceased_2, "Surname_of_deceased_1": Surname_of_deceased_1, "Surname_of_deceased_2": Surname_of_deceased_2, "if_married_woman_maiden_surname_if_known_of_deceased_2": maiden_surname_if_known_of_deceased_2,
        "SEX_3": SEX_3, "SEX_4": SEX_4, "Date_of_birth_if_known_or_age_5": Date_of_birth_5, "Date_of_birth_if_known_or_age_6": Date_of_birth_6, "Occupation_5": Occupation_5, "Occupation_6": Occupation_6, "rank_5": rank_5, "rank_6": rank_6, "profession_5": profession_5, "profession_6": profession_6,
        "Usual_residence_at_time_of_death_or_loss_5": Usual_residence_at_time_of_death_or_loss_5, "Usual_residence_at_time_of_death_or_loss_6": Usual_residence_at_time_of_death_or_loss_6,
        "Nationality_5": Nationality_5, "Nationality_6": Nationality_6, "Cause_of_death_or_loss_5": Cause_of_death_or_loss_5, "Cause_of_death_or_loss_6": Cause_of_death_or_loss_6,
        "Signature_of_master_5": Signature_of_master_5, "Signature_of_master_6": Signature_of_master_6, "Signature_of_a_member_of_the_crew_5": Signature_of_a_member_of_the_crew_5, "Signature_of_a_member_of_the_crew_6": Signature_of_a_member_of_the_crew_6,
        "Port_at_which_return_is_made_5": Port_at_which_return_is_made_5, "Port_at_which_return_is_made_6": Port_at_which_return_is_made_6, "Date_3": Date_3, "Date_4": Date_4,
        "Title_of_officer_to_whom_return_is_made_3": Title_of_officer_to_whom_return_is_made_3, "Title_of_officer_to_whom_return_is_made_4": Title_of_officer_to_whom_return_is_made_4
      }

    }

    //olb-4
    if (formId == 72) {
      var Date_of_muster_drill_training_instruction_or_inspection = (document.getElementById("Date_of_muster_drill_training_instruction_or_inspection") as HTMLInputElement).innerHTML
      var Date_of_muster_drill_training_instruction_or_inspection_1 = (this.datePipe.transform((document.getElementById("Date_of_muster_drill_training_instruction_or_inspection_1") as HTMLInputElement).value, 'dd-MMM-yyyy'));
      var Nature_of_muster = (document.getElementById("Nature_of_muster") as HTMLInputElement).innerHTML
      var Nature_of_muster_1 = (document.getElementById("Nature_of_muster_1") as HTMLInputElement).value
      var Nature_of_drill = (document.getElementById("Nature_of_drill") as HTMLInputElement).innerHTML
      var Nature_of_drill_1 = (document.getElementById("Nature_of_drill_1") as HTMLInputElement).value
      var Nature_of_training_1 = (document.getElementById("Nature_of_training_1") as HTMLInputElement).value
      var Nature = (document.getElementById("Nature_of_instruction_or_inspection_(including_the_condition_in_which_the_life-saving_and_fire_appliances_were_found)_and_the_record_of_the_occassions_on_which_the_lifeboats_were_swung_out_or_lowered") as HTMLInputElement).innerHTML
      var Nature1 = (document.getElementById("Nature1") as HTMLInputElement).value
      var Date_of_Entry = (document.getElementById("Date_of_Entry") as HTMLInputElement).innerHTML
      var Date_of_Entry_1 = (this.datePipe.transform((document.getElementById("Date_of_Entry_1") as HTMLInputElement).value, 'dd-MMM-yyyy'));
      var Signature_of_master_of_crew = (document.getElementById("Signature_of_master_of_crew") as HTMLInputElement).innerHTML
      var Signature_of_master_of_crew_1 = (document.getElementById("Signature_of_master_of_crew_1") as HTMLInputElement).value
      var Signature_of_member_of_crew = (document.getElementById("Signature_of_member_of_crew") as HTMLInputElement).innerHTML
      var Signature_of_member_of_crew_1 = (document.getElementById("Signature_of_member_of_crew_1") as HTMLInputElement).value


      parameterdata = {
        "Date_of_muster_drill_training_instruction_or_inspection": Date_of_muster_drill_training_instruction_or_inspection, "Date_of_muster_drill_training_instruction_or_inspection_1": Date_of_muster_drill_training_instruction_or_inspection_1,
        "Nature_of_muster": Nature_of_muster, "Nature_of_muster_1": Nature_of_muster_1, "Nature_of_drill": Nature_of_drill, "Nature_of_drill_1": Nature_of_drill_1, "Nature_of_training_1": Nature_of_training_1, "Nature": Nature,
        "Nature1": Nature1, "Date_of_Entry": Date_of_Entry, "Date_of_Entry_1": Date_of_Entry_1, "Signature_of_master_of_crew": Signature_of_master_of_crew, "Signature_of_master_of_crew_1": Signature_of_master_of_crew_1, "Signature_of_member_of_crew": Signature_of_member_of_crew, "Signature_of_member_of_crew_1": Signature_of_member_of_crew_1
      }
    }

    //olb-5
    if (formId == 73) {


      var Date_of_test_drill_inspection_or_pre_sea_check = (document.getElementById("Date_of_test_drill_inspection_or_pre-sea_check") as HTMLInputElement).innerHTML
      var Date_of_test_drill_inspection_or_pre_sea_check_1 = (this.datePipe.transform((document.getElementById("Date_of_test_drill_inspection_or_pre_sea_check_1") as HTMLInputElement).value, 'dd-MMM-yyyy'));
      var Time_of_test_drill_inspection_or_pre_sea_check = (document.getElementById("Time_of_test_drill_inspection_or_pre-sea_check") as HTMLInputElement).innerText
      var Time_of_test_drill_inspection_or_pre_sea_check_1 = (document.getElementById("Time_of_test_drill_inspection_or_pre_sea_check_1") as HTMLInputElement).value;
      var place_of_test_drill = (document.getElementById("place_of_test_drill") as HTMLInputElement).innerHTML
      var place_of_test_drill_1 = (document.getElementById("place_of_test_drill_1") as HTMLInputElement).value
      var place_of_inspection_or_pre_sea_check = (document.getElementById("place_of_inspection_or_pre-sea_check") as HTMLInputElement).innerHTML
      var place_of_inspection_or_pre_sea_check_1 = (document.getElementById("place_of_inspection_or_pre_sea_check_1") as HTMLInputElement).value
      var Nature_of_inspection_of_Steering_Gear = (document.getElementById("Nature_of_inspection_of_Steering_Gear") as HTMLInputElement).innerHTML
      var Nature_of_inspection_of_Steering_Gear_1 = (document.getElementById("Nature_of_inspection_of_Steering_Gear_1") as HTMLInputElement).value
      var Nature_of_test_drill_or_check_of_Steering_Gear = (document.getElementById("Nature_of_test_drill_or_check_of_Steering_Gear") as HTMLInputElement).innerHTML
      var Nature_of_test_drill_or_check_of_Steering_Gear_1 = (document.getElementById("Nature_of_test_drill_or_check_of_Steering_Gear_1") as HTMLInputElement).value
      var Date_of_Entry = (document.getElementById("Date_of_Entry") as HTMLInputElement).innerHTML
      var Date_of_Entry_1 = (this.datePipe.transform((document.getElementById("Date_of_Entry_1") as HTMLInputElement).value, 'dd-MMM-yyyy'));
      var Signature_of_master = (document.getElementById("Signature_of_master") as HTMLInputElement).innerHTML
      var Signature_of_master_1 = (document.getElementById("Signature_of_master_1") as HTMLInputElement).value
      var Signature_of_officer = (document.getElementById("Signature_of_officer") as HTMLInputElement).innerHTML
      var Signature_of_officer_1 = (document.getElementById("Signature_of_officer_1") as HTMLInputElement).value


      parameterdata = {
        "Date_of_test_drill_inspection_or_pre_sea_check": Date_of_test_drill_inspection_or_pre_sea_check, "Date_of_test_drill_inspection_or_pre_sea_check_1": Date_of_test_drill_inspection_or_pre_sea_check_1, "Time_of_test_drill_inspection_or_pre_sea_check": Time_of_test_drill_inspection_or_pre_sea_check, "Time_of_test_drill_inspection_or_pre_sea_check_1": Time_of_test_drill_inspection_or_pre_sea_check_1, "place_of_test_drill": place_of_test_drill, "place_of_test_drill_1": place_of_test_drill_1,
        "place_of_inspection_or_pre_sea_check": place_of_inspection_or_pre_sea_check, "place_of_inspection_or_pre_sea_check_1": place_of_inspection_or_pre_sea_check_1, "Nature_of_inspection_of_Steering_Gear": Nature_of_inspection_of_Steering_Gear, "Nature_of_inspection_of_Steering_Gear_1": Nature_of_inspection_of_Steering_Gear_1,
        "Nature_of_test_drill_or_check_of_Steering_Gear": Nature_of_test_drill_or_check_of_Steering_Gear,
        "Nature_of_test_drill_or_check_of_Steering_Gear_1": Nature_of_test_drill_or_check_of_Steering_Gear_1,
        "Date_of_Entry": Date_of_Entry, "Date_of_Entry_1": Date_of_Entry_1, "Signature_of_master": Signature_of_master, "Signature_of_master_1": Signature_of_master_1,
        "Signature_of_officer": Signature_of_officer, "Signature_of_officer_1": Signature_of_officer_1
      }
    }

    //olb-6
    if (formId == 74) {
      var Time_of_inspection = (document.getElementById("Time_of_inspection") as HTMLInputElement).innerHTML
      var Time_of_inspection_1 = (document.getElementById("Time_of_inspection_1") as HTMLInputElement).value;
      var Date_of_inspection = (document.getElementById("Date_of_inspection") as HTMLInputElement).innerHTML
      var Date_of_inspection_1 = (this.datePipe.transform((document.getElementById("Date_of_inspection_1") as HTMLInputElement).value, 'dd-MMM-yyyy'));
      var Names_of_persons_making_the_inspection = (document.getElementById("Names_of_persons_making_the_inspection") as HTMLInputElement).innerHTML
      var Names_of_persons_making_the_inspection_1 = (document.getElementById("Names_of_persons_making_the_inspection_1") as HTMLInputElement).value
      var Ranks_of_persons_making_the_inspection = (document.getElementById("Ranks_of_persons_making_the_inspection") as HTMLInputElement).innerHTML
      var Ranks_of_persons_making_the_inspection_1 = (document.getElementById("Ranks_of_persons_making_the_inspection_1") as HTMLInputElement).value
      var Particulars = (document.getElementById("Particulars_of_any_respects_in_which_crew_accomodation_or_any_part_of_it_is_found_not_to_comply_with_the_Regulations") as HTMLInputElement).innerHTML
      var Particulars_1 = (document.getElementById("Particulars_of_any_respects_in_which_crew_accomodation_or_any_part_of_it_is_found_not_to_comply_with_the_Regulations_1") as HTMLInputElement).value
      var Date_of_Entry = (document.getElementById("Date_of_Entry") as HTMLInputElement).innerHTML
      var Date_of_Entry_1 = (this.datePipe.transform((document.getElementById("Date_of_Entry_1") as HTMLInputElement).value, 'dd-MMM-yyyy'));
      var Signature_of_master_of_the_crew = (document.getElementById("Signature_of_master_of_the_crew") as HTMLInputElement).innerHTML
      var Signature_of_master_of_the_crew_1 = (document.getElementById("Signature_of_master_of_the_crew_1") as HTMLInputElement).value
      var Signature_of_member_of_the_crew = (document.getElementById("Signature_of_member_of_the_crew") as HTMLInputElement).innerHTML
      var Signature_of_member_of_the_crew_1 = (document.getElementById("Signature_of_member_of_the_crew_1") as HTMLInputElement).value


      parameterdata = {
        "Time_of_inspection": Time_of_inspection, "Time_of_inspection_1": Time_of_inspection_1, "Date_of_inspection": Date_of_inspection, "Date_of_inspection_1": Date_of_inspection_1,
        " Names_of_persons_making_the_inspection": Names_of_persons_making_the_inspection, "Names_of_persons_making_the_inspection_1": Names_of_persons_making_the_inspection_1, "Ranks_of_persons_making_the_inspection": Ranks_of_persons_making_the_inspection,
        "Ranks_of_persons_making_the_inspection_1": Ranks_of_persons_making_the_inspection_1, "Particulars": Particulars, "Particulars_of_any_respects_in_which_crew_accomodation_or_any_part_of_it_is_found_not_to_comply_with_the_Regulations_1": Particulars_1, "Date_of_Entry": Date_of_Entry,
        Date_of_Entry_1: Date_of_Entry_1, "Signature_of_master_of_the_crew": Signature_of_master_of_the_crew, "Signature_of_master_of_the_crew_1": Signature_of_master_of_the_crew_1,
        "Signature_of_member_of_the_crew": Signature_of_member_of_the_crew, "Signature_of_member_of_the_crew_1": Signature_of_member_of_the_crew_1
      }
    }

    //olb-7
    if (formId == 75) {
      var Date_of_Inspection = (document.getElementById("Date_of_Inspection") as HTMLInputElement).innerHTML
      var Date_of_Inspection_1 = (this.datePipe.transform((document.getElementById("Date_of_Inspection_1") as HTMLInputElement).value, 'dd-MMM-yyyy'));
      var Names_of_persons_making_the_inspection = (document.getElementById("Names_of_persons_making_the_inspection") as HTMLInputElement).innerHTML
      var Names_of_persons_making_the_inspection_1 = (document.getElementById("Names_of_persons_making_the_inspection_1") as HTMLInputElement).value
      var Ranks_of_persons_making_the_inspection = (document.getElementById("Ranks_of_persons_making_the_inspection") as HTMLInputElement).innerHTML
      var Ranks_of_persons_making_the_inspection_1 = (document.getElementById("Ranks_of_persons_making_the_inspection_1") as HTMLInputElement).value
      var Result_of_inspection_of_supplies_of_food_and_water = (document.getElementById("Result_of_inspection_of_supplies_of_food_and_water") as HTMLInputElement).innerHTML
      var Result_of_inspection_of_supplies_of_food_and_water_1 = (document.getElementById("Result_of_inspection_of_supplies_of_food_and_water_1") as HTMLInputElement).value
      var Date_of_Entry = (document.getElementById("Date_of_Entry") as HTMLInputElement).innerHTML
      var Date_of_Entry_1 = (this.datePipe.transform((document.getElementById("Date_of_Entry_1") as HTMLInputElement).value, 'dd-MMM-yyyy'));
      var Signature_of_persons_making_the_inspection = (document.getElementById("Signature_of_persons_making_the_inspection") as HTMLInputElement).innerHTML
      var Signature_of_persons_making_the_inspection_1 = (document.getElementById("Signature_of_persons_making_the_inspection_1") as HTMLInputElement).value

      parameterdata = {
        "Date_of_Inspection": Date_of_Inspection, "Date_of_Inspection_1": Date_of_Inspection_1, "Names_of_persons_making_the_inspection": Names_of_persons_making_the_inspection,
        "Names_of_persons_making_the_inspection_1": Names_of_persons_making_the_inspection_1, "Ranks_of_persons_making_the_inspection": Ranks_of_persons_making_the_inspection, "Ranks_of_persons_making_the_inspection_1": Ranks_of_persons_making_the_inspection_1,
        "Result_of_inspection_of_supplies_of_food_and_water": Result_of_inspection_of_supplies_of_food_and_water, "Result_of_inspection_of_supplies_of_food_and_water_1": Result_of_inspection_of_supplies_of_food_and_water_1,
        "Date_of_Entry": Date_of_Entry, "Date_of_Entry_1": Date_of_Entry_1, "Signature_of_persons_making_the_inspection": Signature_of_persons_making_the_inspection,
        "Signature_of_persons_making_the_inspection_1": Signature_of_persons_making_the_inspection_1
      }
    }

    //olb-8
    if (formId == 76) {
      //NONE
      var POSITIONS_OF_THE_DECK_LINE_AND_LOAD_LINE = (document.getElementById("POSITIONS_OF_THE_DECK_LINE_AND_LOAD_LINE") as HTMLInputElement).innerHTML
      //FREEBOARD FROM DECK LINE
      var Tropical_1 = (document.getElementById("Tropical_1") as HTMLInputElement).innerHTML
      var Tropical_2 = (document.getElementById("Tropical_2") as HTMLInputElement).value
      var mm_1 = (document.getElementById("mm_1") as HTMLInputElement).innerHTML
      var Summer_1 = (document.getElementById("Summer_1") as HTMLInputElement).innerHTML
      var Summer_2 = (document.getElementById("Summer_2") as HTMLInputElement).value
      var Winter_1 = (document.getElementById("Winter_1") as HTMLInputElement).innerHTML
      var Winter_2 = (document.getElementById("Winter_2") as HTMLInputElement).value
      var mm_3 = (document.getElementById("mm_3") as HTMLInputElement).innerHTML
      var Winter_North_Atlantic_1 = (document.getElementById("Winter_North_Atlantic_1") as HTMLInputElement).innerHTML
      var Winter_North_Atlantic_2 = (document.getElementById("Winter_North_Atlantic_2") as HTMLInputElement).value
      var mm_4 = (document.getElementById("mm_4") as HTMLInputElement).innerHTML
      var Timber_Tropical_1 = (document.getElementById("Timber_Tropical_1") as HTMLInputElement).innerHTML
      var Timber_Tropical_2 = (document.getElementById("Timber_Tropical_2") as HTMLInputElement).value
      var mm_5 = (document.getElementById("mm_5") as HTMLInputElement).innerHTML
      var Timber_Summer_1 = (document.getElementById("Timber_Summer_1") as HTMLInputElement).innerHTML
      var Timber_Summer_2 = (document.getElementById("Timber_Summer_2") as HTMLInputElement).value
      var mm_6 = (document.getElementById("mm_5") as HTMLInputElement).innerHTML
      var Timber_Winter_1 = (document.getElementById("Timber_Winter_1") as HTMLInputElement).innerHTML
      var Timber_Winter_2 = (document.getElementById("Timber_Winter_2") as HTMLInputElement).value
      var mm_7 = (document.getElementById("mm_7") as HTMLInputElement).innerHTML
      var Timber_Winter_North_Atlantic_1 = (document.getElementById("Timber_Winter_North_Atlantic_1") as HTMLInputElement).innerHTML
      var Timber_Winter_North_Atlantic_2 = (document.getElementById("Timber_Winter_North_Atlantic_2") as HTMLInputElement).value
      var mm_8 = (document.getElementById("mm_8") as HTMLInputElement).innerHTML
      //LOAD LINE
      var T_1 = (document.getElementById("T_1") as HTMLInputElement).innerHTML
      var T_2 = (document.getElementById("T_2") as HTMLInputElement).value
      var mm_above_S_Upper_edge_of_line_through_center_of_ring = (document.getElementById("mm_._above_(S)_Upper_edge_of_line_through_center_of_ring") as HTMLInputElement).innerHTML
      var W_1 = (document.getElementById("W_1") as HTMLInputElement).innerHTML
      var W_2 = (document.getElementById("W_2") as HTMLInputElement).value
      var mm_below_S_1 = (document.getElementById("mm_._below_(S)_1") as HTMLInputElement).innerHTML
      var WNA_1 = (document.getElementById("WNA_1") as HTMLInputElement).innerHTML
      var WNA_2 = (document.getElementById("WNA_2") as HTMLInputElement).value
      var mm_below_S_2 = (document.getElementById("mm_._below_(S)_2") as HTMLInputElement).innerHTML
      var LT_1 = (document.getElementById("LT_1") as HTMLInputElement).innerHTML
      var LT_2 = (document.getElementById("LT_2") as HTMLInputElement).value
      var mm_above_LS_1 = (document.getElementById("mm_._above_(LS)_1") as HTMLInputElement).innerHTML
      var LS_1 = (document.getElementById("LS_1") as HTMLInputElement).innerHTML
      var LS_2 = (document.getElementById("LS_2") as HTMLInputElement).value
      var mm_above_S_1 = (document.getElementById("mm_._above_(S)_1") as HTMLInputElement).innerHTML
      var LW_1 = (document.getElementById("LW_1") as HTMLInputElement).innerHTML
      var LW_2 = (document.getElementById("LW_2") as HTMLInputElement).value
      var mm_below_LS_1 = (document.getElementById("mm_._below_(LS)_1") as HTMLInputElement).innerHTML
      var LWNA_1 = (document.getElementById("LWNA_1") as HTMLInputElement).innerHTML
      var LWNA_2 = (document.getElementById("LWNA_2") as HTMLInputElement).value
      var mm_below_LS_2 = (document.getElementById("mm_._below_(LS)_2") as HTMLInputElement).innerHTML
      //NONE
      var Allowance_for_fresh_water_for_all_freeboards_other_then_timber_1 = (document.getElementById("Allowance_for_fresh_water_for_all_freeboards_other_then_timber_1") as HTMLInputElement).innerHTML
      var Allowance_for_fresh_water_for_all_freeboards_other_then_timber_2 = (document.getElementById("Allowance_for_fresh_water_for_all_freeboards_other_then_timber_2") as HTMLInputElement).value
      var mm_9 = (document.getElementById("mm_9") as HTMLInputElement).innerHTML
      var Allowance_for_fresh_water_for_timber_freeboards_1 = (document.getElementById("Allowance_for_fresh_water_for_timber_freeboards_1") as HTMLInputElement).innerHTML
      var Allowance_for_fresh_water_for_timber_freeboards_2 = (document.getElementById("Allowance_for_fresh_water_for_timber_freeboards_2") as HTMLInputElement).value
      var mm_10 = (document.getElementById("mm_10") as HTMLInputElement).innerHTML
      var The_upper_edge_of_the_deckline_from_which_these_freeboards_are_measured_is_1 = (document.getElementById("The_upper_edge_of_the_deckline_from_which_these_freeboards_are_measured_is_1") as HTMLInputElement).innerHTML
      var The_upper_edge_of_the_deckline_from_which_these_freeboards_are_measured_is_2 = (document.getElementById("The_upper_edge_of_the_deckline_from_which_these_freeboards_are_measured_is_2") as HTMLInputElement).value
      var Above_particulars_to_be_taken_from_loadline_certificate = (document.getElementById("Above_particulars_to_be_taken_from_loadline_certificate") as HTMLInputElement).innerHTML
      var Maximum_draught_of_water_in_summer_2 = (document.getElementById("Maximum_draught_of_water_in_summer_2") as HTMLInputElement).value

      parameterdata = {
        "POSITIONS_OF_THE_DECK_LINE_AND_LOAD_LINE": POSITIONS_OF_THE_DECK_LINE_AND_LOAD_LINE, "Tropical_1": Tropical_1, "Tropical_2": Tropical_2, "mm_1": mm_1, "Summer_1": Summer_1, "Summer_2": Summer_2,
        "Winter_1": Winter_1, "Winter_2": Winter_2, "mm_3": mm_3, "Winter_North_Atlantic_1": Winter_North_Atlantic_1, "Winter_North_Atlantic_2": Winter_North_Atlantic_2, "mm_4": mm_4, "Timber_Tropical_1": Timber_Tropical_1, "Timber_Tropical_2": Timber_Tropical_2, "mm_5": mm_5,
        "Timber_Summer_1": Timber_Summer_1, "Timber_Summer_2": Timber_Summer_2, mm_6, "Timber_Winter_1": Timber_Winter_1, "Timber_Winter_2": Timber_Winter_2, "mm_7": mm_7, "Timber_Winter_North_Atlantic_1": Timber_Winter_North_Atlantic_1, "Timber_Winter_North_Atlantic_2": Timber_Winter_North_Atlantic_2, "mm_8": mm_8,
        "T_1": T_1, "T_2": T_2, "mm_above_S_Upper_edge_of_line_through_center_of_ring": mm_above_S_Upper_edge_of_line_through_center_of_ring,
        "W_1": W_1, "W_2": W_2,
        "mm_below_S_1": mm_below_S_1, "WNA_1": WNA_1, "WNA_2": WNA_2, "mm_below_S_2": mm_below_S_2, "LT_1": LT_1, "LT_2": LT_2, "mm_above_LS_1": mm_above_LS_1, "LS_1": LS_1, "LS_2": LS_2, "mm_above_S_1": mm_above_S_1,
        "LW_1": LW_1, "LW_2": LW_2, "mm_below_LS_1": mm_below_LS_1, "LWNA_1": LWNA_1, "LWNA_2": LWNA_2, "mm_below_LS_2": mm_below_LS_2,
        "Allowance_for_fresh_water_for_all_freeboards_other_then_timber_1": Allowance_for_fresh_water_for_all_freeboards_other_then_timber_1, "Allowance_for_fresh_water_for_all_freeboards_other_then_timber_2": Allowance_for_fresh_water_for_all_freeboards_other_then_timber_2,
        "mm_9": mm_9, "Allowance_for_fresh_water_for_timber_freeboards_1": Allowance_for_fresh_water_for_timber_freeboards_1, "Allowance_for_fresh_water_for_timber_freeboards_2 ": Allowance_for_fresh_water_for_timber_freeboards_2, "mm_10": mm_10, "The_upper_edge_of_the_deckline_from_which_these_freeboards_are_measured_is_1": The_upper_edge_of_the_deckline_from_which_these_freeboards_are_measured_is_1, "The_upper_edge_of_the_deckline_from_which_these_freeboards_are_measured_is_2": The_upper_edge_of_the_deckline_from_which_these_freeboards_are_measured_is_2,
        "Above_particulars_to_be_taken_from_loadline_certificate": Above_particulars_to_be_taken_from_loadline_certificate, "Maximum_draught_of_water_in_summer_2": Maximum_draught_of_water_in_summer_2
      }
    }

    //olb-9
    if (formId == 77) {
      //DEPARTURES
      var DEPARTURES = (document.getElementById("DEPARTURES") as HTMLInputElement).innerHTML
      var Date_of_Departure_1_1 = (document.getElementById("Date_of_Departure_(1)_1") as HTMLInputElement).innerHTML
      var Date_of_Departure_1_2 = (this.datePipe.transform((document.getElementById("Date_of_Departure_1_2") as HTMLInputElement).value, 'dd-MMM-yyyy'));
      var hour_of_Departure_1_1 = (document.getElementById("hour_of_Departure_(1)_1") as HTMLInputElement).innerHTML
      var hour_of_Departure_1_2 = (document.getElementById("hour_of_Departure_1_2") as HTMLInputElement).value;
      var Dock_2_1 = (document.getElementById("Dock_(2)_1") as HTMLInputElement).innerHTML
      var Dock_2_2 = (document.getElementById("Dock_2_2") as HTMLInputElement).value
      var Wharf_2_1 = (document.getElementById("Wharf_(2)_1") as HTMLInputElement).innerHTML
      var Wharf_2_2 = (document.getElementById("Wharf_2_2") as HTMLInputElement).value
      var harbour_2_1 = (document.getElementById("harbour_(2)_1") as HTMLInputElement).innerHTML
      var harbour_2_2 = (document.getElementById("harbour_2_2") as HTMLInputElement).value
      var other_place_2_1 = (document.getElementById("other_place_(2)_1") as HTMLInputElement).innerHTML
      var other_place_2_2 = (document.getElementById("other_place_2_2") as HTMLInputElement).value
      var ACTUAL_DRAUGHT_OF_WATER = (document.getElementById("ACTUAL_DRAUGHT_OF_WATER") as HTMLInputElement).innerHTML
      var Forward_3_1 = (document.getElementById("Forward_(3)_1") as HTMLInputElement).innerHTML
      var Forward_3_2 = (document.getElementById("Forward_3_2") as HTMLInputElement).value
      var Aft_4_1 = (document.getElementById("Aft_(4)_1") as HTMLInputElement).innerHTML
      var Aft_4_2 = (document.getElementById("Aft_4_2") as HTMLInputElement).value
      var ACTUAL_FREEBOARD_AMIDSHIPS = (document.getElementById("ACTUAL_FREEBOARD_AMIDSHIPS") as HTMLInputElement).innerHTML
      var Port_5_1 = (document.getElementById("Port_(5)_1") as HTMLInputElement).innerHTML
      var Port_5_2 = (document.getElementById("Port_5_2") as HTMLInputElement).value
      var mm_1 = (document.getElementById("mm_1") as HTMLInputElement).innerHTML
      var Star_board_6_1 = (document.getElementById("Star-board_(6)_1") as HTMLInputElement).innerHTML
      var Star_board_6_2 = (document.getElementById("Star_board_6_2") as HTMLInputElement).value
      var mm_2 = (document.getElementById("mm_2") as HTMLInputElement).innerHTML
      var Mean_7_1 = (document.getElementById("Mean_(7)_1") as HTMLInputElement).innerHTML
      var Mean_7_2 = (document.getElementById("Mean_7_2") as HTMLInputElement).value
      var mm_3 = (document.getElementById("mm_3") as HTMLInputElement).innerHTML
      var Density_of_Water_8_1 = (document.getElementById("Density_of_Water_(8)_1") as HTMLInputElement).innerHTML
      var Density_of_Water_8_2 = (document.getElementById("Density_of_Water_8_2") as HTMLInputElement).value
      var mm_4 = (document.getElementById("mm_4") as HTMLInputElement).innerHTML
      var ALLOWANCE = (document.getElementById("ALLOWANCE") as HTMLInputElement).innerHTML
      var For_Density_of_Water_9_1 = (document.getElementById("For_Density_of_Water_(9)_1") as HTMLInputElement).innerHTML
      var For_Density_of_Water_9_2 = (document.getElementById("For_Density_of_Water_9_2") as HTMLInputElement).value
      var mm_5 = (document.getElementById("mm_5") as HTMLInputElement).innerHTML
      var For_rubbish_10_1 = (document.getElementById("For_rubbish_(10)_1") as HTMLInputElement).innerHTML
      var For_rubbish_10_2 = (document.getElementById("For_rubbish_10_2") as HTMLInputElement).value
      var weight_1 = (document.getElementById("weight_1") as HTMLInputElement).innerHTML
      var For_rubbish_10_3 = (document.getElementById("For_rubbish_(10)_3") as HTMLInputElement).innerHTML
      var For_rubbish_10_4 = (document.getElementById("For_rubbish_10_4") as HTMLInputElement).value
      var mm_6 = (document.getElementById("mm_6") as HTMLInputElement).innerHTML
      var For_fuel_water_and_stores_to_be_consumed_on_stretch_of_inland_water_11_1 = (document.getElementById("For_fuel_water_and_stores_to_be_consumed_on_stretch_of_inland_water_(11)_1") as HTMLInputElement).innerHTML
      var For_fuel_water_and_stores_to_be_consumed_on_stretch_of_inland_water_11_2 = (document.getElementById("For_fuel_water_and_stores_to_be_consumed_on_stretch_of_inland_water_11_2") as HTMLInputElement).value
      var distance_1 = (document.getElementById("distance_1") as HTMLInputElement).innerHTML

      var For_fuel_water_and_stores_to_be_consumed_on_stretch_of_inland_water_11_3 = (document.getElementById("For_fuel_water_and_stores_to_be_consumed_on_stretch_of_inland_water_(11)_3") as HTMLInputElement).innerHTML
      var For_fuel_water_and_stores_to_be_consumed_on_stretch_of_inland_water_11_4 = (document.getElementById("For_fuel_water_and_stores_to_be_consumed_on_stretch_of_inland_water_11_4") as HTMLInputElement).value
      var mm_7 = (document.getElementById("mm_7") as HTMLInputElement).innerHTML
      var Total_allowances_12_1 = (document.getElementById("Total_allowances_(12)_1") as HTMLInputElement).innerHTML
      var Total_allowances_12_2 = (document.getElementById("Total_allowances_12_2") as HTMLInputElement).value
      var mm_8 = (document.getElementById("mm_8") as HTMLInputElement).innerHTML
      var Mean_Draught_in_salt_water_as_calculated_after_making_the_appropriate_allowances_13_1 = (document.getElementById("Mean_Draught_in_salt_water_as_calculated_after_making_the_appropriate_allowances_(13)_1") as HTMLInputElement).innerHTML
      var Mean_Draught_in_salt_water_as_calculated_after_making_the_appropriate_allowances_13_2 = (document.getElementById("Mean_Draught_in_salt_water_as_calculated_after_making_the_appropriate_allowances_13_2") as HTMLInputElement).value
      var Mean_Freeboard_Amidships_in_salt_Water_as_calculated_after_making_the_appropriate_allowances_14_1 = (document.getElementById("Mean_Freeboard_Amidships_in_salt_Water_as_calculated_after_making_the_appropriate_allowances_(14)_1") as HTMLInputElement).innerHTML
      var Mean_Freeboard_Amidships_in_salt_Water_as_calculated_after_making_the_appropriate_allowances_14_2 = (document.getElementById("Mean_Freeboard_Amidships_in_salt_Water_as_calculated_after_making_the_appropriate_allowances_14_2") as HTMLInputElement).value

      var mm_9 = (document.getElementById("mm_9") as HTMLInputElement).innerHTML
      var Date_of_posting_the_Notice_Notice_FRE13_15_1 = (document.getElementById("Date_of_posting_the_Notice_(Notice_FRE13)_(15)_1") as HTMLInputElement).innerHTML
      var Date_of_posting_the_Notice_Notice_FRE13_15_2 = (this.datePipe.transform((document.getElementById("Date_of_posting_the_Notice_Notice_FRE13_15_2") as HTMLInputElement).value, 'dd-MMM-yyyy'));
      var time_of_posting_the_Notice_Notice_FRE13_15_1 = (document.getElementById("time_of_posting_the_Notice_(Notice_FRE13)_(15)_1") as HTMLInputElement).innerHTML
      var time_of_posting_the_Notice_Notice_FRE13_15_2 = (document.getElementById("time_of_posting_the_Notice_Notice_FRE13_15_2") as HTMLInputElement).value;
      //SIGNATURES
      var SIGNATURES = (document.getElementById("SIGNATURES") as HTMLInputElement).innerHTML
      var Master_16_1 = (document.getElementById("Master_(16)_1") as HTMLInputElement).innerHTML
      var Master_16_2 = (document.getElementById("Master_16_2") as HTMLInputElement).value
      var Officer_17_1 = (document.getElementById("Officer_(17)_1") as HTMLInputElement).innerHTML
      var Officer_17_2 = (document.getElementById("Officer_17_2") as HTMLInputElement).value
      //ARRIVALS
      var Date_of_arrival_18_1 = (document.getElementById("Date_of_arrival_(18)_1") as HTMLInputElement).innerHTML
      var Date_of_arrival_18_2 = (this.datePipe.transform((document.getElementById("Date_of_arrival_18_2") as HTMLInputElement).value, 'dd-MMM-yyyy'));
      var hour_of_arrival_18_1 = (document.getElementById("hour_of_arrival_(18)_1") as HTMLInputElement).innerHTML
      var hour_of_arrival_18_2 = (document.getElementById("hour_of_arrival_18_2") as HTMLInputElement).value;
      var Dock_19_1 = (document.getElementById("Dock_(19)_1") as HTMLInputElement).innerHTML
      var Dock_19_2 = (document.getElementById("Dock_19_2") as HTMLInputElement).value
      var wharf_19_1 = (document.getElementById("wharf_(19)_1") as HTMLInputElement).innerHTML
      var wharf_19_2 = (document.getElementById("wharf_19_2") as HTMLInputElement).value
      var harbour_19_1 = (document.getElementById("harbour_(19)_1") as HTMLInputElement).innerHTML
      var harbour_19_2 = (document.getElementById("harbour_19_2") as HTMLInputElement).value
      var other_place_19_1 = (document.getElementById("other_place_(19)_1") as HTMLInputElement).innerHTML
      var other_place_19_2 = (document.getElementById("other_place_19_2") as HTMLInputElement).value

      parameterdata = {
        "Date_of_Departure_1_1": Date_of_Departure_1_1, "Date_of_Departure_1_2": Date_of_Departure_1_2, "hour_of_Departure_1_1": hour_of_Departure_1_1,
        "hour_of_Departure_1_2": hour_of_Departure_1_2, "Dock_2_1": Dock_2_1, "Dock_2_2": Dock_2_2, "Wharf_2_1": Wharf_2_1, "Wharf_2_2": Wharf_2_2, "harbour_2_1": harbour_2_1, "harbour_2_2": harbour_2_2, "other_place_2_1": other_place_2_1, "other_place_2_2": other_place_2_2,
        "ACTUAL_DRAUGHT_OF_WATER": ACTUAL_DRAUGHT_OF_WATER, "Forward_3_1": Forward_3_1, "Forward_3_2": Forward_3_2, "Aft_4_1": Aft_4_1, "Aft_4_2": Aft_4_2, "ACTUAL_FREEBOARD_AMIDSHIPS": ACTUAL_FREEBOARD_AMIDSHIPS,
        "Port_5_1": Port_5_1, "Port_5_2": Port_5_2, "mm_1": mm_1, "Star_board_6_1": Star_board_6_1, "Star_board_6_2": Star_board_6_2, "mm_2": mm_2, "Mean_7_1": Mean_7_1, "Mean_7_2": Mean_7_2, "mm_3": mm_3, "Density_of_Water_8_1": Density_of_Water_8_1, "Density_of_Water_8_2": Density_of_Water_8_2,
        "mm_4": mm_4, "ALLOWANCE": ALLOWANCE, "For_Density_of_Water_9_1": For_Density_of_Water_9_1, "For_Density_of_Water_9_2": For_Density_of_Water_9_2, "mm_5": mm_5, "For_rubbish_10_1": For_rubbish_10_1, "For_rubbish_10_2": For_rubbish_10_2, "weight_1": weight_1, "For_rubbish_10_3": For_rubbish_10_3, "For_rubbish_10_4": For_rubbish_10_4, "mm_6": mm_6, "For_fuel_water_and_stores_to_be_consumed_on_stretch_of_inland_water_11_1": For_fuel_water_and_stores_to_be_consumed_on_stretch_of_inland_water_11_1,
        "For_fuel_water_and_stores_to_be_consumed_on_stretch_of_inland_water_11_2": For_fuel_water_and_stores_to_be_consumed_on_stretch_of_inland_water_11_2,
        "distance_1": distance_1, "For_fuel_water_and_stores_to_be_consumed_on_stretch_of_inland_water_11_3": For_fuel_water_and_stores_to_be_consumed_on_stretch_of_inland_water_11_3, "For_fuel_water_and_stores_to_be_consumed_on_stretch_of_inland_water_11_4": For_fuel_water_and_stores_to_be_consumed_on_stretch_of_inland_water_11_4,
        "mm_7": mm_7, "Total_allowances_12_1": Total_allowances_12_1, "Total_allowances_12_2": Total_allowances_12_2, "mm_8": mm_8, "Mean_Draught_in_salt_water_as_calculated_after_making_the_appropriate_allowances_13_1": Mean_Draught_in_salt_water_as_calculated_after_making_the_appropriate_allowances_13_1,
        "Mean_Draught_in_salt_water_as_calculated_after_making_the_appropriate_allowances_13_2": Mean_Draught_in_salt_water_as_calculated_after_making_the_appropriate_allowances_13_2, "Mean_Freeboard_Amidships_in_salt_Water_as_calculated_after_making_the_appropriate_allowances_14_1": Mean_Freeboard_Amidships_in_salt_Water_as_calculated_after_making_the_appropriate_allowances_14_1,
        "Mean_Freeboard_Amidships_in_salt_Water_as_calculated_after_making_the_appropriate_allowances_14_2": Mean_Freeboard_Amidships_in_salt_Water_as_calculated_after_making_the_appropriate_allowances_14_2,
        "mm_9": mm_9, "Date_of_posting_the_Notice_Notice_FRE13_15_1": Date_of_posting_the_Notice_Notice_FRE13_15_1, "Date_of_posting_the_Notice_Notice_FRE13_15_2": Date_of_posting_the_Notice_Notice_FRE13_15_2,
        "time_of_posting_the_Notice_Notice_FRE13_15_1": time_of_posting_the_Notice_Notice_FRE13_15_1, "time_of_posting_the_Notice_Notice_FRE13_15_2": time_of_posting_the_Notice_Notice_FRE13_15_2,
        "Master_16_1": Master_16_1, "Master_16_2": Master_16_2, "Officer_17_1": Officer_17_1, "Officer_17_2": Officer_17_2, "Date_of_arrival_18_1": Date_of_arrival_18_1, "Date_of_arrival_18_2": Date_of_arrival_18_2, "hour_of_arrival_18_1": hour_of_arrival_18_1, "hour_of_arrival_18_2": hour_of_arrival_18_2,
        "Dock_19_1": Dock_19_1, "Dock_19_2": Dock_19_2,
        "wharf_19_1": wharf_19_1, "wharf_19_2": wharf_19_2, "harbour_19_1": harbour_19_1, "harbour_19_2": harbour_19_2, "other_place_19_1": other_place_19_1, "other_place_19_2": other_place_19_2
      }
    }

    //olb-10
    if (formId == 78) {
      var Date_of_the_occurence_1 = (document.getElementById("Date_of_the_occurence_1") as HTMLInputElement).innerHTML
      var Date_of_the_occurence_2 = (this.datePipe.transform((document.getElementById("Date_of_the_occurence_2") as HTMLInputElement).value, 'dd-MMM-yyyy'));
      var hour_of_the_occurence_1 = (document.getElementById("hour_of_the_occurence_1") as HTMLInputElement).innerHTML
      var hour_of_the_occurence_2 = (document.getElementById("hour_of_the_occurence_2") as HTMLInputElement).value;
      var Place_of_the_occurence_or_situation_by_latitude_and_longitude_at_sea_1 = (document.getElementById("Place_of_the_occurence_or_situation_by_latitude_and_longitude_at_sea_1") as HTMLInputElement).innerHTML
      var Place_of_the_occurence_or_situation_by_latitude_and_longitude_at_sea_2 = (document.getElementById("Place_of_the_occurence_or_situation_by_latitude_and_longitude_at_sea_2") as HTMLInputElement).value
      var Date_of_Entry_1 = (document.getElementById("Date_of_Entry_1") as HTMLInputElement).innerHTML
      var Date_of_Entry_2 = (this.datePipe.transform((document.getElementById("Date_of_Entry_2") as HTMLInputElement).value, 'dd-MMM-yyyy'));
      var Entries_required_by_Regulations_made_under_Section_143_of_the_merchant_Shipping_Act_1976_1 = (document.getElementById("Entries_required_by_Regulations_made_under_Section_143_of_the_merchant_Shipping_Act_1976_1") as HTMLInputElement).innerHTML
      var Entries_required_by_Regulations_made_under_Section_143_of_the_merchant_Shipping_Act_1976_2 = (document.getElementById("Entries_required_by_Regulations_made_under_Section_143_of_the_merchant_Shipping_Act_1976_2") as HTMLInputElement).value
      var State_fine_imposed_if_any_1 = (document.getElementById("State_fine_imposed_if_any_1") as HTMLInputElement).innerHTML
      var State_fine_imposed_if_any_2 = (document.getElementById("State_fine_imposed_if_any_2") as HTMLInputElement).value

      parameterdata = {
        "Date_of_the_occurence_1": Date_of_the_occurence_1, "Date_of_the_occurence_2": Date_of_the_occurence_2, "hour_of_the_occurence_1": hour_of_the_occurence_1, "hour_of_the_occurence_2": hour_of_the_occurence_2, "Place_of_the_occurence_or_situation_by_latitude_and_longitude_at_sea_1": Place_of_the_occurence_or_situation_by_latitude_and_longitude_at_sea_1,
        "Place_of_the_occurence_or_situation_by_latitude_and_longitude_at_sea_2": Place_of_the_occurence_or_situation_by_latitude_and_longitude_at_sea_2,
        "Date_of_Entry_1": Date_of_Entry_1, "Date_of_Entry_2": Date_of_Entry_2,
        "Entries_required_by_Regulations_made_under_Section_143_of_the_merchant_Shipping_Act_1976_1": Entries_required_by_Regulations_made_under_Section_143_of_the_merchant_Shipping_Act_1976_1,
        "Entries_required_by_Regulations_made_under_Section_143_of_the_merchant_Shipping_Act_1976_2": Entries_required_by_Regulations_made_under_Section_143_of_the_merchant_Shipping_Act_1976_2,
        "State_fine_imposed_if_any_1": State_fine_imposed_if_any_1, "State_fine_imposed_if_any_2": State_fine_imposed_if_any_2
      }
    }

    let currentDate = new Date();
    console.log(formdata.value);
    console.log("====this.modifiedData11===", this.modifiedData);
    console.log("====this.modifiedData12==", parameterdata);
    const newData = {};
    Object.entries(formdata.value).filter(([, value]) => value !== "").forEach(([key, value]) => (newData[key] = value));
    console.log(newData);
    let ky = Object.keys(newData);

    let changeField = ky.toString();  //changeFields

    if (this.decklogbook || this.deckbook || this.audit || this.olb) {
      for (let key in parameterdata) {
        if (this.oldData.hasOwnProperty(key) && !changeField.includes(key)) {
          parameterdata[key] = this.oldData[key]; // Update parameterdata with the edited value
        }
      }

      console.log('===editedData old===', parameterdata, this.oldData, this.edited_fields_reason_value)
      const now = new Date();
      var currentDateTime = now.toLocaleString();
      var editedOn='';
      var editBy='';
      var editReason='';
      for (let key in this.edited_fields_reason_value) {
        if (parameterdata.hasOwnProperty(key)) {
        //  parameterdata[key] = this.edited_fields_reason_value[key] + "####" + this.edited_fields_reason_value[key] + "####" + this.firstname + ' ' + this.lastname + "####" + currentDateTime; // Update parameterdata with the comment

          editedOn = `<b>Edited On</b>: ${currentDateTime}<br>`;
          editBy = `<b>Edited By</b>: ${this.firstname + ' ' + this.lastname }<br>`;
          editReason =`<b>Reason</b>: ${this.edited_fields_reason_value[key]['reason']}`;
          parameterdata[key] = `
            <div class="box-edit-top"><strike>${this.modifiedData[key]}</strike></div>
            <div class="box-edit-message">
              ${this.edited_fields_reason_value[key]['value']}
              <div>
                  <div style="margin-top: 10px;">
                    <span class="box-edit-time">${editedOn} ${editBy} ${editReason}</span>
                  </div>
                </div>
            </div></ br>`;
            console.log('===editedDatanew 22===',this.modifiedData[key])
            console.log('===editedDatanew 33===',this.edited_fields_reason_value[key]['value'])
        }
      }
    console.log('===editedDatanew 11===', parameterdata)

    }
    var data =
    {
      "data": [
        {
          "actionDate": this.session.get('actionDate'),
          "actionTime": this.session.get('actionTime'),
          "changeFields": changeField,
          "formData": parameterdata,
          "formId": formId,
          "is_mobile_sync": "false",
          "is_sync": "false",
          "userComment": '',
          "isEdit": false,


          "rowId": this.session.get('rowId'),
          "sectionId": "123",
          "timeStamp": currentDate.getTime(),
          "vesselId": this.currentVessel,
          "voyageId": this.voyageId,
          "voyageNo": this.voyageNo,
          "watchId": this.session.get('watchId'),


        }

      ], "userId": this.session.get('userid'),  //this.userid
      "userName": this.firstname + this.lastname,
      "userSign": this.session.get('userSignature')
    }

    console.log("data datadata:  " + JSON.stringify(data));

    return this.http.post(this.service.getBaseUrl() + '/createTableByFormData/', data)
      .subscribe((result) => {
        // console.log(result);


        if (result['responsecode'] === 200 || result['responsecode'] === '200') {
          this.successbox.text = result['message'];
          this.successbox.show();
          formdata.reset();

          this.showpoptable = 1;
          this.showpopdeck = 1;
          this.aircompressor = 0;
          this.logbook = "";
          this.showpopreefer = 0;
          this.showpopaircondition = 0;
          this.showpopauxiliary = 0;
          this.reefer = 0;
          this.auxiliary = 0;
          this.aircondition = 0;
          this.showpopaircompressor = 0;
          this.olb = "";
          this.decklogbook = 0;
          this.audit = "";
          this.deckbook = "";
          this.openpanel(this.editedBookName,this.editedBookId,this.editedBookIndex);
        }
        else {
          this.showErrorMsg('', result['message'])
        }
      });

  }

  public getChangedFields(modifiedData, parameterdata) {
    const differences = [];

    for (const key in parameterdata) {
      const cleanMainValue = this.stripHtmlTags(modifiedData[key]);
      const cleanParamValue = this.stripHtmlTags(parameterdata[key]);

      if ((cleanMainValue || "") !== (cleanParamValue || "")) {
        differences.push({
          field: key,
          oldValue: cleanMainValue,
          newValue: cleanParamValue
        });
      }
    }

    return differences;
  }

  closePopup() {
    this.saveReason = false;
  }


  saveComment(): void {

    if (!this.reasonText.trim()) {
      this.showError = true;
      return;
    }
    this.showError = false;

    var user_comment_value = this.stripHtmlTags(this.reasonText);
    console.log("User Comment: ", user_comment_value);

    if (!this.edited_fields_reason_value[this.edited_field_id]) {
      this.edited_fields_reason_value[this.edited_field_id] = {};
    }

    this.edited_fields_reason_value[this.edited_field_id]= {
      "reason":user_comment_value,
      "value":this.edited_field_value
    };
    this.reasonText = '';
    this.edited_field_id = '';
    // Save the comment to the database or perform any other action
    // For demonstration, we'll just log it to the console
    console.log("edited_fields_reason_value Saved Text1: ", user_comment_value);
    console.log("edited_fields_reason_value Saved Text2: ", this.edited_fields_reason_value);
    console.log("edited_fields_reason_value Saved Text4: ", this.edited_field_value);
    // Optionally, you can close the popup after saving
    this.closePopup();
  }

  public stripHtmlTags(str) {
    if (typeof str === 'string') {
      return str.replace(/<\/?[^>]+(>|$)/g, "").trim();
    }
    return str;
  }

  public processFields(data) {
    const result = {};

    for (let key in data) {
      // If the value is a string, split it by '####' and get the first element
      if (typeof data[key] === 'string') {
        result[key] = data[key].split('####')[0] || '';
      } else {
        // If it's not a string (like an object or array), just add it as is
        result[key] = data[key];
      }
    }

    return (result as any);
  }

 public modifiedDataUpdate(data: any): any {
  const result = {};

  const start = '<div class="box-edit-message">';
  const end = '<div>';

  for (let key in data) {
    const fullText = data[key];

    if (typeof fullText === 'string' && fullText.includes(start)) {
      const regex = new RegExp(`${start}(.*?)${end}`, 's'); // 's' for multiline match
      const match = fullText.match(regex);

      if (match && match[1]) {
        result[key] = match[1].trim(); // Only the content inside box-edit-message
      } else {
        result[key] = fullText; // Leave it unchanged if pattern not matched
      }
    }else if (typeof fullText === 'string' && fullText.includes('####')) {
       result[key] = fullText.split('####')[0] || '';
    } else {
      result[key] = fullText; // Leave non-matching or non-string values as is
    }
  }

  return result;
}

  //*** EDIT FUNCTION ***/
  public onClick(action, processedData, index) {
    // console.log('-----onClick--- check');
    // console.log(action)
    // console.log("====processedData====", processedData)
    // console.log(index)
    this.oldData = processedData;

    const data = this.modifiedDataUpdate(processedData);
    this.modifiedData = data;
    console.log("====modifiedData====", this.modifiedData);

    //setTimeout(()=>{
    if (action == 'edit') {

      this.showpoptable = 0;
      this.showpopreefer = 0;
      this.showpopauxiliary = 0;
      this.showpopaircondition = 0;
      this.reefer = 0;
      this.aircondition = 0;
      this.showpopaircompressor = 0;
      this.auxiliary = 0;
      this.aircompressor = 0;
      this.showpopdeck = 0;
      this.decklogbook = 0;
      this.tableshow = data.formId;

      this.session.set('onClick data', data);
      this.session.set('rowId', data.rowId);
      this.session.set('actionDate', data.actionDate);
      this.session.set('actionTime', data.actionTime);
      this.session.set('watchHourId', data.watchHourId);
      this.session.set('watchId', data.watchId);
      this.session.set('watchHourTime', data.watchHourTime);
      //console.log("DATA IS" + "" + JSON.stringify(data));
      // console.log(action);




      if (data.formId == 22) {
        this.logbook = 22;
        setTimeout(() => {
          //main engine M/E1
          (document.getElementById("Gov_Index_186") as HTMLInputElement).value = data.Gov_Index_186;
          (document.getElementById("Load_187") as HTMLInputElement).value = data.Load_187;
          (document.getElementById("Rev_Counter_188") as HTMLInputElement).value = data.Rev_Counter_188;
          (document.getElementById("RPM_189") as HTMLInputElement).value = data.RPM_189;
          (document.getElementById("Sump_Level_825") as HTMLInputElement).value = data.Sump_Level_825;
          (document.getElementById("TCh_RPM_10") as HTMLInputElement).value = data.TCh_RPM_10;
          //main engine  M/E LUBE OIL PRESSURE
          (document.getElementById("ME_Lo_Pr_In_194") as HTMLInputElement).value = data['ME_Lo_Pr_In_194'];
          (document.getElementById("ME_Lo_Filter_Before_195") as HTMLInputElement).value = data.ME_Lo_Filter_Before_195;
          (document.getElementById("ME_Lo_Filter_After_196") as HTMLInputElement).value = data.ME_Lo_Filter_After_196;
          (document.getElementById("ME_Pist_Cool_In_197") as HTMLInputElement).value = data.ME_Pist_Cool_In_197;
          (document.getElementById("ME_Thrust_Brg_198") as HTMLInputElement).value = data.ME_Thrust_Brg_198;
          (document.getElementById("ME_TCH_Pr_199") as HTMLInputElement).value = data.ME_TCH_Pr_199;
          (document.getElementById("ME_ST_Lo_Pr_208") as HTMLInputElement).value = data.ME_ST_Lo_Pr_208;
          //M/E LUBE OIL TEMPERATURE
          (document.getElementById("ME_ST_Lo_Temp_209") as HTMLInputElement).value = data.ME_ST_Lo_Temp_209;
          (document.getElementById("Water_Content_210") as HTMLInputElement).value = data.Water_Content_210;
          (document.getElementById("Eng_Brg_Temp_01_211") as HTMLInputElement).value = data.Eng_Brg_Temp_01_211;
          (document.getElementById("Eng_Brg_Temp_02_212") as HTMLInputElement).value = data.Eng_Brg_Temp_02_212;
          (document.getElementById("Eng_Brg_Temp_03_213") as HTMLInputElement).value = data.Eng_Brg_Temp_03_213;
          (document.getElementById("Eng_Brg_Temp_04_214") as HTMLInputElement).value = data.Eng_Brg_Temp_04_214;
          (document.getElementById("Eng_Brg_Temp_05_215") as HTMLInputElement).value = data.Eng_Brg_Temp_05_215;
          (document.getElementById("Eng_Brg_Temp_06_224") as HTMLInputElement).value = data.Eng_Brg_Temp_06_224;
          (document.getElementById("Eng_Brg_Temp_07_225") as HTMLInputElement).value = data.Eng_Brg_Temp_07_225;
          (document.getElementById("Eng_Brg_Temp_08_226") as HTMLInputElement).value = data.Eng_Brg_Temp_08_226;
          (document.getElementById("Piston_Cooling_Put_01_227") as HTMLInputElement).value = data.Piston_Cooling_Put_01_227;
          (document.getElementById("Piston_Cooling_Put_02_228") as HTMLInputElement).value = data.Piston_Cooling_Put_02_228;
          (document.getElementById("Piston_Cooling_Put_03_230") as HTMLInputElement).value = data.Piston_Cooling_Put_03_230;
          (document.getElementById("Piston_Cooling_Put_04_232") as HTMLInputElement).value = data.Piston_Cooling_Put_04_232;
          (document.getElementById("Piston_Cooling_Put_05_233") as HTMLInputElement).value = data.Piston_Cooling_Put_05_233;
          (document.getElementById("Piston_Cooling_Put_06_234") as HTMLInputElement).value = data.Piston_Cooling_Put_06_234;
          (document.getElementById("Piston_Cooling_Put_07_235") as HTMLInputElement).value = data.Piston_Cooling_Put_07_235;
          (document.getElementById("Piston_Cooling_Put_08_236") as HTMLInputElement).value = data.Piston_Cooling_Put_08_236;
          (document.getElementById("ME_Thrust_Pad_Temp_237") as HTMLInputElement).value = data.ME_Thrust_Pad_Temp_237;
          (document.getElementById("ME_Int_Shaft_Brg_Temp_238") as HTMLInputElement).value = data.ME_Int_Shaft_Brg_Temp_238;
          (document.getElementById("ME_LO_Cooler_In_244") as HTMLInputElement).value = data.ME_LO_Cooler_In_244;
          (document.getElementById("ME_LO_Cooler_Out_245") as HTMLInputElement).value = data.ME_LO_Cooler_Out_245;
          (document.getElementById("ME_TCh_LO_In_246") as HTMLInputElement).value = data.ME_TCh_LO_In_246;
          (document.getElementById("ME_TCh_LO_Out_247") as HTMLInputElement).value = data.ME_TCh_LO_Out_247;
          //M/E CW
          (document.getElementById("ME_CW_HT_IN_Pr_264") as HTMLInputElement).value = data.ME_CW_HT_IN_Pr_264;
          (document.getElementById("ME_CW_LT_IN_Pr_273") as HTMLInputElement).value = data.ME_CW_LT_IN_Pr_273;
          (document.getElementById("CFW_Cooler1_In_274") as HTMLInputElement).value = data.CFW_Cooler1_In_274;
          (document.getElementById("CFW_Cooler1_Out_284") as HTMLInputElement).value = data.CFW_Cooler1_Out_284;
          (document.getElementById("CFW_Cooler2_In_285") as HTMLInputElement).value = data.CFW_Cooler2_In_285;
          (document.getElementById("CFW_Cooler2_Out_288") as HTMLInputElement).value = data.CFW_Cooler2_Out_288;
          (document.getElementById("CSW_Cooler1_In_294") as HTMLInputElement).value = data.CSW_Cooler1_In_294;
          (document.getElementById("CSW_Cooler1_Out_295") as HTMLInputElement).value = data.CSW_Cooler1_Out_295;
          (document.getElementById("CSW_Cooler2_In_296") as HTMLInputElement).value = data.CSW_Cooler2_In_296;
          (document.getElementById("CSW_Cooler2_Out_297") as HTMLInputElement).value = data.CSW_Cooler2_Out_297;
          (document.getElementById("CFW_To_Eng_T_298") as HTMLInputElement).value = data.CFW_To_Eng_T_298;
          (document.getElementById("CFW_Cyl_Outlet_01_299") as HTMLInputElement).value = data.CFW_Cyl_Outlet_01_299;
          (document.getElementById("CFW_Cyl_Outlet_02_300") as HTMLInputElement).value = data.CFW_Cyl_Outlet_02_300;
          (document.getElementById("CFW_Cyl_Outlet_03_301") as HTMLInputElement).value = data.CFW_Cyl_Outlet_03_301;
          (document.getElementById("CFW_Cyl_Outlet_04_302") as HTMLInputElement).value = data.CFW_Cyl_Outlet_04_302;
          (document.getElementById("CFW_Cyl_Outlet_05_303") as HTMLInputElement).value = data.CFW_Cyl_Outlet_05_303;
          (document.getElementById("CFW_Cyl_Outlet_06_304") as HTMLInputElement).value = data.CFW_Cyl_Outlet_06_304;
          (document.getElementById("CFW_Cyl_Outlet_07_305") as HTMLInputElement).value = data.CFW_Cyl_Outlet_07_305;
          (document.getElementById("CFW_Cyl_Outlet_08_306") as HTMLInputElement).value = data.CFW_Cyl_Outlet_08_306;
          //"M/E FUEL OIL PRESSURE
          (document.getElementById("ME_Fuel_Index_307") as HTMLInputElement).value = data.ME_Fuel_Index_307;
          (document.getElementById("ME_Fuel_Oil_In_Pr_308") as HTMLInputElement).value = data.ME_Fuel_Oil_In_Pr_308;
          (document.getElementById("ME_Fuel_Oil_Filter_In_309") as HTMLInputElement).value = data.ME_Fuel_Oil_Filter_In_309;
          (document.getElementById("ME_Fuel_Oil_Filter_Out_310") as HTMLInputElement).value = data.ME_Fuel_Oil_Filter_Out_310;
          (document.getElementById("ME_Fuel_Oil_Viscosity_Set_311") as HTMLInputElement).value = data.ME_Fuel_Oil_Viscosity_Set_311;
          (document.getElementById("ME_Fuel_Oil_Viscosity_PV_312") as HTMLInputElement).value = data.ME_Fuel_Oil_Viscosity_PV_312;
          //M/E FUEL OIL TEMPERATURE
          (document.getElementById("ME_Fuel_Oil_Temp_In_313") as HTMLInputElement).value = data.ME_Fuel_Oil_Temp_In_313;
          (document.getElementById("ME_Fuel_Rack_01_314") as HTMLInputElement).value = data.ME_Fuel_Rack_01_314;
          (document.getElementById("ME_Fuel_Rack_02_315") as HTMLInputElement).value = data.ME_Fuel_Rack_02_315;
          (document.getElementById("ME_Fuel_Rack_03_316") as HTMLInputElement).value = data.ME_Fuel_Rack_03_316;
          (document.getElementById("ME_Fuel_Rack_04_317") as HTMLInputElement).value = data.ME_Fuel_Rack_04_317;
          (document.getElementById("ME_Fuel_Rack_05_318") as HTMLInputElement).value = data.ME_Fuel_Rack_05_318;
          (document.getElementById("ME_Fuel_Rack_06_319") as HTMLInputElement).value = data.ME_Fuel_Rack_06_319;
          (document.getElementById("ME_Fuel_Rack_07_320") as HTMLInputElement).value = data.ME_Fuel_Rack_07_320;
          (document.getElementById("ME_Fuel_Rack_08_321") as HTMLInputElement).value = data.ME_Fuel_Rack_08_321;
          (document.getElementById("ME_VIT_Rack_01_322") as HTMLInputElement).value = data.ME_VIT_Rack_01_322;
          (document.getElementById("ME_VIT_Rack_02_323") as HTMLInputElement).value = data.ME_VIT_Rack_02_323;
          (document.getElementById("ME_VIT_Rack_03_324") as HTMLInputElement).value = data.ME_VIT_Rack_03_324;
          (document.getElementById("ME_VIT_Rack_04_325") as HTMLInputElement).value = data.ME_VIT_Rack_04_325;
          (document.getElementById("ME_VIT_Rack_05_326") as HTMLInputElement).value = data.ME_VIT_Rack_05_326;
          (document.getElementById("ME_VIT_Rack_06_327") as HTMLInputElement).value = data.ME_VIT_Rack_06_327;
          (document.getElementById("ME_VIT_Rack_07_328") as HTMLInputElement).value = data.ME_VIT_Rack_07_328;
          (document.getElementById("ME_VIT_Rack_08_329") as HTMLInputElement).value = data.ME_VIT_Rack_08_329;
          //M/E/T/C AIR COOLER
          (document.getElementById("Atm_Pr_330") as HTMLInputElement).value = data.Atm_Pr_330;
          (document.getElementById("ME_Scav_Pr_331") as HTMLInputElement).value = data.ME_Scav_Pr_331;
          (document.getElementById("ME_Exh_Gas_Receiver_332") as HTMLInputElement).value = data.ME_Exh_Gas_Receiver_332;
          (document.getElementById("Pr_Drop_Accross_TCh_Filter_333") as HTMLInputElement).value = data.Pr_Drop_Accross_TCh_Filter_333;
          (document.getElementById("Pr_Drop_Accross_Air_Cooler_334") as HTMLInputElement).value = data.Pr_Drop_Accross_Air_Cooler_334;
          (document.getElementById("Pr_Drop_Accross_EGE_335") as HTMLInputElement).value = data.Pr_Drop_Accross_EGE_335;
          (document.getElementById("Air_Cooler_Temp_In_336") as HTMLInputElement).value = data.Air_Cooler_Temp_In_336;
          (document.getElementById("Air_Cooler_Temp_Out_337") as HTMLInputElement).value = data.Air_Cooler_Temp_Out_337;
          (document.getElementById("TCh_Exh_Gas_Temp_In_338") as HTMLInputElement).value = data.TCh_Exh_Gas_Temp_In_338;
          (document.getElementById("TCh_Exh_Gas_Temp_Out_339") as HTMLInputElement).value = data.TCh_Exh_Gas_Temp_Out_339;
          (document.getElementById("Exh_Gas_Temp_01_340") as HTMLInputElement).value = data.Exh_Gas_Temp_01_340;
          (document.getElementById("Exh_Gas_Temp_02_341") as HTMLInputElement).value = data.Exh_Gas_Temp_02_341;
          (document.getElementById("Exh_Gas_Temp_03_342") as HTMLInputElement).value = data.Exh_Gas_Temp_03_342;
          (document.getElementById("Exh_Gas_Temp_04_343") as HTMLInputElement).value = data.Exh_Gas_Temp_04_343;
          (document.getElementById("Exh_Gas_Temp_05_344") as HTMLInputElement).value = data.Exh_Gas_Temp_05_344;
          (document.getElementById("Exh_Gas_Temp_06_345") as HTMLInputElement).value = data.Exh_Gas_Temp_06_345;
          (document.getElementById("Exh_Gas_Temp_07_346") as HTMLInputElement).value = data.Exh_Gas_Temp_07_346;
          (document.getElementById("Exh_Gas_Temp_08_347") as HTMLInputElement).value = data.Exh_Gas_Temp_08_347;
          (document.getElementById("EGE_Temp_In_348") as HTMLInputElement).value = data.EGE_Temp_In_348;
          (document.getElementById("EGE_Temp_Out_349") as HTMLInputElement).value = data.EGE_Temp_Out_349;
          //M/E Scav AND Exh
          (document.getElementById("Pressures_Scav_Air_Pr_826") as HTMLInputElement).value = data.Pressures_Scav_Air_Pr_826;
          (document.getElementById("Temperatures_Scav_Temp_827") as HTMLInputElement).value = data.Temperatures_Scav_Temp_827;
          (document.getElementById("Exh_Temp_Out_01_828") as HTMLInputElement).value = data.Exh_Temp_Out_01_828;
          (document.getElementById("Exh_Temp_Out_02_829") as HTMLInputElement).value = data.Exh_Temp_Out_02_829;
          (document.getElementById("Exh_Temp_Out_03_830") as HTMLInputElement).value = data.Exh_Temp_Out_03_830;
          (document.getElementById("Exh_Temp_Out_04_831") as HTMLInputElement).value = data.Exh_Temp_Out_04_831;
          (document.getElementById("Exh_Temp_Out_05_832") as HTMLInputElement).value = data.Exh_Temp_Out_05_832;
          (document.getElementById("Exh_Temp_Out_06_833") as HTMLInputElement).value = data.Exh_Temp_Out_06_833;
          (document.getElementById("TCH_Temp_In_834") as HTMLInputElement).value = data.TCH_Temp_In_834;
          (document.getElementById("TCH_Temp_Out_835") as HTMLInputElement).value = data.TCH_Temp_Out_835;
        }, 500);

      }
      //AUXILLARY ENGINE 1
      if (data.formId == 1) {
        this.logbook = 1;
        setTimeout(() => {
          (document.getElementById("Load_1") as HTMLInputElement).value = data.Load_1;
          (document.getElementById("Amps_2") as HTMLInputElement).value = data.Amps_2;
          (document.getElementById("Power_Factor_3") as HTMLInputElement).value = data.Power_Factor_3;
          (document.getElementById("Voltage_4") as HTMLInputElement).value = data.Voltage_4;
          (document.getElementById("Hours_Run_6") as HTMLInputElement).value = data.Hours_Run_6;
          (document.getElementById("Gov_Index_7") as HTMLInputElement).value = data.Gov_Index_7;
          (document.getElementById("Sump_Level_8") as HTMLInputElement).value = data.Sump_Level_8;
          (document.getElementById("TCh_RPM_10") as HTMLInputElement).value = data.TCh_RPM_10;
          //Pressure
          (document.getElementById("LO_Pressure_13") as HTMLInputElement).value = data.LO_Pressure_13;
          (document.getElementById("Filter_LO_Pr_In_15") as HTMLInputElement).value = data.Filter_LO_Pr_In_15;
          (document.getElementById("Filter_LO_Pr_Out_17") as HTMLInputElement).value = data.Filter_LO_Pr_Out_17;
          (document.getElementById("TCh_LO_Pr_In_19") as HTMLInputElement).value = data.TCh_LO_Pr_In_19;
          //TEMPERATURES
          (document.getElementById("LO_Inlet_Temp_20") as HTMLInputElement).value = data.LO_Inlet_Temp_20;
          (document.getElementById("LO_Cooler_Temp_In_22") as HTMLInputElement).value = data.LO_Cooler_Temp_In_22;
          (document.getElementById("LO_Cooler_Temp_Out_24") as HTMLInputElement).value = data.LO_Cooler_Temp_Out_24;
          (document.getElementById("LO_TCh_Temp_In_26") as HTMLInputElement).value = data.LO_TCh_Temp_In_26;
          //FRESH WATER
          (document.getElementById("Ht_Pr_In_28") as HTMLInputElement).value = data.Ht_Pr_In_28;
          (document.getElementById("Lt_Pr_In_30") as HTMLInputElement).value = data.Lt_Pr_In_30;
          (document.getElementById("Cooling_Water_Out_1_32") as HTMLInputElement).value = data.Cooling_Water_Out_1_32;
          (document.getElementById("Cooling_Water_Out_2_33") as HTMLInputElement).value = data.Cooling_Water_Out_2_33;
          (document.getElementById("Cooling_Water_Out_3_34") as HTMLInputElement).value = data.Cooling_Water_Out_3_34;
          (document.getElementById("Cooling_Water_Out_4_36") as HTMLInputElement).value = data.Cooling_Water_Out_4_36;
          (document.getElementById("Cooling_Water_Out_5_37") as HTMLInputElement).value = data.Cooling_Water_Out_5_37;
          (document.getElementById("Cooling_Water_Out_6_39") as HTMLInputElement).value = data.Cooling_Water_Out_6_39;
          //SCAV AND EXH
          (document.getElementById("Pressures_Scav_Air_Pr_35") as HTMLInputElement).value = data.Pressures_Scav_Air_Pr_35;
          (document.getElementById("Temperatures_Scav_Temp_44") as HTMLInputElement).value = data.Temperatures_Scav_Temp_44;
          (document.getElementById("Exh_Temp_Out_01_45") as HTMLInputElement).value = data.Exh_Temp_Out_01_45;
          (document.getElementById("Exh_Temp_Out_02_46") as HTMLInputElement).value = data.Exh_Temp_Out_02_46;
          (document.getElementById("Exh_Temp_Out_03_47") as HTMLInputElement).value = data.Exh_Temp_Out_03_47;
          (document.getElementById("Exh_Temp_Out_04_48") as HTMLInputElement).value = data.Exh_Temp_Out_04_48;
          (document.getElementById("Exh_Temp_Out_05_49") as HTMLInputElement).value = data.Exh_Temp_Out_05_49;
          (document.getElementById("Exh_Temp_Out_06_50") as HTMLInputElement).value = data.Exh_Temp_Out_06_50;
          (document.getElementById("TCH_Temp_In_51") as HTMLInputElement).value = data.TCH_Temp_In_51;
          (document.getElementById("TCH_Temp_Out_52") as HTMLInputElement).value = data.TCH_Temp_Out_52;
          //ALTERNATOR
          (document.getElementById("Bearing_1_Temp_38") as HTMLInputElement).value = data.Bearing_1_Temp_38;
          (document.getElementById("Bearing_2_Temp_40") as HTMLInputElement).value = data.Bearing_2_Temp_40;
          (document.getElementById("Winding_Temp_R_S_41") as HTMLInputElement).value = data.Winding_Temp_R_S_41;
          (document.getElementById("Winding_Temp_S_T_42") as HTMLInputElement).value = data.Winding_Temp_S_T_42;
          (document.getElementById("Winding_Temp_R_T_43") as HTMLInputElement).value = data.Winding_Temp_R_T_43;
        }, 500);
      }

      // AUXILIARY ENGINE Engine2 (CENTER)
      if (data.formId == 20) {
        this.logbook = 20;
        setTimeout(() => {
          //None
          // console.log("====data===", data, data.Load_166);
          (document.getElementById("Load_166") as HTMLInputElement).value = data.Load_166;
          (document.getElementById("Amps_167") as HTMLInputElement).value = data.Amps_167;
          (document.getElementById("Power_Factor_168") as HTMLInputElement).value = data.Power_Factor_168;
          (document.getElementById("Voltage_169") as HTMLInputElement).value = data.Voltage_169;
          (document.getElementById("Hours_Run_170") as HTMLInputElement).value = data.Hours_Run_170;
          (document.getElementById("Gov_Index_171") as HTMLInputElement).value = data.Gov_Index_171;
          (document.getElementById("Sump_Level_172") as HTMLInputElement).value = data.Sump_Level_172;
          (document.getElementById("TCh_RPM_173") as HTMLInputElement).value = data.TCh_RPM_173;
          //Pressures
          (document.getElementById("LO_Pressure_178") as HTMLInputElement).value = data.LO_Pressure_178;
          (document.getElementById("Filter_LO_Pr_In_179") as HTMLInputElement).value = data.Filter_LO_Pr_In_179;
          (document.getElementById("Filter_LO_Pr_Out_180") as HTMLInputElement).value = data.Filter_LO_Pr_Out_180;
          (document.getElementById("TCh_LO_Pr_In_181") as HTMLInputElement).value = data.TCh_LO_Pr_In_181;
          //TEMPERATURES
          (document.getElementById("LO_Inlet_Temp_190") as HTMLInputElement).value = data.LO_Inlet_Temp_190;
          (document.getElementById("LO_Cooler_Temp_In_191") as HTMLInputElement).value = data.LO_Cooler_Temp_In_191;
          (document.getElementById("LO_Cooler_Temp_Out_192") as HTMLInputElement).value = data.LO_Cooler_Temp_Out_192;
          (document.getElementById("LO_TCh_Temp_In_193") as HTMLInputElement).value = data.LO_TCh_Temp_In_193;
          //FRESH WATER
          (document.getElementById("Ht_Pr_In_200") as HTMLInputElement).value = data.Ht_Pr_In_200;
          (document.getElementById("Lt_Pr_In_201") as HTMLInputElement).value = data.Lt_Pr_In_201;
          (document.getElementById("Cooling_Water_Out_1_202") as HTMLInputElement).value = data.Cooling_Water_Out_1_202;
          (document.getElementById("Cooling_Water_Out_2_203") as HTMLInputElement).value = data.Cooling_Water_Out_2_203;
          (document.getElementById("Cooling_Water_Out_3_204") as HTMLInputElement).value = data.Cooling_Water_Out_3_204;
          (document.getElementById("Cooling_Water_Out_4_205") as HTMLInputElement).value = data.Cooling_Water_Out_4_205;
          (document.getElementById("Cooling_Water_Out_5_206") as HTMLInputElement).value = data.Cooling_Water_Out_5_206;
          (document.getElementById("Cooling_Water_Out_6_207") as HTMLInputElement).value = data.Cooling_Water_Out_6_207;
          //SCAV AND EXH
          // console.log("===SCAV AND EXH===", data);
          (document.getElementById("Pressures_Scav_Air_Pr_216") as HTMLInputElement).value = data["Pressures_Scav_Air_Pr_216"];
          (document.getElementById("Temperatures_Scav_Temp_217") as HTMLInputElement).value = data.Temperatures_Scav_Temp_217;
          (document.getElementById("Exh_Temp_Out_01_218") as HTMLInputElement).value = data.Exh_Temp_Out_01_218;
          (document.getElementById("Exh_Temp_Out_02_219") as HTMLInputElement).value = data.Exh_Temp_Out_02_219;
          (document.getElementById("Exh_Temp_Out_03_220") as HTMLInputElement).value = data.Exh_Temp_Out_03_220;
          (document.getElementById("Exh_Temp_Out_04_221") as HTMLInputElement).value = data.Exh_Temp_Out_04_221;
          (document.getElementById("Exh_Temp_Out_05_222") as HTMLInputElement).value = data.Exh_Temp_Out_05_222;
          (document.getElementById("Exh_Temp_Out_06_223") as HTMLInputElement).value = data.Exh_Temp_Out_06_223;
          (document.getElementById("TCH_Temp_In_229") as HTMLInputElement).value = data.TCH_Temp_In_229;
          (document.getElementById("TCH_Temp_Out_231") as HTMLInputElement).value = data.TCH_Temp_Out_231;
          //ALTERNATOR
          (document.getElementById("Bearing_1_Temp_239") as HTMLInputElement).value = data.Bearing_1_Temp_239;
          (document.getElementById("Bearing_2_Temp_240") as HTMLInputElement).value = data.Bearing_2_Temp_240;
          (document.getElementById("Winding_Temp_R_S_241") as HTMLInputElement).value = data.Winding_Temp_R_S_241;
          (document.getElementById("Winding_Temp_S_T_242") as HTMLInputElement).value = data.Winding_Temp_S_T_242;
          (document.getElementById("Winding_Temp_R_T_243") as HTMLInputElement).value = data.Winding_Temp_R_T_243;
        }, 500);

      }

      // AUXILIARY ENGINE Engine3(STBD)
      if (data.formId == 21) {
        this.logbook = 21;
        setTimeout(() => {
          //None
          (document.getElementById("Load_248") as HTMLInputElement).value = data.Load_248;
          (document.getElementById("Amps_249") as HTMLInputElement).value = data.Amps_249;
          (document.getElementById("Power_Factor_250") as HTMLInputElement).value = data.Power_Factor_250;
          (document.getElementById("Voltage_251") as HTMLInputElement).value = data.Voltage_251;
          (document.getElementById("Hours_Run_252") as HTMLInputElement).value = data.Hours_Run_252;
          (document.getElementById("Gov_Index_253") as HTMLInputElement).value = data.Gov_Index_253;
          (document.getElementById("Sump_Level_254") as HTMLInputElement).value = data.Sump_Level_254;
          (document.getElementById("TCh_RPM_255") as HTMLInputElement).value = data.TCh_RPM_255;
          //Pressures
          (document.getElementById("LO_Pressure_256") as HTMLInputElement).value = data.LO_Pressure_256;
          (document.getElementById("Filter_LO_Pr_In_257") as HTMLInputElement).value = data.Filter_LO_Pr_In_257;
          (document.getElementById("Filter_LO_Pr_Out_258") as HTMLInputElement).value = data.Filter_LO_Pr_Out_258;
          (document.getElementById("TCh_LO_Pr_In_259") as HTMLInputElement).value = data.TCh_LO_Pr_In_259;
          //TEMPERATURES
          (document.getElementById("LO_Inlet_Temp_260") as HTMLInputElement).value = data.LO_Inlet_Temp_260;
          (document.getElementById("LO_Cooler_Temp_In_261") as HTMLInputElement).value = data.LO_Cooler_Temp_In_261;
          (document.getElementById("LO_Cooler_Temp_Out_262") as HTMLInputElement).value = data.LO_Cooler_Temp_Out_262;
          (document.getElementById("LO_TCh_Temp_In_263") as HTMLInputElement).value = data.LO_TCh_Temp_In_263;
          //FRESH WATER
          (document.getElementById("Ht_Pr_In_265") as HTMLInputElement).value = data.Ht_Pr_In_265;
          (document.getElementById("Lt_Pr_In_266") as HTMLInputElement).value = data.Lt_Pr_In_266;
          (document.getElementById("Cooling_Water_Out_1_267") as HTMLInputElement).value = data.Cooling_Water_Out_1_267;
          (document.getElementById("Cooling_Water_Out_2_268") as HTMLInputElement).value = data.Cooling_Water_Out_2_268;
          (document.getElementById("Cooling_Water_Out_3_269") as HTMLInputElement).value = data.Cooling_Water_Out_3_269;
          (document.getElementById("Cooling_Water_Out_4_270") as HTMLInputElement).value = data.Cooling_Water_Out_4_270;
          (document.getElementById("Cooling_Water_Out_5_271") as HTMLInputElement).value = data.Cooling_Water_Out_5_271;
          (document.getElementById("Cooling_Water_Out_6_272") as HTMLInputElement).value = data.Cooling_Water_Out_6_272;
          //SCAV AND EXH
          (document.getElementById("Pressures_Scav_Air_Pr_275") as HTMLInputElement).value = data.Pressures_Scav_Air_Pr_275
            (document.getElementById("Temperatures_Scav_Temp_276") as HTMLInputElement).value = data.Temperatures_Scav_Temp_276;
          (document.getElementById("Exh_Temp_Out_01_278") as HTMLInputElement).value = data.Exh_Temp_Out_01_278;
          (document.getElementById("Exh_Temp_Out_02_279") as HTMLInputElement).value = data.Exh_Temp_Out_02_279;
          (document.getElementById("Exh_Temp_Out_03_280") as HTMLInputElement).value = data.Exh_Temp_Out_03_280;
          (document.getElementById("Exh_Temp_Out_04_281") as HTMLInputElement).value = data.Exh_Temp_Out_04_281;
          (document.getElementById("Exh_Temp_Out_05_282") as HTMLInputElement).value = data.Exh_Temp_Out_05_282;
          (document.getElementById("Exh_Temp_Out_06_283") as HTMLInputElement).value = data.Exh_Temp_Out_06_283;
          (document.getElementById("TCH_Temp_In_286") as HTMLInputElement).value = data.TCH_Temp_In_286;
          (document.getElementById("TCH_Temp_Out_287") as HTMLInputElement).value = data.TCH_Temp_Out_287;
          //ALTERNATOR
          (document.getElementById("Bearing_1_Temp_289") as HTMLInputElement).value = data.Bearing_1_Temp_289;
          (document.getElementById("Bearing_2_Temp_290") as HTMLInputElement).value = data.Bearing_2_Temp_290;
          (document.getElementById("Winding_Temp_R_S_291") as HTMLInputElement).value = data.Winding_Temp_R_S_291;
          (document.getElementById("Winding_Temp_S_T_292") as HTMLInputElement).value = data.Winding_Temp_S_T_292;
          (document.getElementById("Winding_Temp_R_T_293") as HTMLInputElement).value = data.Winding_Temp_R_T_293;

        }, 500);
      }

      //Reefer Equipment1
      if (data.formId == 2) {
        this.logbook = 2;
        setTimeout(() => {
          (document.getElementById("Suction_Pr_5") as HTMLInputElement).value = data.Suction_Pr_5;
          (document.getElementById("Discharge_Pr_9") as HTMLInputElement).value = data.Discharge_Pr_9;
          (document.getElementById("Oil_Pr_11") as HTMLInputElement).value = data.Oil_Pr_11;
          (document.getElementById("Sump_Level_12") as HTMLInputElement).value = data.Sump_Level_12;
          (document.getElementById("Meat_Room_14") as HTMLInputElement).value = data.Meat_Room_14;
          (document.getElementById("Fish_Room_16") as HTMLInputElement).value = data.Fish_Room_16;
          (document.getElementById("Veg_Room_18") as HTMLInputElement).value = data.Veg_Room_18;
          (document.getElementById("Lobby_Room_21") as HTMLInputElement).value = data.Lobby_Room_21;
          (document.getElementById("Dairy_Room_23") as HTMLInputElement).value = data.Dairy_Room_23;
          (document.getElementById("Misc_Space_25") as HTMLInputElement).value = data.Misc_Space_25;
          (document.getElementById("Condensor_Cooling_Water_In_27") as HTMLInputElement).value = data.Condensor_Cooling_Water_In_27;
          (document.getElementById("Condensor_Cooling_Water_out_29") as HTMLInputElement).value = data.Condensor_Cooling_Water_out_29;
          (document.getElementById("Refrigerant_Level_31") as HTMLInputElement).value = data.Refrigerant_Level_31;

        }, 500);

      }
      //Reefer Equipment 2
      if (data.formId == 3) {
        this.logbook = 3;
        setTimeout(() => {
          (document.getElementById("Suction_Pr_53") as HTMLInputElement).value = data.Suction_Pr_53;
          (document.getElementById("Discharge_Pr_54") as HTMLInputElement).value = data.Discharge_Pr_54;
          (document.getElementById("Oil_Pr_55") as HTMLInputElement).value = data.Oil_Pr_55;
          (document.getElementById("Sump_Level_56") as HTMLInputElement).value = data.Sump_Level_56;
          (document.getElementById("Meat_Room_57") as HTMLInputElement).value = data.Meat_Room_57;
          (document.getElementById("Fish_Room_58") as HTMLInputElement).value = data.Fish_Room_58;
          (document.getElementById("Veg_Room_59") as HTMLInputElement).value = data.Veg_Room_59;
          (document.getElementById("Lobby_Room_60") as HTMLInputElement).value = data.Lobby_Room_60;
          (document.getElementById("Dairy_Room_61") as HTMLInputElement).value = data.Dairy_Room_61;
          (document.getElementById("Misc_Space_62") as HTMLInputElement).value = data.Misc_Space_62;
          (document.getElementById("Condensor_Cooling_Water_In_63") as HTMLInputElement).value = data.Condensor_Cooling_Water_In_63;
          (document.getElementById("Condensor_Cooling_Water_out_64") as HTMLInputElement).value = data.Condensor_Cooling_Water_out_64;
          (document.getElementById("Refrigerant_Level_65") as HTMLInputElement).value = data.Refrigerant_Level_65;

        }, 500);
      }


      //Air Condition 1
      if (data.formId == 4) {
        this.logbook = 4;
        setTimeout(() => {
          (document.getElementById("Suction_Pr_66") as HTMLInputElement).value = data.Suction_Pr_66;
          (document.getElementById("Discharge_Pr_67") as HTMLInputElement).value = data.Discharge_Pr_67;
          (document.getElementById("Oil_Pr_68") as HTMLInputElement).value = data.Oil_Pr_68;
          (document.getElementById("Sump_Level_69") as HTMLInputElement).value = data.Sump_Level_69;
          (document.getElementById("Refrigerant_Level_70") as HTMLInputElement).value = data.Refrigerant_Level_70;
          (document.getElementById("Compressor_Amps_71") as HTMLInputElement).value = data.Compressor_Amps_71;

        }, 500);
      }
      //Air Condition 2
      if (data.formId == 5) {
        this.logbook = 5;
        setTimeout(() => {
          (document.getElementById("Suction_Pr_72") as HTMLInputElement).value = data.Suction_Pr_72;
          (document.getElementById("Discharge_Pr_73") as HTMLInputElement).value = data.Discharge_Pr_73;
          (document.getElementById("Oil_Pr_74") as HTMLInputElement).value = data.Oil_Pr_74;
          (document.getElementById("Sump_Level_75") as HTMLInputElement).value = data.Sump_Level_75;
          (document.getElementById("Refrigerant_Level_76") as HTMLInputElement).value = data.Refrigerant_Level_76;
          (document.getElementById("Compressor_Amps_77") as HTMLInputElement).value = data.Compressor_Amps_77;

        }, 500);
      }

      //AIR CONDITION AHU 1
      if (data.formId == 6) {
        this.logbook = 6;
        setTimeout(() => {
          (document.getElementById("AHU_IN_78") as HTMLInputElement).value = data.AHU_IN_78;
          (document.getElementById("AHU_Out_79") as HTMLInputElement).value = data.AHU_Out_79;
          (document.getElementById("Blower_AMPS_80") as HTMLInputElement).value = data.Blower_AMPS_80;
        }, 500);
      }
      //AIR CONDITION AHU 2
      if (data.formId == 7) {
        this.logbook = 7;
        setTimeout(() => {
          (document.getElementById("AHU_IN_81") as HTMLInputElement).value = data.AHU_IN_81;
          (document.getElementById("AHU_Out_82") as HTMLInputElement).value = data.AHU_Out_82;
          (document.getElementById("Blower_AMPS_83") as HTMLInputElement).value = data.Blower_AMPS_83;
        }, 500);
      }
      //"Main Air Compr 1"
      if (data.formId == 8) {
        this.logbook = 8;
        setTimeout(() => {
          (document.getElementById("Suction_Pr_84") as HTMLInputElement).value = data.Suction_Pr_84;
          (document.getElementById("Discharge_Pr_85") as HTMLInputElement).value = data.Discharge_Pr_85;
          (document.getElementById("Lube_Oil_Pr_86") as HTMLInputElement).value = data.Lube_Oil_Pr_86;
          (document.getElementById("Cooling_Water_Pr_87") as HTMLInputElement).value = data.Cooling_Water_Pr_87;
          (document.getElementById("Air_Temp_88") as HTMLInputElement).value = data.Air_Temp_88;
          (document.getElementById("Compressor_Amps_89") as HTMLInputElement).value = data.Compressor_Amps_89;
          (document.getElementById("Oil_Level_90") as HTMLInputElement).value = data.Oil_Level_90;
        }, 500);
      }
      //"Main Air Compr 2"
      if (data.formId == 9) {
        this.logbook = 9;
        setTimeout(() => {
          (document.getElementById("Suction_Pr_91") as HTMLInputElement).value = data.Suction_Pr_91;
          (document.getElementById("Discharge_Pr_92") as HTMLInputElement).value = data.Discharge_Pr_92;
          (document.getElementById("Lube_Oil_Pr_93") as HTMLInputElement).value = data.Lube_Oil_Pr_93;
          (document.getElementById("Cooling_Water_Pr_94") as HTMLInputElement).value = data.Cooling_Water_Pr_94;
          (document.getElementById("Air_Temp_95") as HTMLInputElement).value = data.Air_Temp_95;
          (document.getElementById("Compressor_Amps_97") as HTMLInputElement).value = data.Compressor_Amps_97;
          (document.getElementById("Oil_Level_99") as HTMLInputElement).value = data.Oil_Level_99;
        }, 500);
      }

      //Control Air Compr
      if (data.formId == 10) {
        this.logbook = 10;
        setTimeout(() => {
          (document.getElementById("Suction_Pr_96") as HTMLInputElement).value = data.Suction_Pr_96;
          (document.getElementById("Discharge_Pr_98") as HTMLInputElement).value = data.Discharge_Pr_98;
          (document.getElementById("Lube_Oil_Pr_100") as HTMLInputElement).value = data.Lube_Oil_Pr_100;
          (document.getElementById("Cooling_Water_Pr_101") as HTMLInputElement).value = data.Cooling_Water_Pr_101;
          (document.getElementById("Air_Temp_103") as HTMLInputElement).value = data.Air_Temp_103;
          (document.getElementById("Compressor_Amps_104") as HTMLInputElement).value = data.Compressor_Amps_104;
          (document.getElementById("Oil_Level_107") as HTMLInputElement).value = data.Oil_Level_107;
        }, 500);
      }
      //"Service Air Compr"
      if (data.formId == 11) {
        this.logbook = 11;
        setTimeout(() => {
          (document.getElementById("Suction_Pr_102") as HTMLInputElement).value = data.Suction_Pr_102;
          (document.getElementById("Discharge_Pr_105") as HTMLInputElement).value = data.Discharge_Pr_105;
          (document.getElementById("Lube_Oil_Pr_106") as HTMLInputElement).value = data.Lube_Oil_Pr_106;
          (document.getElementById("Cooling_Water_Pr_108") as HTMLInputElement).value = data.Cooling_Water_Pr_108;
          (document.getElementById("Air_Temp_109") as HTMLInputElement).value = data.Air_Temp_109;
          (document.getElementById("Compressor_Amps_110") as HTMLInputElement).value = data.Compressor_Amps_110;
          (document.getElementById("Oil_Level_111") as HTMLInputElement).value = data.Oil_Level_111;
        }, 500);
      }

      //Control Air Dryers
      if (data.formId == 12) {
        this.logbook = 12;
        setTimeout(() => {
          (document.getElementById("Suction_Pr_112") as HTMLInputElement).value = data.Suction_Pr_112;
          (document.getElementById("Discharge_Pr_113") as HTMLInputElement).value = data.Discharge_Pr_113;
          (document.getElementById("Air_Temp_114") as HTMLInputElement).value = data.Air_Temp_114;
        }, 500);
      }

      //FRESH WATER GENERATOR
      if (data.formId == 13) {
        this.logbook = 13;
        setTimeout(() => {
          (document.getElementById("Ejector_Pump_Pr_115") as HTMLInputElement).value = data.Ejector_Pump_Pr_115;
          (document.getElementById("JCW_Temp_In_In_116") as HTMLInputElement).value = data.JCW_Temp_In_In_116;
          (document.getElementById("JCW_Temp_In_Out_117") as HTMLInputElement).value = data.JCW_Temp_In_Out_117;
          (document.getElementById("Shell_Temp_118") as HTMLInputElement).value = data.Shell_Temp_118;
          (document.getElementById("Vaccum_119") as HTMLInputElement).value = data.Vaccum_119;
          (document.getElementById("Water_Made_120") as HTMLInputElement).value = data.Water_Made_120;
          (document.getElementById("Salinity_121") as HTMLInputElement).value = data.Salinity_121;
        }, 500);
      }
      //Purifiers
      if (data.formId == 14) {
        this.logbook = 14;
        setTimeout(() => {
          (document.getElementById("Inlet_Temp_122") as HTMLInputElement).value = data.Inlet_Temp_122;
          (document.getElementById("Amps_123") as HTMLInputElement).value = data.Amps_123;
          (document.getElementById("Pressure_124") as HTMLInputElement).value = data.Pressure_124;
          (document.getElementById("Running_Hour_Counter_125") as HTMLInputElement).value = data.Running_Hour_Counter_125;
          (document.getElementById("Inlet_Temp_127") as HTMLInputElement).value = data.Inlet_Temp_127;
          (document.getElementById("Amps_128") as HTMLInputElement).value = data.Amps_128;
          (document.getElementById("Pressure_129") as HTMLInputElement).value = data.Pressure_129;
          (document.getElementById("Running_Hour_Counter_130") as HTMLInputElement).value = data.Running_Hour_Counter_130;
          (document.getElementById("Inlet_Temp_131") as HTMLInputElement).value = data.Inlet_Temp_131;
          (document.getElementById("Amps_132") as HTMLInputElement).value = data.Amps_132;
          (document.getElementById("Pressure_133") as HTMLInputElement).value = data.Pressure_133;
          (document.getElementById("Running_Hour_Counter_134") as HTMLInputElement).value = data.Running_Hour_Counter_134;
          (document.getElementById("Inlet_Temp_135") as HTMLInputElement).value = data.Inlet_Temp_135;
          (document.getElementById("Amps_136") as HTMLInputElement).value = data.Amps_136;
          (document.getElementById("Pressure_137") as HTMLInputElement).value = data.Pressure_137;
          (document.getElementById("Running_Hour_Counter_138") as HTMLInputElement).value = data.Running_Hour_Counter_138;
          (document.getElementById("Inlet_Temp_139") as HTMLInputElement).value = data.Inlet_Temp_139;
          (document.getElementById("Amps_140") as HTMLInputElement).value = data.Amps_140;
          (document.getElementById("Pressure_141") as HTMLInputElement).value = data.Pressure_141;
          (document.getElementById("Running_Hour_Counter_142") as HTMLInputElement).value = data.Running_Hour_Counter_142;
        }, 500);

      }

      //Incinerator
      if (data.formId == 15) {
        this.logbook = 15;
        setTimeout(() => {
          (document.getElementById("Running_126") as HTMLInputElement).value = data.Running_126;
          (document.getElementById("Furnace_Pr_144") as HTMLInputElement).value = data.Furnace_Pr_144;
          (document.getElementById("Uptake_Temp_146") as HTMLInputElement).value = data.Uptake_Temp_146;
          (document.getElementById("Waste_Oil_Tank_Temp_147") as HTMLInputElement).value = data.Waste_Oil_Tank_Temp_147;
          (document.getElementById("Running_Hours_149") as HTMLInputElement).value = data.Running_Hours_149;
        }, 500);

      }
      //Oily Water Seperator
      if (data.formId == 16) {
        this.logbook = 16;
        setTimeout(() => {
          (document.getElementById("Running_143") as HTMLInputElement).value = data.Running_143;
          (document.getElementById("System_Pressure_145") as HTMLInputElement).value = data.System_Pressure_145;
          (document.getElementById("PPM_Outlet_148") as HTMLInputElement).value = data.PPM_Outlet_148
        }, 500);
      }

      //Sewage Treatment Plan
      if (data.formId == 17) {
        this.logbook = 17;
        setTimeout(() => {
          (document.getElementById("Running_Hrs_150") as HTMLInputElement).value = data.Running_Hrs_150;
          (document.getElementById("Blower_Pr_152") as HTMLInputElement).value = data.Blower_Pr_152;
          (document.getElementById("Dosing_Pumps_Run_153") as HTMLInputElement).value = data.Dosing_Pumps_Run_153;
        }, 500);

      }
      //Boiler
      if (data.formId == 18) {
        this.logbook = 18;
        setTimeout(() => {
          (document.getElementById("Running_151") as HTMLInputElement).value = data.Running_151;
          (document.getElementById("Fuel_Oil_Pr_154") as HTMLInputElement).value = data.Fuel_Oil_Pr_154;
          (document.getElementById("Furnace_Draft_155") as HTMLInputElement).value = data.Furnace_Draft_155;
          (document.getElementById("Steam_Pr_158") as HTMLInputElement).value = data.Steam_Pr_158;
          (document.getElementById("Water_Level_160") as HTMLInputElement).value = data.Water_Level_160;
          (document.getElementById("Hot_Well_Temp_162") as HTMLInputElement).value = data.Hot_Well_Temp_162;
          (document.getElementById("Salinity_164") as HTMLInputElement).value = data.Salinity_164;
          (document.getElementById("Oil_Content_165") as HTMLInputElement).value = data.Oil_Content_165;
        }, 500);
      }
      //Steering Gears  PENDING
      if (data.formId == 19) {
        this.logbook = 19;
        setTimeout(() => {
          //(document.getElementById("1_Run_156") as HTMLInputElement).value = data.1_Run_156;
          (document.getElementById("Oil_Level_157") as HTMLInputElement).value = data.Oil_Level_157;
          (document.getElementById("Oil_Temp_159") as HTMLInputElement).value = data.Oil_Temp_159;
          (document.getElementById("Motor_Amps_161") as HTMLInputElement).value = data.Motor_Amps_161;
          //(document.getElementById("2_Run_163") as HTMLInputElement).value = data.2_Run_163
          (document.getElementById("Oil_Level_352") as HTMLInputElement).value = data.Oil_Level_352;
          (document.getElementById("Oil_Temp_353") as HTMLInputElement).value = data.Oil_Temp_353;
          (document.getElementById("Motor_Amps_354") as HTMLInputElement).value = data.Motor_Amps_354;

        }, 500);
      }
      //Running Hours and consumptions
      if (data.formId == 45) {
        this.logbook = 45;
        setTimeout(() => {
          (document.getElementById("Main_Engine_836") as HTMLInputElement).value = data.Main_Engine_836;
          (document.getElementById("Running_Hours_1_837") as HTMLInputElement).value = data.Running_Hours_1_837;
          (document.getElementById("Aux_Engine_1_840") as HTMLInputElement).value = data.Aux_Engine_1_840;
          (document.getElementById("Running_Hours_2_842") as HTMLInputElement).value = data.Running_Hours_2_842;
          (document.getElementById("Aux_Engine_2_844") as HTMLInputElement).value = data.Aux_Engine_2_844;
          (document.getElementById("Running_Hours_3_847") as HTMLInputElement).value = data.Running_Hours_3_847;
          (document.getElementById("Aux_Engine_3_849") as HTMLInputElement).value = data.Aux_Engine_3_849;
          (document.getElementById("Running_Hours_4_852") as HTMLInputElement).value = data.Running_Hours_4_852;
          (document.getElementById("Fresh_water_generator_854") as HTMLInputElement).value = data.Fresh_water_generator_854;
          (document.getElementById("Running_Hours_5_857") as HTMLInputElement).value = data.Running_Hours_5_857;
          //WORK DONE
          (document.getElementById("Work_done_863") as HTMLInputElement).value = data.Work_done_863;
          //TANK ROBS
          (document.getElementById("Tank_Name_1_864") as HTMLInputElement).value = data.Tank_Name_1_864;
          (document.getElementById("ROB_1_866") as HTMLInputElement).value = data.ROB_1_866;
          (document.getElementById("MT_1_867") as HTMLInputElement).value = data.MT_1_867;
          (document.getElementById("Tank_Name_2_868") as HTMLInputElement).value = data.Tank_Name_2_868;
          (document.getElementById("ROB_2_869") as HTMLInputElement).value = data.ROB_2_869;
          (document.getElementById("MT_2_870") as HTMLInputElement).value = data.MT_2_870;
          (document.getElementById("Tank_Name_3_871") as HTMLInputElement).value = data.Tank_Name_3_871;
          (document.getElementById("ROB_3_875") as HTMLInputElement).value = data.ROB_3_875;
          (document.getElementById("MT_3_876") as HTMLInputElement).value = data.MT_3_876;
          (document.getElementById("Tank_Name_4_878") as HTMLInputElement).value = data.Tank_Name_4_878;
          (document.getElementById("ROB_4_879") as HTMLInputElement).value = data.ROB_4_879;
          (document.getElementById("MT_4_881") as HTMLInputElement).value = data.MT_4_881;
          (document.getElementById("Tank_Name_5_882") as HTMLInputElement).value = data.Tank_Name_5_882;
          (document.getElementById("ROB_5_884") as HTMLInputElement).value = data.ROB_5_884;
          (document.getElementById("MT_5_885") as HTMLInputElement).value = data.MT_5_885;
          (document.getElementById("Tank_Name_6_886") as HTMLInputElement).value = data.Tank_Name_6_886;
          (document.getElementById("ROB_6_887") as HTMLInputElement).value = data.ROB_6_887;
          // (document.getElementById("MT_6_888") as HTMLInputElement).value = data.MT_6_888
          (document.getElementById("HFO_1080") as HTMLInputElement).value = data.HFO_1080;
          (document.getElementById("LSMGO_1081") as HTMLInputElement).value = data.LSMGO_1081;
          (document.getElementById("ME_FO_1082") as HTMLInputElement).value = data.ME_FO_1082;
          (document.getElementById("consumption1_1083") as HTMLInputElement).value = data.consumption1_1083;
          (document.getElementById("consumption2_1084") as HTMLInputElement).value = data.consumption2_1084;
          (document.getElementById("Aux_Engine_1085") as HTMLInputElement).value = data.Aux_Engine_1085;
          (document.getElementById("consumption3_1086") as HTMLInputElement).value = data.consumption3_1086;
          (document.getElementById("consumption4_1087") as HTMLInputElement).value = data.consumption4_1087;
          (document.getElementById("Boiler_1088") as HTMLInputElement).value = data.Boiler_1088;
          (document.getElementById("consumption5_1089") as HTMLInputElement).value = data.consumption5_1089;
          (document.getElementById("consumption6_1090") as HTMLInputElement).value = data.consumption6_1090;

        }, 500);
      }
      //NOON REPORT DATA
      if (data.formId == 46) {
        this.logbook = 46;
        setTimeout(() => {
          (document.getElementById("Average_RPM_2_846") as HTMLInputElement).value = data.Average_RPM_2_846;
          (document.getElementById("Distance_by_Engine_2_850") as HTMLInputElement).value = data.Distance_by_Engine_2_850;
          (document.getElementById("Distance_by_Observation_2_853") as HTMLInputElement).value = data.Distance_by_Observation_2_853;
          (document.getElementById("Distance_to_go_2_865") as HTMLInputElement).value = data.Distance_to_go_2_865;
          (document.getElementById("Hours_Full_Speed_2_843") as HTMLInputElement).value = data.Hours_Full_Speed_2_843;
          (document.getElementById("Hours_Underway_2_839") as HTMLInputElement).value = data.Hours_Underway_2_839;
          (document.getElementById("Propeller_slip_2_859") as HTMLInputElement).value = data.Propeller_slip_2_859;
          (document.getElementById("Speed_kts_2_856") as HTMLInputElement).value = data.Speed_kts_2_856;
          (document.getElementById("Total_Distance_Run_2_861") as HTMLInputElement).value = data.Total_Distance_Run_2_861;
        }, 500);
      }

      //DECK LOG BOOK
      //Audits / Inspections / Drills / Drafts
      if (data.formId == 40) {
        this.audit = 40;
        setTimeout(() => {
          (document.getElementById("Date_of_Drill_701") as HTMLInputElement).value = data.Date_of_Drill_701;
          (document.getElementById("Drill_Date_702") as HTMLInputElement).value = data.Drill_Date_702;
          (document.getElementById("Drill_Description_703") as HTMLInputElement).value = data.Drill_Description_703;
          (document.getElementById("Participants_704") as HTMLInputElement).value = data.Participants_704;
          (document.getElementById("Date_Time_of_Departure_705") as HTMLInputElement).value = data.Date_Time_of_Departure_705;
          (document.getElementById("Date_of_Departure_706") as HTMLInputElement).value = data.Date_of_Departure_706;
          (document.getElementById("Time_of_departure_707") as HTMLInputElement).value = data.Time_of_departure_707;
          (document.getElementById("Port_708") as HTMLInputElement).value = data.Port_708;
          (document.getElementById("Draft_710") as HTMLInputElement).value = data.Draft_710;
          (document.getElementById("Draft_Fwd_711") as HTMLInputElement).value = data.Draft_Fwd_711;
          (document.getElementById("Draft_Alt_712") as HTMLInputElement).value = data.Draft_Alt_712;
          (document.getElementById("Actual_Freeboard_Amidships_713") as HTMLInputElement).value = data.Actual_Freeboard_Amidships_713;
          (document.getElementById("Amidship_port_714") as HTMLInputElement).value = data.Amidship_port_714;
          (document.getElementById("Amidship_stbd_715") as HTMLInputElement).value = data.Amidship_stbd_715;
          (document.getElementById("Amidships_mean_716") as HTMLInputElement).value = data.Amidships_mean_716;
          (document.getElementById("Density_of_water_717") as HTMLInputElement).value = data.Density_of_water_717;
          (document.getElementById("Allowance_for_density_718") as HTMLInputElement).value = data.Allowance_for_density_718;
          (document.getElementById("Inspections_have_been_carried_out_719") as HTMLInputElement).value = data.Inspections_have_been_carried_out_719;
          (document.getElementById("Equipment_720") as HTMLInputElement).value = data.Equipment_720;
          (document.getElementById("Date_of_equipment_721") as HTMLInputElement).value = data.Date_of_equipment_721;
          (document.getElementById("Firemens_outfits_722") as HTMLInputElement).value = data.Firemens_outfits_722;
          (document.getElementById("Fire_extinguishers_723") as HTMLInputElement).value = data.Fire_extinguishers_723;
          (document.getElementById("Fire_hydrants_724") as HTMLInputElement).value = data.Fire_hydrants_724;
          (document.getElementById("Hoses_and_nozzles_725") as HTMLInputElement).value = data.Hoses_and_nozzles_725;
          (document.getElementById("correct_position_726") as HTMLInputElement).value = data.correct_position_726;
          (document.getElementById("position_date_727") as HTMLInputElement).value = data.position_date_727;
          (document.getElementById("fire_pumps_operated_728") as HTMLInputElement).value = data.fire_pumps_operated_728;
          (document.getElementById("pumps_729") as HTMLInputElement).value = data.pumps_729;
          (document.getElementById("free_from_leakage_730") as HTMLInputElement).value = data.free_from_leakage_730;
          (document.getElementById("fire_extinguishing_installation_731") as HTMLInputElement).value = data.fire_extinguishing_installation_731;
          (document.getElementById("General_Remarks_732") as HTMLInputElement).value = data.General_Remarks_732;
          (document.getElementById("test_and_inspections_733") as HTMLInputElement).value = data.test_and_inspections_733;
          (document.getElementById("survival_craft_734") as HTMLInputElement).value = data.survival_craft_734;
          (document.getElementById("survival_craft_date_735") as HTMLInputElement).value = data.survival_craft_date_735;
          (document.getElementById("lifeboats_and_rescue_boats_736") as HTMLInputElement).value = data.lifeboats_and_rescue_boats_736;
          (document.getElementById("lifeboats_and_rescue_boats_date_737") as HTMLInputElement).value = data.lifeboats_and_rescue_boats_date_737;
          (document.getElementById("Lifeboats_moved_738") as HTMLInputElement).value = data.Lifeboats_moved_738;
          (document.getElementById("Lifeboats_moved_date_739") as HTMLInputElement).value = data.Lifeboats_moved_date_739;
          (document.getElementById("emergency_alarm_740") as HTMLInputElement).value = data.emergency_alarm_740;
          (document.getElementById("emergency_alarm_date_741") as HTMLInputElement).value = data.emergency_alarm_date_741;
          (document.getElementById("General_Remarks_742") as HTMLInputElement).value = data.General_Remarks_742;
          (document.getElementById("test_and_inspections_743") as HTMLInputElement).value = data.test_and_inspections_743;
          (document.getElementById("lifeboats_turned_744") as HTMLInputElement).value = data.lifeboats_turned_744;
          (document.getElementById("lifeboats_turned_date_745") as HTMLInputElement).value = data.lifeboats_turned_date_745;
          (document.getElementById("ispection_of_immersion_746") as HTMLInputElement).value = data.ispection_of_immersion_746;
          (document.getElementById("ispection_of_immersion_date_747") as HTMLInputElement).value = data.ispection_of_immersion_date_747;
          (document.getElementById("General_Remarks_748") as HTMLInputElement).value = data.General_Remarks_748;
          (document.getElementById("inspections_examinations_749") as HTMLInputElement).value = data.inspections_examinations_749;
          (document.getElementById("Internation_shore_connection_750") as HTMLInputElement).value = data.Internation_shore_connection_750;
          (document.getElementById("shore_connection_date_751") as HTMLInputElement).value = data.shore_connection_date_751;
          (document.getElementById("fire_fighting_equipment_752") as HTMLInputElement).value = data.fire_fighting_equipment_752;
          (document.getElementById("fire_fighting_equipment_date_753") as HTMLInputElement).value = data.fire_fighting_equipment_date_753;
          (document.getElementById("fire_doors_and_dampers_754") as HTMLInputElement).value = data.fire_doors_and_dampers_754;
          (document.getElementById("doors_dampers_date_755") as HTMLInputElement).value = data.doors_dampers_date_755;
          (document.getElementById("Bottle_connections_756") as HTMLInputElement).value = data.Bottle_connections_756;
          (document.getElementById("Bottle_connections_date_757") as HTMLInputElement).value = data.Bottle_connections_date_757;
          (document.getElementById("examination_and_inspection_remarks_758") as HTMLInputElement).value = data.examination_and_inspection_remarks_758;
        }, 500);

      }

      //CREW RECORD AND MANAGEMENT
      if (data.formId == 41) {
        this.audit = 41;
        setTimeout(() => {
          // console.log("====data======", data);

          (document.getElementById("Rank_759") as HTMLInputElement).value = this.selectedOfficerRankId = data.Rank_759;
          (document.getElementById("Name_of_officer_760") as HTMLInputElement).value = data.Name_of_officer_760;
          (document.getElementById("Certificate_761") as HTMLInputElement).value = data.Certificate_761;
          (document.getElementById("Date_of_joining_762") as HTMLInputElement).value = data.Date_of_joining_762;
          (document.getElementById("officers_date_of_joining_763") as HTMLInputElement).value = data.officers_date_of_joining_763;
          (document.getElementById("code_no_764") as HTMLInputElement).value = data.code_no_764;
          (document.getElementById("name_765") as HTMLInputElement).value = data.name_765;
          (document.getElementById("SIB_No_766") as HTMLInputElement).value = data.SIB_No_766;
          (document.getElementById("crew_name_767") as HTMLInputElement).value = data.crew_name_767;
          (document.getElementById("crew_rank_768") as HTMLInputElement).value = data.crew_rank_768;
          (document.getElementById("crew_place_769") as HTMLInputElement).value = data.crew_place_769;
          (document.getElementById("crew_date_770") as HTMLInputElement).value = data.crew_date_770;
          (document.getElementById("crew_reason_771") as HTMLInputElement).value = data.crew_reason_771;
        }, 500);

      }

      //Watch Entry
      if (data.formId == 43) {
        this.deckbook = 43;
        setTimeout(() => {
          (document.getElementById("Log_Reading_772") as HTMLInputElement).value = data.Log_Reading_772;
          (document.getElementById("Course_773") as HTMLInputElement).value = data.Course_773;
          (document.getElementById("Course_True_774") as HTMLInputElement).value = data.Course_True_774;
          (document.getElementById("Course_Gyro_775") as HTMLInputElement).value = data.Course_Gyro_775;
          (document.getElementById("Course_Standard_776") as HTMLInputElement).value = data.Course_Standard_776;
          (document.getElementById("Gyro_Error_777") as HTMLInputElement).value = data.Gyro_Error_777;
          (document.getElementById("Wind_778") as HTMLInputElement).value = data.Wind_778;
          (document.getElementById("Wind_Direction_779") as HTMLInputElement).value = data.Wind_Direction_779;
          (document.getElementById("Wind_Force_780") as HTMLInputElement).value = data.Wind_Force_780;
          (document.getElementById("Sea_Height_781") as HTMLInputElement).value = data.Sea_Height_781;
          (document.getElementById("Weather_and_visibility_782") as HTMLInputElement).value = data.Weather_and_visibility_782;
          (document.getElementById("Baro_Meter_783") as HTMLInputElement).value = data.Baro_Meter_783;
          (document.getElementById("Temperature_784") as HTMLInputElement).value = data.Temperature_784;
          (document.getElementById("Temerature_Dry_785") as HTMLInputElement).value = data.Temerature_Dry_785;
          (document.getElementById("Temperature_Wet_786") as HTMLInputElement).value = data.Temperature_Wet_786;
          (document.getElementById("Temperature_Sea_787") as HTMLInputElement).value = data.Temperature_Sea_787;
          (document.getElementById("IG_Press_788") as HTMLInputElement).value = data.IG_Press_788;
          (document.getElementById("Look_Out_789") as HTMLInputElement).value = data.Look_Out_789;
          (document.getElementById("Watch_Entry_Remarks_790") as HTMLInputElement).value = data.Watch_Entry_Remarks_790;
          (document.getElementById("Watch_Entry_General_Comments_791") as HTMLInputElement).value = data.Watch_Entry_General_Comments_791;
          (document.getElementById("Watch_Entry_Crew_Work_792") as HTMLInputElement).value = data.Watch_Entry_Crew_Work_792;

        }, 500);

      }


      //Noon Entry
      if (data.formId == 44) {
        this.deckbook = 44;
        setTimeout(() => {
          (document.getElementById("Noon_Position_793") as HTMLInputElement).innerHTML = data.Noon_Position_793;
          (document.getElementById("Noon_LAT_794") as HTMLInputElement).value = data.Noon_LAT_794;
          (document.getElementById("Noon_LONG_795") as HTMLInputElement).value = data.Noon_LONG_795;
          (document.getElementById("Next_Port_796") as HTMLInputElement).value = data.Next_Port_796;
          (document.getElementById("ETA_797") as HTMLInputElement).value = data.ETA_797;
          (document.getElementById("miles_run_in_last_24_hrs_798") as HTMLInputElement).value = data.miles_run_in_last_24_hrs_798;
          (document.getElementById("HRS_STMG_799") as HTMLInputElement).value = data.HRS_STMG_799;
          (document.getElementById("AV_SPD_800") as HTMLInputElement).value = data.AV_SPD_800;
          (document.getElementById("Wind_Force_801") as HTMLInputElement).value = data.Wind_Force_801;
          (document.getElementById("Consumption_For_Propulsion_802") as HTMLInputElement).value = data.Consumption_For_Propulsion_802;
          (document.getElementById("propulsion_HFO_803") as HTMLInputElement).value = data.propulsion_HFO_803;
          (document.getElementById("propulsion_MDO_804") as HTMLInputElement).value = data.propulsion_MDO_804;
          (document.getElementById("Cosumption_for_heating_805") as HTMLInputElement).value = data.Cosumption_for_heating_805;
          (document.getElementById("heating_HFO_806") as HTMLInputElement).value = data.heating_HFO_806;
          (document.getElementById("heating_MDO_807") as HTMLInputElement).value = data.heating_MDO_807;
          (document.getElementById("Consumption_for_cleaning_808") as HTMLInputElement).value = data.Consumption_for_cleaning_808;
          (document.getElementById("Cleaning_HFO_809") as HTMLInputElement).value = data.Cleaning_HFO_809;
          (document.getElementById("Cleaning_MDO_810") as HTMLInputElement).value = data.Cleaning_MDO_810;
          (document.getElementById("Slow_Speed_811") as HTMLInputElement).value = data.Slow_Speed_811;
          (document.getElementById("N_Miles_812") as HTMLInputElement).value = data.N_Miles_812;
          (document.getElementById("speed_hrs_813") as HTMLInputElement).value = data.speed_hrs_813;
          (document.getElementById("AV_RPM_814") as HTMLInputElement).value = data.AV_RPM_814;
          (document.getElementById("Slip_815") as HTMLInputElement).value = data.Slip_815;
          (document.getElementById("Sea_Conditions_816") as HTMLInputElement).value = data.Sea_Conditions_816;
          (document.getElementById("ROB_817") as HTMLInputElement).value = data.ROB_817;
          (document.getElementById("ROB_HFO_818") as HTMLInputElement).value = data.ROB_HFO_818;
          (document.getElementById("ROB_MDO_819") as HTMLInputElement).value = data.ROB_MDO_819;
          (document.getElementById("ROB_LSFO_820") as HTMLInputElement).value = data.ROB_LSFO_820;
          (document.getElementById("ROB_MGO_821") as HTMLInputElement).value = data.ROB_MGO_821;
          (document.getElementById("ROB_FW_822") as HTMLInputElement).value = data.ROB_FW_822;
          (document.getElementById("General_Comments_823") as HTMLInputElement).value = data.General_Comments_823;
          (document.getElementById("Crew_Work_824") as HTMLInputElement).value = data.Crew_Work_824;
        }, 500);

      }

      //olb-1
      if (data.formId == 69) {
        this.olb = 1;
        setTimeout(() => {
          (document.getElementById("Name_of_Ship") as HTMLInputElement).innerHTML = data.Name_of_Ship;
          (document.getElementById("Name_of_Ship_1") as HTMLInputElement).value = data.Name_of_Ship_1;
          (document.getElementById("Port_of_registry") as HTMLInputElement).innerHTML = data.Port_of_registry;
          (document.getElementById("Port_of_registry_2") as HTMLInputElement).value = data.Port_of_registry_2;
          (document.getElementById("Official_number") as HTMLInputElement).innerHTML = data.Official_number;
          (document.getElementById("Official_number_2") as HTMLInputElement).value = data.Official_number_2;
          (document.getElementById("Gross_tonnage") as HTMLInputElement).innerHTML = data.Gross_tonnage;
          (document.getElementById("Gross_tonnage_2") as HTMLInputElement).value = data.Gross_tonnage_2;
          (document.getElementById("Register_(net)_tonnage") as HTMLInputElement).innerHTML = data.Register_net_tonnage;
          (document.getElementById("Register_net_tonnage_2") as HTMLInputElement).value = data.Register_net_tonnage_2;
          (document.getElementById("Name_of_masters") as HTMLInputElement).innerHTML = data.Name_of_masters;
          (document.getElementById("Name_of_masters_2") as HTMLInputElement).value = data.Name_of_masters_2;
          (document.getElementById("Certificate_of_competency_1") as HTMLInputElement).innerHTML = data.Certificate_of_competency_1;
          (document.getElementById("Certificate_of_competency_2") as HTMLInputElement).value = data.Certificate_of_competency_2;
          (document.getElementById("Name_of_the_registered_owner_1") as HTMLInputElement).innerHTML = data.Name_of_the_registered_owner_1;
          (document.getElementById("Name_of_the_registered_owner_2") as HTMLInputElement).value = data.Name_of_the_registered_owner_2;
          (document.getElementById("address_of_the_registered_owner_1") as HTMLInputElement).innerHTML = data.address_of_the_registered_owner_1;
          (document.getElementById("address_of_the_registered_owner_2") as HTMLInputElement).value = data.address_of_the_registered_owner_2;
          (document.getElementById("Date_at_which_log_book_opened_1") as HTMLInputElement).innerHTML = data.Date_at_which_log_book_opened_1;
          (document.getElementById("Date_at_which_log_book_opened_2") as HTMLInputElement).value = data.Date_at_which_log_book_opened_2;;
          (document.getElementById("place_at_which_log_book_opened") as HTMLInputElement).innerHTML = data.place_at_which_log_book_opened;
          (document.getElementById("place_at_which_log_book_opened_1") as HTMLInputElement).value = data.place_at_which_log_book_opened_1;
          (document.getElementById("Date_at_which_log_book_closed_1") as HTMLInputElement).innerHTML = data.Date_at_which_log_book_closed_1;
          (document.getElementById("Date_at_which_log_book_closed_2") as HTMLInputElement).value = data.Date_at_which_log_book_closed_2;
          (document.getElementById("place_at_which_log_book_closed_1") as HTMLInputElement).innerHTML = data.place_at_which_log_book_closed_1;
          (document.getElementById("place_at_which_log_book_closed_2") as HTMLInputElement).value = data.place_at_which_log_book_closed_2;
          (document.getElementById("Delivered_to_the_superintendent") as HTMLInputElement).innerHTML = data.Delivered_to_the_superintendent;
          (document.getElementById("Delivered_to_the_superintendent_1") as HTMLInputElement).value = data.Delivered_to_the_superintendent_1;
          (document.getElementById("on_Office_Stamp") as HTMLInputElement).innerHTML = data.on_Office_Stamp;
          //   (document.getElementById("on_Office_Stamp_1") as HTMLInputElement).value = data.on_Office_Stamp_1;
          (document.getElementById("Date_1") as HTMLInputElement).innerHTML = data.Date_1;
          (document.getElementById("Date_2") as HTMLInputElement).value = data.Date_2;
        }, 500);

        ;


      }

      //olb-2
      if (data.formId == 70) {
        this.olb = 2;
        // console.log('data.Reference_number ' + data.Reference_number);
        setTimeout(() => {
          (document.getElementById("Reference_number_in_list_of_crew") as HTMLInputElement).innerHTML = data.Reference_number_in_list_of_crew;
          (document.getElementById("Reference_number") as HTMLInputElement).value = data.Reference_number;
          (document.getElementById("Name_of_seamen_1") as HTMLInputElement).innerHTML = data.Name_of_seamen_1;
          (document.getElementById("Name_of_seamen_2") as HTMLInputElement).value = data.Name_of_seamen_2;
          (document.getElementById("Capacity_in_which_employed_1") as HTMLInputElement).innerHTML = data.Capacity_in_which_employed_1;
          (document.getElementById("Capacity_in_which_employed") as HTMLInputElement).value = data.Capacity_in_which_employed;
          (document.getElementById("If_entry_made_1") as HTMLInputElement).innerHTML = data.If_entry_made_1;
          (document.getElementById("If_entry_made_2") as HTMLInputElement).value = data.If_entry_made_2;
        }, 500);



      }

      //olb-3
      if (data.formId == 71) {
        this.olb = 3;
        setTimeout(() => {

          //BIRTHS;
          (document.getElementById("DATE_OF_BIRTH_1") as HTMLInputElement).innerHTML = data.DATE_OF_BIRTH_1;
          (document.getElementById("DATE_OF_BIRTH_2") as HTMLInputElement).value = data.DATE_OF_BIRTH_2;
          (document.getElementById("PLACE_OF_BIRTH(Port_or_latitude_and_longitude_if_at_sea)_1") as HTMLInputElement).innerHTML = data.PLACE_OF_BIRTH_Port_or_latitude_and_longitude_if_at_sea_1;
          (document.getElementById("PLACE_OF_BIRTH_Port_or_latitude_and_longitude_if_at_sea_2") as HTMLInputElement).value = data.PLACE_OF_BIRTH_Port_or_latitude_and_longitude_if_at_sea_2;
          (document.getElementById("NAMES(if_any)_AND_SURNAME_OF_CHILD_1") as HTMLInputElement).innerHTML = data.NAMES_if_any_AND_SURNAME_OF_CHILD_1;
          (document.getElementById("NAMES_if_any_AND_SURNAME_OF_CHILD_2") as HTMLInputElement).value = data.NAMES_if_any_AND_SURNAME_OF_CHILD_2;
          (document.getElementById("SEX_1") as HTMLInputElement).innerHTML = data.SEX_1;
          (document.getElementById("SEX_2") as HTMLInputElement).value = data.SEX_2;
          (document.getElementById("FATHER") as HTMLInputElement).innerHTML = data.FATHER;
          (document.getElementById("Name_1") as HTMLInputElement).innerHTML = data.Name_1;
          (document.getElementById("Name_2") as HTMLInputElement).value = data.Name_2;
          (document.getElementById("Surname_1") as HTMLInputElement).innerHTML = data.Surname_1;
          (document.getElementById("Surname_2") as HTMLInputElement).value = data.Surname_2;
          (document.getElementById("Nationality_1") as HTMLInputElement).innerHTML = data.Nationality_1;
          (document.getElementById("Nationality_2") as HTMLInputElement).value = data.Nationality_2;
          (document.getElementById("Occupation_1") as HTMLInputElement).innerHTML = data.Occupation_1;
          (document.getElementById("Occupation_2") as HTMLInputElement).value = data.Occupation_2;
          (document.getElementById("rank_1") as HTMLInputElement).innerHTML = data.rank_1;
          (document.getElementById("rank_2") as HTMLInputElement).value = data.rank_2;
          (document.getElementById("profession_1") as HTMLInputElement).innerHTML = data.profession_1;
          (document.getElementById("profession_2") as HTMLInputElement).value = data.profession_2;
          (document.getElementById("usual_residence_1") as HTMLInputElement).innerHTML = data.usual_residence_1;
          (document.getElementById("usual_residence_2") as HTMLInputElement).value = data.usual_residence_2;
          (document.getElementById("MOTHER") as HTMLInputElement).innerHTML = data.MOTHER;
          (document.getElementById("Name_3") as HTMLInputElement).innerHTML = data.Name_3;
          (document.getElementById("Name_4") as HTMLInputElement).value = data.Name_4;
          (document.getElementById("Surname_3") as HTMLInputElement).innerHTML = data.Surname_3;
          (document.getElementById("Surname_4") as HTMLInputElement).value = data.Surname_4;
          (document.getElementById("Nationality_3") as HTMLInputElement).innerHTML = data.Nationality_3;
          (document.getElementById("Nationality_4") as HTMLInputElement).value = data.Nationality_4;
          (document.getElementById("Maiden_surname_3") as HTMLInputElement).innerHTML = data.Maiden_surname_3;
          (document.getElementById("Maiden_surname_4") as HTMLInputElement).value = data.Maiden_surname_4;
          (document.getElementById("surname_at_marriage_if_different_3") as HTMLInputElement).innerHTML = data.surname_at_marriage_if_different_3;
          (document.getElementById("surname_at_marriage_if_different_4") as HTMLInputElement).value = data.surname_at_marriage_if_different_4;
          (document.getElementById("Usual_residence_3") as HTMLInputElement).innerHTML = data.Usual_residence_3;
          (document.getElementById("Usual_residence_4") as HTMLInputElement).value = data.Usual_residence_4;
          (document.getElementById("Signature_of_the_mother_of_the_child_1") as HTMLInputElement).innerHTML = data.Signature_of_the_mother_of_the_child_1;
          (document.getElementById("Signature_of_the_mother_of_the_child_2") as HTMLInputElement).value = data.Signature_of_the_mother_of_the_child_2;
          (document.getElementById("Port_at_which_return_is_made_1") as HTMLInputElement).value = data.Port_at_which_return_is_made_1;
          (document.getElementById("Port_at_which_return_is_made_2") as HTMLInputElement).value = data.Port_at_which_return_is_made_2;
          (document.getElementById("date_1") as HTMLInputElement).innerHTML = data.date_1;
          (document.getElementById("date_2") as HTMLInputElement).value = data.date_2;
          (document.getElementById("Title_of_officer_to_whom_return_is_made_1") as HTMLInputElement).innerHTML = data.Title_of_officer_to_whom_return_is_made_1;
          (document.getElementById("Title_of_officer_to_whom_return_is_made_2") as HTMLInputElement).value = data.Title_of_officer_to_whom_return_is_made_2;
          //DEATHS

          //  (document.getElementById("Date_of_Death_or_Loss_1") as HTMLInputElement).innerHTML = data.Date_of_Death_or_Loss;
          (document.getElementById("Date_of_Death_or_Loss_1") as HTMLInputElement).innerHTML = data.Date_of_Death_or_Loss_1;
          ;
          (document.getElementById("Date_of_Death_or_Loss_2") as HTMLInputElement).value = data.Date_of_Death_or_Loss_2;
          (document.getElementById("Place_of_Death_or_Loss(latitude_or_longitude_if_at_sea)_1") as HTMLInputElement).innerHTML = data.Place_of_Death_or_Loss_latitude_or_longitude_if_at_sea_1;
          (document.getElementById("Place_of_Death_or_Los_latitude_or_longitude_if_at_sea_2") as HTMLInputElement).value = data.Place_of_Death_or_Los_latitude_or_longitude_if_at_sea_2;
          (document.getElementById("Name_of_deceased_1") as HTMLInputElement).innerHTML = data.Name_of_deceased_1;
          (document.getElementById("Name_of_deceased_2") as HTMLInputElement).value = data.Name_of_deceased_2;
          (document.getElementById("Surname_of_deceased_1") as HTMLInputElement).innerHTML = data.Surname_of_deceased_1;
          (document.getElementById("Surname_of_deceased_2") as HTMLInputElement).value = data.Surname_of_deceased_2;
          (document.getElementById("if_married_woman_maiden_surname_if_known_of_deceased_2") as HTMLInputElement).value = data.if_married_woman_maiden_surname_if_known_of_deceased_2;
          (document.getElementById("SEX_3") as HTMLInputElement).innerHTML = data.SEX_3;
          (document.getElementById("SEX_4") as HTMLInputElement).value = data.SEX_4;
          // (document.getElementById("Date_of_birth_(if_known_or_age)_5") as HTMLInputElement).innerHTML = data.Date_of_birth_5;
          (document.getElementById("Date_of_birth_(if_known_or_age)_5") as HTMLInputElement).innerHTML = data.Date_of_birth_if_known_or_age_5;
          (document.getElementById("Date_of_birth_if_known_or_age_6") as HTMLInputElement).value = data.Date_of_birth_if_known_or_age_6;
          (document.getElementById("Occupation_5") as HTMLInputElement).innerHTML = data.Occupation_5;
          (document.getElementById("Occupation_6") as HTMLInputElement).value = data.Occupation_6;
          (document.getElementById("rank_5") as HTMLInputElement).innerHTML = data.rank_5;
          (document.getElementById("rank_6") as HTMLInputElement).value = data.rank_6;
          (document.getElementById("profession_5") as HTMLInputElement).innerHTML = data.profession_5;
          (document.getElementById("profession_6") as HTMLInputElement).value = data.profession_6;
          (document.getElementById("Usual_residence_at_time_of_death_or_loss_5") as HTMLInputElement).innerHTML = data.Usual_residence_at_time_of_death_or_loss_5;
          (document.getElementById("Usual_residence_at_time_of_death_or_loss_6") as HTMLInputElement).value = data.Usual_residence_at_time_of_death_or_loss_6;
          (document.getElementById("Nationality_5") as HTMLInputElement).innerHTML = data.Nationality_5;
          (document.getElementById("Nationality_6") as HTMLInputElement).value = data.Nationality_6;
          (document.getElementById("Cause_of_death_or_loss_5") as HTMLInputElement).innerHTML = data.Cause_of_death_or_loss_5;
          (document.getElementById("Cause_of_death_or_loss_6") as HTMLInputElement).value = data.Cause_of_death_or_loss_6;
          (document.getElementById("Signature_of_master_5") as HTMLInputElement).innerHTML = data.Signature_of_master_5;
          (document.getElementById("Signature_of_master_6") as HTMLInputElement).value = data.Signature_of_master_6;
          (document.getElementById("Signature_of_a_member_of_the_crew_5") as HTMLInputElement).innerHTML = data.Signature_of_a_member_of_the_crew_5;
          (document.getElementById("Signature_of_a_member_of_the_crew_6") as HTMLInputElement).value = data.Signature_of_a_member_of_the_crew_6;
          (document.getElementById("Port_at_which_return_is_made_5") as HTMLInputElement).innerHTML = data.Port_at_which_return_is_made_5;
          (document.getElementById("Port_at_which_return_is_made_6") as HTMLInputElement).value = data.Port_at_which_return_is_made_6;
          (document.getElementById("Date_3") as HTMLInputElement).innerHTML = data.Date_3;
          (document.getElementById("Date_4") as HTMLInputElement).value = data.Date_4;
          (document.getElementById("Title_of_officer_to_whom_return_is_made_3") as HTMLInputElement).innerHTML = data.Title_of_officer_to_whom_return_is_made_3;
          (document.getElementById("Title_of_officer_to_whom_return_is_made_4") as HTMLInputElement).value = data.Title_of_officer_to_whom_return_is_made_4;
        }, 500);


      }
      //olb-4
      if (data.formId == 72) {
        this.olb = 4;
        setTimeout(() => {
          (document.getElementById("Date_of_muster_drill_training_instruction_or_inspection") as HTMLInputElement).innerHTML = data.Date_of_muster_drill_training_instruction_or_inspection;
          (document.getElementById("Date_of_muster_drill_training_instruction_or_inspection_1") as HTMLInputElement).value = data.Date_of_muster_drill_training_instruction_or_inspection_1;
          (document.getElementById("Nature_of_muster") as HTMLInputElement).innerHTML = data.Nature_of_muster;
          (document.getElementById("Nature_of_muster_1") as HTMLInputElement).value = data.Nature_of_muster_1;
          (document.getElementById("Nature_of_drill") as HTMLInputElement).innerHTML = data.Nature_of_drill;
          (document.getElementById("Nature_of_drill_1") as HTMLInputElement).value = data.Nature_of_drill_1;
          (document.getElementById("Nature_of_training_1") as HTMLInputElement).value = data.Nature_of_training_1;
          (document.getElementById("Nature_of_instruction_or_inspection_(including_the_condition_in_which_the_life-saving_and_fire_appliances_were_found)_and_the_record_of_the_occassions_on_which_the_lifeboats_were_swung_out_or_lowered") as HTMLInputElement).innerHTML = data.Nature;
          (document.getElementById("Nature1") as HTMLInputElement).value = data.Nature1;
          (document.getElementById("Date_of_Entry") as HTMLInputElement).innerHTML = data.Date_of_Entry;
          (document.getElementById("Date_of_Entry_1") as HTMLInputElement).value = data.Date_of_Entry_1;
          (document.getElementById("Signature_of_master_of_crew") as HTMLInputElement).innerHTML = data.Signature_of_master_of_crew;
          (document.getElementById("Signature_of_master_of_crew_1") as HTMLInputElement).value = data.Signature_of_master_of_crew_1;
          (document.getElementById("Signature_of_member_of_crew") as HTMLInputElement).innerHTML = data.Signature_of_member_of_crew;
          (document.getElementById("Signature_of_member_of_crew_1") as HTMLInputElement).value = data.Signature_of_member_of_crew_1;


        }, 500);

      }

      //olb-5
      if (data.formId == 73) {
        this.olb = 5;
        setTimeout(() => {
          (document.getElementById("Date_of_test_drill_inspection_or_pre-sea_check") as HTMLInputElement).innerHTML = data.Date_of_test_drill_inspection_or_pre_sea_check;
          (document.getElementById("Date_of_test_drill_inspection_or_pre_sea_check_1") as HTMLInputElement).value = data.Date_of_test_drill_inspection_or_pre_sea_check_1;
          (document.getElementById("Time_of_test_drill_inspection_or_pre-sea_check") as HTMLInputElement).innerHTML = data.Time_of_test_drill_inspection_or_pre_sea_check;
          (document.getElementById("Time_of_test_drill_inspection_or_pre_sea_check_1") as HTMLInputElement).value = data.Time_of_test_drill_inspection_or_pre_sea_check_1;
          (document.getElementById("place_of_test_drill") as HTMLInputElement).innerHTML = data.place_of_test_drill;
          (document.getElementById("place_of_test_drill_1") as HTMLInputElement).value = data.place_of_test_drill_1;
          (document.getElementById("place_of_inspection_or_pre-sea_check") as HTMLInputElement).innerHTML = data.place_of_inspection_or_pre_sea_check;
          (document.getElementById("place_of_inspection_or_pre_sea_check_1") as HTMLInputElement).value = data.place_of_inspection_or_pre_sea_check_1;
          (document.getElementById("Nature_of_inspection_of_Steering_Gear") as HTMLInputElement).innerHTML = data.Nature_of_inspection_of_Steering_Gear;
          (document.getElementById("Nature_of_inspection_of_Steering_Gear_1") as HTMLInputElement).value = data.Nature_of_inspection_of_Steering_Gear_1;
          (document.getElementById("Nature_of_test_drill_or_check_of_Steering_Gear") as HTMLInputElement).innerHTML = data.Nature_of_test_drill_or_check_of_Steering_Gear;
          (document.getElementById("Nature_of_test_drill_or_check_of_Steering_Gear_1") as HTMLInputElement).value = data.Nature_of_test_drill_or_check_of_Steering_Gear_1;
          (document.getElementById("Date_of_Entry") as HTMLInputElement).innerHTML = data.Date_of_Entry;
          (document.getElementById("Date_of_Entry_1") as HTMLInputElement).value = data.Date_of_Entry_1;
          (document.getElementById("Signature_of_master") as HTMLInputElement).innerHTML = data.Signature_of_master;
          (document.getElementById("Signature_of_master_1") as HTMLInputElement).value = data.Signature_of_master_1;
          (document.getElementById("Signature_of_officer") as HTMLInputElement).innerHTML = data.Signature_of_officer;
          (document.getElementById("Signature_of_officer_1") as HTMLInputElement).value = data.Signature_of_officer_1;

        }, 500);



      }

      //olb-6
      if (data.formId == 74) {
        this.olb = 6;
        setTimeout(() => {
          (document.getElementById("Time_of_inspection") as HTMLInputElement).innerHTML = data.Time_of_inspection;
          (document.getElementById("Time_of_inspection_1") as HTMLInputElement).value = data.Time_of_inspection_1;
          (document.getElementById("Date_of_inspection") as HTMLInputElement).innerHTML = data.Date_of_inspection;
          (document.getElementById("Date_of_inspection_1") as HTMLInputElement).value = data.Date_of_inspection_1;
          (document.getElementById("Names_of_persons_making_the_inspection") as HTMLInputElement).innerHTML = data.Names_of_persons_making_the_inspection;
          (document.getElementById("Names_of_persons_making_the_inspection_1") as HTMLInputElement).value = data.Names_of_persons_making_the_inspection_1;
          (document.getElementById("Ranks_of_persons_making_the_inspection") as HTMLInputElement).innerHTML = data.Ranks_of_persons_making_the_inspection;
          (document.getElementById("Ranks_of_persons_making_the_inspection_1") as HTMLInputElement).value = data.Ranks_of_persons_making_the_inspection_1;
          (document.getElementById("Particulars_of_any_respects_in_which_crew_accomodation_or_any_part_of_it_is_found_not_to_comply_with_the_Regulations") as HTMLInputElement).innerHTML = data.Particulars;
          (document.getElementById("Particulars_of_any_respects_in_which_crew_accomodation_or_any_part_of_it_is_found_not_to_comply_with_the_Regulations_1") as HTMLInputElement).value = data.Particulars_of_any_respects_in_which_crew_accomodation_or_any_part_of_it_is_found_not_to_comply_with_the_Regulations_1;
          (document.getElementById("Date_of_Entry") as HTMLInputElement).innerHTML = data.Date_of_Entry;
          (document.getElementById("Date_of_Entry_1") as HTMLInputElement).value = data.Date_of_Entry_1;
          (document.getElementById("Signature_of_master_of_the_crew") as HTMLInputElement).innerHTML = data.Signature_of_master_of_the_crew;
          (document.getElementById("Signature_of_master_of_the_crew_1") as HTMLInputElement).value = data.Signature_of_master_of_the_crew_1;
          (document.getElementById("Signature_of_member_of_the_crew") as HTMLInputElement).innerHTML = data.Signature_of_member_of_the_crew;
          (document.getElementById("Signature_of_member_of_the_crew_1") as HTMLInputElement).value = data.Signature_of_member_of_the_crew_1;
        }, 500);

      }

      //olb-7
      if (data.formId == 75) {
        this.olb = 7;
        setTimeout(() => {
          (document.getElementById("Date_of_Inspection") as HTMLInputElement).innerHTML = data.Date_of_Inspection;
          (document.getElementById("Date_of_Inspection_1") as HTMLInputElement).value = data.Date_of_Inspection_1;
          (document.getElementById("Names_of_persons_making_the_inspection") as HTMLInputElement).innerHTML = data.Names_of_persons_making_the_inspection;
          (document.getElementById("Names_of_persons_making_the_inspection_1") as HTMLInputElement).value = data.Names_of_persons_making_the_inspection_1;
          (document.getElementById("Ranks_of_persons_making_the_inspection") as HTMLInputElement).innerHTML = data.Ranks_of_persons_making_the_inspection;
          (document.getElementById("Ranks_of_persons_making_the_inspection_1") as HTMLInputElement).value = data.Ranks_of_persons_making_the_inspection_1;
          (document.getElementById("Result_of_inspection_of_supplies_of_food_and_water") as HTMLInputElement).innerHTML = data.Result_of_inspection_of_supplies_of_food_and_water;
          (document.getElementById("Result_of_inspection_of_supplies_of_food_and_water_1") as HTMLInputElement).value = data.Result_of_inspection_of_supplies_of_food_and_water_1;
          (document.getElementById("Date_of_Entry") as HTMLInputElement).innerHTML = data.Date_of_Entry;
          (document.getElementById("Date_of_Entry_1") as HTMLInputElement).value = data.Date_of_Entry_1;
          (document.getElementById("Signature_of_persons_making_the_inspection") as HTMLInputElement).innerHTML = data.Signature_of_persons_making_the_inspection;
          (document.getElementById("Signature_of_persons_making_the_inspection_1") as HTMLInputElement).value = data.Signature_of_persons_making_the_inspection_1;
        }, 500);

      }

      //olb-8
      if (data.formId == 76) {
        this.olb = 8;
        setTimeout(() => {
          //NONE
          (document.getElementById("POSITIONS_OF_THE_DECK_LINE_AND_LOAD_LINE") as HTMLInputElement).innerHTML = data.POSITIONS_OF_THE_DECK_LINE_AND_LOAD_LINE;
          //FREEBOARD FROM DECK LINE
          (document.getElementById("Tropical_1") as HTMLInputElement).innerHTML = data.Tropical_1;
          (document.getElementById("Tropical_2") as HTMLInputElement).value = data.Tropical_2;
          (document.getElementById("mm_1") as HTMLInputElement).innerHTML = data.mm_1;
          (document.getElementById("Summer_1") as HTMLInputElement).innerHTML = data.Summer_1;
          (document.getElementById("Summer_2") as HTMLInputElement).value = data.Summer_2;
          (document.getElementById("Winter_1") as HTMLInputElement).innerHTML = data.Winter_1;
          (document.getElementById("Winter_2") as HTMLInputElement).value = data.Winter_2;
          (document.getElementById("mm_3") as HTMLInputElement).innerHTML = data.mm_3;
          (document.getElementById("Winter_North_Atlantic_1") as HTMLInputElement).innerHTML = data.Winter_North_Atlantic_1;
          (document.getElementById("Winter_North_Atlantic_2") as HTMLInputElement).value = data.Winter_North_Atlantic_2;
          (document.getElementById("mm_4") as HTMLInputElement).innerHTML = data.mm_4;
          (document.getElementById("Timber_Tropical_1") as HTMLInputElement).innerHTML = data.Timber_Tropical_1;
          (document.getElementById("Timber_Tropical_2") as HTMLInputElement).value = data.Timber_Tropical_2;
          (document.getElementById("mm_5") as HTMLInputElement).innerHTML = data.mm_5;
          (document.getElementById("Timber_Summer_1") as HTMLInputElement).innerHTML = data.Timber_Summer_1;
          (document.getElementById("Timber_Summer_2") as HTMLInputElement).value = data.Timber_Summer_2;
          (document.getElementById("mm_5") as HTMLInputElement).innerHTML = data.mm_6;
          (document.getElementById("Timber_Winter_1") as HTMLInputElement).innerHTML = data.Timber_Winter_1;
          (document.getElementById("Timber_Winter_2") as HTMLInputElement).value = data.Timber_Winter_2;
          (document.getElementById("mm_7") as HTMLInputElement).innerHTML = data.mm_7;
          (document.getElementById("Timber_Winter_North_Atlantic_1") as HTMLInputElement).innerHTML = data.Timber_Winter_North_Atlantic_1;
          (document.getElementById("Timber_Winter_North_Atlantic_2") as HTMLInputElement).value = data.Timber_Winter_North_Atlantic_2;
          (document.getElementById("mm_8") as HTMLInputElement).innerHTML = data.mm_8;
          //LOAD LINE
          (document.getElementById("T_1") as HTMLInputElement).innerHTML = data.T_1;
          (document.getElementById("T_2") as HTMLInputElement).value = data.T_2;
          (document.getElementById("mm_._above_(S)_Upper_edge_of_line_through_center_of_ring") as HTMLInputElement).innerHTML = data.mm_above_S_Upper_edge_of_line_through_center_of_ring;
          (document.getElementById("W_1") as HTMLInputElement).innerHTML = data.W_1;
          (document.getElementById("W_2") as HTMLInputElement).value = data.W_2;
          (document.getElementById("mm_._below_(S)_1") as HTMLInputElement).innerHTML = data.mm_below_S_1;
          (document.getElementById("WNA_1") as HTMLInputElement).innerHTML = data.WNA_1;
          (document.getElementById("WNA_2") as HTMLInputElement).value = data.WNA_2;
          (document.getElementById("mm_._below_(S)_2") as HTMLInputElement).innerHTML = data.mm_below_S_2;
          (document.getElementById("LT_1") as HTMLInputElement).innerHTML = data.LT_1;
          (document.getElementById("LT_2") as HTMLInputElement).value = data.LT_2;
          (document.getElementById("mm_._above_(LS)_1") as HTMLInputElement).innerHTML = data.mm_above_LS_1;
          (document.getElementById("LS_1") as HTMLInputElement).innerHTML = data.LS_1;
          (document.getElementById("LS_2") as HTMLInputElement).value = data.LS_2;
          (document.getElementById("mm_._above_(S)_1") as HTMLInputElement).innerHTML = data.mm_above_S_1;
          (document.getElementById("LW_1") as HTMLInputElement).innerHTML = data.LW_1;
          (document.getElementById("LW_2") as HTMLInputElement).value = data.LW_2;
          (document.getElementById("mm_._below_(LS)_1") as HTMLInputElement).innerHTML = data.mm_below_LS_1;
          (document.getElementById("LWNA_1") as HTMLInputElement).innerHTML = data.LWNA_1;
          (document.getElementById("LWNA_2") as HTMLInputElement).value = data.LWNA_2;
          (document.getElementById("mm_._below_(LS)_2") as HTMLInputElement).innerHTML = data.mm_below_LS_2;
          //NONE
          (document.getElementById("Allowance_for_fresh_water_for_all_freeboards_other_then_timber_1") as HTMLInputElement).innerHTML = data.Allowance_for_fresh_water_for_all_freeboards_other_then_timber_1;
          (document.getElementById("Allowance_for_fresh_water_for_all_freeboards_other_then_timber_2") as HTMLInputElement).value = data.Allowance_for_fresh_water_for_all_freeboards_other_then_timber_2;
          (document.getElementById("mm_9") as HTMLInputElement).innerHTML = data.mm_9;
          (document.getElementById("Allowance_for_fresh_water_for_timber_freeboards_1") as HTMLInputElement).innerHTML = data.Allowance_for_fresh_water_for_timber_freeboards_1;
          (document.getElementById("Allowance_for_fresh_water_for_timber_freeboards_2") as HTMLInputElement).value = data.Allowance_for_fresh_water_for_timber_freeboards_2;
          // console.log('check-data', data);
          (document.getElementById("mm_10") as HTMLInputElement).innerHTML = data.mm_10;
          (document.getElementById("The_upper_edge_of_the_deckline_from_which_these_freeboards_are_measured_is_1") as HTMLInputElement).innerHTML = data.The_upper_edge_of_the_deckline_from_which_these_freeboards_are_measured_is_1;
          (document.getElementById("The_upper_edge_of_the_deckline_from_which_these_freeboards_are_measured_is_2") as HTMLInputElement).value = data.The_upper_edge_of_the_deckline_from_which_these_freeboards_are_measured_is_2;
          (document.getElementById("Above_particulars_to_be_taken_from_loadline_certificate") as HTMLInputElement).innerHTML = data.Above_particulars_to_be_taken_from_loadline_certificate;
          (document.getElementById("Maximum_draught_of_water_in_summer_2") as HTMLInputElement).value = data.Maximum_draught_of_water_in_summer_2;
        }, 500);
      }


      //olb-9
      if (data.formId == 77) {
        this.olb = 9;
        setTimeout(() => {
          //DEPARTURES
          //  (document.getElementById("DEPARTURES") as HTMLInputElement).innerHTML = data.DEPARTURES;
          (document.getElementById("Date_of_Departure_(1)_1") as HTMLInputElement).innerHTML = data.Date_of_Departure_1_1;
          (document.getElementById("Date_of_Departure_1_2") as HTMLInputElement).value = data.Date_of_Departure_1_2;
          (document.getElementById("hour_of_Departure_(1)_1") as HTMLInputElement).innerHTML = data.hour_of_Departure_1_1;
          (document.getElementById("hour_of_Departure_1_2") as HTMLInputElement).value = data.hour_of_Departure_1_2;
          // (document.getElementById("Dock_2_1") as HTMLInputElement).innerHTML = data.Dock_2_1;
          (document.getElementById("Dock_2_2") as HTMLInputElement).value = data.Dock_2_2;
          (document.getElementById("Wharf_(2)_1") as HTMLInputElement).innerHTML = data.Wharf_2_1;
          (document.getElementById("Wharf_2_2") as HTMLInputElement).value = data.Wharf_2_2;
          (document.getElementById("harbour_(2)_1") as HTMLInputElement).innerHTML = data.harbour_2_1;
          (document.getElementById("harbour_2_2") as HTMLInputElement).value = data.harbour_2_2;
          (document.getElementById("other_place_(2)_1") as HTMLInputElement).innerHTML = data.other_place_2_1;
          (document.getElementById("other_place_2_2") as HTMLInputElement).value = data.other_place_2_2;
          (document.getElementById("ACTUAL_DRAUGHT_OF_WATER") as HTMLInputElement).innerHTML = data.ACTUAL_DRAUGHT_OF_WATER;
          (document.getElementById("Forward_(3)_1") as HTMLInputElement).innerHTML = data.Forward_3_1;
          (document.getElementById("Forward_3_2") as HTMLInputElement).value = data.Forward_3_2;
          (document.getElementById("Aft_(4)_1") as HTMLInputElement).innerHTML = data.Aft_4_1;
          (document.getElementById("Aft_4_2") as HTMLInputElement).value = data.Aft_4_2;
          (document.getElementById("ACTUAL_FREEBOARD_AMIDSHIPS") as HTMLInputElement).innerHTML = data.ACTUAL_FREEBOARD_AMIDSHIPS;
          (document.getElementById("Port_(5)_1") as HTMLInputElement).innerHTML = data.Port_5_1;
          (document.getElementById("Port_5_2") as HTMLInputElement).value = data.Port_5_2;
          (document.getElementById("mm_1") as HTMLInputElement).innerHTML = data.mm_1;
          (document.getElementById("Star-board_(6)_1") as HTMLInputElement).innerHTML = data.Star_board_6_1;
          (document.getElementById("Star_board_6_2") as HTMLInputElement).value = data.Star_board_6_2;
          (document.getElementById("mm_2") as HTMLInputElement).innerHTML = data.mm_2;
          (document.getElementById("Mean_(7)_1") as HTMLInputElement).innerHTML = data.Mean_7_1;
          (document.getElementById("Mean_7_2") as HTMLInputElement).value = data.Mean_7_2;
          (document.getElementById("mm_3") as HTMLInputElement).innerHTML = data.mm_3;
          (document.getElementById("Density_of_Water_(8)_1") as HTMLInputElement).innerHTML = data.Density_of_Water_8_1;
          (document.getElementById("Density_of_Water_8_2") as HTMLInputElement).value = data.Density_of_Water_8_2;
          (document.getElementById("mm_4") as HTMLInputElement).innerHTML = data.mm_4;
          (document.getElementById("ALLOWANCE") as HTMLInputElement).innerHTML = data.ALLOWANCE;
          (document.getElementById("For_Density_of_Water_(9)_1") as HTMLInputElement).innerHTML = data.For_Density_of_Water_9_1;
          (document.getElementById("For_Density_of_Water_9_2") as HTMLInputElement).value = data.For_Density_of_Water_9_2;
          (document.getElementById("mm_5") as HTMLInputElement).innerHTML = data.mm_5;
          (document.getElementById("For_rubbish_(10)_1") as HTMLInputElement).innerHTML = data.For_rubbish_10_1;
          (document.getElementById("For_rubbish_10_2") as HTMLInputElement).value = data.For_rubbish_10_2;
          (document.getElementById("weight_1") as HTMLInputElement).innerHTML = data.weight_1;
          (document.getElementById("For_rubbish_(10)_3") as HTMLInputElement).innerHTML = data.For_rubbish_10_3;
          (document.getElementById("For_rubbish_10_4") as HTMLInputElement).value = data.For_rubbish_10_4;
          (document.getElementById("mm_6") as HTMLInputElement).innerHTML = data.mm_6;
          (document.getElementById("For_fuel_water_and_stores_to_be_consumed_on_stretch_of_inland_water_(11)_1") as HTMLInputElement).innerHTML = data.For_fuel_water_and_stores_to_be_consumed_on_stretch_of_inland_water_11_1;
          (document.getElementById("For_fuel_water_and_stores_to_be_consumed_on_stretch_of_inland_water_11_2") as HTMLInputElement).value = data.For_fuel_water_and_stores_to_be_consumed_on_stretch_of_inland_water_11_2;
          (document.getElementById("distance_1") as HTMLInputElement).innerHTML = data.distance_1;
          (document.getElementById("For_fuel_water_and_stores_to_be_consumed_on_stretch_of_inland_water_(11)_3") as HTMLInputElement).innerHTML = data.For_fuel_water_and_stores_to_be_consumed_on_stretch_of_inland_water_11_3;
          (document.getElementById("For_fuel_water_and_stores_to_be_consumed_on_stretch_of_inland_water_11_4") as HTMLInputElement).value = data.For_fuel_water_and_stores_to_be_consumed_on_stretch_of_inland_water_11_4;
          (document.getElementById("mm_7") as HTMLInputElement).innerHTML = data.mm_7;
          (document.getElementById("Total_allowances_(12)_1") as HTMLInputElement).innerHTML = data.Total_allowances_12_1;
          (document.getElementById("Total_allowances_12_2") as HTMLInputElement).value = data.Total_allowances_12_2;
          (document.getElementById("mm_8") as HTMLInputElement).innerHTML = data.mm_8;
          (document.getElementById("Mean_Draught_in_salt_water_as_calculated_after_making_the_appropriate_allowances_(13)_1") as HTMLInputElement).innerHTML = data.Mean_Draught_in_salt_water_as_calculated_after_making_the_appropriate_allowances_13_1;
          (document.getElementById("Mean_Draught_in_salt_water_as_calculated_after_making_the_appropriate_allowances_13_2") as HTMLInputElement).value = data.Mean_Draught_in_salt_water_as_calculated_after_making_the_appropriate_allowances_13_2;
          (document.getElementById("Mean_Freeboard_Amidships_in_salt_Water_as_calculated_after_making_the_appropriate_allowances_(14)_1") as HTMLInputElement).innerHTML = data.Mean_Freeboard_Amidships_in_salt_Water_as_calculated_after_making_the_appropriate_allowances_14_1;
          (document.getElementById("Mean_Freeboard_Amidships_in_salt_Water_as_calculated_after_making_the_appropriate_allowances_14_2") as HTMLInputElement).value = data.Mean_Freeboard_Amidships_in_salt_Water_as_calculated_after_making_the_appropriate_allowances_14_2;
          (document.getElementById("mm_9") as HTMLInputElement).innerHTML = data.mm_9;
          (document.getElementById("Date_of_posting_the_Notice_(Notice_FRE13)_(15)_1") as HTMLInputElement).innerHTML = data.Date_of_posting_the_Notice_Notice_FRE13_15_1;
          (document.getElementById("Date_of_posting_the_Notice_Notice_FRE13_15_2") as HTMLInputElement).value = data.Date_of_posting_the_Notice_Notice_FRE13_15_2;
          (document.getElementById("time_of_posting_the_Notice_(Notice_FRE13)_(15)_1") as HTMLInputElement).innerHTML = data.time_of_posting_the_Notice_Notice_FRE13_15_1;
          (document.getElementById("time_of_posting_the_Notice_Notice_FRE13_15_2") as HTMLInputElement).value = data.time_of_posting_the_Notice_Notice_FRE13_15_2;
          //SIGNATURES
          // (document.getElementById("SIGNATURES") as HTMLInputElement).innerHTML = data.SIGNATURES ;
          (document.getElementById("Master_(16)_1") as HTMLInputElement).innerHTML = data.Master_16_1;
          (document.getElementById("Master_16_2") as HTMLInputElement).value = data.Master_16_2;
          (document.getElementById("Officer_(17)_1") as HTMLInputElement).innerHTML = data.Officer_17_1;
          (document.getElementById("Officer_17_2") as HTMLInputElement).value = data.Officer_17_2;
          //ARRIVALS
          (document.getElementById("Date_of_arrival_(18)_1") as HTMLInputElement).innerHTML = data.Date_of_arrival_18_1;
          (document.getElementById("Date_of_arrival_18_2") as HTMLInputElement).value = data.Date_of_arrival_18_2;
          (document.getElementById("hour_of_arrival_(18)_1") as HTMLInputElement).innerHTML = data.hour_of_arrival_18_1;
          (document.getElementById("hour_of_arrival_18_2") as HTMLInputElement).value = data.hour_of_arrival_18_2;
          (document.getElementById("Dock_(19)_1") as HTMLInputElement).innerHTML = data.Dock_19_1;
          (document.getElementById("Dock_19_2") as HTMLInputElement).value = data.Dock_19_2;
          (document.getElementById("wharf_(19)_1") as HTMLInputElement).innerHTML = data.wharf_19_1;
          (document.getElementById("wharf_19_2") as HTMLInputElement).value = data.wharf_19_2;
          (document.getElementById("harbour_(19)_1") as HTMLInputElement).innerHTML = data.harbour_19_1;
          (document.getElementById("harbour_19_2") as HTMLInputElement).value = data.harbour_19_2;
          (document.getElementById("other_place_(19)_1") as HTMLInputElement).innerHTML = data.other_place_19_1;
          (document.getElementById("other_place_19_2") as HTMLInputElement).value = data.other_place_19_2;
        }, 500);

      }



      //olb-10
      if (data.formId == 78) {
        this.olb = 10;
        setTimeout(() => {
          (document.getElementById("Date_of_the_occurence_1") as HTMLInputElement).innerHTML = data.Date_of_the_occurence_1;
          (document.getElementById("Date_of_the_occurence_2") as HTMLInputElement).value = data.Date_of_the_occurence_2;
          (document.getElementById("hour_of_the_occurence_1") as HTMLInputElement).innerHTML = data.hour_of_the_occurence_1;
          (document.getElementById("hour_of_the_occurence_2") as HTMLInputElement).value = data.hour_of_the_occurence_2;
          (document.getElementById("Place_of_the_occurence_or_situation_by_latitude_and_longitude_at_sea_1") as HTMLInputElement).innerHTML = data.Place_of_the_occurence_or_situation_by_latitude_and_longitude_at_sea_1;
          (document.getElementById("Place_of_the_occurence_or_situation_by_latitude_and_longitude_at_sea_2") as HTMLInputElement).value = data.Place_of_the_occurence_or_situation_by_latitude_and_longitude_at_sea_2;
          (document.getElementById("Date_of_Entry_1") as HTMLInputElement).innerHTML = data.Date_of_Entry_1;
          (document.getElementById("Date_of_Entry_2") as HTMLInputElement).value = data.Date_of_Entry_2;
          (document.getElementById("Entries_required_by_Regulations_made_under_Section_143_of_the_merchant_Shipping_Act_1976_1") as HTMLInputElement).innerHTML = data.Entries_required_by_Regulations_made_under_Section_143_of_the_merchant_Shipping_Act_1976_1;
          (document.getElementById("Entries_required_by_Regulations_made_under_Section_143_of_the_merchant_Shipping_Act_1976_2") as HTMLInputElement).value = data.Entries_required_by_Regulations_made_under_Section_143_of_the_merchant_Shipping_Act_1976_2;
          (document.getElementById("State_fine_imposed_if_any_1") as HTMLInputElement).innerHTML = data.State_fine_imposed_if_any_1;
          (document.getElementById("State_fine_imposed_if_any_2") as HTMLInputElement).value = data.State_fine_imposed_if_any_2;
        }, 500);


      }


    }  //***IF TAG CLOSED ****/

  }  //***EDIT FUNCTION CLOSED *****/







  selectionTank1(data) {
    // console.log("TANKS ROBS 1" + data);
    this.session.set('tank1', data);
  }
  selectionTank2(data) {
    // console.log("TANKS ROBS 2" + data);
    this.session.set('tank2', data);
  }
  selectionTank3(data) {
    // console.log("TANKS ROBS 3" + data);
    this.session.set('tank3', data);
  }
  selectionTank4(data) {
    // console.log("TANKS ROBS 4" + data);
    this.session.set('tank4', data);
  }
  selectionTank5(data) {
    // console.log("TANKS ROBS 5" + data);
    this.session.set('tank5', data);
  }
  selectionTank6(data) {
    // console.log("TANKS ROBS 6" + data);
    this.session.set('tank6', data);
  }

  selectedRank(data) {
    console.log("SELECTED RANK" + " " + data);
  }

  onRankChange(event: any) {
    this.selectedRank(event.value); // your existing logic
    console.log('==selectedOfficerRankId==', this.selectedOfficerRankId);
  
    const nativeEvent = new Event('change', { bubbles: true });
    const targetElement = document.getElementById('Rank_759');
    if (targetElement) {
      targetElement.dispatchEvent(nativeEvent);
    }
  }
  

  //radiobutton hard code
  opentextbox() {
    this.ishidden = true;
  }

  closetextbox() {
    this.ishidden = false;
  }

  opengears() {
    this.isgears = true;
  }

  closegears() {
    this.isgears = false;
  }

  openincinerator() {
    this.incinerator = true;
  }

  closeincinerator() {
    this.incinerator = false;
  }



    private formatDateToInputValue(date: Date): string {
      const year = date.getFullYear();
      const month = (date.getMonth() + 1).toString().padStart(2, '0'); // months are 0-based
      const day = date.getDate().toString().padStart(2, '0');
      return `${year}-${month}-${day}`;
    }

  ngOnInit() {
    //this.lockService.enableLock();
    this.dateChangeService.dateChange$.subscribe(({ value, id }) => {
      // console.log('Global date change:', value, 'from:', id);
      this.saveReason = true;
      if (id != 'user_comment') {
        this.edited_field_id = id;  // Get the field ID
        const fullDate = new Date(value);
        this.edited_field_value = this.formatDateToInputValue(fullDate);;  // Get the field I
      }
      // console.log("===onKeyUp===", this.saveReason);
      // console.log("===edited_field_id===", this.edited_field_id);

    });

    //for date and watchhours
    this.editlogbookformsService.getAllWatchHoursWithActive((response) => {
      this.popupwatchhours = response.data;
      // console.log("====main====");
      //  console.log(this.popupwatchhours);
    });



    // getting response for all the accordions
    this.editlogbookformsService.getAllFormBuilder((response) => {
      this.forms = response.data;
      this.forms.forEach((element) => {
        this.formbuilderres.push(element.formbuilderresponse);
      });
      // console.log("====FORMS====");
      // console.log(this.forms);
      // console.log("===FORMBUILDERRESPONSE");
      // console.log(this.formbuilderres);
    });

    //response for tanks
    this.editlogbookformsService.getAllTanks((response) => {
      this.tanks = response.data;

      //  this.tanks.forEach(element => {
      //    this.tankdropdown.push(element.tankName)

      //  });
      // console.log("===TANKS===")
      // console.log(this.tanks);
      //  console.log(this.tankdropdown);
    })


    //for crew record and management of deck logbook
    this.editlogbookformsService.getAllRank((response) => {
      this.crewrecordrank = response.data;
      // console.log("====CREW RECORD RANK====");
      //  console.log(this.crewrecordrank);
    });

    //for crew record and management of deck logbook
    this.editlogbookformsService.getAllDropDowns((response) => {
      this.alldropdown = response.data;
      // console.log("====ALL DROPDOWN====");
      //  console.log(this.alldropdown);
      this.alldropdown.forEach(element => {
        this.crewName.push(element.crewName)
        // console.log("CREW NAME");
        // console.log(this.crewName);

      });
    });


    this.cookieIp = this.cookieService.get("campbell_app_ip_address");

    var companyid = this.session.get("companyId");
    if (companyid) {
      this.getVesselList(companyid);
    } else {
      this.getCompanyList();
    }

    if (this.session.get("passcode")) {
      this.editlogbookformsService.getLatestCOSPByPasscode(
        this.session.get("passcode"),
        (response) => {
          // console.log("==================1=================");
          // console.log(response);
          // console.log("==================111=================");
          const responseData = response.data;
          // console.log(responseData);
          // console.log("=================2222222222==================");
          if (response.responsecode == 200) {
            // console.log("voyageNo" + responseData.voyageNo);
            // console.log("voyageId" + responseData.id);
            this.voyageNo = responseData.voyageNo;
            this.voyageId = responseData.id;

            this.timeZone = responseData.zoneTimeValue;
            // this.getVoyageData(responseData.vesselId);
            // this.selectedVoyage = responseData.voyageNo;
            // this.currentVessel = responseData.vesselId;

            if (this.voyageId) {
              this.vs.getDataById(responseData.vesselId, (vesseldata) => {
                if (vesseldata.responsecode == 200) {
                  // console.log("=================33333==================");

                  if (
                    vesseldata.data.imoNo != null &&
                    vesseldata.data.imoNo != ""
                  ) {
                    this.imoNo = vesseldata.data.imoNo;
                  } else {
                    this.imoNo = vesseldata.data.vesselCode;
                  }

                  this.shipName = responseData.shipName;
                  this.shipFrom = responseData.fromPort;
                  this.shipTo = responseData.toPort;
                  this.startDate = responseData.voyageStartDate;
                  this.selectedCompany = vesseldata.data.companyId;
                  if (!companyid) {
                    this.getVesselList(this.selectedCompany);
                  }
                }
              });
            }
          }
        }
      );
    }

    this.editlogbookformsService.getParentCategory((response) => {
      this.bookType = response.data[0].children;
      this.bookType[4].children = [
        {
          hName: "Ballast Water Record Book",
          id: "47",
          image: "/FileUpload/image.png",
        },
      ];
      this.bookType[5].children = [
        {
          hName: "Fuel Oil and Ozone Depleting Substances",
          id: "48",
          image: "/FileUpload/image.png",
        },
      ];
      this.bookType[6].children = [
        {
          hName: "SECTION A : PARTICULARS OF SHIP",
          id: "49",
          image: "/FileUpload/image.png",
        },
        {
          hName: "SECTION B : QUALIFIED PERSONNEL",
          id: "49-1",
          image: "/FileUpload/image.png",
        },
        {
          hName: "SECTION C : NAME OF SHIP",
          id: "49-2",
          image: "/FileUpload/image.png",
        },
        {
          hName: "GMDSS RADIO LOG",
          id: "49-3",
          image: "/FileUpload/image.png",
        },

      ];
      this.bookType[7].children = [
        { //OLB-1
          //hName: "OLB-1",
          hName: "OFFICIAL LOG BOOK",
          id: "53-1",
          image: "/FileUpload/image.png",
        },
        { //RECORD OF SEAMEN EMPLOYED IN THE SHIP
          //hName: "OLB-2",
          hName: "EMPLOYED SEAMEN RECORD",
          id: "53-2",
          image: "/FileUpload/image.png",
        },
        { //RETURNS AND ENTRIES OF BIRTH AND DEATH IN THE OFFICIAL LOG BOOK
          //hName: "OLB-3",
          hName: "BIRTHS & DEATHS",
          id: "53-3",
          image: "/FileUpload/image.png",
        },
        {
          //RECORD OF MUSTERS BOAT DRILLS AND FIRE DRILLS,TRAINING OF CREW,AND INSPECTIONS OF LIFE-SAVING APPLIANCES AND FIRE APPLIANCES AS REQUIRED BY THE MERCHANT SHIPPING ACTS,1976 TO 1992
          hName: "TRAINING & DRILLS MUSTERS",
          id: "53-4",
          image: "/FileUpload/image.png",
        },
        { //RECORD OF TEST DRILLS AND INSPECTIONS OF THE SHIP'S STEERING GEAR
          hName: "TEST DRILLS & INSPECTIONS",
          id: "53-5",
          image: "/FileUpload/image.png",
        },
        {//RECORD OF INSPECTIONS OF CREW ACCOMODATION CARRIED OUT UNDER REGULATION 38(2) ABD 31(2) OF SCHEDULE 6 OF THE MERCHANT SHIPPING (CREW ACCOMODATIONS),REGULATIONS 1978 AS AMMENDED
          hName: "CREW ACCOMMODATION INSPECTIONS",
          id: "53-6",
          image: "/FileUpload/image.png",
        },
        {//RECORD OF INSPECTIONS CARRIED OUT IN ACCORDANCE WITH INTERNATIONAL LABOUR ORGANISATION CONVENTION NO.68 OF 1946 OF SUPPLIES OF FOOD AND WATER PROVIDED FOR THE CREW
          hName: "ILO ACCORDANCE",
          id: "53-7",
          image: "/FileUpload/image.png",
        },
        {//RECORD OF INSPECTIONS CARRIED OUT IN ACCORDANCE WITH INTERNATIONAL LABOUR ORGANISATION CONVENTION NO.68 OF 1946 OF SUPPLIES OF FOOD AND WATER PROVIDED FOR THE CREW
          hName: "LOADLINE",
          id: "53-8",
          image: "/FileUpload/image.png",
        },
        {//DATES OF DEPARTURE FROM AND ARRIVAL AT EACH ,DOCK,WHARF,HARBOUR OR OTHER PLACE WITH THE DRAUGHT OF WATER AND FREEBOARD UPON EVERY OCCASSION OF THE SHIP PROCEEDING TO THE SEA
          hName: "DEPARTURES & ARRIVALS",
          id: "53-9",
          image: "/FileUpload/image.png",
        },
        {//OFFICIAL LOG OF THE
          hName: "PART IV SCHEDULE OLB",
          id: "53-10",
          image: "/FileUpload/image.png",
        },
      ];



      //changing images as per server settings
      for (let key in this.bookType) {
        if (this.bookType[key].children != null) {
          for (let pey in this.bookType[key].children) {
            if (this.bookType[key].children[pey].image != null)
              this.bookType[key].children[pey].image = this.bookType[
                key
              ].children[pey].image
                .toString()
                .replace("13.127.158.45", this.cookieIp)
                .replace("13.232.247.131", this.cookieIp)
                .replace("192.168.0.25", this.cookieIp);
          }
        }

        if (this.bookType[key].image != null) {
          this.bookType[key].image = this.bookType[key].image
            .toString()
            .replace("13.127.158.45", this.cookieIp)
            .replace("13.232.247.131", this.cookieIp)
            .replace("192.168.0.25", this.cookieIp);
        }
      }

      // console.log("logtype:children");
      // console.log(this.bookType);
    });

    this.editlogbookformsService.getFormByHid((response) => {
      this.formBuilder = response.data;
    });

    this.editlogbookformsService.getAllActiveWatchHour((response) => {
      this.watchHours = response.data;
    });

    this.myForm = this.fb.group({
      bookTypeId: new FormControl(null, [Validators.required]),
      watchId: new FormControl(null),

      //'formId':new FormControl(null, [Validators.required])
    });

  }

  getSignature(imagedata: string) {
    return (imagedata != "" && imagedata != null) ? this.domSanitizer.bypassSecurityTrustUrl('data:image/jpg;base64, ' + imagedata) : this.domSanitizer.bypassSecurityTrustUrl('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAABmJLR0QA/wD/AP+gvaeTAAABQUlEQVRYhe3WTytEYRTH8Q+NNERZmFIWlhQrspK1LUuy8C5EsmFnyxvwHpQsrZSVWVhYSA01CxulFA2LeYY7/tzM4xoW91en+3See875du7TPQ+5/rGeI+wcQ38JkClEI2EMcCYQsQDlxLP0FwCDOJNBJ2IBZAVxhLkIgM+s/FVQRwxZCkCaWq5VwCYucYUtdLXO1fKnfNWGj63cbifARQicxXRYV9oJcB8Ce36YKDWuMyJhpsoBcoAcoNCGGqkz4DsdKAaL0QAWI2OdqP/B9rDj87Fawi6quMFCYq+I4xC3FgMwjgfU8IRHTCX2V3CreVg1ZkU/DoPvCsMxALDu4yTsxX7Cf4DJsK5hxtu9sIqx2OLUD+lpSNgdfMsh+R2WEu9ea+5GGSM/Kd7QhObWwypG3/nmA0RF/cz0ZVE816/rBQZFh/X/XGGHAAAAAElFTkSuQmCC');
  }

  getCompanyList() {
    this.cmps.getData((response) => {
      // console.log("====company====");
      // console.log(response.data);
      this.companyList = response.data;
    });
  }

  selectCompany(id) {
    this.show = null;
    this.currentBook = -1;
    this.cleanReports();
    this.getVesselList(id);
    this.currentVessel = id;
  }

  getVesselList(id) {
    this.userVesselData = [];
    this.userVoyageData = [];
    this.vs.getDataByCompanyId(id, (response) => {
      //  console.log(response);
      this.userVesselData = response.data;
      this.currentVessel = null;
      this.userVoyageData = [];
      this.selectedVoyage = null;
      this.voyageNo = null;
    });
  }

  getVesselDetailsById(id) {
    this.vs.getDataById(id, (response) => {
      // console.log("vessel===data");
      // console.log(response);
      this.selectedCompany = response.data.companyId;
      this.getVesselList(response.data.companyId);
    });
  }




  selectVoyage(value) {
    this.show = null;
    this.currentBook = -1;
    this.voyageNo = value;
    this.selectedVoyage = value;
    this.cleanReports();
  }

  getVoyageData(id) {
    this.loading = true;
    this.selectedVoyage = null;
    this.show = null;
    this.currentBook = -1;
    this.newVesselId = id;
    // console.log('==newVesselId==', this.newVesselId);
    this.voyagelistService.getAllClosedVoyageByvesselId(id, (response) => {
      // console.log("follow the data123");
      // console.log(response.data);
      var combinedArray = [];

      this.voyagelistService.getDataById(id, (resp) => {

        this.loading = false;
        this.voyageNo = null;
        this.selectedVoyage = null;
        if (resp.data) combinedArray.push(resp.data);

        for (let key in response.data) {
          //response.data[key].cosp['type'] = (parseInt(key)+1) + '- COSP'
          combinedArray.push(response.data[key].cosp);
        }

        this.userVoyageData = combinedArray;
        // this.selectedVoyage = resp.data.voyageNo;

        this.voyageNo = resp.data.voyageNo;
        // this.currentVessel = resp.data.vesselId;
        //more variable
        // console.log("====resp.data====");
        // console.log(resp.data);
        this.vs.getDataById(resp.data.vesselId, (responseVessel) => {
          if (
            responseVessel.data.imoNo != null &&
            responseVessel.data.imoNo != ""
          ) {
            this.imoNo = responseVessel.data.imoNo;
          } else {
            this.imoNo = responseVessel.data.vesselCode;
          }
        });

        this.shipName = resp.data.shipName;
        this.shipFrom = resp.data.fromPort;
        this.shipTo = resp.data.toPort;
        this.startDate = resp.data.voyageStartDate;

        this.cleanReports();
      });
    });
  }
  createWatchHoursJson(response) {
    //this.watchHoursList = ['03-01','04-01','05-01','06-01','07-01','08-01'];

    // console.log("==========createWatchHoursJson==============");
    // console.log(response);
    // console.log("==========createWatchHoursJson11==============");
    var watchlist = [];
    if (this.getFormRecordsList.length > 0) {
      for (var r = 0; r < response[0].data.length; r++) {
        var actionTime = response[0].data[r].actionTime;
        if (actionTime) {
          watchlist.push(actionTime);
        }
      }
      this.watchHoursList = Array.from(new Set(watchlist));
      this.watchHoursList.sort();
    }
  }

  getFormDetails(hid) {
    for (var i = 0; i < this.formBuilder.length; i++) {
      if (this.formBuilder[i].hid == hid) {
        for (
          var r = 0;
          r < this.formBuilder[i].formbuilderresponse.length;
          r++
        ) {
          var formName = this.formBuilder[i].formbuilderresponse[r].formName;
          this.formKeys.push(formName);
        }
      }
    }
  }

  getWatchHours(hid) {
    for (var i = 0; i < this.formBuilder.length; i++) {
      if (this.formBuilder[i].hid == hid) {
        for (
          var r = 0;
          r < this.formBuilder[i].formbuilderresponse.length;
          r++
        ) {
          var formName = this.formBuilder[i].formbuilderresponse[r].formName;
          this.formKeys.push(formName);
        }
      }
    }
  }

  callHType(hid, wid, sectionIndex) {
    //hid = 6;
    for (var i = 0; i < this.formBuilder.length; i++) {
      if (this.formBuilder[i].hid == hid) {
        for (
          var r = 0;
          r < this.formBuilder[i].formbuilderresponse.length;
          r++
        ) {
          var formId = this.formBuilder[i].formbuilderresponse[r].formId;
          //alert(formId);
          this.formBuilderSections = this.formBuilder[i].formbuilderresponse[
            r
          ].formbuildersectionnamelist[sectionIndex].formbuilderlist;
          this.numberSection = this.formBuilder[i].formbuilderresponse[
            r
          ].formbuildersectionnamelist.length;
          this.formDetails = [];
          this.objcol = [];
          var sectionId = this.formBuilder[i].formbuilderresponse[r]
            .formbuildersectionnamelist[sectionIndex].sectionId;
          this.editlogbookformsService.getFormDetailsById(
            formId,
            this.voyageNo,
            (formResponse) => {
              var response = formResponse[0];
              if (response.data != null) {
                for (var s = 0; s < response.data.length; s++) {
                  for (var p = 0; p < this.formBuilderSections.length; p++) {
                    var findKey = false;
                    for (let key in response.data[s]) {
                      if (key == this.formBuilderSections[p].fieldName) {
                        findKey = true;
                        this.objcol.push(response.data[s][key]);
                      }
                    }

                    if (findKey != true) {
                      this.objcol.push("NaN");
                    }
                  }

                  // console.log(this.objcol);
                  this.formDetails.push(this.objcol);
                  this.objcol = [];
                }
              }
            }
          );
        }
      }
    }
  }

  getRandomInt(max) {
    return Math.floor(Math.random() * Math.floor(max));
  }

  addTestForm() {
    return {
      formData: {
        Name_of_sec_Tank_Designation_387: "FR-14017(P)",
        TextBox_388: "2222 <b> edited </b>",
        m3_389: "m3",
        TextBox_390: "",
        m3_391: "m3",
        TextBox_392: "",
        m3_393: "m3",
        collected_from_394: "",
        identification_of_source_456: "",
        TextBox_1_395: "",
        m3_396: "m3",
        Sludge_from_397: "",
        Name_of_sec__Tank_Designation_398: "",
        _399: ",",
        TextBox_2_400: "",
        m3_retained_to_401: "m3 retained, to",
        Name_of_sec_Tank_Designation_402: "",
        during_port_stay_403: "DURING PORT STAY",
        Name_of_Port_404: "",
        TextBox_1_405: "",
        m3_406: "m3",
        Water_drained_from_407: "",
        "Name_of_sec_Tank_Designation_408\t": "",
        TextBox_2_409: "",
        m3_retained_to_410: "m3 retained, to",
        Name_of_sec_Tank_Designation_411: "",
        retained_in_tank_412: "RETAINED IN TANK(S)",
        TextBox_3_413: "",
        m3_414: "m3",
        TextBox_1_415: "",
        m3_417: "m3",
        Sludge_from_419: "",
        Name_of_sec_Tank_Designation_420: "",
        TextBox_2_423: "",
        m3_424: "m3 retained, Burned in incinerator for",
        TextBox_3_426: "",
        hours_427: "HOURS",
        TextBox_1_416: "",
        m3_418: "m3",
        Sludge_from_421: "",
        "Name of_sec Tank _Designation_422": "",
        TextBox_2_425: "",
        m3_428: "m3 retained, Burned in Boiler for",
        TextBox_3_429: "",
        hours_430: "HOURS",
      },
      timeStamp: 1581937459527,
      formId: "32",
      rowId: "123456",
      voyageId: "522",
      voyageNo: "12345",
      vesselId: "64",
      changeFields: "{TextBox_388,Name_of_sec_Tank_Designation_387}",
    };
  }



  getOrbPartTwoData(
    hid,
    actionDate = "",
    actionTime = "",
    fromDate = "",
    toDate = ""
  ) {
    for (var i = 0; i < this.formBuilder.length; i++) {
      if (this.formBuilder[i].hid == hid) {
        this.formCount = [];
        this.objcolsection = [];
        var result = [];
        var strFormId = "";

        for (
          var r = 0;
          r < this.formBuilder[i].formbuilderresponse.length;
          r++
        ) {
          if (
            this.formBuilder[i].formbuilderresponse[r].formId == 49 ||
            this.formBuilder[i].formbuilderresponse[r].formId == 50 ||
            this.formBuilder[i].formbuilderresponse[r].formId == 51 ||
            this.formBuilder[i].formbuilderresponse[r].formId == 52 ||
            this.formBuilder[i].formbuilderresponse[r].formId == 53 ||
            this.formBuilder[i].formbuilderresponse[r].formId == 54 ||
            this.formBuilder[i].formbuilderresponse[r].formId == 55 ||
            this.formBuilder[i].formbuilderresponse[r].formId == 56 ||
            this.formBuilder[i].formbuilderresponse[r].formId == 57 ||
            this.formBuilder[i].formbuilderresponse[r].formId == 58 ||
            this.formBuilder[i].formbuilderresponse[r].formId == 59 ||
            this.formBuilder[i].formbuilderresponse[r].formId == 60 ||
            this.formBuilder[i].formbuilderresponse[r].formId == 62 ||
            this.formBuilder[i].formbuilderresponse[r].formId == 63 ||
            this.formBuilder[i].formbuilderresponse[r].formId == 64 ||
            this.formBuilder[i].formbuilderresponse[r].formId == 61 ||
            this.formBuilder[i].formbuilderresponse[r].formId == 65 ||
            this.formBuilder[i].formbuilderresponse[r].formId == 66
          ) {
            strFormId +=
              this.formBuilder[i].formbuilderresponse[r].formId + ",";
            this.formCount.push(this.formBuilder[i].formbuilderresponse[r]);
          }
        }

        var fineStringFormsId = strFormId.replace(/(^,)|(,$)/g, "");
        //alert(fineStringFormsId);

        this.editlogbookformsService.getFormDetailsByActionDateAndTime(
          fineStringFormsId,
          this.voyageNo,
          actionDate,
          actionTime,
          fromDate,
          toDate,
          (multiresponse) => {
            this.objcolsection = [];
            var cnt1 = 0;
            var cnt2 = 0;
            var cnt3 = 0;
            var cnt4 = 0;
            var cnt5 = 0;
            var cnt6 = 0;
            var cnt7 = 0;
            var colsec1 = [];
            var colsec2 = [];
            var colsec3 = [];
            var colsec4 = [];
            var colsec5 = [];
            var colsec6 = [];
            var colsec7 = [];
            var colsec8 = [];
            var coldate = [];
            var colsec9 = [];
            let response = [];
            var signdate = "";
            var masterName = "";
            var masterSignature = "";
            var roleId = "";
            var roleName = "";
            var id = "";

            if (multiresponse != null && multiresponse.length > 0) {
              for (let ky in multiresponse) {
                response.push(this.modifyedData(multiresponse[ky]));
              }

              // console.log("=========final data============");
              // console.log(response);
              // all form response loop
              for (let ky in response) {
                if (response[ky].data != null) {
                  var sectionName = "";
                  this.showpop4 = 0;
                  for (var s = 0; s < response[ky].data.length; s++) {
                    if (response[ky].data[s].isDelete == "1") continue;
                    if (response[ky].data[s].editedBy != null) {
                      this.editedBy = response[ky].data[s].editedBy;
                      //alert(this.editedBy); return;
                    }

                    var usersign = response[ky].data[s].userSign;
                    this.dataSource = new MatTableDataSource(usersign);
                    //     this.dataSource.data.push(usersign)
                    if (
                      response[ky].data[s].masterDate != null &&
                      response[ky].data[s].masterDate != ""
                    ) {
                      signdate = response[ky].data[s].masterDate;
                    }

                    if (
                      response[ky].data[s].masterName != null &&
                      response[ky].data[s].masterName != ""
                    ) {
                      masterName = response[ky].data[s].masterName;
                    }

                    if (
                      response[ky].data[s].masterSignature != null &&
                      response[ky].data[s].masterSignature != ""
                    ) {
                      masterSignature = response[ky].data[s].masterSignature;
                    }

                    if (
                      response[ky].data[s].masterRoleId != null &&
                      response[ky].data[s].masterRoleId != ""
                    ) {
                      roleId = response[ky].data[s].masterRoleId;
                    }

                    if (
                      response[ky].data[s].masterRoleName != null &&
                      response[ky].data[s].masterRoleName != ""
                    ) {
                      roleName = response[ky].data[s].masterRoleName;
                    }
                    if (
                      response[ky].data[s]._id.$oid != null &&
                      response[ky].data[s]._id.$oid != ""
                    ) {
                      id = response[ky].data[s]._id.$oid;
                    }

                    var formId = response[ky].data[s].formId;
                    this.masterSignature = masterSignature;
                    this.masterName = masterName;
                    this.signdate = signdate;
                    this.roleName = roleName;
                    this.id = id;
                    this.formId = formId;

                    this.userSign.push(usersign);

                    this.formBuilderSections = [];
                    for (
                      var r = 0;
                      r < this.formBuilder[i].formbuilderresponse.length;
                      r++
                    ) {
                      if (
                        this.formBuilder[i].formbuilderresponse[r].formId ==
                        formId
                      ) {
                        sectionName = this.formBuilder[i].formbuilderresponse[
                          r
                        ].formName
                          .replace(/Code/gi, "")
                          .replace(/ORB2/gi, "")
                          .replace(/ORB/gi, ""); //.charAt(this.formBuilder[i].formbuilderresponse[r].formName.length-1);
                        for (
                          var u = 0;
                          u <
                          this.formBuilder[i].formbuilderresponse[r]
                            .formbuildersectionnamelist.length;
                          u++
                        ) {
                          this.formBuilderSections.push(
                            this.formBuilder[i].formbuilderresponse[r]
                              .formbuildersectionnamelist[u]
                          ); //.formbuilderlist
                        }
                      }
                    }

                    var p = 0;
                    for (let key in response[ky].data[s]) {
                      for (p = 0; p < this.formBuilderSections.length; p++) {
                        for (
                          var v = 0;
                          v <
                          this.formBuilderSections[p].formbuilderlist.length;
                          v++
                        ) {
                          if (
                            key.toString().toLowerCase() == "created_at" &&
                            response[ky].data[s][key] != ""
                          ) {
                            coldate["date_created"] = response[ky].data[s][key];
                            coldate[
                              "section_length"
                            ] = this.formBuilderSections.length;
                          }
                          if (
                            key.toString().toLowerCase() ==
                            this.formBuilderSections[p].formbuilderlist[
                              v
                            ].fieldName
                              .toString()
                              .toLowerCase()
                          ) {
                            if (formId == 49) {
                              this.garbegForm1 = 0;
                              this.garbegForm2 = 0;
                              this.blstForm = 0;
                              this.orbForm = 0;
                              this.orbpart2 = 1;
                              if (p == 0) {
                                // Name of_sec Tank_Designation_387
                                if (
                                  key.toString().toLowerCase() ==
                                  "Place_of_loading_1175".toLowerCase() &&
                                  response[ky].data[s][key] != ""
                                ) {
                                  colsec1[key.toString().toLowerCase()] =
                                    response[ky].data[s][key];
                                }
                                //
                              }

                              if (p == 1) {
                                //TextBox_388,m3_389
                                if (
                                  (key.toString().toLowerCase() ==
                                    "Type_of_oil_1176".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Tank_name_1177".toLowerCase() &&
                                    response[ky].data[s][key] != "")
                                ) {
                                  colsec2[key.toString().toLowerCase()] =
                                    response[ky].data[s][key];
                                }
                              }
                              //
                              if (p == 2) {
                                //TextBox_390,m3_391
                                if (
                                  (key.toString().toLowerCase() ==
                                    "Total_quantity_of_oil_loaded_1178".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "m3_1179".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Total_content_1180".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "m3_1181".toLowerCase() &&
                                    response[ky].data[s][key] != "")
                                ) {
                                  colsec3[key.toString().toLowerCase()] =
                                    response[ky].data[s][key];
                                }
                                //
                              }

                              //
                            }

                            if (formId == 50) {
                              this.garbegForm1 = 0;
                              this.garbegForm2 = 0;
                              this.blstForm = 0;
                              this.orbForm = 0;
                              this.orbpart2 = 1;
                              //alert(p)
                              if (p == 0) {
                                // Name of_sec Tank_Designation_387
                                if (
                                  (key.toString().toLowerCase() ==
                                    "4.1_from_1182".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Tank_name_1183".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "4.2_to_1184".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Tank_name_1185".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "State_quantity_transferred_1186".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "4000_m3_1187".toLowerCase() &&
                                    response[ky].data[s][key] != "")
                                ) {
                                  colsec1[key.toString().toLowerCase()] =
                                    response[ky].data[s][key];
                                }
                                //
                              }

                              if (p == 1) {
                                //TextBox_388,m3_389
                                if (
                                  key.toString().toLowerCase() ==
                                  "Yes_1188".toLowerCase() ||
                                  key.toString().toLowerCase() ==
                                  "No_1189".toLowerCase() ||
                                  (key.toString().toLowerCase() ==
                                    "State_quantity_retained_1190".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "m3_1191".toLowerCase() &&
                                    response[ky].data[s][key] != "")
                                ) {
                                  colsec2[key.toString().toLowerCase()] =
                                    response[ky].data[s][key];
                                }
                              }
                            }

                            if (formId == 51) {
                              this.orbpart2 = 1;

                              if (p == 0) {
                                if (
                                  key.toString().toLowerCase() ==
                                  "Place_of_unloading_1192".toLowerCase() &&
                                  response[ky].data[s][key] != ""
                                ) {
                                  colsec1[key.toString().toLowerCase()] =
                                    response[ky].data[s][key];
                                }
                              }

                              if (p == 1) {
                                if (
                                  key.toString().toLowerCase() ==
                                  "Tank_name_1193".toLowerCase() &&
                                  response[ky].data[s][key] != ""
                                ) {
                                  colsec2[key.toString().toLowerCase()] =
                                    response[ky].data[s][key];
                                }
                              }

                              if (p == 2) {
                                if (
                                  key.toString().toLowerCase() ==
                                  "Yes_1194".toLowerCase() ||
                                  key.toString().toLowerCase() ==
                                  "No_1195".toLowerCase() ||
                                  (key.toString().toLowerCase() ==
                                    "State_quantity_retained_1196".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "m3_1197".toLowerCase() &&
                                    response[ky].data[s][key] != "")
                                ) {
                                  colsec3[key.toString().toLowerCase()] =
                                    response[ky].data[s][key];
                                }
                              }
                            }

                            if (formId == 52) {
                              this.orbpart2 = 1;

                              if (p == 0) {
                                if (
                                  (key.toString().toLowerCase() ==
                                    "Port_1198".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "port_name_1199".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "position_1200".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "LAT_1201".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "LAT_Degree_1202".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "degree_1203".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Lat_minutes_1204".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "minutes_1205".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "lat_direction_1206".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "LONG_1207".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "long_degree_1208".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "degree_1209".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "long_minutes_1210".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "minutes_1211".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "long_direction_1212".toLowerCase() &&
                                    response[ky].data[s][key] != "")
                                ) {
                                  colsec1[key.toString().toLowerCase()] =
                                    response[ky].data[s][key];
                                }
                              }
                              if (p == 1) {
                                if (
                                  key.toString().toLowerCase() ==
                                  "Tank_name_1213".toLowerCase() &&
                                  response[ky].data[s][key] != ""
                                ) {
                                  colsec2[key.toString().toLowerCase()] =
                                    response[ky].data[s][key];
                                }
                              }
                              if (p == 2) {
                                if (
                                  key.toString().toLowerCase() ==
                                  "No_of_machines_1214".toLowerCase() &&
                                  response[ky].data[s][key] != ""
                                ) {
                                  colsec3[key.toString().toLowerCase()] =
                                    response[ky].data[s][key];
                                }
                              }
                              if (p == 3) {
                                if (
                                  key.toString().toLowerCase() ==
                                  "time_1215".toLowerCase() &&
                                  response[ky].data[s][key] != ""
                                ) {
                                  colsec4[key.toString().toLowerCase()] =
                                    response[ky].data[s][key];
                                }
                              }
                              if (p == 4) {
                                if (
                                  key.toString().toLowerCase() ==
                                  "washing_pattern_1216".toLowerCase() &&
                                  response[ky].data[s][key] != ""
                                ) {
                                  colsec5[key.toString().toLowerCase()] =
                                    response[ky].data[s][key];
                                }
                              }
                              if (p == 5) {
                                if (
                                  key.toString().toLowerCase() ==
                                  "Washing_line_pressure_1217".toLowerCase() &&
                                  response[ky].data[s][key] != ""
                                ) {
                                  colsec6[key.toString().toLowerCase()] =
                                    response[ky].data[s][key];
                                }
                              }
                              if (p == 6) {
                                if (
                                  key.toString().toLowerCase() ==
                                  "time_1218".toLowerCase() &&
                                  response[ky].data[s][key] != ""
                                ) {
                                  colsec7[key.toString().toLowerCase()] =
                                    response[ky].data[s][key];
                                }
                              }
                              if (p == 7) {
                                if (
                                  key.toString().toLowerCase() ==
                                  "state_method_1219".toLowerCase() &&
                                  response[ky].data[s][key] != ""
                                ) {
                                  colsec8[key.toString().toLowerCase()] =
                                    response[ky].data[s][key];
                                }
                              }
                              if (p == 8) {
                                if (
                                  key.toString().toLowerCase() ==
                                  "Remarks_1220".toLowerCase() &&
                                  response[ky].data[s][key] != ""
                                ) {
                                  colsec9[key.toString().toLowerCase()] =
                                    response[ky].data[s][key];
                                }
                              }
                            }

                            if (formId == 53) {
                              this.orbpart2 = 1;

                              if (p == 0) {
                                if (
                                  (key.toString().toLowerCase() ==
                                    "Start_1221".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "LAT_1222".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Lat_degree_1223".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "degree_1224".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "lat_minutes_1225".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "minutes_1226".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "lat_direction_1227".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Long_1228".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "degree_1229".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Long_minutes_1230".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "minutes_1231".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "long_direction_1232".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "STOP_1233".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Lat_1234".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Lat_degree_1235".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "degree_1236".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "lat_minurtes_1237".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "minutes_1238".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "lat_direction_1239".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Long_1240".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "long_degree_1241".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "degree_1242".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Long_minutes_1243".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "minutes_1244".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Long_direction_1245".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "long_degree_1620_1228".toLowerCase() &&
                                    response[ky].data[s][key] != "")
                                ) {
                                  colsec1[key.toString().toLowerCase()] =
                                    response[ky].data[s][key];
                                }
                              }
                              if (p == 1) {
                                if (
                                  (key.toString().toLowerCase() ==
                                    "identity_of_tanks_1246".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "tank_name_1247".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "time_and_start_1248".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Start_1249".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "time_1250".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "END_1251".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "time_1252".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "quantity_of_ballast_1253".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Quantity_of_ballast_received_1254".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "m3_1255".toLowerCase() &&
                                    response[ky].data[s][key] != "")
                                ) {
                                  colsec2[key.toString().toLowerCase()] =
                                    response[ky].data[s][key];
                                }
                              }
                            }

                            if (formId == 56) {
                              this.orbpart2 = 1;

                              if (p == 0) {
                                if (
                                  key.toString().toLowerCase() ==
                                  "Tank_name_1352".toLowerCase() &&
                                  response[ky].data[s][key] != ""
                                ) {
                                  colsec1[key.toString().toLowerCase()] =
                                    response[ky].data[s][key];
                                }
                              }
                              if (p == 3) {
                                if (
                                  (key.toString().toLowerCase() ==
                                    "quantity_1379".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "m3_1380".toLowerCase() &&
                                    response[ky].data[s][key] != "")
                                ) {
                                  colsec2[key.toString().toLowerCase()] =
                                    response[ky].data[s][key];
                                }
                              }

                              if (p == 7) {
                                if (
                                  (key.toString().toLowerCase() ==
                                    "Quantity_of_oily_water_1386".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "tank_name_1387".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Total_quantity_1388".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "m3_1389".toLowerCase() &&
                                    response[ky].data[s][key] != "")
                                ) {
                                  colsec3[key.toString().toLowerCase()] =
                                    response[ky].data[s][key];
                                }
                              }

                              if (p == 8) {
                                if (
                                  (key.toString().toLowerCase() ==
                                    "Quantity_of_oily_water_1390".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Port_name_1391".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Total_Quantity_1392".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "m3_1393".toLowerCase() &&
                                    response[ky].data[s][key] != "")
                                ) {
                                  colsec4[key.toString().toLowerCase()] =
                                    response[ky].data[s][key];
                                }
                              }
                            }

                            if (formId == 59) {
                              this.orbpart2 = 1;
                              if (p == 0) {
                                if (
                                  (key.toString().toLowerCase() ==
                                    "LAT_1456".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "lat_degree_1458".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "degree_1460".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "lat_minutes_1462".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "minutes_1464".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "lat_direction_1465".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "LONG_1466".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "long_degree_1468".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "degree_1469".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "long_minutes_1471".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "minutes_1473".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "minutes_1473".toLowerCase() &&
                                    response[ky].data[s][key] != "")
                                ) {
                                  colsec1[key.toString().toLowerCase()] =
                                    response[ky].data[s][key];
                                }
                              }
                              if (p == 1) {
                                if (
                                  key.toString().toLowerCase() ==
                                  "Tank_name_1475".toLowerCase() &&
                                  response[ky].data[s][key] != ""
                                ) {
                                  colsec2[key.toString().toLowerCase()] =
                                    response[ky].data[s][key];
                                }
                              }

                              if (p == 2) {
                                if (
                                  key.toString().toLowerCase() ==
                                  "Yes_1476".toLowerCase() ||
                                  key.toString().toLowerCase() ==
                                  "No_1477".toLowerCase()
                                ) {
                                  colsec3[key.toString().toLowerCase()] =
                                    response[ky].data[s][key];
                                }
                              }

                              if (p == 3) {
                                if (
                                  (key.toString().toLowerCase() ==
                                    "LAT_1479".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "lat_degree_1481".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "degree_1483".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "lat_minutes_1484".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "minutes_1485".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "lat_direction_1488".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "LONG_1490".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "long_degree_1492".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "long_minutes_1496".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "minutes_1498".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "long_direction_1500".toLowerCase() &&
                                    response[ky].data[s][key] != "")
                                ) {
                                  colsec4[key.toString().toLowerCase()] =
                                    response[ky].data[s][key];
                                }
                              }

                              if (p == 4) {
                                if (
                                  key.toString().toLowerCase() ==
                                  "Yes_1502".toLowerCase() ||
                                  key.toString().toLowerCase() ==
                                  "No_1503".toLowerCase()
                                ) {
                                  colsec5[key.toString().toLowerCase()] =
                                    response[ky].data[s][key];
                                }
                              }
                            }

                            if (formId == 58) {
                              this.orbpart2 = 1;
                              if (p == 0) {
                                if (
                                  key.toString().toLowerCase() ==
                                  "Tank_name_1446".toLowerCase() &&
                                  response[ky].data[s][key] != ""
                                ) {
                                  colsec1[key.toString().toLowerCase()] =
                                    response[ky].data[s][key];
                                }
                              }

                              if (p == 1) {
                                if (
                                  (key.toString().toLowerCase() ==
                                    "Quantity_transferred_1447".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "m3_1448".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Quantity_retained_1449".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "m3_1450".toLowerCase() &&
                                    response[ky].data[s][key] != "")
                                ) {
                                  colsec2[key.toString().toLowerCase()] =
                                    response[ky].data[s][key];
                                }
                              }

                              if (p == 2) {
                                if (
                                  (key.toString().toLowerCase() ==
                                    "disposal_of_reception_1451".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "port_name_1452".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "certificate_obtained_from_1453".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  key.toString().toLowerCase() ==
                                  "yes_1454".toLowerCase() ||
                                  key.toString().toLowerCase() ==
                                  "no_1455".toLowerCase() ||
                                  (key.toString().toLowerCase() ==
                                    "time_1457".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Date_1459".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Quantity_1461".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "cargo_quantity_1467".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "state_quantity_1470".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "from_tank_1480".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "tanks_1482".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Quantity_tank_1486".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "quantity_1487".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "to_tank_1489".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Tanks_1491".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Quantity_tank_1493".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "quantity_1495".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Quantity_transferred_1497".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "total_quantity_1499".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "m3_1501".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "other_method_1504".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "state_quantity_disposal_1505".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "state_quantity_1506".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "m3_1507".toLowerCase() &&
                                    response[ky].data[s][key] != "")
                                ) {
                                  colsec3[key.toString().toLowerCase()] =
                                    response[ky].data[s][key];
                                }
                              }
                            }

                            if (formId == 60) {
                              this.orbpart2 = 1;
                              if (p == 0) {
                                if (
                                  key.toString().toLowerCase() ==
                                  "Tank_name_1508".toLowerCase() &&
                                  response[ky].data[s][key] != ""
                                ) {
                                  colsec1[key.toString().toLowerCase()] =
                                    response[ky].data[s][key];
                                }
                              }

                              if (p == 1) {
                                if (
                                  (key.toString().toLowerCase() ==
                                    "time_1512".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "lat_1514".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "lat_degree_1515".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "degree_1516".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "lat_minutes_1517".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "minutes_1518".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "lat_direction_1519".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "long_1520".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "long_degree_1521".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "degree_1522".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "long_minutes_1523".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "minutes_1524".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "long_direction_1525".toLowerCase() &&
                                    response[ky].data[s][key] != "")
                                ) {
                                  colsec2[key.toString().toLowerCase()] =
                                    response[ky].data[s][key];
                                }
                              }

                              if (p == 2) {
                                if (
                                  (key.toString().toLowerCase() ==
                                    "time_1526".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "lat_1527".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "lat_degree_1528".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "degree_1529".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "lat_minutes_1530".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "minutes_1531".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "lat_direction_1532".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Long_1533".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "long_degree_1534".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "degree_1535".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "long_minutes_1536".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "minutes_1537".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "long_direction_1538".toLowerCase() &&
                                    response[ky].data[s][key] != "")
                                ) {
                                  colsec3[key.toString().toLowerCase()] =
                                    response[ky].data[s][key];
                                }
                              }

                              if (p == 3) {
                                if (
                                  (key.toString().toLowerCase() ==
                                    "into_sea_1539".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "textbox_1540".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "m3_or_1541".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "reception_facility_1542".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Reception_facilities_name_1543".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "port_1544".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Quantity_1545".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "m3_1546".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  key.toString().toLowerCase() ==
                                  "yes_1548".toLowerCase() ||
                                  key.toString().toLowerCase() ==
                                  "no_1549".toLowerCase() ||
                                  (key.toString().toLowerCase() ==
                                    "time_1550".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "date_1551".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Quantity_1552".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "m3_1553".toLowerCase() &&
                                    response[ky].data[s][key] != "")
                                ) {
                                  colsec4[key.toString().toLowerCase()] =
                                    response[ky].data[s][key];
                                }
                              }

                              if (p == 4) {
                                if (
                                  key.toString().toLowerCase() ==
                                  "yes_1554".toLowerCase() ||
                                  key.toString().toLowerCase() ==
                                  "no_1555".toLowerCase()
                                ) {
                                  colsec5[key.toString().toLowerCase()] =
                                    response[ky].data[s][key];
                                }
                              }

                              if (p == 5) {
                                if (
                                  key.toString().toLowerCase() ==
                                  "yes_1556".toLowerCase() ||
                                  key.toString().toLowerCase() ==
                                  "no_1557".toLowerCase()
                                ) {
                                  colsec6[key.toString().toLowerCase()] =
                                    response[ky].data[s][key];
                                }
                              }

                              if (p == 6) {
                                if (
                                  (key.toString().toLowerCase() ==
                                    "time_1558".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "lat_1559".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "lat_degree_1560".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "degree_1561".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "lat_minutes_1562".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "minutes_1563".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "lat_direction_1564".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "long_1565".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "long_degree_1566".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "degree_1567".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "long_minutes_1568".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "minutes_1569".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "long_direction_1570".toLowerCase() &&
                                    response[ky].data[s][key] != "")
                                ) {
                                  colsec7[key.toString().toLowerCase()] =
                                    response[ky].data[s][key];
                                }
                              }
                            }

                            if (formId == 61) {
                              this.orbpart2 = 1;
                              if (p == 0) {
                                if (
                                  key.toString().toLowerCase() ==
                                  "time_1509".toLowerCase() &&
                                  response[ky].data[s][key] != ""
                                ) {
                                  colsec1[key.toString().toLowerCase()] =
                                    response[ky].data[s][key];
                                }
                              }
                              if (p == 1) {
                                if (
                                  key.toString().toLowerCase() ==
                                  "time_1510".toLowerCase() &&
                                  response[ky].data[s][key] != ""
                                ) {
                                  colsec2[key.toString().toLowerCase()] =
                                    response[ky].data[s][key];
                                }
                              }
                              if (p == 2) {
                                if (
                                  key.toString().toLowerCase() ==
                                  "Reason_1511".toLowerCase() &&
                                  response[ky].data[s][key] != ""
                                ) {
                                  colsec3[key.toString().toLowerCase()] =
                                    response[ky].data[s][key];
                                }
                              }
                            }

                            if (formId == 62) {
                              this.orbpart2 = 1;
                              if (p == 0) {
                                if (
                                  key.toString().toLowerCase() ==
                                  "time_1513".toLowerCase() &&
                                  response[ky].data[s][key] != ""
                                ) {
                                  colsec1[key.toString().toLowerCase()] =
                                    response[ky].data[s][key];
                                }
                              }

                              if (p == 2) {
                                if (
                                  (key.toString().toLowerCase() ==
                                    "Quantity_1586".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "m3_1587".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "type_of_oil_1588".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "reason_1589".toLowerCase() &&
                                    response[ky].data[s][key] != "")
                                ) {
                                  colsec2[key.toString().toLowerCase()] =
                                    response[ky].data[s][key];
                                }
                              }
                            }

                            if (formId == 63) {
                              this.orbpart2 = 1;
                              if (p == 0) {
                                if (
                                  (key.toString().toLowerCase() ==
                                    "Procedures_1590".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "General_remarks_1591".toLowerCase() &&
                                    response[ky].data[s][key] != "")
                                ) {
                                  colsec1[key.toString().toLowerCase()] =
                                    response[ky].data[s][key];
                                }
                              }
                            }

                            if (formId == 64) {
                              this.orbpart2 = 1;
                              if (p == 0) {
                                if (
                                  key.toString().toLowerCase() ==
                                  "Tank_name_1592".toLowerCase() &&
                                  response[ky].data[s][key] != ""
                                ) {
                                  colsec1[key.toString().toLowerCase()] =
                                    response[ky].data[s][key];
                                }
                              }

                              if (p == 2) {
                                if (
                                  (key.toString().toLowerCase() ==
                                    "Quantity_1605".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "m3_1606".toLowerCase() &&
                                    response[ky].data[s][key] != "")
                                ) {
                                  colsec2[key.toString().toLowerCase()] =
                                    response[ky].data[s][key];
                                }
                              }

                              if (p == 3) {
                                if (
                                  key.toString().toLowerCase() ==
                                  "Remarks_1607".toLowerCase() &&
                                  response[ky].data[s][key] != ""
                                ) {
                                  colsec3[key.toString().toLowerCase()] =
                                    response[ky].data[s][key];
                                }
                              }
                            }

                            if (formId == 65) {
                              this.orbpart2 = 1;
                              if (p == 0) {
                                if (
                                  key.toString().toLowerCase() ==
                                  "Reason_1608".toLowerCase() &&
                                  response[ky].data[s][key] != ""
                                ) {
                                  colsec1[key.toString().toLowerCase()] =
                                    response[ky].data[s][key];
                                }
                              }
                            }

                            if (formId == 66) {
                              this.orbpart2 = 1;
                              if (p == 0) {
                                if (
                                  key.toString().toLowerCase() ==
                                  "Port_1609".toLowerCase() &&
                                  response[ky].data[s][key] != ""
                                ) {
                                  colsec1[key.toString().toLowerCase()] =
                                    response[ky].data[s][key];
                                }
                              }

                              if (p == 1) {
                                if (
                                  key.toString().toLowerCase() ==
                                  "Name_of_reception_facility_1610".toLowerCase() &&
                                  response[ky].data[s][key] != ""
                                ) {
                                  colsec2[key.toString().toLowerCase()] =
                                    response[ky].data[s][key];
                                }
                              }

                              if (p == 2) {
                                if (
                                  (key.toString().toLowerCase() ==
                                    "Quantity_1611".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "m3_1612".toLowerCase() &&
                                    response[ky].data[s][key] != "")
                                ) {
                                  colsec3[key.toString().toLowerCase()] =
                                    response[ky].data[s][key];
                                }
                              }
                            }

                            if (formId == 57) {
                              this.orbpart2 = 1;
                              if (p == 0) {
                                if (
                                  key.toString().toLowerCase() ==
                                  "Tank_name_1394".toLowerCase() &&
                                  response[ky].data[s][key] != ""
                                ) {
                                  colsec1[key.toString().toLowerCase()] =
                                    response[ky].data[s][key];
                                }
                              }

                              if (p == 1) {
                                if (
                                  key.toString().toLowerCase() ==
                                  "time_1395".toLowerCase() &&
                                  response[ky].data[s][key] != ""
                                ) {
                                  colsec2[key.toString().toLowerCase()] =
                                    response[ky].data[s][key];
                                }
                              }

                              if (p == 2) {
                                if (
                                  key.toString().toLowerCase() ==
                                  "time_1396".toLowerCase() &&
                                  response[ky].data[s][key] != ""
                                ) {
                                  colsec3[key.toString().toLowerCase()] =
                                    response[ky].data[s][key];
                                }
                              }

                              if (p == 4) {
                                if (
                                  key.toString().toLowerCase() ==
                                  "Ullage_of_contents_1401".toLowerCase() &&
                                  response[ky].data[s][key] != ""
                                ) {
                                  colsec4[key.toString().toLowerCase()] =
                                    response[ky].data[s][key];
                                }
                              }

                              if (p == 5) {
                                if (
                                  (key.toString().toLowerCase() ==
                                    "Ullage_of_oil_1402".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Ullage_of_water_1404".toLowerCase() &&
                                    response[ky].data[s][key] != "")
                                ) {
                                  colsec5[key.toString().toLowerCase()] =
                                    response[ky].data[s][key];
                                }
                              }

                              if (p == 6) {
                                if (
                                  (key.toString().toLowerCase() ==
                                    "Bulk_quantity_discharge_1407".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "m3_1411".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Rate_of_discharge_1415".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "m3_hour_1416".toLowerCase() &&
                                    response[ky].data[s][key] != "")
                                ) {
                                  colsec6[key.toString().toLowerCase()] =
                                    response[ky].data[s][key];
                                }
                              }

                              if (p == 10) {
                                if (
                                  (key.toString().toLowerCase() ==
                                    "Ullage_of_oil_1226".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "metres_1429".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Ullage_of_water_1431".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "metres_1433".toLowerCase() &&
                                    response[ky].data[s][key] != "")
                                ) {
                                  colsec7[key.toString().toLowerCase()] =
                                    response[ky].data[s][key];
                                }
                              }

                              if (p == 11) {
                                if (
                                  key.toString().toLowerCase() ==
                                  "Speed_1436".toLowerCase() &&
                                  response[ky].data[s][key] != ""
                                ) {
                                  colsec8[key.toString().toLowerCase()] =
                                    response[ky].data[s][key];
                                }
                              }
                            }

                            if (formId == 54) {
                              this.orbpart2 = 1;
                              if (p == 0) {
                                if (
                                  key.toString().toLowerCase() ==
                                  "Tank_name_1256".toLowerCase() &&
                                  response[ky].data[s][key] != ""
                                ) {
                                  colsec1[key.toString().toLowerCase()] =
                                    response[ky].data[s][key];
                                }
                              }

                              if (p == 1) {
                                if (
                                  (key.toString().toLowerCase() ==
                                    "Port_1257".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Port_name_1258".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "LAT_1265".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "lat_degree_1266".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "degree_1268".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "lat_minutes_1269".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "minutes_1270".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "lat_direction_1271".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Long_1284".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "long_degree_1286".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "degree_1287".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "lat_minutes_1289".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "minutes_1290".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "long_direction_1291".toLowerCase() &&
                                    response[ky].data[s][key] != "")
                                ) {
                                  colsec2[key.toString().toLowerCase()] =
                                    response[ky].data[s][key];
                                }
                              }

                              if (p == 2) {
                                if (
                                  (key.toString().toLowerCase() ==
                                    "Lat_1293".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "lat_degree_1294".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "degree_1297".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "lat_minutes_1299".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "minutes_1300".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "lat_direction_1301".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Long_1303".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "long_degree_1305".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "degree_1307".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "long_minutes_1309".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "minutes_1310".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "long_direction_1311".toLowerCase() &&
                                    response[ky].data[s][key] != "")
                                ) {
                                  colsec3[key.toString().toLowerCase()] =
                                    response[ky].data[s][key];
                                }
                              }

                              if (p == 3) {
                                if (
                                  (key.toString().toLowerCase() ==
                                    "Quantity_of_oily_water_1312".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "state_total_quantity_1314".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "m3_1316".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Tank_name_1318".toLowerCase() &&
                                    response[ky].data[s][key] != "")
                                ) {
                                  colsec4[key.toString().toLowerCase()] =
                                    response[ky].data[s][key];
                                }
                              }

                              if (p == 4) {
                                if (
                                  (key.toString().toLowerCase() ==
                                    "Lat_1323".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "lat_degree_1326".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "degree_1327".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "lat_minutes_1328".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "minutes_1329".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "lat_direction_1330".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Long_1331".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "long_degree_1332".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "degree_1333".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "long_minutes_1334".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "minutes_1335".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "long_direction_1336".toLowerCase() &&
                                    response[ky].data[s][key] != "")
                                ) {
                                  colsec5[key.toString().toLowerCase()] =
                                    response[ky].data[s][key];
                                }
                              }

                              if (p == 5) {
                                if (
                                  (key.toString().toLowerCase() ==
                                    "time_1337".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Lat_1338".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "lat_degree_1339".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "degree_1340".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "lat_minutes_1341".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "minutes_1342".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "lat_direction_1343".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Long_1344".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "long_degree_1345".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "degree_1346".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "long_minutes_1347".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "minutes_1348".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "long_direction_1349".toLowerCase() &&
                                    response[ky].data[s][key] != "")
                                ) {
                                  colsec6[key.toString().toLowerCase()] =
                                    response[ky].data[s][key];
                                }
                              }

                              if (p == 6) {
                                if (
                                  (key.toString().toLowerCase() ==
                                    "Quantuty_of_clean_ballast_1350".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "m3_1351".toLowerCase() &&
                                    response[ky].data[s][key] != "")
                                ) {
                                  colsec7[key.toString().toLowerCase()] =
                                    response[ky].data[s][key];
                                }
                              }
                            }

                            if (formId == 55) {
                              this.orbpart2 = 1;
                              if (p == 0) {
                                if (
                                  key.toString().toLowerCase() ==
                                  "Tank_name_1259".toLowerCase() &&
                                  response[ky].data[s][key] != ""
                                ) {
                                  colsec1[key.toString().toLowerCase()] =
                                    response[ky].data[s][key];
                                }
                              }

                              if (p == 1) {
                                if (
                                  (key.toString().toLowerCase() ==
                                    "Port_1261".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Port_1262".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "LAT_1264".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "LAT_Degree_1267".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "degree_1272".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "LAT_minutes_1273".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "minutes_1274".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "lat_direction_1275".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "LONG_1276".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "long_degree_1277".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "degree_1278".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "long_minutes_1279".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "minutes_1280".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "long_direction_1281".toLowerCase() &&
                                    response[ky].data[s][key] != "")
                                ) {
                                  colsec2[key.toString().toLowerCase()] =
                                    response[ky].data[s][key];
                                }
                              }

                              if (p == 2) {
                                if (
                                  key.toString().toLowerCase() ==
                                  "time_1282".toLowerCase() &&
                                  response[ky].data[s][key] != ""
                                ) {
                                  colsec3[key.toString().toLowerCase()] =
                                    response[ky].data[s][key];
                                }
                              }

                              if (p == 3) {
                                if (
                                  (key.toString().toLowerCase() ==
                                    "Chemical_cleaning_1283".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Chemical_concerned_1285".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Quantity_1288".toLowerCase() &&
                                    response[ky].data[s][key] != "")
                                ) {
                                  colsec4[key.toString().toLowerCase()] =
                                    response[ky].data[s][key];
                                }
                              }

                              if (p == 4) {
                                if (
                                  (key.toString().toLowerCase() ==
                                    "reception_facilities_1292".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "reception_facilities_name_1295".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Port_1296".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Quantity_1298".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "receipts_and_certificates_obtained_1302".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  key.toString().toLowerCase() ==
                                  "Yes_1304".toLowerCase() ||
                                  key.toString().toLowerCase() ==
                                  "No_1306".toLowerCase() ||
                                  (key.toString().toLowerCase() ==
                                    "date_1313".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Quantity_1315".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "m3_1317".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "slop_and_cargo_tank_designated_1319".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "State_quantity_transferred_1321".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "m3_1322".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Total_quantity_1324".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "m3_1325".toLowerCase() &&
                                    response[ky].data[s][key] != "")
                                ) {
                                  colsec5[key.toString().toLowerCase()] =
                                    response[ky].data[s][key];
                                }
                              }
                            }
                          }
                        }
                      }
                    }

                    // end getting response data into array
                    if (formId == 55) {
                      if (
                        coldate["date_created"] != null &&
                        coldate["date_created"] != ""
                      ) {
                        var date = new Date(coldate["date_created"]);
                        var day = date.getDate();
                        var month = date.getMonth() + 1;
                        var year = date.getFullYear();
                        var sectionLenght = coldate["section_length"];
                        this.createdAt.push([
                          year + "-" + month + "-" + day,
                          sectionLenght,
                          sectionName,
                          cnt1++,
                        ]);
                      }

                      if (colsec1["Tank_name_1259".toLowerCase()] != null) {
                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "27",
                          colsec1["Tank_name_1259".toLowerCase()],
                        ]);
                        colsec1 = [];
                      } else {
                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "27",
                          "",
                        ]);
                        colsec1 = [];
                      }
                      this.userSign.push(usersign);

                      if (colsec2["degree_1272".toLowerCase()] != null) {
                        if (colsec2["Port_1261".toLowerCase()] == null)
                          colsec2["Port_1261".toLowerCase()] = "";
                        if (colsec2["Port_1262".toLowerCase()] == null)
                          colsec2["Port_1262".toLowerCase()] = "";
                        if (colsec2["LAT_Degree_1267".toLowerCase()] == null)
                          colsec2["LAT_Degree_1267".toLowerCase()] = "";
                        if (colsec2["LAT_1264".toLowerCase()] == null)
                          colsec2["LAT_1264".toLowerCase()] = "";
                        if (colsec2["LAT_minutes_1273".toLowerCase()] == null)
                          colsec2["LAT_minutes_1273".toLowerCase()] = "";
                        if (colsec2["minutes_1274".toLowerCase()] == null)
                          colsec2["minutes_1274".toLowerCase()] = "";
                        if (colsec2["lat_direction_1275".toLowerCase()] == null)
                          colsec2["lat_direction_1275".toLowerCase()] = "";
                        if (colsec2["LONG_1276".toLowerCase()] == null)
                          colsec2["LONG_1276".toLowerCase()] = "";
                        if (colsec2["long_degree_1277".toLowerCase()] == null)
                          colsec2["long_degree_1277".toLowerCase()] = "";
                        if (colsec2["degree_1278".toLowerCase()] == null)
                          colsec2["degree_1278".toLowerCase()] = "";
                        if (colsec2["long_minutes_1279".toLowerCase()] == null)
                          colsec2["long_minutes_1279".toLowerCase()] = "";
                        if (colsec2["minutes_1280".toLowerCase()] == null)
                          colsec2["minutes_1280".toLowerCase()] = "";
                        if (
                          colsec2["long_direction_1281".toLowerCase()] == null
                        )
                          colsec2["long_direction_1281".toLowerCase()] = "";

                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "28",
                          colsec2["Port_1261".toLowerCase()] +
                          " " +
                          colsec2["Port_1262".toLowerCase()] +
                          " " +
                          colsec2["LAT_1264".toLowerCase()] +
                          " " +
                          colsec2["LAT_Degree_1267".toLowerCase()] +
                          " " +
                          colsec2["degree_1272".toLowerCase()] +
                          " " +
                          colsec2["LAT_minutes_1273".toLowerCase()] +
                          " " +
                          colsec2["minutes_1274".toLowerCase()] +
                          " " +
                          colsec2["lat_direction_1275".toLowerCase()] +
                          "/" +
                          colsec2["LONG_1276".toLowerCase()] +
                          " " +
                          colsec2["long_degree_1277".toLowerCase()] +
                          " " +
                          colsec2["degree_1278".toLowerCase()] +
                          " " +
                          colsec2["long_minutes_1279".toLowerCase()] +
                          " " +
                          colsec2["minutes_1280".toLowerCase()] +
                          " " +
                          colsec2["long_direction_1281".toLowerCase()],
                        ]);
                        colsec2 = [];
                      } else {
                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "28",
                          "",
                        ]);
                        colsec2 = [];
                      }
                      this.userSign.push(usersign);

                      if (colsec3["time_1282".toLowerCase()] != null) {
                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "29",
                          colsec3["time_1282".toLowerCase()],
                        ]);
                        colsec3 = [];
                      } else {
                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "29",
                          "",
                        ]);
                        colsec3 = [];
                      }
                      this.userSign.push(usersign);

                      if (
                        colsec4["Chemical_cleaning_1283".toLowerCase()] != null
                      ) {
                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "30",
                          colsec4["Chemical_cleaning_1283".toLowerCase()] +
                          " " +
                          colsec4["Chemical_concerned_1285".toLowerCase()] +
                          " " +
                          colsec4["Quantity_1288".toLowerCase()],
                        ]);
                        colsec4 = [];
                      } else {
                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "30",
                          "",
                        ]);
                        colsec4 = [];
                      }
                      this.userSign.push(usersign);
                      if (colsec5["m3_1325".toLowerCase()] != null) {
                        if (
                          colsec5["reception_facilities_1292".toLowerCase()] ==
                          null
                        )
                          colsec5["reception_facilities_1292".toLowerCase()] =
                            "";
                        if (
                          colsec5[
                          "reception_facilities_name_1295".toLowerCase()
                          ] == null
                        )
                          colsec5[
                            "reception_facilities_name_1295".toLowerCase()
                          ] = "";
                        if (colsec5["Port_1296".toLowerCase()] == null)
                          colsec5["Port_1296".toLowerCase()] = "";
                        if (colsec5["Quantity_1298".toLowerCase()] == null)
                          colsec5["Quantity_1298".toLowerCase()] = "";
                        if (
                          colsec5[
                          "receipts_and_certificates_obtained_1302".toLowerCase()
                          ] == null
                        )
                          colsec5[
                            "receipts_and_certificates_obtained_1302".toLowerCase()
                          ] = "";
                        if (colsec5["Yes_1304".toLowerCase()] == null)
                          colsec5["Yes_1304".toLowerCase()] = "";
                        if (colsec5["No_1306".toLowerCase()] == null)
                          colsec5["No_1306".toLowerCase()] = "";
                        if (colsec5["date_1313".toLowerCase()] == null)
                          colsec5["date_1313".toLowerCase()] = "";
                        if (colsec5["Quantity_1315".toLowerCase()] == null)
                          colsec5["Quantity_1315".toLowerCase()] = "";
                        if (
                          colsec5[
                          "slop_and_cargo_tank_designated_1319".toLowerCase()
                          ] == null
                        )
                          colsec5[
                            "slop_and_cargo_tank_designated_1319".toLowerCase()
                          ] = "";
                        if (
                          colsec5[
                          "State_quantity_transferred_1321".toLowerCase()
                          ] == null
                        )
                          colsec5[
                            "State_quantity_transferred_1321".toLowerCase()
                          ] = "";
                        if (colsec5["m3_1322".toLowerCase()] == null)
                          colsec5["m3_1322".toLowerCase()] = "";
                        if (
                          colsec5["Total_quantity_1324".toLowerCase()] == null
                        )
                          colsec5["Total_quantity_1324".toLowerCase()] = "";
                        if (colsec5["m3_1325".toLowerCase()] == null)
                          colsec5["m3_1325".toLowerCase()] = "";
                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "31",
                          colsec5["reception_facilities_1292".toLowerCase()] +
                          " " +
                          colsec5[
                          "reception_facilities_name_1295".toLowerCase()
                          ] +
                          " " +
                          colsec5["Port_1296".toLowerCase()] +
                          " " +
                          colsec5["Quantity_1298".toLowerCase()] +
                          " " +
                          colsec5[
                          "receipts_and_certificates_obtained_1302".toLowerCase()
                          ] +
                          " " +
                          colsec5["Yes_1304".toLowerCase()] +
                          " " +
                          colsec5["No_1306".toLowerCase()] +
                          " " +
                          colsec5["date_1313".toLowerCase()] +
                          " " +
                          colsec5["Quantity_1315".toLowerCase()] +
                          " " +
                          colsec5["m3_1317".toLowerCase()] +
                          " " +
                          colsec5[
                          "slop_and_cargo_tank_designated_1319".toLowerCase()
                          ] +
                          " " +
                          colsec5[
                          "State_quantity_transferred_1321".toLowerCase()
                          ] +
                          " " +
                          colsec5["m3_1322".toLowerCase()] +
                          " " +
                          colsec5["Total_quantity_1324".toLowerCase()] +
                          " " +
                          colsec5["m3_1325".toLowerCase()],
                        ]);
                        colsec5 = [];
                      } else {
                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "31",
                          "",
                        ]);
                        colsec5 = [];
                      }
                      this.userSign.push(usersign);
                    }

                    // end getting response data into array
                    if (formId == 54) {
                      if (
                        coldate["date_created"] != null &&
                        coldate["date_created"] != ""
                      ) {
                        var date = new Date(coldate["date_created"]);
                        var day = date.getDate();
                        var month = date.getMonth() + 1;
                        var year = date.getFullYear();
                        var sectionLenght = coldate["section_length"];
                        this.createdAt.push([
                          year + "-" + month + "-" + day,
                          sectionLenght,
                          sectionName,
                          cnt1++,
                        ]);
                      }

                      if (colsec1["Tank_name_1256".toLowerCase()] != null) {
                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "20",
                          colsec1["Tank_name_1256".toLowerCase()],
                        ]);
                        colsec1 = [];
                      } else {
                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "20",
                          "",
                        ]);
                        colsec1 = [];
                      }
                      this.userSign.push(usersign);

                      if (colsec2["degree_1268".toLowerCase()] != null) {
                        if (colsec2["Port_1257".toLowerCase()] == null) {
                          colsec2["Port_1257".toLowerCase()] = "";
                        }
                        if (colsec2["Port_name_1258".toLowerCase()] == null) {
                          colsec2["Port_name_1258".toLowerCase()] = "";
                        }
                        if (colsec2["LAT_1265".toLowerCase()] == null) {
                          colsec2["LAT_1265".toLowerCase()] = "";
                        }
                        if (colsec2["lat_degree_1266".toLowerCase()] == null) {
                          colsec2["lat_degree_1266".toLowerCase()] = "";
                        }
                        if (colsec2["minutes_1270".toLowerCase()] == null) {
                          colsec2["minutes_1270".toLowerCase()] = "";
                        }
                        if (
                          colsec2["lat_direction_1271".toLowerCase()] == null
                        ) {
                          colsec2["lat_direction_1271".toLowerCase()] = "";
                        }
                        if (colsec2["lat_minutes_1269".toLowerCase()] == null) {
                          colsec2["lat_minutes_1269".toLowerCase()] = "";
                        }
                        if (colsec2["Long_1284".toLowerCase()] == null) {
                          colsec2["Long_1284".toLowerCase()] = "";
                        }
                        if (colsec2["lat_minutes_1289".toLowerCase()] == null) {
                          colsec2["lat_minutes_1289".toLowerCase()] = "";
                        }
                        if (colsec2["minutes_1290".toLowerCase()] == null) {
                          colsec2["minutes_1290".toLowerCase()] = "";
                        }
                        if (
                          colsec2["long_direction_1291".toLowerCase()] == null
                        ) {
                          colsec2["long_direction_1291".toLowerCase()] = "";
                        }
                        if (colsec2["degree_1287".toLowerCase()] == null) {
                          colsec2["degree_1287".toLowerCase()] = "";
                        }
                        if (colsec2["long_degree_1286".toLowerCase()] == null) {
                          colsec2["long_degree_1286".toLowerCase()] = "";
                        }

                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "21",
                          colsec2["Port_1257".toLowerCase()] +
                          " " +
                          colsec2["Port_name_1258".toLowerCase()] +
                          " " +
                          colsec2["LAT_1265".toLowerCase()] +
                          " " +
                          colsec2["lat_degree_1266".toLowerCase()] +
                          " " +
                          colsec2["degree_1268".toLowerCase()] +
                          " " +
                          colsec2["lat_minutes_1269".toLowerCase()] +
                          " " +
                          colsec2["minutes_1270".toLowerCase()] +
                          " " +
                          colsec2["lat_direction_1271".toLowerCase()] +
                          "/" +
                          colsec2["Long_1284".toLowerCase()] +
                          " " +
                          colsec2["long_degree_1286".toLowerCase()] +
                          " " +
                          colsec2["degree_1287".toLowerCase()] +
                          " " +
                          colsec2["lat_minutes_1289".toLowerCase()] +
                          " " +
                          colsec2["minutes_1290".toLowerCase()] +
                          " " +
                          colsec2["long_direction_1291".toLowerCase()],
                        ]);
                        colsec2 = [];
                      } else {
                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "21",
                          "",
                        ]);
                        colsec2 = [];
                      }

                      this.userSign.push(usersign);

                      if (colsec3["degree_1297".toLowerCase()] != null) {
                        if (colsec2["Lat_1293".toLowerCase()] == null) {
                          colsec2["Lat_1293".toLowerCase()] = "";
                        }
                        if (colsec2["lat_degree_1294".toLowerCase()] == null) {
                          colsec2["lat_degree_1294".toLowerCase()] = "";
                        }
                        if (colsec2["degree_1297".toLowerCase()] == null) {
                          colsec2["degree_1297".toLowerCase()] = "";
                        }
                        if (colsec2["lat_minutes_1299".toLowerCase()] == null) {
                          colsec2["lat_minutes_1299".toLowerCase()] = "";
                        }
                        if (colsec2["Long_1303".toLowerCase()] == null) {
                          colsec2["Long_1303".toLowerCase()] = "";
                        }
                        if (colsec2["long_degree_1305".toLowerCase()] == null) {
                          colsec2["long_degree_1305".toLowerCase()] = "";
                        }
                        if (colsec2["minutes_1290".toLowerCase()] == null) {
                          colsec2["minutes_1290".toLowerCase()] = "";
                        }
                        if (colsec2["degree_1307".toLowerCase()] == null) {
                          colsec2["degree_1307".toLowerCase()] = "";
                        }
                        if (
                          colsec2["long_minutes_1309".toLowerCase()] == null
                        ) {
                          colsec2["long_minutes_1309".toLowerCase()] = "";
                        }
                        if (
                          colsec2["long_direction_1311".toLowerCase()] == null
                        ) {
                          colsec2["long_direction_1311".toLowerCase()] = "";
                        }
                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "22",
                          colsec3["Lat_1293".toLowerCase()] +
                          " " +
                          colsec3["lat_degree_1294".toLowerCase()] +
                          " " +
                          colsec3["degree_1297".toLowerCase()] +
                          " " +
                          colsec3["lat_minutes_1299".toLowerCase()] +
                          " " +
                          colsec3["minutes_1300".toLowerCase()] +
                          " " +
                          colsec3["lat_direction_1301".toLowerCase()] +
                          "/" +
                          colsec3["Long_1303".toLowerCase()] +
                          " " +
                          colsec3["long_degree_1305".toLowerCase()] +
                          " " +
                          colsec3["degree_1307".toLowerCase()] +
                          " " +
                          colsec3["long_minutes_1309".toLowerCase()] +
                          " " +
                          colsec3["minutes_1310".toLowerCase()] +
                          " " +
                          colsec3["long_direction_1311".toLowerCase()],
                        ]);
                        colsec3 = [];
                      } else {
                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "22",
                          "",
                        ]);
                        colsec3 = [];
                      }
                      this.userSign.push(usersign);

                      if (colsec4["m3_1316".toLowerCase()] != null) {
                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "23",
                          colsec4["Quantity_of_oily_water_1312".toLowerCase()] +
                          " " +
                          colsec4["state_total_quantity_1314".toLowerCase()] +
                          " " +
                          colsec4["m3_1316".toLowerCase()] +
                          " " +
                          colsec4["Tank_name_1318".toLowerCase()],
                        ]);
                        colsec4 = [];
                      } else {
                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "23",
                          "",
                        ]);
                        colsec4 = [];
                      }
                      this.userSign.push(usersign);

                      if (colsec5["degree_1327".toLowerCase()] != null) {
                        if (colsec5["Lat_1323".toLowerCase()] == null) {
                          colsec5["Lat_1323".toLowerCase()] = "0.00";
                        }
                        if (colsec5["lat_degree_1326".toLowerCase()] == null) {
                          colsec5["lat_degree_1326".toLowerCase()] = "";
                        }
                        if (colsec5["degree_1327".toLowerCase()] == null) {
                          colsec5["degree_1327".toLowerCase()] = "";
                        }
                        if (colsec5["lat_minutes_1328".toLowerCase()] == null) {
                          colsec5["lat_minutes_1328".toLowerCase()] = "";
                        }
                        if (colsec5["minutes_1329".toLowerCase()] == null) {
                          colsec5["minutes_1329".toLowerCase()] = "";
                        }
                        if (
                          colsec5["lat_direction_1330".toLowerCase()] == null
                        ) {
                          colsec5["lat_direction_1330".toLowerCase()] = "";
                        }
                        if (colsec5["Long_1331".toLowerCase()] == null) {
                          colsec5["Long_1331".toLowerCase()] = "";
                        }
                        if (colsec5["long_degree_1332".toLowerCase()] == null) {
                          colsec5["long_degree_1332".toLowerCase()] = "";
                        }
                        if (colsec5["degree_1333".toLowerCase()] == null) {
                          colsec5["degree_1333".toLowerCase()] = "";
                        }
                        if (
                          colsec5["long_minutes_1334".toLowerCase()] == null
                        ) {
                          colsec5["long_minutes_1334".toLowerCase()] = "";
                        }
                        if (colsec5["minutes_1335".toLowerCase()] == null) {
                          colsec5["minutes_1335".toLowerCase()] = "";
                        }
                        if (
                          colsec5["long_direction_1336".toLowerCase()] == null
                        ) {
                          colsec5["long_direction_1336".toLowerCase()] = "";
                        }

                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "24",
                          colsec5["Lat_1323".toLowerCase()] +
                          " " +
                          colsec5["lat_degree_1326".toLowerCase()] +
                          " " +
                          colsec5["degree_1327".toLowerCase()] +
                          " " +
                          colsec5["lat_minutes_1328".toLowerCase()] +
                          " " +
                          colsec5["minutes_1329".toLowerCase()] +
                          " " +
                          colsec5["lat_direction_1330".toLowerCase()] +
                          "/" +
                          colsec5["Long_1331".toLowerCase()] +
                          " " +
                          colsec5["long_degree_1332".toLowerCase()] +
                          " " +
                          colsec5["degree_1333".toLowerCase()] +
                          " " +
                          colsec5["long_minutes_1334".toLowerCase()] +
                          " " +
                          colsec5["minutes_1335".toLowerCase()] +
                          " " +
                          colsec5["long_direction_1336".toLowerCase()],
                        ]);
                        colsec5 = [];
                      } else {
                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "24",
                          "",
                        ]);
                        colsec5 = [];
                      }
                      this.userSign.push(usersign);

                      if (colsec6["degree_1340".toLowerCase()] != null) {
                        if (colsec6["Lat_1338".toLowerCase()] == null) {
                          colsec6["Lat_1338".toLowerCase()] = "0.00";
                        }
                        if (colsec6["lat_degree_1339".toLowerCase()] == null) {
                          colsec6["lat_degree_1339".toLowerCase()] = "0.00";
                        }
                        if (colsec6["degree_1340".toLowerCase()] == null) {
                          colsec6["degree_1340".toLowerCase()] = "";
                        }
                        if (colsec6["lat_minutes_1341".toLowerCase()] == null) {
                          colsec6["lat_minutes_1341".toLowerCase()] = "";
                        }
                        if (colsec6["minutes_1342".toLowerCase()] == null) {
                          colsec6["minutes_1342".toLowerCase()] = "";
                        }
                        if (
                          colsec6["lat_direction_1343".toLowerCase()] == null
                        ) {
                          colsec6["lat_direction_1343".toLowerCase()] = "";
                        }
                        if (colsec6["Long_1344".toLowerCase()] == null) {
                          colsec6["Long_1344".toLowerCase()] = "";
                        }
                        if (colsec6["long_degree_1345".toLowerCase()] == null) {
                          colsec6["long_degree_1345".toLowerCase()] = "";
                        }
                        if (colsec6["degree_1346".toLowerCase()] == null) {
                          colsec6["degree_1346".toLowerCase()] = "";
                        }
                        if (
                          colsec6["long_minutes_1347".toLowerCase()] == null
                        ) {
                          colsec6["long_minutes_1347".toLowerCase()] = "";
                        }
                        if (colsec6["minutes_1348".toLowerCase()] == null) {
                          colsec6["minutes_1348".toLowerCase()] = "";
                        }
                        if (
                          colsec6["long_direction_1349".toLowerCase()] == null
                        ) {
                          colsec6["long_direction_1349".toLowerCase()] = "";
                        }

                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "25",
                          colsec6["time_1337".toLowerCase()] +
                          " " +
                          colsec6["Lat_1338".toLowerCase()] +
                          " " +
                          colsec6["lat_degree_1339".toLowerCase()] +
                          " " +
                          colsec6["degree_1340".toLowerCase()] +
                          " " +
                          colsec6["lat_minutes_1341".toLowerCase()] +
                          " " +
                          colsec6["minutes_1342".toLowerCase()] +
                          " " +
                          colsec6["lat_direction_1343".toLowerCase()] +
                          "/" +
                          colsec6["Long_1344".toLowerCase()] +
                          " " +
                          colsec6["long_degree_1345".toLowerCase()] +
                          " " +
                          colsec6["degree_1346".toLowerCase()] +
                          " " +
                          colsec6["long_minutes_1347".toLowerCase()] +
                          " " +
                          colsec6["minutes_1348".toLowerCase()] +
                          " " +
                          colsec6["long_direction_1349".toLowerCase()],
                        ]);
                        colsec6 = [];
                      } else {
                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "25",
                          "",
                        ]);
                        colsec6 = [];
                      }
                      this.userSign.push(usersign);

                      if (
                        colsec7[
                        "Quantuty_of_clean_ballast_1350".toLowerCase()
                        ] != null
                      ) {
                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "26",
                          colsec7[
                          "Quantuty_of_clean_ballast_1350".toLowerCase()
                          ] +
                          " " +
                          colsec7["m3_1351".toLowerCase()],
                        ]);
                        colsec7 = [];
                      } else {
                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "26",
                          "",
                        ]);
                        colsec7 = [];
                      }
                      this.userSign.push(usersign);
                    }

                    // end getting response data into array
                    if (formId == 57) {
                      if (
                        coldate["date_created"] != null &&
                        coldate["date_created"] != ""
                      ) {
                        var date = new Date(coldate["date_created"]);
                        var day = date.getDate();
                        var month = date.getMonth() + 1;
                        var year = date.getFullYear();
                        var sectionLenght = 8; //coldate['section_length'];
                        this.createdAt.push([
                          year + "-" + month + "-" + day,
                          sectionLenght,
                          sectionName,
                          cnt1++,
                        ]);
                      }

                      if (colsec1["Tank_name_1394".toLowerCase()] != null) {
                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "41",
                          colsec1["Tank_name_1394".toLowerCase()],
                        ]);
                        colsec1 = [];
                      } else {
                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "41",
                          "",
                        ]);
                        colsec1 = [];
                      }
                      this.userSign.push(usersign);

                      if (colsec2["time_1395".toLowerCase()] != null) {
                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "42",
                          colsec2["time_1395".toLowerCase()],
                        ]);
                        colsec2 = [];
                      } else {
                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "42",
                          "",
                        ]);
                        colsec2 = [];
                      }
                      this.userSign.push(usersign);

                      if (colsec3["time_1396".toLowerCase()] != null) {
                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "43",
                          colsec3["time_1396".toLowerCase()],
                        ]);
                        colsec3 = [];
                      } else {
                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "43",
                          "",
                        ]);
                        colsec3 = [];
                      }
                      this.userSign.push(usersign);

                      if (
                        colsec4["Ullage_of_contents_1401".toLowerCase()] != null
                      ) {
                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "45",
                          colsec4["Ullage_of_contents_1401".toLowerCase()],
                        ]);
                        colsec4 = [];
                      } else {
                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "45",
                          "",
                        ]);
                        colsec4 = [];
                      }
                      this.userSign.push(usersign);

                      if (colsec5["Ullage_of_oil_1402".toLowerCase()] != null) {
                        if (
                          colsec5["Ullage_of_water_1404".toLowerCase()] == null
                        ) {
                          colsec5["Ullage_of_water_1404".toLowerCase()] =
                            "0.00";
                        }
                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "46",
                          colsec5["Ullage_of_oil_1402".toLowerCase()] +
                          " " +
                          colsec5["Ullage_of_water_1404".toLowerCase()],
                        ]);
                        colsec5 = [];
                      } else {
                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "46",
                          "",
                        ]);
                        colsec5 = [];
                      }
                      this.userSign.push(usersign);

                      if (colsec6["m3_1411".toLowerCase()] != null) {
                        if (
                          colsec6[
                          "Bulk_quantity_discharge_1407".toLowerCase()
                          ] == null
                        ) {
                          colsec6[
                            "Bulk_quantity_discharge_1407".toLowerCase()
                          ] = "0.00";
                        }
                        if (
                          colsec6["Rate_of_discharge_1415".toLowerCase()] ==
                          null
                        ) {
                          colsec6["Rate_of_discharge_1415".toLowerCase()] = "";
                        }
                        if (colsec6["m3_hour_1416".toLowerCase()] == null) {
                          colsec6["m3_hour_1416".toLowerCase()] = "";
                        }

                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "47",
                          colsec6[
                          "Bulk_quantity_discharge_1407".toLowerCase()
                          ] +
                          " " +
                          colsec6["m3_1411".toLowerCase()] +
                          " " +
                          colsec6["Rate_of_discharge_1415".toLowerCase()] +
                          " " +
                          colsec6["m3_hour_1416".toLowerCase()],
                        ]);
                        colsec6 = [];
                      } else {
                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "47",
                          "",
                        ]);
                        colsec6 = [];
                      }

                      this.userSign.push(usersign);

                      if (colsec7["metres_1429".toLowerCase()] != null) {
                        if (
                          colsec7["Ullage_of_oil_1226".toLowerCase()] == null
                        ) {
                          colsec7["Ullage_of_oil_1226".toLowerCase()] = "0.00";
                        }
                        if (
                          colsec7["Ullage_of_water_1431".toLowerCase()] == null
                        ) {
                          colsec7["Ullage_of_water_1431".toLowerCase()] =
                            "0.00";
                        }
                        if (colsec7["metres_1433".toLowerCase()] == null) {
                          colsec7["metres_1433".toLowerCase()] = "";
                        }

                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "51",
                          colsec7["Ullage_of_oil_1226".toLowerCase()] +
                          " " +
                          colsec7["metres_1429".toLowerCase()] +
                          " " +
                          colsec7["Ullage_of_water_1431".toLowerCase()] +
                          " " +
                          colsec7["metres_1433".toLowerCase()],
                        ]);
                        colsec7 = [];
                      } else {
                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "51",
                          "",
                        ]);
                        colsec7 = [];
                      }
                      this.userSign.push(usersign);

                      if (colsec8["Speed_1436".toLowerCase()] != null) {
                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "52",
                          colsec8["Speed_1436".toLowerCase()],
                        ]);
                        colsec8 = [];
                      } else {
                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "52",
                          "",
                        ]);
                        colsec8 = [];
                      }
                      this.userSign.push(usersign);
                    }

                    // end getting response data into array
                    if (formId == 58) {
                      if (
                        coldate["date_created"] != null &&
                        coldate["date_created"] != ""
                      ) {
                        var date = new Date(coldate["date_created"]);
                        var day = date.getDate();
                        var month = date.getMonth() + 1;
                        var year = date.getFullYear();
                        var sectionLenght = coldate["section_length"];
                        this.createdAt.push([
                          year + "-" + month + "-" + day,
                          sectionLenght,
                          sectionName,
                          cnt1++,
                        ]);
                      }

                      if (colsec1["Tank_name_1446".toLowerCase()] != null) {
                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "55",
                          colsec1["Tank_name_1446".toLowerCase()],
                        ]);
                        colsec1 = [];
                      } else {
                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "55",
                          "",
                        ]);
                        colsec1 = [];
                      }
                      this.userSign.push(usersign);

                      if (colsec2["m3_1450".toLowerCase()] != null) {
                        if (
                          colsec2["Quantity_transferred_1447".toLowerCase()] ==
                          null
                        ) {
                          colsec2["Quantity_transferred_1447".toLowerCase()] =
                            "";
                        }
                        if (colsec2["m3_1448".toLowerCase()] == null) {
                          colsec2["m3_1448".toLowerCase()] = "";
                        }
                        if (
                          colsec2["Quantity_retained_1449".toLowerCase()] ==
                          null
                        ) {
                          colsec2["Quantity_retained_1449".toLowerCase()] = "";
                        }
                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "56",
                          colsec2["Quantity_transferred_1447".toLowerCase()] +
                          " " +
                          colsec2["m3_1448".toLowerCase()] +
                          " " +
                          colsec2["Quantity_retained_1449".toLowerCase()] +
                          " " +
                          colsec2["m3_1450".toLowerCase()],
                        ]);
                        colsec2 = [];
                      } else {
                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "56",
                          "",
                        ]);
                        colsec2 = [];
                      }
                      this.userSign.push(usersign);

                      if (colsec3["port_name_1452".toLowerCase()] != null) {
                        if (
                          colsec3["disposal_of_reception_1451".toLowerCase()] ==
                          null
                        ) {
                          colsec3["disposal_of_reception_1451".toLowerCase()] =
                            "";
                        }
                        if (colsec3["port_name_1452".toLowerCase()] == null) {
                          colsec3["port_name_1452".toLowerCase()] = "";
                        }
                        if (
                          colsec3[
                          "certificate_obtained_from_1453".toLowerCase()
                          ] == null
                        ) {
                          colsec3["Quantity_retained_1449".toLowerCase()] = "";
                        }
                        if (colsec3["yes_1454".toLowerCase()] == null) {
                          colsec3["yes_1454".toLowerCase()] = "";
                        }
                        if (colsec3["no_1455".toLowerCase()] == null) {
                          colsec3["no_1455".toLowerCase()] = "";
                        }
                        if (colsec3["time_1457".toLowerCase()] == null) {
                          colsec3["time_1457".toLowerCase()] = "";
                        }
                        if (colsec3["Date_1459".toLowerCase()] == null) {
                          colsec3["Date_1459".toLowerCase()] = "";
                        }
                        if (colsec3["Quantity_1461".toLowerCase()] == null) {
                          colsec3["Quantity_1461".toLowerCase()] = "";
                        }
                        if (colsec3["m3_1463".toLowerCase()] == null) {
                          colsec3["m3_1463".toLowerCase()] = "";
                        }
                        if (
                          colsec3["cargo_quantity_1467".toLowerCase()] == null
                        ) {
                          colsec3["cargo_quantity_1467".toLowerCase()] = "";
                        }
                        if (
                          colsec3["state_quantity_1470".toLowerCase()] == null
                        ) {
                          colsec3["state_quantity_1470".toLowerCase()] = "";
                        }
                        if (colsec3["from_tank_1480".toLowerCase()] == null) {
                          colsec3["from_tank_1480".toLowerCase()] = "";
                        }
                        if (colsec3["tanks_1482".toLowerCase()] == null) {
                          colsec3["tanks_1482".toLowerCase()] = "";
                        }
                        if (
                          colsec3["Quantity_tank_1486".toLowerCase()] == null
                        ) {
                          colsec3["Quantity_tank_1486".toLowerCase()] = "";
                        }
                        if (colsec3["quantity_1487".toLowerCase()] == null) {
                          colsec3["quantity_1487".toLowerCase()] = "";
                        }
                        if (colsec3["to_tank_1489".toLowerCase()] == null) {
                          colsec3["to_tank_1489".toLowerCase()] = "";
                        }
                        if (colsec3["Tanks_1491".toLowerCase()] == null) {
                          colsec3["Tanks_1491".toLowerCase()] = "";
                        }
                        if (
                          colsec3["Quantity_tank_1493".toLowerCase()] == null
                        ) {
                          colsec3["Quantity_tank_1493".toLowerCase()] = "";
                        }
                        if (colsec3["quantity_1495".toLowerCase()] == null) {
                          colsec3["quantity_1495".toLowerCase()] = "";
                        }
                        if (
                          colsec3["Quantity_transferred_1497".toLowerCase()] ==
                          null
                        ) {
                          colsec3["Quantity_transferred_1497".toLowerCase()] =
                            "";
                        }
                        if (
                          colsec3["total_quantity_1499".toLowerCase()] == null
                        ) {
                          colsec3["total_quantity_1499".toLowerCase()] = "";
                        }
                        if (colsec3["m3_1501".toLowerCase()] == null) {
                          colsec3["m3_1501".toLowerCase()] = "";
                        }
                        if (
                          colsec3["other_method_1504".toLowerCase()] == null
                        ) {
                          colsec3["other_method_1504".toLowerCase()] = "";
                        }
                        if (
                          colsec3[
                          "state_quantity_disposal_1505".toLowerCase()
                          ] == null
                        ) {
                          colsec3[
                            "state_quantity_disposal_1505".toLowerCase()
                          ] = "";
                        }
                        if (
                          colsec3["state_quantity_1506".toLowerCase()] == null
                        ) {
                          colsec3["state_quantity_1506".toLowerCase()] = "";
                        }

                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "57",
                          colsec3["port_name_1452".toLowerCase()] +
                          " " +
                          colsec3[
                          "certificate_obtained_from_1453".toLowerCase()
                          ] +
                          " " +
                          colsec3["yes_1454".toLowerCase()] +
                          " " +
                          colsec3["no_1455".toLowerCase()] +
                          " " +
                          colsec3["time_1457".toLowerCase()] +
                          " " +
                          colsec3["Date_1459".toLowerCase()] +
                          " " +
                          colsec3["Quantity_1461".toLowerCase()] +
                          " " +
                          colsec3["m3_1463".toLowerCase()] +
                          " " +
                          colsec3["cargo_quantity_1467".toLowerCase()] +
                          " " +
                          colsec3["state_quantity_1470".toLowerCase()] +
                          "/" +
                          colsec3["from_tank_1480".toLowerCase()] +
                          " " +
                          colsec3["tanks_1482".toLowerCase()] +
                          " " +
                          colsec3["Quantity_tank_1486".toLowerCase()] +
                          " " +
                          colsec3["quantity_1487".toLowerCase()] +
                          " " +
                          colsec3["to_tank_1489".toLowerCase()] +
                          "/" +
                          colsec3["Tanks_1491".toLowerCase()] +
                          " " +
                          colsec3["Quantity_tank_1493".toLowerCase()] +
                          " " +
                          colsec3["quantity_1495".toLowerCase()] +
                          " " +
                          colsec3["Quantity_transferred_1497".toLowerCase()] +
                          " " +
                          colsec3["total_quantity_1499".toLowerCase()] +
                          " " +
                          colsec3["m3_1501".toLowerCase()] +
                          " " +
                          colsec3["other_method_1504".toLowerCase()] +
                          " " +
                          colsec3[
                          "state_quantity_disposal_1505".toLowerCase()
                          ] +
                          " " +
                          colsec3["state_quantity_1506".toLowerCase()] +
                          " " +
                          colsec3["m3_1507".toLowerCase()],
                        ]);
                        colsec3 = [];
                      } else {
                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "57",
                          "",
                        ]);
                        colsec3 = [];
                      }
                      this.userSign.push(usersign);
                    }

                    // end getting response data into array
                    if (formId == 66) {
                      if (
                        coldate["date_created"] != null &&
                        coldate["date_created"] != ""
                      ) {
                        var date = new Date(coldate["date_created"]);
                        var day = date.getDate();
                        var month = date.getMonth() + 1;
                        var year = date.getFullYear();
                        var sectionLenght = coldate["section_length"];
                        this.createdAt.push([
                          year + "-" + month + "-" + day,
                          sectionLenght,
                          sectionName,
                          cnt1++,
                        ]);
                      }

                      if (colsec1["Port_1609".toLowerCase()] != null) {
                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "82",
                          colsec1["Port_1609".toLowerCase()],
                        ]);
                        colsec1 = [];
                      } else {
                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "82",
                          "",
                        ]);
                        colsec1 = [];
                      }

                      if (
                        colsec2[
                        "Name_of_reception_facility_1610".toLowerCase()
                        ] != null
                      ) {
                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "83",
                          colsec2[
                          "Name_of_reception_facility_1610".toLowerCase()
                          ],
                        ]);
                        colsec2 = [];
                      } else {
                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "83",
                          "",
                        ]);
                        colsec2 = [];
                      }

                      if (colsec3["m3_1612".toLowerCase()] != null) {
                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "84",
                          colsec3["Quantity_1611".toLowerCase()] +
                          " " +
                          colsec3["m3_1612".toLowerCase()],
                        ]);
                        colsec3 = [];
                      } else {
                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "84",
                          "",
                        ]);
                        colsec3 = [];
                      }
                      this.userSign.push(usersign);
                    }

                    // end getting response data into array
                    if (formId == 65) {
                      if (
                        coldate["date_created"] != null &&
                        coldate["date_created"] != ""
                      ) {
                        var date = new Date(coldate["date_created"]);
                        var day = date.getDate();
                        var month = date.getMonth() + 1;
                        var year = date.getFullYear();
                        var sectionLenght = coldate["section_length"];
                        this.createdAt.push([
                          year + "-" + month + "-" + day,
                          sectionLenght,
                          sectionName,
                          cnt1++,
                        ]);
                      }

                      if (colsec1["Reason_1608".toLowerCase()] != null) {
                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "81",
                          colsec1["Reason_1608".toLowerCase()],
                        ]);
                        colsec1 = [];
                      } else {
                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "81",
                          "",
                        ]);
                        colsec1 = [];
                      }
                      this.userSign.push(usersign);
                    }

                    // end getting response data into array
                    if (formId == 64) {
                      if (
                        coldate["date_created"] != null &&
                        coldate["date_created"] != ""
                      ) {
                        var date = new Date(coldate["date_created"]);
                        var day = date.getDate();
                        var month = date.getMonth() + 1;
                        var year = date.getFullYear();
                        var sectionLenght = coldate["section_length"];
                        this.createdAt.push([
                          year + "-" + month + "-" + day,
                          sectionLenght,
                          sectionName,
                          cnt1++,
                        ]);
                      }

                      if (colsec1["Tank_name_1592".toLowerCase()] != null) {
                        if (colsec1["Tank_name_1592".toLowerCase()] == null) {
                          colsec1["Tank_name_1592".toLowerCase()] = "";
                        }
                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "77",
                          colsec1["Tank_name_1592".toLowerCase()],
                        ]);
                        colsec1 = [];
                      } else {
                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "77",
                          "",
                        ]);
                        colsec1 = [];
                      }
                      this.userSign.push(usersign);

                      if (colsec2["m3_1606".toLowerCase()] != null) {
                        if (colsec2["Quantity_1605".toLowerCase()] == null) {
                          colsec2["Quantity_1605".toLowerCase()] = "";
                        }
                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "79",
                          colsec2["Quantity_1605".toLowerCase()] +
                          " " +
                          colsec2["m3_1606".toLowerCase()],
                        ]);
                        colsec2 = [];
                      } else {
                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "79",
                          "",
                        ]);
                        colsec2 = [];
                      }
                      this.userSign.push(usersign);

                      if (colsec3["Remarks_1607".toLowerCase()] != null) {
                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "80",
                          colsec3["Remarks_1607".toLowerCase()],
                        ]);
                        colsec3 = [];
                      } else {
                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "80",
                          "",
                        ]);
                        colsec3 = [];
                      }
                      this.userSign.push(usersign);
                    }

                    // end getting response data into array
                    if (formId == 63) {
                      if (
                        coldate["date_created"] != null &&
                        coldate["date_created"] != ""
                      ) {
                        var date = new Date(coldate["date_created"]);
                        var day = date.getDate();
                        var month = date.getMonth() + 1;
                        var year = date.getFullYear();
                        var sectionLenght = coldate["section_length"];
                        this.createdAt.push([
                          year + "-" + month + "-" + day,
                          sectionLenght,
                          sectionName,
                          cnt1++,
                        ]);
                      }

                      if (colsec1["Procedures_1590".toLowerCase()] != null) {
                        if (
                          colsec1["General_remarks_1591".toLowerCase()] == null
                        ) {
                          colsec1["General_remarks_1591".toLowerCase()] = "";
                        }
                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "76",
                          colsec1["Procedures_1590".toLowerCase()] +
                          " " +
                          colsec1["General_remarks_1591".toLowerCase()],
                        ]);
                        colsec1 = [];
                      } else {
                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "76",
                          "",
                        ]);
                        colsec1 = [];
                      }
                      this.userSign.push(usersign);
                    }

                    // end getting response data into array
                    if (formId == 62) {
                      if (
                        coldate["date_created"] != null &&
                        coldate["date_created"] != ""
                      ) {
                        var date = new Date(coldate["date_created"]);
                        var day = date.getDate();
                        var month = date.getMonth() + 1;
                        var year = date.getFullYear();
                        var sectionLenght = coldate["section_length"];
                        this.createdAt.push([
                          year + "-" + month + "-" + day,
                          sectionLenght,
                          sectionName,
                          cnt1++,
                        ]);
                      }

                      if (colsec1["time_1513".toLowerCase()] != null) {
                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "73",
                          colsec1["time_1513".toLowerCase()],
                        ]);
                        colsec1 = [];
                      } else {
                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "73",
                          "",
                        ]);
                        colsec1 = [];
                      }
                      this.userSign.push(usersign);

                      if (colsec2["m3_1587".toLowerCase()] != null) {
                        if (colsec2["Quantity_1586".toLowerCase()] == null) {
                          colsec2["Quantity_1586".toLowerCase()] = "";
                        }
                        if (colsec2["type_of_oil_1588".toLowerCase()] == null) {
                          colsec2["type_of_oil_1588".toLowerCase()] = "";
                        }
                        if (colsec2["reason_1589".toLowerCase()] == null) {
                          colsec2["reason_1589".toLowerCase()] = "";
                        }

                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "75",
                          colsec2["Quantity_1586".toLowerCase()] +
                          " " +
                          colsec2["m3_1587".toLowerCase()] +
                          " " +
                          colsec2["type_of_oil_1588".toLowerCase()] +
                          " " +
                          colsec2["reason_1589".toLowerCase()],
                        ]);
                        colsec2 = [];
                      } else {
                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "75",
                          "",
                        ]);
                        colsec2 = [];
                      }

                      this.userSign.push(usersign);
                    }

                    // end getting response data into array
                    if (formId == 60) {
                      if (
                        coldate["date_created"] != null &&
                        coldate["date_created"] != ""
                      ) {
                        var date = new Date(coldate["date_created"]);
                        var day = date.getDate();
                        var month = date.getMonth() + 1;
                        var year = date.getFullYear();
                        var sectionLenght = coldate["section_length"];
                        this.createdAt.push([
                          year + "-" + month + "-" + day,
                          sectionLenght,
                          sectionName,
                          cnt1++,
                        ]);
                      }

                      if (colsec1["Tank_name_1508".toLowerCase()] != null) {
                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "63",
                          colsec1["Tank_name_1508".toLowerCase()],
                        ]);
                        colsec1 = [];
                      } else {
                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "63",
                          "",
                        ]);
                        colsec1 = [];
                      }
                      this.userSign.push(usersign);

                      if (colsec2["minutes_1518".toLowerCase()] != null) {
                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "64",
                          colsec2["time_1512".toLowerCase()] +
                          " " +
                          colsec2["lat_1514".toLowerCase()] +
                          " " +
                          colsec2["lat_degree_1515".toLowerCase()] +
                          " " +
                          colsec2["degree_1516".toLowerCase()] +
                          " " +
                          colsec2["lat_minutes_1517".toLowerCase()] +
                          " " +
                          colsec2["minutes_1518".toLowerCase()] +
                          " " +
                          colsec2["lat_direction_1519".toLowerCase()] +
                          "/" +
                          colsec2["long_1520".toLowerCase()] +
                          " " +
                          colsec2["long_degree_1521".toLowerCase()] +
                          " " +
                          colsec2["degree_1522".toLowerCase()] +
                          " " +
                          colsec2["long_minutes_1523".toLowerCase()] +
                          " " +
                          colsec2["minutes_1524".toLowerCase()] +
                          " " +
                          colsec2["long_direction_1525".toLowerCase()],
                        ]);
                        colsec2 = [];
                      } else {
                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "64",
                          "",
                        ]);
                        colsec2 = [];
                      }
                      this.userSign.push(usersign);

                      if (colsec3["minutes_1531".toLowerCase()] != null) {
                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "65",
                          colsec3["time_1526".toLowerCase()] +
                          " " +
                          colsec3["lat_1527".toLowerCase()] +
                          " " +
                          colsec3["lat_degree_1528".toLowerCase()] +
                          " " +
                          colsec3["degree_1529".toLowerCase()] +
                          " " +
                          colsec3["lat_minutes_1530".toLowerCase()] +
                          " " +
                          colsec3["minutes_1531".toLowerCase()] +
                          " " +
                          colsec3["lat_direction_1532".toLowerCase()] +
                          "/" +
                          colsec3["long_1533".toLowerCase()] +
                          " " +
                          colsec3["long_degree_1534".toLowerCase()] +
                          " " +
                          colsec3["degree_1535".toLowerCase()] +
                          " " +
                          colsec3["long_minutes_1536".toLowerCase()] +
                          " " +
                          colsec3["minutes_1537".toLowerCase()] +
                          " " +
                          colsec3["long_direction_1538".toLowerCase()],
                        ]);
                        colsec3 = [];
                      } else {
                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "65",
                          "",
                        ]);
                        colsec3 = [];
                      }

                      this.userSign.push(usersign);

                      if (colsec4["m3_or_1541".toLowerCase()] != null) {
                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "66",
                          colsec4["into_sea_1539".toLowerCase()] +
                          " " +
                          colsec4["textbox_1540".toLowerCase()] +
                          " " +
                          colsec4["m3_or_1541".toLowerCase()] +
                          " " +
                          colsec4["reception_facility_1542".toLowerCase()] +
                          " " +
                          colsec4[
                          "Reception_facilities_name_1543".toLowerCase()
                          ] +
                          " " +
                          colsec4["port_1544".toLowerCase()] +
                          " " +
                          colsec4["Quantity_1545".toLowerCase()] +
                          " " +
                          colsec4["m3_1546".toLowerCase()] +
                          " " +
                          colsec4["yes_1548".toLowerCase()] +
                          " " +
                          colsec4["no_1549".toLowerCase()] +
                          " " +
                          colsec4["time_1550".toLowerCase()] +
                          " " +
                          colsec4["date_1551".toLowerCase()] +
                          " " +
                          colsec4["Quantity_1552".toLowerCase()] +
                          " " +
                          colsec4["m3_1553".toLowerCase()],
                        ]);
                        colsec4 = [];
                      } else {
                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "66",
                          "",
                        ]);
                        colsec4 = [];
                      }

                      this.userSign.push(usersign);

                      if (
                        colsec5["yes_1554".toLowerCase()] != null ||
                        colsec5["no_1555".toLowerCase()] != null
                      ) {
                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "67",
                          colsec5["yes_1554".toLowerCase()] +
                          " " +
                          colsec5["no_1555".toLowerCase()],
                        ]);
                        colsec5 = [];
                      } else {
                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "67",
                          "",
                        ]);
                        colsec5 = [];
                      }

                      this.userSign.push(usersign);

                      if (colsec6["yes_1556".toLowerCase()] != null) {
                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "68",
                          colsec6["yes_1556".toLowerCase()] +
                          " " +
                          colsec6["no_1557".toLowerCase()],
                        ]);
                        colsec6 = [];
                      } else {
                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "68",
                          "",
                        ]);
                        colsec6 = [];
                      }

                      this.userSign.push(usersign);

                      if (colsec7["degree_1561".toLowerCase()] != null) {
                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "69",
                          colsec7["time_1558".toLowerCase()] +
                          " " +
                          colsec7["lat_1559".toLowerCase()] +
                          " " +
                          colsec7["lat_degree_1560".toLowerCase()] +
                          " " +
                          colsec7["degree_1561".toLowerCase()] +
                          " " +
                          colsec7["lat_minutes_1562".toLowerCase()] +
                          " " +
                          colsec7["minutes_1563".toLowerCase()] +
                          " " +
                          colsec7["lat_direction_1564".toLowerCase()] +
                          "/" +
                          colsec7["long_1565".toLowerCase()] +
                          " " +
                          colsec7["long_degree_1566".toLowerCase()] +
                          " " +
                          colsec7["degree_1567".toLowerCase()] +
                          " " +
                          colsec7["long_minutes_1568".toLowerCase()] +
                          " " +
                          colsec7["minutes_1569".toLowerCase()] +
                          " " +
                          colsec7["long_direction_1570".toLowerCase()],
                        ]);
                        colsec7 = [];
                      } else {
                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "69",
                          "",
                        ]);
                        colsec7 = [];
                      }

                      this.userSign.push(usersign);
                    }

                    // end getting response data into array
                    if (formId == 61) {
                      if (
                        coldate["date_created"] != null &&
                        coldate["date_created"] != ""
                      ) {
                        var date = new Date(coldate["date_created"]);
                        var day = date.getDate();
                        var month = date.getMonth() + 1;
                        var year = date.getFullYear();
                        var sectionLenght = coldate["section_length"];
                        this.createdAt.push([
                          year + "-" + month + "-" + day,
                          sectionLenght,
                          sectionName,
                          cnt1++,
                        ]);
                      }

                      if (colsec1["time_1509".toLowerCase()] != null) {
                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "70",
                          colsec1["time_1509".toLowerCase()],
                        ]);
                        colsec1 = [];
                      } else {
                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "70",
                          "",
                        ]);
                        colsec1 = [];
                      }
                      this.userSign.push(usersign);

                      if (colsec2["time_1510".toLowerCase()] != null) {
                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "71",
                          colsec2["time_1510".toLowerCase()],
                        ]);
                        colsec2 = [];
                      } else {
                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "71",
                          "",
                        ]);
                        colsec2 = [];
                      }

                      this.userSign.push(usersign);
                      if (colsec3["Reason_1511".toLowerCase()] != null) {
                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "72",
                          colsec3["Reason_1511".toLowerCase()],
                        ]);
                        colsec3 = [];
                      } else {
                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "72",
                          "",
                        ]);
                        colsec3 = [];
                      }

                      this.userSign.push(usersign);
                    }

                    // end getting response data into array
                    if (formId == 59) {
                      if (
                        coldate["date_created"] != null &&
                        coldate["date_created"] != ""
                      ) {
                        var date = new Date(coldate["date_created"]);
                        var day = date.getDate();
                        var month = date.getMonth() + 1;
                        var year = date.getFullYear();
                        var sectionLenght = coldate["section_length"];
                        this.createdAt.push([
                          year + "-" + month + "-" + day,
                          sectionLenght,
                          sectionName,
                          cnt1++,
                        ]);
                      }

                      if (colsec1["degree_1460".toLowerCase()] != null) {
                        if (colsec1["LAT_1456".toLowerCase()] == null) {
                          colsec1["LAT_1456".toLowerCase()] = "";
                        }
                        if (colsec1["lat_degree_1458".toLowerCase()] == null) {
                          colsec1["lat_degree_1458".toLowerCase()] = "";
                        }
                        if (colsec1["degree_1460".toLowerCase()] == null) {
                          colsec1["degree_1460".toLowerCase()] = "";
                        }
                        if (colsec1["lat_minutes_1462".toLowerCase()] == null) {
                          colsec1["lat_minutes_1462".toLowerCase()] = "";
                        }
                        if (colsec1["minutes_1464".toLowerCase()] == null) {
                          colsec1["minutes_1464".toLowerCase()] = "";
                        }
                        if (
                          colsec1["lat_direction_1465".toLowerCase()] == null
                        ) {
                          colsec1["lat_direction_1465".toLowerCase()] = "";
                        }
                        if (colsec1["long_degree_1468".toLowerCase()] == null) {
                          colsec1["long_degree_1468".toLowerCase()] = "";
                        }
                        if (colsec1["degree_1469".toLowerCase()] == null) {
                          colsec1["degree_1469".toLowerCase()] = "";
                        }
                        if (
                          colsec1["long_minutes_1471".toLowerCase()] == null
                        ) {
                          colsec1["long_minutes_1471".toLowerCase()] = "";
                        }
                        if (colsec1["minutes_1473".toLowerCase()] == null) {
                          colsec1["minutes_1473".toLowerCase()] = "";
                        }
                        if (
                          colsec1["long_direction_1474".toLowerCase()] == null
                        ) {
                          colsec1["long_direction_1474".toLowerCase()] = "";
                        }
                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "58",
                          colsec1["LAT_1456".toLowerCase()] +
                          " " +
                          colsec1["lat_degree_1458".toLowerCase()] +
                          " " +
                          colsec1["degree_1460".toLowerCase()] +
                          " " +
                          colsec1["lat_minutes_1462".toLowerCase()] +
                          " " +
                          colsec1["minutes_1464".toLowerCase()] +
                          " " +
                          colsec1["lat_direction_1465".toLowerCase()] +
                          "/" +
                          colsec1["LONG_1466".toLowerCase()] +
                          " " +
                          colsec1["long_degree_1468".toLowerCase()] +
                          " " +
                          colsec1["degree_1469".toLowerCase()] +
                          " " +
                          colsec1["long_minutes_1471".toLowerCase()] +
                          " " +
                          colsec1["minutes_1473".toLowerCase()] +
                          " " +
                          colsec1["long_direction_1474".toLowerCase()],
                        ]);
                        colsec1 = [];
                      } else {
                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "58",
                          "",
                        ]);
                        colsec1 = [];
                      }

                      this.userSign.push(usersign);

                      if (colsec2["Tank_name_1475".toLowerCase()] != null) {
                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "59",
                          colsec2["Tank_name_1475".toLowerCase()],
                        ]);
                        colsec2 = [];
                      } else {
                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "59",
                          "",
                        ]);
                        colsec2 = [];
                      }

                      this.userSign.push(usersign);

                      if (colsec3["Yes_1476".toLowerCase()] != null) {
                        if (colsec3["No_1477".toLowerCase()] == null) {
                          colsec3["No_1477".toLowerCase()] = "";
                        }
                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "60",
                          colsec3["Yes_1476".toLowerCase()] +
                          " " +
                          colsec3["No_1477".toLowerCase()],
                        ]);
                        colsec3 = [];
                      } else {
                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "60",
                          "",
                        ]);
                        colsec3 = [];
                      }

                      this.userSign.push(usersign);

                      if (colsec4["degree_1483".toLowerCase()] != null) {
                        if (colsec4["LAT_1479".toLowerCase()] == null) {
                          colsec4["LAT_1479".toLowerCase()] = "";
                        }
                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "61",
                          colsec4["LAT_1479".toLowerCase()] +
                          " " +
                          colsec4["lat_degree_1481".toLowerCase()] +
                          " " +
                          colsec4["degree_1483".toLowerCase()] +
                          " " +
                          colsec4["lat_minutes_1484".toLowerCase()] +
                          " " +
                          colsec4["minutes_1485".toLowerCase()] +
                          " " +
                          colsec4["lat_direction_1488".toLowerCase()] +
                          "/" +
                          colsec4["long_degree_1492".toLowerCase()] +
                          " " +
                          colsec4["degree_1494".toLowerCase()] +
                          " " +
                          colsec4["long_minutes_1496".toLowerCase()] +
                          " " +
                          colsec4["minutes_1498".toLowerCase()] +
                          " " +
                          colsec4["long_direction_1500".toLowerCase()],
                        ]);
                        colsec4 = [];
                      } else {
                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "61",
                          "",
                        ]);
                        colsec4 = [];
                      }

                      this.userSign.push(usersign);

                      if (colsec5["Yes_1502".toLowerCase()] != null) {
                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "62",
                          colsec5["Yes_1502".toLowerCase()] +
                          " " +
                          colsec5["No_1503".toLowerCase()],
                        ]);
                        colsec5 = [];
                      } else {
                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "62",
                          "",
                        ]);
                        colsec5 = [];
                      }

                      this.userSign.push(usersign);
                    }

                    // end getting response data into array
                    if (formId == 56) {
                      if (
                        coldate["date_created"] != null &&
                        coldate["date_created"] != ""
                      ) {
                        var date = new Date(coldate["date_created"]);
                        var day = date.getDate();
                        var month = date.getMonth() + 1;
                        var year = date.getFullYear();
                        var sectionLenght = coldate["section_length"];
                        this.createdAt.push([
                          year + "-" + month + "-" + day,
                          sectionLenght,
                          sectionName,
                          cnt1++,
                        ]);
                      }

                      if (colsec1["Tank_name_1352".toLowerCase()] != null) {
                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "32",
                          colsec1["Tank_name_1352".toLowerCase()],
                        ]);
                        colsec1 = [];
                      } else {
                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "32",
                          "",
                        ]);
                        colsec1 = [];
                      }

                      this.userSign.push(usersign);

                      if (colsec2["m3_1380".toLowerCase()] != null) {
                        if (colsec2["quantity_1379".toLowerCase()] == null) {
                          colsec2["quantity_1379".toLowerCase()] = "";
                        }
                        if (colsec2["m3_1380".toLowerCase()] == null) {
                          colsec2["m3_1380".toLowerCase()] = "";
                        }

                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "35",
                          colsec2["quantity_1379".toLowerCase()] +
                          " " +
                          colsec2["m3_1380".toLowerCase()],
                        ]);
                        colsec2 = [];
                      } else {
                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "35",
                          "",
                        ]);
                        colsec2 = [];
                      }

                      this.userSign.push(usersign);

                      if (colsec3["m3_1389".toLowerCase()] != null) {
                        if (
                          colsec3[
                          "Quantity_of_oily_water_1386".toLowerCase()
                          ] == null
                        ) {
                          colsec3["Quantity_of_oily_water_1386".toLowerCase()] =
                            "0.00";
                        }
                        if (colsec3["tank_name_1387".toLowerCase()] == null) {
                          colsec3["tank_name_1387".toLowerCase()] = "";
                        }
                        if (
                          colsec3["Total_quantity_1388".toLowerCase()] == null
                        ) {
                          colsec3["Total_quantity_1388".toLowerCase()] = "0.00";
                        }
                        if (colsec3["m3_1389".toLowerCase()] == null) {
                          colsec3["m3_1389".toLowerCase()] = "";
                        }
                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "39",
                          colsec3["Quantity_of_oily_water_1386".toLowerCase()] +
                          " " +
                          colsec3["tank_name_1387".toLowerCase()] +
                          " " +
                          colsec3["Total_quantity_1388".toLowerCase()] +
                          " " +
                          colsec3["m3_1389".toLowerCase()],
                        ]);
                        colsec3 = [];
                      } else {
                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "39",
                          "",
                        ]);
                        colsec3 = [];
                      }
                      this.userSign.push(usersign);

                      if (colsec4["m3_1393".toLowerCase()] != null) {
                        if (
                          colsec4[
                          "Quantity_of_oily_water_1390".toLowerCase()
                          ] == null
                        ) {
                          colsec4["Quantity_of_oily_water_1390".toLowerCase()] =
                            "0.00";
                        }
                        if (colsec4["Port_name_1391".toLowerCase()] == null) {
                          colsec4["Port_name_1391".toLowerCase()] = "";
                        }
                        if (
                          colsec4["Total_Quantity_1392".toLowerCase()] == null
                        ) {
                          colsec4["Total_Quantity_1392".toLowerCase()] = "0.00";
                        }
                        if (colsec4["m3_1393".toLowerCase()] == null) {
                          colsec4["m3_1393".toLowerCase()] = "";
                        }
                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "40",
                          colsec4["Quantity_of_oily_water_1390".toLowerCase()] +
                          " " +
                          colsec4["Port_name_1391".toLowerCase()] +
                          " " +
                          colsec4["Total_Quantity_1392".toLowerCase()] +
                          " " +
                          colsec4["m3_1393".toLowerCase()],
                        ]);
                        colsec4 = [];
                      } else {
                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "40",
                          "",
                        ]);
                        colsec4 = [];
                      }

                      this.userSign.push(usersign);
                    }

                    if (formId == 49) {
                      if (
                        coldate["date_created"] != null &&
                        coldate["date_created"] != ""
                      ) {
                        var date = new Date(coldate["date_created"]);
                        var day = date.getDate();
                        var month = date.getMonth() + 1;
                        var year = date.getFullYear();
                        var sectionLenght = coldate["section_length"];
                        this.createdAt.push([
                          year + "-" + month + "-" + day,
                          sectionLenght,
                          sectionName,
                          cnt1++,
                        ]);
                      }

                      if (
                        colsec1["Place_of_loading_1175".toLowerCase()] != null
                      ) {
                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "1",
                          colsec1["Place_of_loading_1175".toLowerCase()],
                        ]);
                        colsec1 = [];
                      } else {
                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "1",
                          "",
                        ]);
                        colsec1 = [];
                      }

                      this.userSign.push(usersign);

                      if (colsec2["Tank_name_1177".toLowerCase()] != null) {
                        if (colsec2["Type_of_oil_1176".toLowerCase()] == null) {
                          colsec2["Type_of_oil_1176".toLowerCase()] = "";
                        }
                        if (colsec2["Tank_name_1177".toLowerCase()] == null) {
                          colsec2["Tank_name_1177".toLowerCase()] = "";
                        }

                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "2",
                          colsec2["Type_of_oil_1176".toLowerCase()] +
                          " " +
                          colsec2["Tank_name_1177".toLowerCase()],
                        ]);
                        colsec2 = [];
                      } else {
                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "2",
                          "",
                        ]);
                      }

                      this.userSign.push(usersign);

                      if (colsec3["m3_1179".toLowerCase()] != null) {
                        if (
                          colsec3[
                          "Total_quantity_of_oil_loaded_1178".toLowerCase()
                          ] == null
                        ) {
                          colsec3[
                            "Total_quantity_of_oil_loaded_1178".toLowerCase()
                          ] = "0.00";
                        }
                        if (colsec3["m3_1179".toLowerCase()] == null) {
                          colsec3["m3_1179".toLowerCase()] = "";
                        }
                        if (
                          colsec3["Total_content_1180".toLowerCase()] == null
                        ) {
                          colsec3["Total_content_1180".toLowerCase()] = "0.00";
                        }
                        if (colsec3["m3_1181".toLowerCase()] == null) {
                          colsec3["m3_1181".toLowerCase()] = "m3";
                        }
                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "3",
                          colsec3[
                          "Total_quantity_of_oil_loaded_1178".toLowerCase()
                          ] +
                          " " +
                          colsec3["m3_1179".toLowerCase()] +
                          " " +
                          colsec3["Total_content_1180".toLowerCase()] +
                          " " +
                          colsec3["m3_1181".toLowerCase()],
                        ]);
                        colsec3 = [];
                      } else {
                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "3",
                          "",
                        ]);
                      }

                      this.userSign.push(usersign);
                    }

                    if (formId == 50) {
                      if (
                        coldate["date_created"] != null &&
                        coldate["date_created"] != ""
                      ) {
                        var date = new Date(coldate["date_created"]);
                        var day = date.getDate();
                        var month = date.getMonth() + 1;
                        var year = date.getFullYear();
                        var sectionLenght = 3; //coldate['section_length'];
                        this.createdAt.push([
                          year + "-" + month + "-" + day,
                          sectionLenght,
                          sectionName,
                          cnt2++,
                        ]);
                      }

                      if (
                        colsec1[
                        "State_quantity_transferred_1186".toLowerCase()
                        ] != null
                      ) {
                        if (colsec1["4.1_from_1182".toLowerCase()] == null) {
                          colsec1["4.1_from_1182".toLowerCase()] = "";
                        }
                        if (colsec1["Tank_name_1183".toLowerCase()] == null) {
                          colsec1["Tank_name_1183".toLowerCase()] = "";
                        }
                        if (colsec1["4.2_to_1184".toLowerCase()] == null) {
                          colsec1["4.2_to_1184".toLowerCase()] = "";
                        }
                        //if(colsec1['Tank_name_1185'.toLowerCase()]==null) {colsec1['Tank_name_1185'.toLowerCase()] = ""};
                        if (
                          colsec1[
                          "State_quantity_transferred_1186".toLowerCase()
                          ] == null
                        ) {
                          colsec1[
                            "State_quantity_transferred_1186".toLowerCase()
                          ] = "";
                        }
                        if (colsec1["4000_m3_1187".toLowerCase()] == null) {
                          colsec1["4000_m3_1187".toLowerCase()] = "";
                        }

                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "4.1",
                          colsec1["4.1_from_1182".toLowerCase()] +
                          " " +
                          colsec1["Tank_name_1183".toLowerCase()],
                        ]);

                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "4.2",
                          colsec1["4.2_to_1184".toLowerCase()] +
                          " " +
                          colsec1["Tank_name_1185".toLowerCase()] +
                          " (" +
                          colsec1[
                          "State_quantity_transferred_1186".toLowerCase()
                          ] +
                          " m3)",
                        ]);
                        colsec1 = [];
                      } else {
                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "4.1",
                          "",
                        ]);
                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "4.2",
                          "",
                        ]);
                      }

                      this.userSign.push(usersign);

                      if (colsec2["m3_1191".toLowerCase()] != null) {
                        if (colsec2["Yes_1188".toLowerCase()] == null) {
                          colsec2["Yes_1188".toLowerCase()] = "";
                        }
                        if (colsec2["No_1189".toLowerCase()] == null) {
                          colsec2["No_1189".toLowerCase()] = "";
                        }
                        if (
                          colsec2[
                          "State_quantity_retained_1190".toLowerCase()
                          ] == null
                        ) {
                          colsec2[
                            "State_quantity_retained_1190".toLowerCase()
                          ] = "";
                        }
                        if (colsec2["m3_1191".toLowerCase()] == null) {
                          colsec2["m3_1191".toLowerCase()] = "";
                        }

                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "5",
                          colsec2["Yes_1188".toLowerCase()] +
                          " " +
                          colsec2["No_1189".toLowerCase()] +
                          " " +
                          colsec2[
                          "State_quantity_retained_1190".toLowerCase()
                          ] +
                          " " +
                          colsec2["m3_1191".toLowerCase()],
                        ]);
                        colsec2 = [];
                      } else {
                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "5",
                          "",
                        ]);
                      }

                      this.userSign.push(usersign);

                      p = 0;
                    }

                    if (formId == 51) {
                      if (
                        coldate["date_created"] != null &&
                        coldate["date_created"] != ""
                      ) {
                        var date = new Date(coldate["date_created"]);
                        var day = date.getDate();
                        var month = date.getMonth() + 1;
                        var year = date.getFullYear();
                        var sectionLenght = coldate["section_length"];
                        this.createdAt.push([
                          year + "-" + month + "-" + day,
                          sectionLenght,
                          sectionName,
                          cnt3++,
                        ]);
                      }

                      if (
                        colsec1["Place_of_unloading_1192".toLowerCase()] != null
                      ) {
                        if (
                          colsec1["Place_of_unloading_1192".toLowerCase()] ==
                          null
                        ) {
                          colsec1["Place_of_unloading_1192".toLowerCase()] = "";
                        }
                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "6",
                          colsec1["Place_of_unloading_1192".toLowerCase()],
                        ]);
                        colsec1 = [];
                      } else {
                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "6",
                          "",
                        ]);
                      }

                      this.userSign.push(usersign);

                      if (colsec2["Tank_name_1193".toLowerCase()] != null) {
                        if (colsec2["Tank_name_1193".toLowerCase()] == null) {
                          colsec2["Tank_name_1193".toLowerCase()] = "";
                        }
                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "7",
                          colsec2["Tank_name_1193".toLowerCase()],
                        ]);
                        colsec2 = [];
                      } else {
                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "7",
                          "",
                        ]);
                      }

                      this.userSign.push(usersign);

                      if (
                        colsec3["No_1195".toLowerCase()] != "" ||
                        colsec3["Yes_1194".toLowerCase()] != ""
                      ) {
                        if (colsec3["No_1195".toLowerCase()] == null) {
                          colsec3["No_1195".toLowerCase()] = "";
                        }
                        if (colsec3["Yes_1194".toLowerCase()] == null) {
                          colsec3["Yes_1194".toLowerCase()] = "";
                        }
                        if (
                          colsec3[
                          "State_quantity_retained_1196".toLowerCase()
                          ] == null
                        ) {
                          colsec3[
                            "State_quantity_retained_1196".toLowerCase()
                          ] = "";
                        }
                        if (colsec3["m3_1197".toLowerCase()] == null) {
                          colsec3["m3_1197".toLowerCase()] = "";
                        }

                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "8",
                          colsec3["No_1195".toLowerCase()] +
                          colsec3["Yes_1194".toLowerCase()] +
                          " " +
                          colsec3[
                          "State_quantity_retained_1196".toLowerCase()
                          ] +
                          " " +
                          colsec3["m3_1197".toLowerCase()],
                        ]);
                        colsec3 = [];
                      } else {
                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "8",
                          "",
                        ]);
                      }
                      this.userSign.push(usersign);
                      p = 0;
                    }

                    if (formId == 52) {
                      if (
                        coldate["date_created"] != null &&
                        coldate["date_created"] != ""
                      ) {
                        var date = new Date(coldate["date_created"]);
                        var day = date.getDate();
                        var month = date.getMonth() + 1;
                        var year = date.getFullYear();
                        var sectionLenght = coldate["section_length"];
                        this.createdAt.push([
                          year + "-" + month + "-" + day,
                          sectionLenght,
                          sectionName,
                          cnt4++,
                        ]);
                      }

                      if (colsec1["degree_1203".toLowerCase()] != null) {
                        if (colsec1["port_name_1199".toLowerCase()] == null) {
                          colsec1["port_name_1199".toLowerCase()] = "";
                        }
                        if (colsec1["position_1200".toLowerCase()] == null) {
                          colsec1["position_1200".toLowerCase()] = "";
                        }
                        if (colsec1["LAT_1201".toLowerCase()] == null) {
                          colsec1["LAT_1201".toLowerCase()] = "";
                        }
                        if (colsec1["LAT_Degree_1202".toLowerCase()] == null) {
                          colsec1["LAT_Degree_1202".toLowerCase()] = "";
                        }
                        if (colsec1["degree_1203".toLowerCase()] == null) {
                          colsec1["degree_1203".toLowerCase()] = "";
                        }
                        if (colsec1["Lat_minutes_1204".toLowerCase()] == null) {
                          colsec1["Lat_minutes_1204".toLowerCase()] = "";
                        }
                        if (colsec1["minutes_1205".toLowerCase()] == null) {
                          colsec1["minutes_1205".toLowerCase()] = "";
                        }
                        if (
                          colsec1["lat_direction_1206".toLowerCase()] == null
                        ) {
                          colsec1["lat_direction_1206".toLowerCase()] = "";
                        }
                        if (colsec1["LONG_1207".toLowerCase()] == null) {
                          colsec1["LONG_1207".toLowerCase()] = "";
                        }
                        if (colsec1["long_degree_1208".toLowerCase()] == null) {
                          colsec1["long_degree_1208".toLowerCase()] = "";
                        }
                        if (colsec1["degree_1209".toLowerCase()] == null) {
                          colsec1["degree_1209".toLowerCase()] = "";
                        }
                        if (
                          colsec1["long_minutes_1210".toLowerCase()] == null
                        ) {
                          colsec1["long_minutes_1210".toLowerCase()] = "";
                        }
                        if (colsec1["minutes_1211".toLowerCase()] == null) {
                          colsec1["minutes_1211".toLowerCase()] = "";
                        }
                        if (
                          colsec1["long_direction_1212".toLowerCase()] == null
                        ) {
                          colsec1["long_direction_1212".toLowerCase()] = "";
                        }

                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "9",
                          colsec1["port_name_1199".toLowerCase()] +
                          " " +
                          colsec1["position_1200".toLowerCase()] +
                          " " +
                          colsec1["LAT_1201".toLowerCase()] +
                          " " +
                          colsec1["LAT_Degree_1202".toLowerCase()] +
                          " " +
                          colsec1["degree_1203".toLowerCase()] +
                          " " +
                          colsec1["Lat_minutes_1204".toLowerCase()] +
                          " " +
                          colsec1["minutes_1205".toLowerCase()] +
                          " " +
                          colsec1["lat_direction_1206".toLowerCase()] +
                          "/" +
                          colsec1["LONG_1207".toLowerCase()] +
                          " " +
                          colsec1["long_degree_1208".toLowerCase()] +
                          " " +
                          colsec1["degree_1209".toLowerCase()] +
                          " " +
                          colsec1["long_minutes_1210".toLowerCase()] +
                          " " +
                          colsec1["minutes_1211".toLowerCase()] +
                          " " +
                          colsec1["long_direction_1212".toLowerCase()],
                        ]);
                        colsec1 = [];
                      } else {
                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "9",
                          "",
                        ]);
                      }
                      this.userSign.push(usersign);

                      if (colsec2["Tank_name_1213".toLowerCase()] != null) {
                        if (colsec2["Tank_name_1213".toLowerCase()] == null) {
                          colsec2["Tank_name_1213".toLowerCase()] = "";
                        }

                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "10",
                          colsec2["Tank_name_1213".toLowerCase()],
                        ]);
                        colsec2 = [];
                      } else {
                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "10",
                          "",
                        ]);
                      }
                      this.userSign.push(usersign);

                      if (
                        colsec3["No_of_machines_1214".toLowerCase()] != null
                      ) {
                        if (
                          colsec3["No_of_machines_1214".toLowerCase()] == null
                        ) {
                          colsec3["No_of_machines_1214".toLowerCase()] = "";
                        }
                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "11",
                          colsec3["No_of_machines_1214".toLowerCase()],
                        ]);
                        colsec3 = [];
                      } else {
                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "11",
                          "",
                        ]);
                      }
                      this.userSign.push(usersign);

                      if (colsec4["time_1215".toLowerCase()] != null) {
                        if (colsec4["time_1215".toLowerCase()] == null) {
                          colsec4["time_1215".toLowerCase()] = "";
                        }

                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "12",
                          colsec4["time_1215".toLowerCase()],
                        ]);
                        colsec4 = [];
                      } else {
                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "12",
                          "",
                        ]);
                      }
                      this.userSign.push(usersign);

                      if (
                        colsec5["washing_pattern_1216".toLowerCase()] != null
                      ) {
                        if (
                          colsec5["washing_pattern_1216".toLowerCase()] == null
                        ) {
                          colsec5["washing_pattern_1216".toLowerCase()] = "";
                        }

                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "13",
                          colsec5["washing_pattern_1216".toLowerCase()],
                        ]);
                        colsec5 = [];
                      } else {
                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "13",
                          "",
                        ]);
                      }

                      this.userSign.push(usersign);

                      if (
                        colsec6["Washing_line_pressure_1217".toLowerCase()] !=
                        null
                      ) {
                        if (
                          colsec6["Washing_line_pressure_1217".toLowerCase()] ==
                          null
                        ) {
                          colsec6["Washing_line_pressure_1217".toLowerCase()] =
                            "";
                        }

                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "14",
                          colsec6["Washing_line_pressure_1217".toLowerCase()],
                        ]);
                        colsec6 = [];
                      } else {
                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "14",
                          "",
                        ]);
                      }

                      this.userSign.push(usersign);

                      if (colsec7["time_1218".toLowerCase()] != null) {
                        if (colsec7["time_1218".toLowerCase()] == null) {
                          colsec7["time_1218".toLowerCase()] = "";
                        }

                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "15",
                          colsec7["time_1218".toLowerCase()],
                        ]);
                        colsec7 = [];
                      } else {
                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "15",
                          "",
                        ]);
                      }

                      this.userSign.push(usersign);

                      if (colsec8["state_method_1219".toLowerCase()] != null) {
                        if (
                          colsec8["state_method_1219".toLowerCase()] == null
                        ) {
                          colsec8["state_method_1219".toLowerCase()] = "";
                        }

                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "16",
                          colsec8["state_method_1219".toLowerCase()],
                        ]);
                        colsec8 = [];
                      } else {
                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "16",
                          "",
                        ]);
                      }

                      this.userSign.push(usersign);

                      if (colsec9["Remarks_1220".toLowerCase()] != null) {
                        if (colsec9["Remarks_1220".toLowerCase()] == null) {
                          colsec9["Remarks_1220".toLowerCase()] = "";
                        }

                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "17",
                          colsec9["Remarks_1220".toLowerCase()],
                        ]);
                        colsec9 = [];
                      } else {
                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "17",
                          "",
                        ]);
                      }

                      this.userSign.push(usersign);

                      p = 0;
                    }

                    if (formId == 53) {
                      if (
                        coldate["date_created"] != null &&
                        coldate["date_created"] != ""
                      ) {
                        var date = new Date(coldate["date_created"]);
                        var day = date.getDate();
                        var month = date.getMonth() + 1;
                        var year = date.getFullYear();
                        var sectionLenght = coldate["section_length"];
                        this.createdAt.push([
                          year + "-" + month + "-" + day,
                          sectionLenght,
                          sectionName,
                          cnt5++,
                        ]);
                      }

                      if (colsec1["degree_1236".toLowerCase()] != null) {
                        if (colsec1["Start_1221".toLowerCase()] == null) {
                          colsec1["Start_1221".toLowerCase()] = "";
                        }
                        if (colsec1["LAT_1222".toLowerCase()] == null) {
                          colsec1["LAT_1222".toLowerCase()] = "";
                        }
                        if (colsec1["degree_1224".toLowerCase()] == null) {
                          colsec1["degree_1224".toLowerCase()] = "";
                        }
                        if (colsec1["lat_minutes_1225".toLowerCase()] == null) {
                          colsec1["lat_minutes_1225".toLowerCase()] = "";
                        }
                        if (colsec1["minutes_1226".toLowerCase()] == null) {
                          colsec1["minutes_1226".toLowerCase()] = "";
                        }
                        if (
                          colsec1["lat_direction_1227".toLowerCase()] == null
                        ) {
                          colsec1["lat_direction_1227".toLowerCase()] = "";
                        }
                        if (colsec1["Long_1228".toLowerCase()] == null) {
                          colsec1["Long_1228".toLowerCase()] = "";
                        }
                        if (colsec1["degree_1229".toLowerCase()] == null) {
                          colsec1["degree_1229".toLowerCase()] = "";
                        }
                        if (
                          colsec1["Long_minutes_1230".toLowerCase()] == null
                        ) {
                          colsec1["Long_minutes_1230".toLowerCase()] = "";
                        }
                        if (colsec1["minutes_1231".toLowerCase()] == null) {
                          colsec1["minutes_1231".toLowerCase()] = "";
                        }
                        if (
                          colsec1["long_direction_1232".toLowerCase()] == null
                        ) {
                          colsec1["long_direction_1232".toLowerCase()] = "";
                        }
                        if (colsec1["STOP_1233".toLowerCase()] == null) {
                          colsec1["STOP_1233".toLowerCase()] = "";
                        }
                        if (colsec1["Lat_1234".toLowerCase()] == null) {
                          colsec1["Lat_1234".toLowerCase()] = "";
                        }
                        if (colsec1["Lat_degree_1235".toLowerCase()] == null) {
                          colsec1["Lat_degree_1235".toLowerCase()] = "";
                        }
                        if (colsec1["degree_1236".toLowerCase()] == null) {
                          colsec1["degree_1236".toLowerCase()] = "";
                        }
                        if (
                          colsec1["lat_minurtes_1237".toLowerCase()] == null
                        ) {
                          colsec1["lat_minurtes_1237".toLowerCase()] = "";
                        }
                        if (colsec1["minutes_1238".toLowerCase()] == null) {
                          colsec1["minutes_1238".toLowerCase()] = "";
                        }
                        if (
                          colsec1["lat_direction_1239".toLowerCase()] == null
                        ) {
                          colsec1["lat_direction_1239".toLowerCase()] = "";
                        }
                        if (colsec1["Long_1240".toLowerCase()] == null) {
                          colsec1["Long_1240".toLowerCase()] = "";
                        }
                        if (colsec1["long_degree_1241".toLowerCase()] == null) {
                          colsec1["long_degree_1241".toLowerCase()] = "";
                        }
                        if (colsec1["degree_1242".toLowerCase()] == null) {
                          colsec1["degree_1242".toLowerCase()] = "";
                        }
                        if (
                          colsec1["Long_minutes_1243".toLowerCase()] == null
                        ) {
                          colsec1["Long_minutes_1243".toLowerCase()] = "";
                        }
                        if (colsec1["minutes_1244".toLowerCase()] == null) {
                          colsec1["minutes_1244".toLowerCase()] = "";
                        }
                        if (
                          colsec1["Long_direction_1245".toLowerCase()] == null
                        ) {
                          colsec1["Long_direction_1245".toLowerCase()] = "";
                        }
                        if (
                          colsec1["long_degree_1620_1228".toLowerCase()] == null
                        ) {
                          colsec1["long_degree_1620_1228".toLowerCase()] = "";
                        }

                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "18",
                          colsec1["Start_1221".toLowerCase()] +
                          " " +
                          colsec1["LAT_1222".toLowerCase()] +
                          " " +
                          colsec1["degree_1224".toLowerCase()] +
                          " " +
                          colsec1["lat_minutes_1225".toLowerCase()] +
                          " " +
                          colsec1["minutes_1226".toLowerCase()] +
                          " " +
                          colsec1["lat_direction_1227".toLowerCase()] +
                          "/" +
                          colsec1["Long_1228".toLowerCase()] +
                          " " +
                          colsec1["degree_1229".toLowerCase()] +
                          " " +
                          colsec1["Long_minutes_1230".toLowerCase()] +
                          " " +
                          colsec1["minutes_1231".toLowerCase()] +
                          " " +
                          colsec1["long_direction_1232".toLowerCase()] +
                          "/" +
                          colsec1["STOP_1233".toLowerCase()] +
                          " " +
                          colsec1["Lat_1234".toLowerCase()] +
                          " " +
                          colsec1["Lat_degree_1235".toLowerCase()] +
                          " " +
                          colsec1["degree_1236".toLowerCase()] +
                          " " +
                          colsec1["lat_minurtes_1237".toLowerCase()] +
                          " " +
                          colsec1["minutes_1238".toLowerCase()] +
                          " " +
                          colsec1["lat_direction_1239".toLowerCase()] +
                          "/" +
                          colsec1["Long_1240".toLowerCase()] +
                          " " +
                          colsec1["long_degree_1241".toLowerCase()] +
                          " " +
                          colsec1["degree_1242".toLowerCase()] +
                          " " +
                          colsec1["Long_minutes_1243".toLowerCase()] +
                          " " +
                          colsec1["minutes_1244".toLowerCase()] +
                          " " +
                          colsec1["Long_direction_1245".toLowerCase()] +
                          " " +
                          colsec1["long_degree_1620_1228".toLowerCase()],
                        ]);
                        colsec1 = [];
                      } else {
                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "18",
                          "",
                        ]);
                      }

                      this.userSign.push(usersign);

                      if (colsec2["m3_1255".toLowerCase()] != null) {
                        if (
                          colsec2["identity_of_tanks_1246".toLowerCase()] ==
                          null
                        ) {
                          colsec2["identity_of_tanks_1246".toLowerCase()] = "";
                        }
                        if (colsec2["tank_name_1247".toLowerCase()] == null) {
                          colsec2["tank_name_1247".toLowerCase()] = "";
                        }
                        if (
                          colsec2["time_and_start_1248".toLowerCase()] == null
                        ) {
                          colsec2["time_and_start_1248".toLowerCase()] = "";
                        }
                        if (colsec2["Start_1249".toLowerCase()] == null) {
                          colsec2["Start_1249".toLowerCase()] = "";
                        }
                        if (colsec2["time_1250".toLowerCase()] == null) {
                          colsec2["time_1250".toLowerCase()] = "";
                        }
                        if (colsec2["END_1251".toLowerCase()] == null) {
                          colsec2["END_1251".toLowerCase()] = "";
                        }
                        if (colsec2["time_1252".toLowerCase()] == null) {
                          colsec2["time_1252".toLowerCase()] = "";
                        }
                        if (
                          colsec2["quantity_of_ballast_1253".toLowerCase()] ==
                          null
                        ) {
                          colsec2["quantity_of_ballast_1253".toLowerCase()] =
                            "";
                        }
                        if (
                          colsec2[
                          "Quantity_of_ballast_received_1254".toLowerCase()
                          ] == null
                        ) {
                          colsec2[
                            "Quantity_of_ballast_received_1254".toLowerCase()
                          ] = "";
                        }
                        if (colsec2["m3_1255".toLowerCase()] == null) {
                          colsec2["m3_1255".toLowerCase()] = "";
                        }

                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "19",
                          colsec2["identity_of_tanks_1246".toLowerCase()] +
                          " " +
                          colsec2["tank_name_1247".toLowerCase()] +
                          " " +
                          colsec2["time_and_start_1248".toLowerCase()] +
                          " " +
                          colsec2["Start_1249".toLowerCase()] +
                          " " +
                          colsec2["time_1250".toLowerCase()] +
                          " " +
                          colsec2["END_1251".toLowerCase()] +
                          " " +
                          colsec2["time_1252".toLowerCase()] +
                          " " +
                          colsec2["quantity_of_ballast_1253".toLowerCase()] +
                          " " +
                          colsec2[
                          "Quantity_of_ballast_received_1254".toLowerCase()
                          ] +
                          " " +
                          colsec2["m3_1255".toLowerCase()],
                        ]);
                        colsec2 = [];
                      } else {
                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "19",
                          "",
                        ]);
                      }

                      this.userSign.push(usersign);

                      p = 0;
                    }

                    // end collection column data to make it tabular
                  }

                  // collection of data into seperate array to be used in html
                  // console.log("mylog::mylog");
                  this.createCollectionLayout(this.objcolsection);
                  this.objcolcollection.push([
                    this.objcolsection,
                    this.createdAt,
                  ]);
                  // console.log(this.objcolcollection);
                  this.objcolsection = [];
                  this.createdAt = [];
                }
              }
            }
          }
        );

        break;
      }
    }
  }

  getFormdataAllforms1(hid) {
    var fromDate = (document.getElementById("dp4") as HTMLInputElement).value;
    fromDate = this.datePipe.transform(fromDate, "dd-MMM-yyyy");
    var toDate = (document.getElementById("dp3") as HTMLInputElement).value;
    toDate = this.datePipe.transform(toDate, "dd-MMM-yyyy");
    var watchHour = this.selectedValueWatch;
    // alert("=hid="+hid+"=fromDate="+fromDate+'=toDate='+toDate+'==watchHour=='+watchHour);
    if (fromDate == null) {
      return alert("From Date is required");
    }
    if (hid == 36) {
      this.orbForm = 1;
      // console.log(
      //   hid +
      //   " whtchhours:" +
      //   watchHour +
      //   " fromdate:" +
      //   fromDate +
      //   " toDate:" +
      //   toDate
      // );
      this.getFormdataAllforms(hid, "", "", fromDate, toDate);
    } else if (hid == 37) {
      this.getOrbPartTwoData(hid, "", watchHour, fromDate, toDate);
    } else if (hid == 39 || hid == 40 || hid == 47 || hid == 48) {
      this.callHTypeGarbegBallast(hid, "", watchHour, fromDate, toDate);
    } else if (hid == 42 || hid == 43) {
      this.callHTypeAudit(hid, "", watchHour, fromDate, toDate);
    } else if (hid == 44) {
      this.getFormdataAllformsDeckBook(hid, "", watchHour, fromDate, toDate);
    } else if (hid == "49-3") {
      this.gmdss_log_book_list(hid, "", "", fromDate, toDate);
    }
  }

  getFormdataAllforms(
    hid,
    actionDate = "",
    actionTime = "",
    fromDate = "",
    toDate = ""
  ) {
    for (var i = 0; i < this.formBuilder.length; i++) {
      if (this.formBuilder[i].hid == hid) {
        this.formCount = [];
        this.objcolsection = [];
        var result = [];
        var strFormId = "";
        for (
          var r = 0;
          r < this.formBuilder[i].formbuilderresponse.length;
          r++
        ) {
          if (
            this.formBuilder[i].formbuilderresponse[r].formId != 30 &&
            this.formBuilder[i].formbuilderresponse[r].formId != 31
          ) {
            strFormId +=
              this.formBuilder[i].formbuilderresponse[r].formId + ",";
            this.formCount.push(this.formBuilder[i].formbuilderresponse[r]);
          }
        }

        var fineStringFormsId = strFormId.replace(/(^,)|(,$)/g, "");
        this.editlogbookformsService.getFormDetailsByActionDateAndTime(
          fineStringFormsId,
          this.voyageNo,
          actionDate,
          actionTime,
          fromDate,
          toDate,
          (multiresponse) => {
            this.objcolsection = [];
            let response = [];
            var cnt1 = 0;
            var cnt2 = 0;
            var cnt3 = 0;
            var cnt4 = 0;
            var cnt5 = 0;
            var cnt6 = 0;
            var colsec1 = [];
            var colsec2 = [];
            var colsec3 = [];
            var colsec4 = [];
            var colsec5 = [];
            var colsec6 = [];
            var colsec7 = [];
            var colsec8 = [];
            var coldate = [];
            var signdate = "";
            var masterName = "";
            var masterSignature = "";
            var roleId = "";
            var roleName = "";
            var id = "";

            if (multiresponse != null && multiresponse.length > 0) {
              for (let ky in multiresponse) {
                response.push(this.modifyedData(multiresponse[ky]));
              }

              // all form response loop
              for (let ky in response) {
                if (response[ky].data != null) {
                  var sectionName = "";
                  var sectionId = "";
                  this.showpop3 = 0;
                  for (var s = 0; s < response[ky].data.length; s++) {
                    if (response[ky].data[s].isDelete == "1") continue;
                    var formId = response[ky].data[s].formId;
                    var rowId = response[ky].data[s].rowId;
                    if (response[ky].data[s].editedBy != null) {
                      this.editedBy = response[ky].data[s].editedBy;
                    }

                    var usersign = response[ky].data[s].userSign;
                    if (
                      response[ky].data[s].masterDate != null &&
                      response[ky].data[s].masterDate != ""
                    ) {
                      signdate = response[ky].data[s].masterDate;
                    }

                    if (
                      response[ky].data[s].masterName != null &&
                      response[ky].data[s].masterName != ""
                    ) {
                      masterName = response[ky].data[s].masterName;
                    }

                    if (
                      response[ky].data[s].masterSignature != null &&
                      response[ky].data[s].masterSignature != ""
                    ) {
                      masterSignature = response[ky].data[s].masterSignature;
                    }

                    if (
                      response[ky].data[s].masterRoleId != null &&
                      response[ky].data[s].masterRoleId != ""
                    ) {
                      roleId = response[ky].data[s].masterRoleId;
                    }

                    if (
                      response[ky].data[s].masterRoleName != null &&
                      response[ky].data[s].masterRoleName != ""
                    ) {
                      roleName = response[ky].data[s].masterRoleName;
                    }
                    if (
                      response[ky].data[s]._id.$oid != null &&
                      response[ky].data[s]._id.$oid != ""
                    ) {
                      id = response[ky].data[s]._id.$oid;
                    }

                    this.masterSignature = masterSignature;
                    this.masterName = masterName;
                    this.signdate = signdate;
                    this.roleName = roleName;
                    this.id = id;
                    this.formId = formId;

                    this.formBuilderSections = [];
                    for (
                      var r = 0;
                      r < this.formBuilder[i].formbuilderresponse.length;
                      r++
                    ) {
                      if (
                        this.formBuilder[i].formbuilderresponse[r].formId ==
                        formId
                      ) {
                        sectionName = this.formBuilder[i].formbuilderresponse[
                          r
                        ].formName.charAt(
                          this.formBuilder[i].formbuilderresponse[r].formName
                            .length - 1
                        );

                        for (
                          var u = 0;
                          u <
                          this.formBuilder[i].formbuilderresponse[r]
                            .formbuildersectionnamelist.length;
                          u++
                        ) {
                          this.formBuilderSections.push(
                            this.formBuilder[i].formbuilderresponse[r]
                              .formbuildersectionnamelist[u]
                          ); //.formbuilderlist
                        }
                      }
                    }
                    //alert(formId);

                    var p = 0;
                    for (let key in response[ky].data[s]) {
                      for (p = 0; p < this.formBuilderSections.length; p++) {
                        for (
                          var v = 0;
                          v <
                          this.formBuilderSections[p].formbuilderlist.length;
                          v++
                        ) {
                          //alert(key.toString().toLowerCase());
                          //alert(key.toString().toLowerCase() + '-- field--' + this.formBuilderSections[p].formbuilderlist[v].fieldName.toString().toLowerCase() + '_' + this.formBuilderSections[p].formbuilderlist[v].fieldId.toString().toLowerCase());
                          if (
                            key.toString().toLowerCase() == "created_at" &&
                            response[ky].data[s][key] != ""
                          ) {
                            coldate["date_created"] = response[ky].data[s][key];
                            coldate[
                              "section_length"
                            ] = this.formBuilderSections.length;
                          }
                          if (
                            key.toString().toLowerCase() ==
                            this.formBuilderSections[p].formbuilderlist[
                              v
                            ].fieldName
                              .toString()
                              .toLowerCase()
                          ) {
                            //alert(key.toString().toLowerCase() + '-- field--' + this.formBuilderSections[p].formbuilderlist[v].fieldName.toString().toLowerCase());
                            sectionId = this.formBuilderSections[p].sectionId;
                            sectionId = this.formBuilderSections[p].sectionId;

                            //alert(sectionId);
                            if (formId == 32) {
                              this.garbegForm1 = 0;
                              this.garbegForm2 = 0;
                              this.blstForm = 0;
                              this.orbForm = 1;
                              if (p == 0) {
                                // Name of_sec Tank_Designation_387
                                if (
                                  key.toString().toLowerCase() ==
                                  "Name_of_sec_Tank_Designation_387".toLowerCase() &&
                                  response[ky].data[s][key] != ""
                                ) {
                                  colsec1[key.toString().toLowerCase()] =
                                    response[ky].data[s][key];
                                }
                                //
                              }

                              if (p == 1) {
                                //TextBox_388,m3_389
                                if (
                                  (key.toString().toLowerCase() ==
                                    "TextBox_388".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() == "m3_389" &&
                                    response[ky].data[s][key] != "")
                                ) {
                                  colsec2[key.toString().toLowerCase()] =
                                    response[ky].data[s][key];
                                }
                              }
                              //
                              if (p == 2) {
                                //TextBox_390,m3_391
                                if (
                                  (key.toString().toLowerCase() ==
                                    "TextBox_390".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() == "m3_391" &&
                                    response[ky].data[s][key] != "")
                                ) {
                                  colsec3[key.toString().toLowerCase()] =
                                    response[ky].data[s][key];
                                }
                                //
                              }

                              if (p == 3) {
                                //TextBox_392,m3_393,collected_from_394,identification_of_source_456
                                if (
                                  (key.toString().toLowerCase() ==
                                    "TextBox_392".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() == "m3_393" &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "collected_from_394" &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "identification_of_source_456" &&
                                    response[ky].data[s][key] != "")
                                ) {
                                  colsec4[key.toString().toLowerCase()] =
                                    response[ky].data[s][key];
                                }
                                //
                              }

                              if (p == 4) {
                                //TextBox_1_395, m3_396, Sludge_from_397, Name_of_sec__Tank_Designation_398, _399, TextBox_2_400, m3_retained_to_401, Name_of_sec_Tank_Designation_402,during_port_stay_403,Name_of_Port_404
                                if (
                                  (key.toString().toLowerCase() ==
                                    "TextBox_1_395".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() == "m3_396" &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Sludge_from_397".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Name_of_sec__Tank_Designation_398".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() == "_399" &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "TextBox_2_400".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "m3_retained_to_401".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Name_of_sec_Tank_Designation_402".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "during_port_stay_403" &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Name_of_Port_404".toLowerCase() &&
                                    response[ky].data[s][key] != "")
                                ) {
                                  colsec5[key.toString().toLowerCase()] =
                                    response[ky].data[s][key];
                                }
                                //
                              }

                              if (p == 5) {
                                //TextBox_1_405,m3_406,Water_drained_from_407,Name_of_sec_Tank_Designation_408,TextBox_2_409,m3_retained_to_410,Name_of_sec_Tank_Designation_411,retained_in_tank_412,TextBox_3_413,m3_414
                                if (
                                  (key.toString().toLowerCase() ==
                                    "TextBox_1_405".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() == "m3_406" &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Name_of_sec_Tank_Designation_402".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Water_drained_from_407".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Name_of_sec_Tank_Designation_408".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "TextBox_2_409".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "m3_retained_to_410" &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Name_of_sec_Tank_Designation_411".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "retained_in_tank_412".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "TextBox_3_413".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() == "m3_414" &&
                                    response[ky].data[s][key] != "")
                                ) {
                                  colsec6[key.toString().toLowerCase()] =
                                    response[ky].data[s][key];
                                }
                                //
                              }

                              if (p == 6) {
                                //TextBox_1_415,m3_417,Sludge_from_419,Name_of_sec_Tank_Designation_420,TextBox_2_423,m3_424,TextBox_3_426,hours_427
                                if (
                                  (key.toString().toLowerCase() ==
                                    "TextBox_1_415".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() == "m3_417" &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Sludge_from_419".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Name_of_sec_Tank_Designation_420".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "TextBox_2_423".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() == "m3_424" &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "TextBox_3_426".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "hours_427" &&
                                    response[ky].data[s][key] != "")
                                ) {
                                  colsec7[key.toString().toLowerCase()] =
                                    response[ky].data[s][key];
                                }
                                //
                              }

                              if (p == 7) {
                                //TextBox_1_416,m3_418,Sludge_from_421,Name of_sec Tank _Designation_422,TextBox_2_425,m3_428,TextBox_3_429,hours_430
                                if (
                                  (key.toString().toLowerCase() ==
                                    "TextBox_1_416".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() == "m3_418" &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Sludge_from_421".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "name _of_sec _tank _designation_422".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "TextBox_2_425".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() == "m3_428" &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "TextBox_3_429".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "hours_430" &&
                                    response[ky].data[s][key] != "")
                                ) {
                                  colsec8[key.toString().toLowerCase()] =
                                    response[ky].data[s][key];
                                }
                                //
                              }
                            }

                            if (formId == 33) {
                              this.garbegForm1 = 0;
                              this.garbegForm2 = 0;
                              this.blstForm = 0;
                              this.orbForm = 1;
                              //alert(p)
                              if (p == 0) {
                                // Name of_sec Tank_Designation_387
                                if (
                                  (key.toString().toLowerCase() ==
                                    "TextBox_1_431".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "m3_432".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Blige_water_from_433".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Engine_room_bilge_wells_435".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "t_438".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "TextBox_2_440".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "NA_442".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "TextBox_494".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "name _of_ port_495".toLowerCase() &&
                                    response[ky].data[s][key] != "")
                                ) {
                                  colsec1[key.toString().toLowerCase()] =
                                    response[ky].data[s][key];
                                }
                                //
                              }

                              if (p == 1) {
                                //TextBox_388,m3_389
                                if (
                                  (key.toString().toLowerCase() ==
                                    "Start_434".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Stop_437".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "TextBox_2_439".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "TextBox_1_436".toLowerCase() &&
                                    response[ky].data[s][key] != "")
                                ) {
                                  colsec2[key.toString().toLowerCase()] =
                                    response[ky].data[s][key];
                                }
                              }
                              //
                              if (p == 2) {
                                //TextBox_390,m3_391
                                if (
                                  (key.toString().toLowerCase() ==
                                    "Through_441".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "TextBox_1_443".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "ppm_474".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Equipment_overboard_475".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Position_start_476".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "TextBox_2_477".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "deg_478".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "TextBox_3_479".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "min_480".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "TextBox_4_481".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "deg_482".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "TextBox_5_483".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "min_484".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Position_stop_485".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "TextBox_6_486".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "deg_487".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "TextBox_7_488".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "min_489".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "TextBox_8_490".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "deg_491".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "TextBox_9_492".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "min_493".toLowerCase() &&
                                    response[ky].data[s][key] != "")
                                ) {
                                  colsec3[key.toString().toLowerCase()] =
                                    response[ky].data[s][key];
                                }
                                //
                              }

                              if (p == 3) {
                                //TextBox_392,m3_393,collected_from_394,identification_of_source_456
                                if (
                                  key.toString().toLowerCase() ==
                                  "Name_of_Port_459".toLowerCase() &&
                                  response[ky].data[s][key] != ""
                                ) {
                                  colsec4[key.toString().toLowerCase()] =
                                    response[ky].data[s][key];
                                }
                                //
                              }

                              if (p == 4) {
                                //TextBox_1_395, m3_396, Sludge_from_397, Name_of_sec__Tank_Designation_398, _399, TextBox_2_400, m3_retained_to_401, Name_of_sec_Tank_Designation_402,during_port_stay_403,Name_of_Port_404
                                if (
                                  (key.toString().toLowerCase() ==
                                    "collected_in_460".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "name_of_sec_tank_designation_461" &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Retained_in_tank_462".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Name_of_sec__Tank_Designation_398".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "TextBox_1_463" &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "m3_464".toLowerCase() &&
                                    response[ky].data[s][key] != "")
                                ) {
                                  colsec5[key.toString().toLowerCase()] =
                                    response[ky].data[s][key];
                                }
                                //
                              }
                            }

                            if (formId == 34) {
                              this.orbForm = 1;

                              if (p == 0) {
                                if (
                                  (key.toString().toLowerCase() ==
                                    "Pump_start_496".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "TextBox_1_497".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "at_498".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "TextBox_2_499".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() == "deg_500" &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "TextBox_3_501".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "min_502".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "TextBox_4_503".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "deg_504".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "TextBox_5_505".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "min_E/W_from_506".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Name_of_sec_Tank_Designation_507".toLowerCase() &&
                                    response[ky].data[s][key] != "")
                                ) {
                                  colsec1[key.toString().toLowerCase()] =
                                    response[ky].data[s][key];
                                }
                              }

                              if (p == 1) {
                                if (
                                  (key.toString().toLowerCase() ==
                                    "Transfer_start_508".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "TextBox_509".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "to_510".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Name_of_sec_Tank_Designation_511".toLowerCase() &&
                                    response[ky].data[s][key] != "")
                                ) {
                                  colsec2[key.toString().toLowerCase()] =
                                    response[ky].data[s][key];
                                }
                              }

                              if (p == 2) {
                                if (
                                  (key.toString().toLowerCase() ==
                                    "Stop_512".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "TextBox_513".toLowerCase() &&
                                    response[ky].data[s][key] != "")
                                ) {
                                  colsec3[key.toString().toLowerCase()] =
                                    response[ky].data[s][key];
                                }
                              }
                            }

                            if (formId == 35) {
                              this.orbForm = 1;

                              if (p == 0) {
                                if (
                                  key.toString().toLowerCase() ==
                                  "TextBox_514".toLowerCase() &&
                                  response[ky].data[s][key] != ""
                                ) {
                                  colsec1[key.toString().toLowerCase()] =
                                    response[ky].data[s][key];
                                }
                              }
                              if (p == 1) {
                                if (
                                  key.toString().toLowerCase() ==
                                  "TextBox_515".toLowerCase() &&
                                  response[ky].data[s][key] != ""
                                ) {
                                  colsec2[key.toString().toLowerCase()] =
                                    response[ky].data[s][key];
                                }
                              }
                              if (p == 2) {
                                if (
                                  key.toString().toLowerCase() ==
                                  "Reason_for_Failure_if_known_516".toLowerCase() &&
                                  response[ky].data[s][key] != ""
                                ) {
                                  colsec3[key.toString().toLowerCase()] =
                                    response[ky].data[s][key];
                                }
                              }
                            }

                            if (formId == 36) {
                              this.orbForm = 1;

                              if (p == 0) {
                                if (
                                  key.toString().toLowerCase() ==
                                  "TextBox_517".toLowerCase() &&
                                  response[ky].data[s][key] != ""
                                ) {
                                  colsec1[key.toString().toLowerCase()] =
                                    response[ky].data[s][key];
                                }
                              }
                              if (p == 1) {
                                if (
                                  (key.toString().toLowerCase() ==
                                    "Place_or_Position_518".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "TextBox_1_519".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "deg_520".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "TextBox_2_521".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "min_522".toLowerCase() &&
                                    response[ky].data[s][key] != "")
                                ) {
                                  colsec2[key.toString().toLowerCase()] =
                                    response[ky].data[s][key];
                                }
                              }
                              if (p == 2) {
                                if (
                                  (key.toString().toLowerCase() ==
                                    "Type_of_Oil_523".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Quantity_524".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "of_oily_residue_525".toLowerCase() &&
                                    response[ky].data[s][key] != "")
                                ) {
                                  colsec3[key.toString().toLowerCase()] =
                                    response[ky].data[s][key];
                                }
                              }
                              if (p == 3) {
                                if (
                                  key.toString().toLowerCase() ==
                                  "Circumstances_of_the_discharge_526".toLowerCase() &&
                                  response[ky].data[s][key] != ""
                                ) {
                                  colsec4[key.toString().toLowerCase()] =
                                    response[ky].data[s][key];
                                }
                              }
                            }

                            if (formId == 37) {
                              this.orbForm = 1;

                              if (p == 0) {
                                if (
                                  key.toString().toLowerCase() ==
                                  "Name_of_Port_527".toLowerCase() &&
                                  response[ky].data[s][key] != ""
                                ) {
                                  colsec1[key.toString().toLowerCase()] =
                                    response[ky].data[s][key];
                                }
                              }
                              if (p == 1) {
                                if (
                                  (key.toString().toLowerCase() ==
                                    "Start_528".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "TextBox_1_529".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "TextBox_2_530".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Stop_531".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "TextBox_3_532".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "TextBox_4_533".toLowerCase() &&
                                    response[ky].data[s][key] != "")
                                ) {
                                  colsec2[key.toString().toLowerCase()] =
                                    response[ky].data[s][key];
                                }
                              }
                              if (p == 2) {
                                if (
                                  (key.toString().toLowerCase() ==
                                    "TextBox_1_534".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "MT_of_535".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "TextBox_3_537".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "TextBox_2_536".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "TextBox_4_539".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "S_bunkered_in_tanks_538".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "MT_added_to_540".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Tank_Name_Designation_541".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "now_containing_542".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "TextBox_5_543".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "MT_544".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "TextBox_6_555".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "MT_added_to_556".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Tank_Name_Designation_557".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "now_containing_558".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "TextBox_7_559".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "MT_560".toLowerCase() &&
                                    response[ky].data[s][key] != "")
                                ) {
                                  colsec3[key.toString().toLowerCase()] =
                                    response[ky].data[s][key];
                                }
                              }
                              if (p == 3) {
                                if (
                                  (key.toString().toLowerCase() ==
                                    "TextBox_1_545".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "MT_546".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Type_of_Oil_547".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "bunkered_in_tanks_548".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "TextBox_2_549".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "MT_added_to_550".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Tank_Name_Designation_551".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "now_containing_552".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "TextBox_3_553".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "MT_554".toLowerCase() &&
                                    response[ky].data[s][key] != "")
                                ) {
                                  colsec4[key.toString().toLowerCase()] =
                                    response[ky].data[s][key];
                                }
                              }
                            }
                          }
                        }
                      }
                    }

                    // end getting response data into array

                    if (formId == 32) {
                      if (
                        coldate["date_created"] != null &&
                        coldate["date_created"] != ""
                      ) {
                        var date = new Date(coldate["date_created"]);
                        var day = date.getDate();
                        var month = date.getMonth() + 1;
                        var year = date.getFullYear();
                        var rand = this.getRandomInt(900000);
                        var sectionLenght = coldate["section_length"];
                        this.createdAt.push([
                          year + "-" + month + "-" + day,
                          sectionLenght,
                          sectionName,
                          cnt1++,
                        ]);
                      }

                      if (colsec1["name_of_sec_tank_designation_387"] != null) {
                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "11.1",
                          colsec1["name_of_sec_tank_designation_387"],
                        ]);
                        colsec1 = [];
                      } else {
                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "11.1",
                          "",
                        ]);
                        colsec1 = [];
                      }

                      this.userSign.push(usersign);

                      if (colsec2["m3_389"] != null) {
                        if (colsec2["textbox_388"] == null) {
                          colsec2["textbox_388"] = "0.00";
                        }
                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "11.2",
                          colsec2["textbox_388"] + " " + colsec2["m3_389"],
                        ]);
                        colsec2 = [];
                      } else {
                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "11.2",
                          "",
                        ]);
                      }

                      this.userSign.push(usersign);

                      if (colsec3["m3_391"] != null) {
                        if (colsec3["textbox_390"] == null) {
                          colsec3["textbox_390"] = "0.00";
                        }
                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "11.3",
                          colsec3["textbox_390"] + " " + colsec3["m3_391"],
                        ]);
                        colsec3 = [];
                      } else {
                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "11.3",
                          "",
                        ]);
                      }

                      this.userSign.push(usersign);

                      if (colsec4["m3_393"] != null) {
                        if (colsec4["textbox_392"] == null) {
                          colsec4["textbox_392"] = "0.00";
                        }
                        if (colsec4["collected_from_394"] == null) {
                          colsec4["collected_from_394"] = "";
                        }
                        if (colsec4["identification_of_source_456"] == null) {
                          colsec4["identification_of_source_456"] = "";
                        }
                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "11.4",
                          colsec4["textbox_392"] +
                          " " +
                          colsec4["m3_393"] +
                          "," +
                          colsec4["collected_from_394"] +
                          "," +
                          colsec4["identification_of_source_456"],
                        ]);
                        colsec4 = [];
                      } else {
                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "11.4",
                          "",
                        ]);
                      }
                      this.userSign.push(usersign);

                      if (colsec5["m3_396"] != null) {
                        if (colsec5["textbox_1_395"] == null) {
                          colsec5["textbox_1_395"] = "0.00";
                        }
                        if (colsec5["m3_396"] == null) {
                          colsec5["m3_396"] = "";
                        }
                        if (colsec5["sludge_from_397"] == null) {
                          colsec5["sludge_from_397"] = "";
                        }
                        if (
                          colsec5["name_of_sec__tank_designation_398"] == null
                        ) {
                          colsec5["name_of_sec__tank_designation_398"] = "";
                        }
                        if (colsec5["_399"] == null) {
                          colsec5["_399"] = "";
                        }
                        if (colsec5["textbox_2_400"] == null) {
                          colsec5["textbox_2_400"] = "0.00";
                        }
                        if (colsec5["m3_retained_to_401"] == null) {
                          colsec5["m3_retained_to_401"] = "";
                        }
                        if (
                          colsec5["name_of_sec_tank_designation_402"] == null
                        ) {
                          colsec5["name_of_sec_tank_designation_402"] = "";
                        }
                        if (colsec5["during_port_stay_403"] == null) {
                          colsec5["during_port_stay_403"] = "";
                        }
                        if (colsec5["name_of_port_404"] == null) {
                          colsec5["name_of_port_404"] = "";
                        }

                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "12.1",
                          colsec5["textbox_1_395"] +
                          " " +
                          colsec5["m3_396"] +
                          "," +
                          colsec5["sludge_from_397"] +
                          "," +
                          colsec5["name_of_sec__tank_designation_398"] +
                          "," +
                          colsec5["_399"] +
                          "," +
                          colsec5["textbox_2_400"] +
                          " " +
                          colsec5["m3_retained_to_401"] +
                          "," +
                          colsec5["name_of_sec_tank_designation_402"] +
                          "," +
                          colsec5["during_port_stay_403"] +
                          "," +
                          colsec5["name_of_port_404"],
                        ]);
                        colsec5 = [];
                      } else {
                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "12.1",
                          "",
                        ]);
                      }
                      this.userSign.push(usersign);

                      if (colsec6["m3_406"] != null) {
                        if (colsec6["textbox_1_405"] == null) {
                          colsec6["textbox_1_405"] = "0.00";
                        }
                        if (colsec6["water_drained_from_407"] == null) {
                          colsec6["water_drained_from_407"] = "";
                        }
                        if (
                          colsec6["name_of_sec_tank_designation_408"] == null
                        ) {
                          colsec6["name_of_sec_tank_designation_408"] = "";
                        }
                        if (colsec6["textbox_2_409"] == null) {
                          colsec6["textbox_2_409"] = "";
                        }
                        if (colsec6["m3_retained_to_410"] == null) {
                          colsec6["m3_retained_to_410"] = "";
                        }
                        if (
                          colsec6["name_of_sec_tank_designation_411"] == null
                        ) {
                          colsec6["name_of_sec_tank_designation_411"] = "";
                        }
                        if (colsec6["retained_in_tank_412"] == null) {
                          colsec6["retained_in_tank_412"] = "";
                        }
                        if (colsec6["textbox_3_413"] == null) {
                          colsec6["textbox_3_413"] = "0.00";
                        }
                        if (colsec6["m3_414"] == null) {
                          colsec6["m3_414"] = "";
                        }

                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "12.2",
                          colsec6["textbox_1_405"] +
                          " " +
                          colsec6["m3_406"] +
                          "," +
                          colsec6["water_drained_from_407"] +
                          "," +
                          colsec6["name_of_sec_tank_designation_408"] +
                          "," +
                          colsec6["textbox_2_409"] +
                          "," +
                          colsec6["m3_retained_to_410"] +
                          "," +
                          colsec6["name_of_sec_tank_designation_411"] +
                          "," +
                          colsec6["retained_in_tank_412"] +
                          "," +
                          colsec6["textbox_3_413"] +
                          " " +
                          colsec6["m3_414"],
                        ]);
                        colsec6 = [];
                      } else {
                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "12.2",
                          "",
                        ]);
                      }
                      this.userSign.push(usersign);

                      if (colsec7["m3_424"] != null) {
                        if (colsec7["textbox_1_415"] == null) {
                          colsec7["textbox_1_415"] = "0.00";
                        }
                        if (colsec7["sludge_from_419"] == null) {
                          colsec7["sludge_from_419"] = "";
                        }
                        if (colsec7["m3_417"] == null) {
                          colsec7["m3_417"] = "";
                        }
                        if (
                          colsec7["name_of_sec_tank_designation_420"] == null
                        ) {
                          colsec7["name_of_sec_tank_designation_420"] = "";
                        }
                        if (colsec7["textbox_2_423"] == null) {
                          colsec7["textbox_2_423"] = "0.00";
                        }
                        if (colsec7["textbox_3_426"] == null) {
                          colsec7["textbox_3_426"] = "";
                        }
                        if (colsec7["hours_427"] == null) {
                          colsec7["hours_427"] = "";
                        }

                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "12.3",
                          colsec7["textbox_1_415"] +
                          " " +
                          colsec7["m3_417"] +
                          "," +
                          colsec7["sludge_from_419"] +
                          "," +
                          colsec7["name_of_sec_tank_designation_420"] +
                          "," +
                          colsec7["textbox_2_423"] +
                          " " +
                          colsec7["m3_424"] +
                          "," +
                          colsec7["textbox_3_426"] +
                          "," +
                          colsec7["hours_427"],
                        ]);
                        colsec7 = [];
                      } else {
                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "12.3",
                          "",
                        ]);
                      }
                      this.userSign.push(usersign);

                      if (colsec8["m3_428"] != null) {
                        if (colsec8["textbox_1_416"] == null) {
                          colsec8["textbox_1_416"] = "0.00 ";
                        }
                        if (colsec8["m3_418"] == null) {
                          colsec8["m3_418"] = "";
                        }
                        if (colsec8["sludge_from_421"] == null) {
                          colsec8["sludge_from_421"] = "";
                        }
                        if (
                          colsec8["name _of_sec _tank _designation_422"] == null
                        ) {
                          colsec8["name _of_sec _tank _designation_422"] = "";
                        }
                        if (colsec8["textbox_2_425"] == null) {
                          colsec8["textbox_2_425"] = "0.00 ";
                        }
                        if (colsec8["textbox_3_429"] == null) {
                          colsec8["textbox_3_429"] = "";
                        }
                        if (colsec8["hours_430"] == null) {
                          colsec8["hours_430"] = "";
                        }

                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "12.4",
                          colsec8["textbox_1_416"] +
                          "" +
                          colsec8["m3_418"] +
                          "," +
                          colsec8["sludge_from_421"] +
                          "," +
                          colsec8["name _of_sec _tank _designation_422"] +
                          "" +
                          colsec8["textbox_2_425"] +
                          "," +
                          colsec8["m3_428"] +
                          "," +
                          colsec8["textbox_3_429"] +
                          "," +
                          colsec8["hours_430"],
                        ]);
                        colsec8 = [];
                      } else {
                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "12.4",
                          "",
                        ]);
                      }
                      this.userSign.push(usersign);

                      p = 0;
                    }

                    if (formId == 33) {
                      if (
                        coldate["date_created"] != null &&
                        coldate["date_created"] != ""
                      ) {
                        var date = new Date(coldate["date_created"]);
                        var day = date.getDate();
                        var month = date.getMonth() + 1;
                        var year = date.getFullYear();
                        var sectionLenght = coldate["section_length"];
                        this.createdAt.push([
                          year + "-" + month + "-" + day,
                          sectionLenght,
                          sectionName,
                          cnt2++,
                        ]);
                      }

                      if (colsec1["m3_432"] != null) {
                        if (colsec1["textbox_1_431"] == null) {
                          colsec1["textbox_1_431"] = "0.00";
                        }
                        if (colsec1["blige_water_from_433"] == null) {
                          colsec1["blige_water_from_433"] = "";
                        }
                        if (colsec1["engine_room_bilge_wells_435"] == null) {
                          colsec1["engine_room_bilge_wells_435"] = "";
                        }
                        if (colsec1["t_438"] == null) {
                          colsec1["t_438"] = "";
                        }
                        if (colsec1["textbox_2_440"] == null) {
                          colsec1["textbox_2_440"] = "";
                        }
                        if (colsec1["textbox_494"] == null) {
                          colsec1["textbox_494"] = "";
                        }
                        if (colsec1["textbox_1_431"] == null) {
                          colsec1["textbox_1_431"] = "";
                        }
                        if (colsec1["name of Port_495"] == null) {
                          colsec1["name of Port_495"] = "";
                        }
                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "13.0",
                          colsec1["textbox_1_431"] +
                          " " +
                          colsec1["m3_432"] +
                          " " +
                          colsec1["blige_water_from_433"] +
                          " " +
                          colsec1["engine_room_bilge_wells_435"] +
                          " " +
                          colsec1["t_438"] +
                          " " +
                          colsec1["textbox_2_440"] +
                          " " +
                          colsec1["na_442"] +
                          " " +
                          colsec1["textbox_494"] +
                          " " +
                          colsec1["name _of_ port_495"],
                        ]);
                        colsec1 = [];
                      } else {
                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "13.0",
                          "",
                        ]);
                      }
                      this.userSign.push(usersign);

                      if (colsec2["start_434"] != null) {
                        if (colsec2["stop_437"] == null) {
                          colsec2["stop_437"] = "";
                        }
                        if (colsec2["textbox_1_436"] == null) {
                          colsec2["textbox_1_436"] = "";
                        }
                        if (colsec2["textbox_2_439"] == null) {
                          colsec2["textbox_2_439"] = "";
                        }
                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "14.0",
                          colsec2["start_434"] +
                          "," +
                          colsec2["textbox_1_436"] +
                          "," +
                          colsec2["stop_437"] +
                          "," +
                          colsec2["textbox_2_439"],
                        ]);
                        colsec2 = [];
                      } else {
                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "14.0",
                          "",
                        ]);
                      }
                      this.userSign.push(usersign);

                      if (colsec3["through_441"] != null) {
                        if (colsec3["textbox_1_443"] == null) {
                          colsec3["textbox_1_443"] = "";
                        }
                        if (colsec3["ppm_474"] == null) {
                          colsec3["ppm_474"] = "";
                        }
                        if (colsec3["equipment_overboard_475"] == null) {
                          colsec3["equipment_overboard_475"] = "";
                        }
                        if (colsec3["position_start_476"] == null) {
                          colsec3["position_start_476"] = "";
                        }
                        if (colsec3["textbox_2_477"] == null) {
                          colsec3["textbox_2_477"] = "";
                        }
                        if (colsec3["deg_478"] == null) {
                          colsec3["deg_478"] = "";
                        }
                        if (colsec3["textbox_3_479"] == null) {
                          colsec3["textbox_3_479"] = "";
                        }
                        if (colsec3["min_480"] == null) {
                          colsec3["min_480"] = "";
                        }
                        if (colsec3["textbox_4_481"] == null) {
                          colsec3["textbox_4_481"] = "";
                        }
                        if (colsec3["deg_482"] == null) {
                          colsec3["deg_482"] = "";
                        }
                        if (colsec3["textbox_5_483"] == null) {
                          colsec3["textbox_5_483"] = "";
                        }

                        if (colsec3["min_484"] == null) {
                          colsec3["min_484"] = "";
                        }
                        if (colsec3["position_stop_485"] == null) {
                          colsec3["position_stop_485"] = "";
                        }
                        if (colsec3["textbox_5_483"] == null) {
                          colsec3["textbox_5_483"] = "";
                        }
                        if (colsec3["textbox_6_486"] == null) {
                          colsec3["textbox_6_486"] = "";
                        }

                        if (colsec3["deg_487"] == null) {
                          colsec3["deg_487"] = "";
                        }
                        if (colsec3["min_489"] == null) {
                          colsec3["min_489"] = "";
                        }
                        if (colsec3["textbox_8_490"] == null) {
                          colsec3["textbox_8_490"] = "";
                        }
                        if (colsec3["deg_491"] == null) {
                          colsec3["deg_491"] = "";
                        }
                        if (colsec3["textbox_9_492"] == null) {
                          colsec3["textbox_9_492"] = "";
                        }
                        if (colsec3["min_493"] == null) {
                          colsec3["min_493"] = "";
                        }

                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "15.1",
                          colsec3["through_441"] +
                          "," +
                          colsec3["textbox_1_443"] +
                          "," +
                          colsec3["ppm_474"] +
                          "," +
                          colsec3["equipment_overboard_475"] +
                          "," +
                          colsec3["position_start_476"] +
                          "," +
                          colsec3["textbox_2_477"] +
                          "," +
                          colsec3["deg_478"] +
                          "," +
                          colsec3["textbox_3_479"] +
                          "," +
                          colsec3["min_480"] +
                          "," +
                          colsec3["textbox_4_481"] +
                          "," +
                          colsec3["deg_482"] +
                          "," +
                          colsec3["textbox_5_483"] +
                          "," +
                          colsec3["min_484"] +
                          "," +
                          colsec3["position_stop_485"] +
                          "," +
                          colsec3["textbox_6_486"] +
                          "," +
                          colsec3["deg_487"] +
                          "," +
                          colsec3["min_489"] +
                          "," +
                          colsec3["textbox_8_490"] +
                          "," +
                          colsec3["deg_491"] +
                          "," +
                          colsec3["textbox_9_492"] +
                          "," +
                          colsec3["min_493"],
                        ]);
                        colsec3 = [];
                      } else {
                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "15.1",
                          "",
                        ]);
                      }
                      this.userSign.push(usersign);

                      if (colsec4["name_of_port_459"] != null) {
                        if (colsec4["name_of_port_459"] == null) {
                          colsec4["name_of_port_459"] = "";
                        }
                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "15.2",
                          colsec4["name_of_port_459"],
                        ]);
                        colsec4 = [];
                      } else {
                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "15.2",
                          "",
                        ]);
                      }
                      this.userSign.push(usersign);

                      if (colsec5["collected_in_460"] != null) {
                        if (
                          colsec5["name_of_sec_tank_designation_461"] == null
                        ) {
                          colsec5["name_of_sec_tank_designation_461"] = "";
                        }
                        if (colsec5["retained_in_tank_462"] == null) {
                          colsec5["retained_in_tank_462"] = "";
                        }
                        if (colsec5["textbox_1_463"] == null) {
                          colsec5["textbox_1_463"] = "0.00";
                        }
                        if (colsec5["m3_464"] == null) {
                          colsec5["m3_464"] = "";
                        }

                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "15.3",
                          colsec5["collected_in_460"] +
                          "," +
                          colsec5["name_of_sec_tank_designation_461"] +
                          "," +
                          colsec5["retained_in_tank_462"] +
                          "," +
                          colsec5["textbox_1_463"] +
                          " " +
                          colsec5["m3_464"],
                        ]);
                        colsec5 = [];
                      } else {
                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "15.3",
                          "",
                        ]);
                      }

                      this.userSign.push(usersign);

                      p = 0;
                    }

                    if (formId == 34) {
                      if (
                        coldate["date_created"] != null &&
                        coldate["date_created"] != ""
                      ) {
                        var date = new Date(coldate["date_created"]);
                        var day = date.getDate();
                        var month = date.getMonth() + 1;
                        var year = date.getFullYear();
                        var sectionLenght = coldate["section_length"];
                        this.createdAt.push([
                          year + "-" + month + "-" + day,
                          sectionLenght,
                          sectionName,
                          cnt3++,
                        ]);
                      }

                      if (colsec1["pump_start_496"] != null) {
                        if (colsec1["textbox_1_497"] == null) {
                          colsec1["textbox_1_497"] = "";
                        }
                        if (colsec1["at_498"] == null) {
                          colsec1["at_498"] = "";
                        }
                        if (colsec1["textbox_2_499"] == null) {
                          colsec1["textbox_2_499"] = "";
                        }
                        if (colsec1["deg_500"] == null) {
                          colsec1["deg_500"] = "";
                        }
                        if (colsec1["textbox_3_501"] == null) {
                          colsec1["textbox_3_501"] = "";
                        }
                        if (colsec1["min_502"] == null) {
                          colsec1["min_502"] = "";
                        }
                        if (colsec1["textbox_4_503"] == null) {
                          colsec1["textbox_4_503"] = "";
                        }
                        if (colsec1["deg_504"] == null) {
                          colsec1["deg_504"] = "";
                        }
                        if (colsec1["min_e/w_from_506"] == null) {
                          colsec1["min_e/w_from_506"] = "";
                        }
                        if (
                          colsec1["name_of_sec_tank_designation_507"] == null
                        ) {
                          colsec1["name_of_sec_tank_designation_507"] = "";
                        }

                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "16.0",
                          colsec1["pump_start_496"] +
                          "," +
                          colsec1["textbox_1_497"] +
                          "," +
                          colsec1["at_498"] +
                          "," +
                          colsec1["textbox_2_499"] +
                          "," +
                          colsec1["deg_500"] +
                          "," +
                          colsec1["textbox_3_501"] +
                          "," +
                          colsec1["min_502"] +
                          "," +
                          colsec1["textbox_4_503"] +
                          "," +
                          colsec1["deg_504"] +
                          "," +
                          colsec1["min_e/w_from_506"] +
                          "," +
                          colsec1["name_of_sec_tank_designation_507"],
                        ]);
                        colsec1 = [];
                      } else {
                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "16.0",
                          "",
                        ]);
                      }

                      this.userSign.push(usersign);

                      if (colsec2["transfer_start_508"] != null) {
                        if (colsec2["textbox_509"] == null) {
                          colsec2["textbox_509"] = "";
                        }
                        if (colsec2["to_510"] == null) {
                          colsec2["to_510"] = "";
                        }
                        if (
                          colsec2["name_of_sec_tank_designation_511"] == null
                        ) {
                          colsec2["name_of_sec_tank_designation_511"] = "";
                        }

                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "17.0",
                          colsec2["transfer_start_508"] +
                          "," +
                          colsec2["textbox_509"] +
                          "," +
                          colsec2["to_510"] +
                          "," +
                          colsec2["name_of_sec_tank_designation_511"],
                        ]);
                        colsec2 = [];
                      } else {
                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "17.0",
                          "",
                        ]);
                      }

                      this.userSign.push(usersign);

                      if (colsec3["stop_512"] != null) {
                        if (colsec3["textbox_513"] == null) {
                          colsec3["textbox_513"] = "";
                        }

                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "18.0",
                          colsec3["stop_512"] + "," + colsec3["textbox_513"],
                        ]);
                        colsec3 = [];
                      } else {
                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "18.0",
                          "",
                        ]);
                      }
                      this.userSign.push(usersign);
                      p = 0;
                    }

                    if (formId == 35) {
                      if (
                        coldate["date_created"] != null &&
                        coldate["date_created"] != ""
                      ) {
                        var date = new Date(coldate["date_created"]);
                        var day = date.getDate();
                        var month = date.getMonth() + 1;
                        var year = date.getFullYear();
                        var sectionLenght = coldate["section_length"];
                        this.createdAt.push([
                          year + "-" + month + "-" + day,
                          sectionLenght,
                          sectionName,
                          cnt4++,
                        ]);
                      }

                      if (colsec1["textbox_514"] != null) {
                        if (colsec1["textbox_514"] == null) {
                          colsec1["textbox_514"] = "";
                        }
                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "19.0",
                          colsec1["textbox_514"],
                        ]);
                        colsec1 = [];
                      } else {
                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "19.0",
                          "",
                        ]);
                      }

                      this.userSign.push(usersign);

                      if (colsec2["textbox_515"] != null) {
                        if (colsec2["textbox_515"] == null) {
                          colsec2["textbox_515"] = "";
                        }

                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "20.0",
                          colsec2["textbox_515"],
                        ]);
                        colsec2 = [];
                      } else {
                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "20.0",
                          "",
                        ]);
                      }

                      this.userSign.push(usersign);

                      if (colsec3["reason_for_failure_if_known_516"] != null) {
                        if (
                          colsec3["reason_for_failure_if_known_516"] == null
                        ) {
                          colsec3["reason_for_failure_if_known_516"] = "";
                        }
                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "21.0",
                          colsec3["reason_for_failure_if_known_516"],
                        ]);
                        colsec3 = [];
                      } else {
                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "21.0",
                          "",
                        ]);
                      }

                      this.userSign.push(usersign);
                      p = 0;
                    }

                    if (formId == 36) {
                      if (
                        coldate["date_created"] != null &&
                        coldate["date_created"] != ""
                      ) {
                        var date = new Date(coldate["date_created"]);
                        var day = date.getDate();
                        var month = date.getMonth() + 1;
                        var year = date.getFullYear();
                        var sectionLenght = coldate["section_length"];
                        this.createdAt.push([
                          year + "-" + month + "-" + day,
                          sectionLenght,
                          sectionName,
                          cnt5++,
                        ]);
                      }

                      if (colsec1["textbox_517"] != null) {
                        if (colsec1["textbox_517"] == null) {
                          colsec1["textbox_517"] = "";
                        }
                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "22.0",
                          colsec1["textbox_517"],
                        ]);
                        colsec1 = [];
                      } else {
                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "22.0",
                          "",
                        ]);
                      }
                      this.userSign.push(usersign);

                      if (colsec2["place_or_position_518"] != null) {
                        if (colsec2["textbox_1_519"] == null) {
                          colsec2["textbox_1_519"] = "";
                        }
                        if (colsec2["deg_520"] == null) {
                          colsec2["deg_520"] = "";
                        }
                        if (colsec2["textbox_2_521"] == null) {
                          colsec2["textbox_2_521"] = "";
                        }
                        if (colsec2["min_522"] == null) {
                          colsec2["min_522"] = "";
                        }

                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "23.0",
                          colsec2["place_or_position_518"] +
                          "," +
                          colsec2["textbox_1_519"] +
                          "," +
                          colsec2["deg_520"] +
                          "," +
                          colsec2["textbox_2_521"] +
                          "," +
                          colsec2["min_522"],
                        ]);
                        colsec2 = [];
                      } else {
                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "23.0",
                          "",
                        ]);
                      }

                      this.userSign.push(usersign);

                      if (colsec3["of_oily_residue_525"] != null) {
                        if (colsec3["quantity_524"] == null) {
                          colsec3["quantity_524"] = "";
                        }
                        if (colsec3["type_of_oil_523"] == null) {
                          colsec3["type_of_oil_523"] = "";
                        }
                        if (colsec3["of_oily_residue_525"] == null) {
                          colsec3["of_oily_residue_525"] = "";
                        }

                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "24.0",
                          colsec3["type_of_oil_523"] +
                          "," +
                          colsec3["quantity_524"] +
                          "," +
                          colsec3["of_oily_residue_525"],
                        ]);
                        colsec3 = [];
                      } else {
                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "24.0",
                          "",
                        ]);
                      }
                      this.userSign.push(usersign);

                      if (
                        colsec4["circumstances_of_the_discharge_526"] != null
                      ) {
                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "25.0",
                          colsec4["circumstances_of_the_discharge_526"],
                        ]);
                        colsec4 = [];
                      } else {
                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "25.0",
                          "",
                        ]);
                      }
                      this.userSign.push(usersign);

                      p = 0;
                    }

                    if (formId == 37) {
                      if (
                        coldate["date_created"] != null &&
                        coldate["date_created"] != ""
                      ) {
                        var date = new Date(coldate["date_created"]);
                        var day = date.getDate();
                        var month = date.getMonth() + 1;
                        var year = date.getFullYear();
                        var sectionLenght = coldate["section_length"];
                        this.createdAt.push([
                          year + "-" + month + "-" + day,
                          sectionLenght,
                          sectionName,
                          cnt6++,
                        ]);
                      }

                      if (colsec1["name_of_port_527"] != null) {
                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "26.1",
                          colsec1["name_of_port_527"],
                        ]);
                        colsec1 = [];
                      } else {
                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "26.1",
                          "",
                        ]);
                      }
                      this.userSign.push(usersign);

                      if (colsec2["start_528"] != null) {
                        if (colsec2["textbox_1_529"] == null) {
                          colsec2["textbox_1_529"] = "";
                        }
                        if (colsec2["textbox_2_530"] == null) {
                          colsec2["textbox_2_530"] = "";
                        }
                        if (colsec2["stop_531"] == null) {
                          colsec2["stop_531"] = "";
                        }
                        if (colsec2["textbox_3_532"] == null) {
                          colsec2["textbox_3_532"] = "";
                        }
                        if (colsec2["textbox_4_533"] == null) {
                          colsec2["textbox_4_533"] = "";
                        }

                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "26.2",
                          colsec2["start_528"] +
                          "," +
                          colsec2["textbox_1_529"] +
                          "," +
                          colsec2["textbox_2_530"] +
                          "," +
                          colsec2["stop_531"] +
                          "," +
                          colsec2["textbox_3_532"] +
                          "," +
                          colsec2["textbox_4_533"],
                        ]);
                        colsec2 = [];
                      } else {
                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "26.2",
                          "",
                        ]);
                      }
                      this.userSign.push(usersign);

                      if (colsec3["textbox_1_534"] != null) {
                        if (colsec3["mt_of_535"] == null) {
                          colsec3["mt_of_535"] = "";
                        }
                        if (colsec3["textbox_2_536"] == null) {
                          colsec3["textbox_2_536"] = "";
                        }
                        if (colsec3["textbox_3_537"] == null) {
                          colsec3["textbox_3_537"] = "";
                        }
                        if (colsec3["s_bunkered_in_tanks_538"] == null) {
                          colsec3["s_bunkered_in_tanks_538"] = "";
                        }
                        if (colsec3["textbox_4_539"] == null) {
                          colsec3["textbox_4_539"] = "";
                        }
                        if (colsec3["mt_added_to_540"] == null) {
                          colsec3["mt_added_to_540"] = "";
                        }
                        if (colsec3["tank_name_designation_541"] == null) {
                          colsec3["tank_name_designation_541"] = "";
                        }
                        if (colsec3["now_containing_542"] == null) {
                          colsec3["now_containing_542"] = "";
                        }
                        if (colsec3["textbox_5_543"] == null) {
                          colsec3["textbox_5_543"] = "";
                        }
                        if (colsec3["mt_544"] == null) {
                          colsec3["mt_544"] = "";
                        }

                        if (colsec3["textbox_6_555"] == null) {
                          colsec3["textbox_6_555"] = "";
                        }
                        if (colsec3["mt_added_to_556"] == null) {
                          colsec3["mt_added_to_556"] = "";
                        }
                        if (colsec3["tank_name_designation_557"] == null) {
                          colsec3["tank_name_designation_557"] = "";
                        }
                        if (colsec3["now_containing_558"] == null) {
                          colsec3["now_containing_558"] = "";
                        }
                        if (colsec3["textbox_7_559"] == null) {
                          colsec3["textbox_7_559"] = "";
                        }
                        if (colsec3["mt_560"] == null) {
                          colsec3["mt_560"] = "";
                        }

                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "26.3",
                          colsec3["textbox_1_534"] +
                          "," +
                          colsec3["mt_of_535"] +
                          "," +
                          colsec3["textbox_2_536"] +
                          "," +
                          colsec3["textbox_3_537"] +
                          "," +
                          colsec3["s_bunkered_in_tanks_538"] +
                          "," +
                          colsec3["textbox_4_539"] +
                          "," +
                          colsec3["mt_added_to_540"] +
                          "," +
                          colsec3["tank_name_designation_541"] +
                          "," +
                          colsec3["now_containing_542"] +
                          "," +
                          colsec3["textbox_5_543"] +
                          "," +
                          colsec3["mt_544"] +
                          "," +
                          colsec3["textbox_6_555"] +
                          "," +
                          colsec3["mt_added_to_556"] +
                          "," +
                          colsec3["tank_name_designation_557"] +
                          "," +
                          colsec3["now_containing_558"] +
                          "," +
                          colsec3["textbox_7_559"] +
                          "," +
                          colsec3["mt_560"],
                        ]);
                        colsec3 = [];
                      } else {
                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "26.3",
                          "",
                        ]);
                      }

                      this.userSign.push(usersign);

                      if (colsec4["mt_546"] != null) {
                        if (colsec4["mt_546"] == null) {
                          colsec4["mt_546"] = "";
                        }
                        if (colsec4["type_of_oil_547"] == null) {
                          colsec4["type_of_oil_547"] = "";
                        }
                        if (colsec4["bunkered_in_tanks_548"] == null) {
                          colsec4["bunkered_in_tanks_548"] = "";
                        }
                        if (colsec4["textbox_2_549"] == null) {
                          colsec4["textbox_2_549"] = "";
                        }
                        if (colsec4["mt_added_to_550"] == null) {
                          colsec4["mt_added_to_550"] = "";
                        }
                        if (colsec4["now_containing_552"] == null) {
                          colsec4["now_containing_552"] = "";
                        }
                        if (colsec4["textbox_3_553"] == null) {
                          colsec4["textbox_3_553"] = "";
                        }
                        if (colsec4["mt_554"] == null) {
                          colsec4["mt_554"] = "";
                        }
                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "26.4",
                          colsec4["textbox_1_545"] +
                          "," +
                          colsec4["mt_546"] +
                          "," +
                          colsec4["type_of_oil_547"] +
                          "," +
                          colsec4["bunkered_in_tanks_548"] +
                          "," +
                          colsec4["textbox_2_549"] +
                          "," +
                          colsec4["mt_added_to_550"] +
                          "," +
                          colsec4["tank_name_designation_551"] +
                          "," +
                          colsec4["now_containing_552"] +
                          "," +
                          colsec4["textbox_3_553"] +
                          "," +
                          colsec4["mt_554"],
                        ]);
                        colsec4 = [];
                      } else {
                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "26.4",
                          "",
                        ]);
                      }
                      this.userSign.push(usersign);
                      p = 0;
                    }

                    // end collection column data to make it tabular
                  }

                  // collection of data into seperate array to be used in html
                  // console.log("mylog::mylog");
                  this.createCollectionLayout(this.objcolsection);
                  this.objcolcollection.push([
                    this.objcolsection,
                    this.createdAt,
                  ]);
                  // console.log(this.objcolcollection);
                  this.objcolsection = [];
                  this.createdAt = [];
                }
              }
            }
          }
        );

        break;
      }
    }
  }

  callHTypeGarbeg(bname, hid, wid, sectionIndex) {
    this.currentBookName = bname;
    this.cleanReports();
    //alert(hid)
    if (hid == 36) {
      this.onSubReportPop(hid);
      //this.getFormdataAllforms(hid);
    } else if (hid == 42 || hid == 43) {
      this.onSubReportPop(hid);
      //this.callHTypeAudit(hid,wid,sectionIndex);
    } else if (hid == 44) {
      this.onSubReportPop(hid);
      //this.getFormdataAllformsDeckBook(hid);
    } else if (hid == 37) {
      this.onSubReportPop(hid);
      //this.getOrbPartTwoData(hid)
    } else if (hid == 49 || hid == "49-1" || hid == "49-2") {
      this.gmdss_log_book(hid);
    } else if (hid == "49-3") {
      this.onSubReportPop(hid);
      //this.callHTypeGarbegBallast(hid,wid,sectionIndex);
    } else {
      this.onSubReportPop(hid);
    }
  }

  onlyUnique(value, index, self) {
    return self.indexOf(value) === index;
  }

  modifyedData(response) {
    // console.log("==========modifyedData11============",response);
    for (let row in response.data) {
      response.data[row].rowId = response.data[row].rowId.replace("rowId", "");
    }
    // console.log("==========modifyedData22============",response.data);
    var groupedCollection = [];
    groupedCollection = _.sortBy(response.data, "timeStamp");
    groupedCollection = _.groupBy(groupedCollection, "rowId");
    // console.log("==========modifyedData33============",groupedCollection);
    response.data = [];
    var cnt = 0;
    let value = [];
    for (const [key, value] of Object.entries(groupedCollection)) {
      for (let arr in value) {
        if (value[arr].changeFields != null && value[arr].changeFields != "") {
          var changeControlIds = value[arr].changeFields.toString().split(",");
          for (let tey in value[arr]) {
            if (changeControlIds.indexOf(tey) != -1) {
              if (value.length > 1) {
                value[arr]["isDelete"] = "1";
              }
              if (value[parseInt(arr) - 1] != null) {
                value[parseInt(arr) - 1]["editedBy"] =
                  '<span class="box-edit-time">Edited On: ' +
                  value[parseInt(arr)].updated_at +
                  "<br> Edited By: " +
                  value[parseInt(arr)].userName +
                  "</span>";
                value[parseInt(arr) - 1][tey] =
                  "<strike>" +
                  value[parseInt(arr) - 1][tey] +
                  "</strike> &nbsp; <b>" +
                  value[parseInt(arr)][tey] +
                  "</b>";
              } else {
                value[parseInt(arr)]["editedBy"] =
                  '<span class="box-edit-time">Edited On: ' +
                  value[parseInt(arr)].updated_at +
                  "<br> Edited By: " +
                  value[parseInt(arr)].userName +
                  "</span>";
                value[parseInt(arr)][tey] =
                  "<b>" + value[parseInt(arr)][tey] + "</b>";
              }
            }
          }
        }

        response.data.push(value[arr]);
      }
    }


    console.log("==========modifyedData666 ============",response.data);
    return response;
  }

  callHTypeGarbegBallast(
    hid,
    actionDate = "",
    actionTime = "",
    fromDate = "",
    toDate = ""
  ) {
    if (hid == 39 || hid == 40 || hid == 47 || hid == 48) {
    } else {
      console.log("not found");
      return;
    }

    for (var i = 0; i < this.formBuilder.length; i++) {
      if (this.formBuilder[i].hid == hid) {
        this.formCount = [];

        for (
          var r = 0;
          r < this.formBuilder[i].formbuilderresponse.length;
          r++
        ) {
          var formId = this.formBuilder[i].formbuilderresponse[r].formId;

          // console.log("main array result");
          // console.log(this.formBuilder[i].formbuilderresponse[r]);

          if (
            (formId == 38 && hid == 39) ||
            (formId == 39 && hid == 40) ||
            (formId == 47 && hid == 47) ||
            (formId == 48 && hid == 48)
          ) {
            //alert(this.formBuilder[i].formbuilderresponse[r].formName + ' form Id' + formId );
            this.formCount.push(
              this.formBuilder[i].formbuilderresponse[r].formName
            );
            this.formBuilderSections = [];
            for (
              var u = 0;
              u <
              this.formBuilder[i].formbuilderresponse[r]
                .formbuildersectionnamelist.length;
              u++
            ) {
              this.formBuilderSections.push(
                this.formBuilder[i].formbuilderresponse[r]
                  .formbuildersectionnamelist[u]
              ); //.formbuilderlist
            }

            this.editlogbookformsService.getFormDetailsByActionDateAndTime(
              formId,
              this.voyageNo,
              actionDate,
              actionTime,
              fromDate,
              toDate,
              (formResponse) => {
                var response = this.modifyedData(formResponse[0]);
                // console.log("=======filter response========");
                // console.log(response);
                if (response.data != null) {
                  this.objcolsection = [];
                  this.objcol = [];
                  this.userSign = [];
                  this.showpop5 = 0;
                  this.showpop6 = 0;
                  this.showpop7 = 0;
                  this.showpop8 = 0;
                  for (var s = 0; s < response.data.length; s++) {
                    if (response.data[s].isDelete == "1") continue;
                    var findKey = false;
                    var sectionName = "";
                    var rowId = "";
                    var Id = "";

                    this.formDetails = [];
                    var colsec1 = [];
                    var colsec2 = [];
                    var colsec3 = [];
                    var colsec4 = [];
                    var colsec5 = [];
                    var colsec6 = [];
                    var coldate = [];
                    var changeSectionIds = [];
                    var sectionIdArray = [];
                    var changeControlIds = [];
                    var changeControlArray = [];
                    var rowId = "";
                    var sectionId = 0;
                    this.editedBy = "";
                    var usersign = "";
                    var signdate = "";
                    var masterName = "";
                    var masterSignature = "";
                    var roleId = "";
                    var roleName = "";
                    var id = "";
                    //clearing the rest record if row is edited
                    // console.log("===chanage value checking====");
                    if (response.data[s].editedBy != null) {
                      this.editedBy = response.data[s].editedBy;
                    }

                    usersign = response.data[s].userSign;

                    for (let key in response.data[s]) {
                      for (
                        var p = 0;
                        p < this.formBuilderSections.length;
                        p++
                      ) {
                        for (
                          var v = 0;
                          v <
                          this.formBuilderSections[p].formbuilderlist.length;
                          v++
                        ) {
                          //alert(key.toString().toLowerCase());
                          //console.log(key.toString().toLowerCase() + '-- field--' + this.formBuilderSections[p].formbuilderlist[v].fieldName.toString().toLowerCase() + '_' + this.formBuilderSections[p].formbuilderlist[v].fieldId.toString().toLowerCase());
                          if (
                            key.toString().toLowerCase() == "created_at" &&
                            response.data[s][key] != ""
                          ) {
                            coldate["date_created"] = response.data[s][key];
                            coldate[
                              "section_length"
                            ] = this.formBuilderSections.length;
                          }
                          if (
                            key.toString().toLowerCase() ==
                            this.formBuilderSections[p].formbuilderlist[
                              v
                            ].fieldName
                              .toString()
                              .toLowerCase()
                          ) {
                            //alert(key.toString().toLowerCase() + '-- field--' + this.formBuilderSections[p].formbuilderlist[v].fieldName.toString().toLowerCase());
                            sectionName = this.formBuilderSections[p]
                              .sectionName;
                            sectionId = this.formBuilderSections[p].sectionId;

                            if (formId == 38) {
                              if (
                                response.data[s].sectionId != null &&
                                response.data[s].sectionId != "" &&
                                response.data[s][key] != "" &&
                                sectionIdArray.length == 0
                              ) {
                                changeSectionIds = response.data[s].sectionId
                                  .toString()
                                  .split(",");
                                sectionIdArray = Array.from(
                                  new Set(changeSectionIds)
                                );

                                if (response.data[s].changeFields != null) {
                                  changeControlIds = response.data[
                                    s
                                  ].changeFields
                                    .toString()
                                    .split(",");
                                  changeControlArray = Array.from(
                                    new Set(changeControlIds)
                                  );
                                }

                                rowId =
                                  response.data[s].id +
                                  "-" +
                                  response.data[s].rowId;
                              }

                              if (
                                response.data[s].userSign != null &&
                                response.data[s].userSign != ""
                              ) {
                                usersign = response.data[s].userSign;
                              }

                              if (
                                response.data[s].date != null &&
                                response.data[s].date != ""
                              ) {
                                signdate = response.data[s].date;
                              }

                              if (
                                response.data[s].masterName != null &&
                                response.data[s].masterName != ""
                              ) {
                                masterName = response.data[s].masterName;
                              }

                              if (
                                response.data[s].masterSignature != null &&
                                response.data[s].masterSignature != ""
                              ) {
                                masterSignature =
                                  response.data[s].masterSignature;
                              }

                              if (
                                response.data[s].roleId != null &&
                                response.data[s].roleId != ""
                              ) {
                                roleId = response.data[s].roleId;
                              }

                              if (
                                response.data[s].roleName != null &&
                                response.data[s].roleName != ""
                              ) {
                                roleName = response.data[s].roleName;
                              }
                              if (
                                response.data[s]._id.$oid != null &&
                                response.data[s]._id.$oid != ""
                              ) {
                                id = response.data[s]._id.$oid;
                              }

                              this.masterSignature = masterSignature;
                              this.signdate = signdate;
                              this.roleName = roleName;
                              this.masterName = masterName;
                              this.id = id;
                              this.formId = formId;

                              this.garbegForm1 = 1;
                              if (p == 0) {
                                //Port_580,Facility_581,Name_of_ship_582 Remarks_596:remarks,'-':estimate amoutn inceinrated, '-':estimate amount discharged in cm3 (textbox_589+m3_590):estimate amount discharged in reception facility, categories_585:category,long_578:longitude, lat_576:latitude, textbox_562:date start, textbox_563:time start
                                if (
                                  (key.toString().toLowerCase() ==
                                    "Port_580".toLowerCase() &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Facility_581".toLowerCase() &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Name_of_ship_582".toLowerCase() &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "remarks_1094" &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() == "m3_590" &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "textbox_589" &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "categories_585" &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() == "long_578" &&
                                    response.data[s][key] != "") ||
                                  key.toString().toLowerCase() == "lat_576" ||
                                  key.toString().toLowerCase() ==
                                  "textbox_1_562" ||
                                  (key.toString().toLowerCase() ==
                                    "textbox_2_563" &&
                                    response.data[s][key] != "")
                                ) {
                                  colsec1[key.toString().toLowerCase()] =
                                    response.data[s][key];
                                }
                                //
                              }

                              if (p == 1) {
                                //remarks_630:remarks (textbox_626+m3_628):estimate amoutn inceinrated, '-':estimate amount discharged in cm3 ,'-':estimate amount discharged in reception facility, categories_622:category,long_612:longitude, lat_610:latitude ,long_617:longitude , lat_616:latitude, textbox_1_593:date start, textbox_2_594:time start,textbox_3_599:date end, textbox_4_601:time end
                                if (
                                  (key.toString().toLowerCase() ==
                                    "textbox_626" &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() == "m3_628" &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "remarks_630" &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "categories_622" &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() == "long_612" &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() == "lat_610" &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() == "long_617" &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() == "lat_616" &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "textbox_1_593" &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "textbox_2_594" &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "textbox_3_599" &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "textbox_4_601" &&
                                    response.data[s][key] != "")
                                ) {
                                  colsec2[key.toString().toLowerCase()] =
                                    response.data[s][key];
                                }
                              }
                              //
                              if (p == 2) {
                                //remarks_661:remarks '_':estimate amoutn inceinrated, 'textbox_658'+'m3_660':estimate amount discharged in cm3 ,'-':estimate amount discharged in reception facility, categories_653:category,long_643:longitude , lat_641:latitude, textbox_1_635:date start, textbox_2_636:time start
                                if (
                                  (key.toString().toLowerCase() ==
                                    "remarks_661" &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "textbox_658" &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() == "m3_660" &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "categories_653" &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() == "long_643" &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() == "lat_646" &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() == "long_648" &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() == "lat_641" &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "textbox_1_635" &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "textbox_2_636" &&
                                    response.data[s][key] != "")
                                ) {
                                  colsec3[key.toString().toLowerCase()] =
                                    response.data[s][key];
                                }
                                //
                              }

                              if (p == 3) {
                                //name_of_port_675, textarea_683:remarks ,textbox_680+m3_681:amount lost in  , categories_678:category,long_674:longitude , lat_673:latitude, textbox_1_666:date start, textbox_2_667:time start
                                if (
                                  (key.toString().toLowerCase() ==
                                    "name_of_port_675" &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "textarea_683" &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "textbox_680" &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() == "m3_681" &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "categories_678" &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() == "long_674" &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() == "lat_673" &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "water_depth_676" &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "textbox_1_666" &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "textbox_2_667" &&
                                    response.data[s][key] != "")
                                ) {
                                  colsec4[key.toString().toLowerCase()] =
                                    response.data[s][key];
                                }
                                //
                              }
                            }

                            if (formId == 39) {
                              if (
                                response.data[s].sectionId != null &&
                                response.data[s].sectionId != "" &&
                                response.data[s][key] != "" &&
                                sectionIdArray.length == 0
                              ) {
                                changeSectionIds = response.data[s].sectionId
                                  .toString()
                                  .split(",");
                                sectionIdArray = Array.from(
                                  new Set(changeSectionIds)
                                );

                                if (response.data[s].changeFields != null) {
                                  changeControlIds = response.data[
                                    s
                                  ].changeFields
                                    .toString()
                                    .split(",");
                                  changeControlArray = Array.from(
                                    new Set(changeControlIds)
                                  );
                                }
                              }

                              if (
                                response.data[s].date != null &&
                                response.data[s].date != ""
                              ) {
                                signdate = response.data[s].date;
                              }

                              if (
                                response.data[s].masterName != null &&
                                response.data[s].masterName != ""
                              ) {
                                masterName = response.data[s].masterName;
                              }

                              if (
                                response.data[s].masterSignature != null &&
                                response.data[s].masterSignature != ""
                              ) {
                                masterSignature =
                                  response.data[s].masterSignature;
                              }

                              if (
                                response.data[s].roleId != null &&
                                response.data[s].roleId != ""
                              ) {
                                roleId = response.data[s].roleId;
                              }

                              if (
                                response.data[s].roleName != null &&
                                response.data[s].roleName != ""
                              ) {
                                roleName = response.data[s].roleName;
                              }
                              if (
                                response.data[s]._id.$oid != null &&
                                response.data[s]._id.$oid != ""
                              ) {
                                id = response.data[s]._id.$oid;
                              }

                              this.masterSignature = masterSignature;
                              this.signdate = signdate;
                              this.roleName = roleName;
                              this.masterName = masterName;
                              this.id = id;
                              this.formId = formId;

                              this.garbegForm2 = 1;

                              if (p == 0) {
                                // '-':estimate amoutn inceinrated, '-':estimate amount discharged in (cm3) (textbox_3_586+m3_587):estimate amount discharged in reception , j_579:category,long_571:longitude, lat_570:latitude, textbox_1_566:date start, textbox_2_567:time start
                                if (
                                  (key.toString().toLowerCase() ==
                                    "textbox_3_586" &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() == "m3_587" &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() == "j_579" &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() == "long_571" &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() == "lat_570" &&
                                    response.data[s][key] != "") ||
                                  key.toString().toLowerCase() ==
                                  "textbox_1_566" ||
                                  key.toString().toLowerCase() ==
                                  "textbox_2_567"
                                ) {
                                  colsec1[key.toString().toLowerCase()] =
                                    response.data[s][key];
                                }
                                //
                              }

                              if (p == 1) {
                                //lat_689,long_690 : stop:lat_692,long_693 : textbox_3_695:remarks '-':estimate amoutn inceinrated, '(textbox_4_699+m3_700)':estimate amount discharged in cm3 ,'-':estimate amount discharged in reception facility, k_697:category,long_687:longitude , lat_686:latitude, textbox_1_633:date start
                                if (
                                  (key.toString().toLowerCase() == "lat_689" &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() == "long_690" &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() == "lat_692" &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() == "long_693" &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "textbox_3_695" &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "textbox_4_699" &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() == "m3_700" &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() == "k_697" &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() == "long_687" &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() == "lat_686" &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "textbox_1_633" &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "textbox_2_634" &&
                                    response.data[s][key] != "")
                                ) {
                                  colsec2[key.toString().toLowerCase()] =
                                    response.data[s][key];
                                }
                              }
                            }

                            if (formId == 47) {
                              if (
                                response.data[s].date != null &&
                                response.data[s].date != ""
                              ) {
                                signdate = response.data[s].date;
                              }

                              if (
                                response.data[s].masterName != null &&
                                response.data[s].masterName != ""
                              ) {
                                masterName = response.data[s].masterName;
                              }

                              if (
                                response.data[s].masterSignature != null &&
                                response.data[s].masterSignature != ""
                              ) {
                                masterSignature =
                                  response.data[s].masterSignature;
                              }

                              if (
                                response.data[s].roleId != null &&
                                response.data[s].roleId != ""
                              ) {
                                roleId = response.data[s].roleId;
                              }

                              if (
                                response.data[s].roleName != null &&
                                response.data[s].roleName != ""
                              ) {
                                roleName = response.data[s].roleName;
                              }
                              if (
                                response.data[s]._id.$oid != null &&
                                response.data[s]._id.$oid != ""
                              ) {
                                id = response.data[s]._id.$oid;
                              }

                              this.masterSignature = masterSignature;
                              this.signdate = signdate;
                              this.roleName = roleName;
                              this.masterName = masterName;
                              this.id = id;
                              this.formId = formId;

                              this.blstForm = 1;

                              if (p == 0) {
                                // volume_of_uptake_902/m3_903/date_891 / time_892 / location_893/lat_894/long_895/depth_900/Volume_of_uptake_902/Name_of_port_896/reception_facility_name_898
                                if (
                                  (key.toString().toLowerCase() == "m3_903" &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "remark_1091" &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "name_of_port_896" &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() == "date_891" &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() == "time_892" &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "location_893" &&
                                    response.data[s][key] != "") ||
                                  key.toString().toLowerCase() == "lat_894" ||
                                  (key.toString().toLowerCase() == "long_895" &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "depth_900" &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "estimated_volume_901" &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "reception_facility_name_898" &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "volume_of_uptake_902" &&
                                    response.data[s][key] != "")
                                ) {
                                  colsec1[key.toString().toLowerCase()] =
                                    response.data[s][key];
                                }
                                //
                              }

                              if (p == 1) {
                                // Date_905/time_906/Volume_circulated_or_treated_908/m3_909
                                if (
                                  (key.toString().toLowerCase() == "date_905" &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() == "time_906" &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "volume_circulated_or_treated_908" &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() == "yes_911" &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() == "no_912" &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "remark_1092" &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() == "m3_909" &&
                                    response.data[s][key] != "")
                                ) {
                                  colsec2[key.toString().toLowerCase()] =
                                    response.data[s][key];
                                }
                              }
                              //
                              if (p == 2) {
                                //date_914 / time_915/2_estimated_volume_923 /reception_facility_name_921/Name_of_port_919/location_916/lat_917/long_918/Volume_discharged_924/m3_925/remaining_volume_926/m3_927
                                if (
                                  (key.toString().toLowerCase() == "m3_927" &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "remaining_volume_926" &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() == "m3_925" &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() == "date_914" &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() == "time_915" &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "reception_facility_name_921" &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "location_916" &&
                                    response.data[s][key] != "") ||
                                  key.toString().toLowerCase() == "lat_917" ||
                                  (key.toString().toLowerCase() == "long_918" &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "2_estimated_volume_923" &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "name_of_port_919" &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() == "yes_929" &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() == "no_930" &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "remark_1093" &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "volume_discharged_924" &&
                                    response.data[s][key] != "")
                                ) {
                                  colsec3[key.toString().toLowerCase()] =
                                    response.data[s][key];
                                }
                                //
                              }

                              if (p == 3) {
                                //date_932/time_933/lat_935/long_936/date_938/time_939/lat_941/long_942/port/_944Name_of_port_945/Volume_discharged_947/m3_948/Volume_taken_up_949/m3_950
                                if (
                                  (key.toString().toLowerCase() == "date_932" &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() == "time_933" &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() == "lat_935" &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() == "long_936" &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "date _938" &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() == "time_939" &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() == "lat_941" &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() == "long_942" &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() == "port_944" &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "location_of_discharge_940" &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "name_of_port_945" &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "volume_discharge_947" &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() == "m3_948" &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "volume_taken_up_949" &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() == "m3_950" &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() == "yes_952" &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() == "no_953" &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "remark_1173" &&
                                    response.data[s][key] != "")
                                ) {
                                  colsec4[key.toString().toLowerCase()] =
                                    response.data[s][key];
                                }
                                //
                              }

                              if (p == 4) {
                                //date_955 / time_956 / port_958/Name_of_port_959/lat_960/long_961/Volume_964/m3_965/Circumstances_of_uptake_967/General_remarks_968
                                if (
                                  (key.toString().toLowerCase() == "date_955" &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() == "time_956" &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() == "port_958" &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "name_of_port_959" &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() == "lat_960" &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() == "long_961" &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "circumstances_of_uptake_967" &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "general_remarks_968" &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() == "long_961" &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() == "m3_965" &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() == "yes_970" &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() == "no_971" &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "volume_964" &&
                                    response.data[s][key] != "")
                                ) {
                                  colsec5[key.toString().toLowerCase()] =
                                    response.data[s][key];
                                }
                                //
                              }

                              if (p == 5) {
                                //operational_procedure_972/General_remarks_973
                                if (
                                  (key.toString().toLowerCase() ==
                                    "operational_procedure_972" &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "general_remarks_973" &&
                                    response.data[s][key] != "")
                                ) {
                                  colsec6[key.toString().toLowerCase()] =
                                    response.data[s][key];
                                }
                                //
                              }
                            }

                            if (formId == 48) {
                              if (
                                response.data[s].date != null &&
                                response.data[s].date != ""
                              ) {
                                signdate = response.data[s].date;
                              }

                              if (
                                response.data[s].masterName != null &&
                                response.data[s].masterName != ""
                              ) {
                                masterName = response.data[s].masterName;
                              }

                              if (
                                response.data[s].masterSignature != null &&
                                response.data[s].masterSignature != ""
                              ) {
                                masterSignature =
                                  response.data[s].masterSignature;
                              }

                              if (
                                response.data[s].roleId != null &&
                                response.data[s].roleId != ""
                              ) {
                                roleId = response.data[s].roleId;
                              }

                              if (
                                response.data[s].roleName != null &&
                                response.data[s].roleName != ""
                              ) {
                                roleName = response.data[s].roleName;
                              }
                              if (
                                response.data[s]._id.$oid != null &&
                                response.data[s]._id.$oid != ""
                              ) {
                                id = response.data[s]._id.$oid;
                              }

                              this.masterSignature = masterSignature;
                              this.signdate = signdate;
                              this.roleName = roleName;
                              this.masterName = masterName;
                              this.id = id;
                              this.formId = formId;

                              this.oilnozoneForm = 1;

                              if (p == 1) {
                                // volume_of_uptake_902/m3_903/date_891 / time_892 / location_893/lat_894/long_895/depth_900/Volume_of_uptake_902/Name_of_port_896/reception_facility_name_898
                                if (
                                  (key.toString().toLowerCase() ==
                                    "Date_of_Bunkering_975"
                                      .toString()
                                      .toLowerCase() &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Bunker_Deliver_note_Ref_No_976"
                                      .toString()
                                      .toLowerCase() &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Supplier_978".toString().toLowerCase() &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Name_of_Supplier_979"
                                      .toString()
                                      .toLowerCase() &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "MARPOL_Sample_Seat_no_980"
                                      .toString()
                                      .toLowerCase() &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Yes_982".toString().toLowerCase() &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "No_983".toString().toLowerCase() &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Supplier_checkbox_985"
                                      .toString()
                                      .toLowerCase() &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Date_sample_destroyed_988"
                                      .toString()
                                      .toLowerCase() &&
                                    response.data[s][key] != "")
                                ) {
                                  colsec1[key.toString().toLowerCase()] =
                                    response.data[s][key];
                                }
                                //
                              }

                              if (p == 2) {
                                //Date_of_custody_transfer_993
                                if (
                                  (key.toString().toLowerCase() ==
                                    "Bunker_Deliver_note_ref_no_990"
                                      .toString()
                                      .toLowerCase() &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "MARPOL_Sample_Seat_no_991"
                                      .toString()
                                      .toLowerCase() &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Port_of_custody_transfer_992"
                                      .toString()
                                      .toLowerCase() &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Date_of_custody_transfer_993"
                                      .toString()
                                      .toLowerCase() &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Reciever_name_994"
                                      .toString()
                                      .toLowerCase() &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Reciever_Address_995"
                                      .toString()
                                      .toLowerCase() &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Receiver_Contact_996"
                                      .toString()
                                      .toLowerCase() &&
                                    response.data[s][key] != "")
                                ) {
                                  colsec2[key.toString().toLowerCase()] =
                                    response.data[s][key];
                                }
                              }
                              //
                              if (p == 3) {
                                if (
                                  (key.toString().toLowerCase() ==
                                    "Bunker_Delivery_Note_Ref_997"
                                      .toString()
                                      .toLowerCase() &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Port_Name_998".toString().toLowerCase() &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Delivery_Date_999"
                                      .toString()
                                      .toLowerCase() &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Fuel_specification_1000"
                                      .toString()
                                      .toLowerCase() &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Fuel_Type_1001".toString().toLowerCase() &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Sulphur_1002".toString().toLowerCase() &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "t_1003".toString().toLowerCase() &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "t_1004".toString().toLowerCase() &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Location_when_bunkered_1005"
                                      .toString()
                                      .toLowerCase() &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Quantity_1007".toString().toLowerCase() &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Tank_No_1006".toString().toLowerCase() &&
                                    response.data[s][key] != "")
                                ) {
                                  colsec3[key.toString().toLowerCase()] =
                                    response.data[s][key];
                                }
                                //
                              }

                              if (p == 4) {
                                if (
                                  (key.toString().toLowerCase() ==
                                    "in_CO_to_LSF_1009"
                                      .toString()
                                      .toLowerCase() &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Date1_1010".toString().toLowerCase() &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Time1_1011".toString().toLowerCase() &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Position_1012".toString().toLowerCase() &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "LAT_1013".toString().toLowerCase() &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "LONG_1014".toString().toLowerCase() &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Complete_CO_to_LSF_1015"
                                      .toString()
                                      .toLowerCase() &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "DATE_1016".toString().toLowerCase() &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "TIME_1017".toString().toLowerCase() &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "POSITION_1018".toString().toLowerCase() &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "LAT_1019".toString().toLowerCase() &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "LONG_1020".toString().toLowerCase() &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Fuel_Type_1021".toString().toLowerCase() &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Tank_1022".toString().toLowerCase() &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Volume_of_LSF_after_completion_1023"
                                      .toString()
                                      .toLowerCase() &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "m3_1024".toString().toLowerCase() &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Regulated_Area_Entry_1025"
                                      .toString()
                                      .toLowerCase() &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Date_1026".toString().toLowerCase() &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Time_1027".toString().toLowerCase() &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Position_1028".toString().toLowerCase() &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "LAT_1029".toString().toLowerCase() &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "LONG_1030".toString().toLowerCase() &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Regulated_Area_Exit_1031"
                                      .toString()
                                      .toLowerCase() &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Date_1032".toString().toLowerCase() &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Time_1033".toString().toLowerCase() &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Position_1034".toString().toLowerCase() &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "LAT_1035".toString().toLowerCase() &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "LONG_1036".toString().toLowerCase() &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Begin_CO_to_HSF_1037"
                                      .toString()
                                      .toLowerCase() &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Date_1038".toString().toLowerCase() &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Time_1039".toString().toLowerCase() &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Position_1040".toString().toLowerCase() &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "LAT_1041".toString().toLowerCase() &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "LONG_1042".toString().toLowerCase() &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Complete_CO_to_HSF_1043"
                                      .toString()
                                      .toLowerCase() &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Date_1044".toString().toLowerCase() &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Time_1045".toString().toLowerCase() &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Postion_1046".toString().toLowerCase() &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "LAT_1047".toString().toLowerCase() &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "LONG_1048".toString().toLowerCase() &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Fuel_Type_2_1049"
                                      .toString()
                                      .toLowerCase() &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Tank2_1050".toString().toLowerCase() &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Volume_of_LSF_after_completion_of_CO_2_1051"
                                      .toString()
                                      .toLowerCase() &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "m3_2_1052".toString().toLowerCase() &&
                                    response.data[s][key] != "")
                                ) {
                                  colsec4[key.toString().toLowerCase()] =
                                    response.data[s][key];
                                }
                                //
                              }

                              if (p == 5) {
                                if (
                                  (key.toString().toLowerCase() ==
                                    "ODS_Name_1053".toString().toLowerCase() &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Equipment_name_1054"
                                      .toString()
                                      .toLowerCase() &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Capapcity_1055".toString().toLowerCase() &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "kg_1056".toString().toLowerCase() &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Recharge_1057".toString().toLowerCase() &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Full_recharge_1058"
                                      .toString()
                                      .toLowerCase() &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Partial_recharge_1059"
                                      .toString()
                                      .toLowerCase() &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "ODS_charged_mass_1060"
                                      .toString()
                                      .toLowerCase() &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "kg1_1061".toString().toLowerCase() &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Description_Of_repair_or_maintenanace_carried_out_1062"
                                      .toString()
                                      .toLowerCase() &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Discharge_of_ODS_to_atmosphere_1063"
                                      .toString()
                                      .toLowerCase() &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "State_1064".toString().toLowerCase() &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Deliberate_1065"
                                      .toString()
                                      .toLowerCase() &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Non-deliberate_1066"
                                      .toString()
                                      .toLowerCase() &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Volume_of_LSF_after_completion_1023"
                                      .toString()
                                      .toLowerCase() &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Mass_1067".toString().toLowerCase() &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Kg3_1068".toString().toLowerCase() &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Discharge_of_ods_to_shore_reception_facility_1069"
                                      .toString()
                                      .toLowerCase() &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Name_of_reception_facility_1070"
                                      .toString()
                                      .toLowerCase() &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Address_of_reception_facility_1071"
                                      .toString()
                                      .toLowerCase() &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "LAT_1029".toString().toLowerCase() &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "LONG_1030".toString().toLowerCase() &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Regulated_Area_Exit_1031"
                                      .toString()
                                      .toLowerCase() &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Mass3_1072".toString().toLowerCase() &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Kg3_1073".toString().toLowerCase() &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "ods_received_on_board_1074"
                                      .toString()
                                      .toLowerCase() &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "ODS_name_1075".toString().toLowerCase() &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Port_name_1076".toString().toLowerCase() &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Date_1077".toString().toLowerCase() &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Mass5_1078".toString().toLowerCase() &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Kg5_1079".toString().toLowerCase() &&
                                    response.data[s][key] != "")
                                ) {
                                  colsec5[key.toString().toLowerCase()] =
                                    response.data[s][key];
                                }
                                //
                              }
                            }
                          }
                        }
                      }
                    }

                    if (formId == 48) {
                      if (
                        coldate["date_created"] != null &&
                        coldate["date_created"] != ""
                      ) {
                        var date = new Date(coldate["date_created"]);
                        var day = date.getDate();
                        var month = date.getMonth() + 1;
                        var year = date.getFullYear();

                        var sectionLenght = coldate["section_length"];
                        this.createdAt.push([
                          year + "-" + month + "-" + day,
                          sectionLenght,
                        ]);
                      }

                      if (
                        colsec1["Supplier_978".toString().toLowerCase()] !=
                        null &&
                        colsec1["yes_982".toString().toLowerCase()] != ""
                      ) {
                        if (
                          colsec1[
                          "Date_of_Bunkering_975".toString().toLowerCase()
                          ] == null
                        ) {
                          colsec1[
                            "Date_of_Bunkering_975".toString().toLowerCase()
                          ] = "";
                        }
                        if (
                          colsec1[
                          "Bunker_Deliver_note_Ref_No_976"
                            .toString()
                            .toLowerCase()
                          ] == null
                        ) {
                          colsec1[
                            "Bunker_Deliver_note_Ref_No_976"
                              .toString()
                              .toLowerCase()
                          ] = "";
                        }
                        if (
                          colsec1[
                          "Name_of_Supplier_979".toString().toLowerCase()
                          ] == null
                        ) {
                          colsec1[
                            "Name_of_Supplier_979".toString().toLowerCase()
                          ] = "";
                        }
                        if (
                          colsec1["Supplier_978".toString().toLowerCase()] ==
                          null
                        ) {
                          colsec1["Supplier_978".toString().toLowerCase()] = "";
                        }
                        if (
                          colsec1[
                          "MARPOL_Sample_Seat_no_980".toString().toLowerCase()
                          ] == null
                        ) {
                          colsec1[
                            "MARPOL_Sample_Seat_no_980".toString().toLowerCase()
                          ] = "";
                        }
                        if (
                          colsec1["Yes_982".toString().toLowerCase()] == null
                        ) {
                          colsec1["Yes_982".toString().toLowerCase()] = "";
                        }
                        if (
                          colsec1["No_983".toString().toLowerCase()] == null
                        ) {
                          colsec1["No_983".toString().toLowerCase()] = "";
                        }
                        if (
                          colsec1[
                          "Supplier_checkbox_985".toString().toLowerCase()
                          ] == null
                        ) {
                          colsec1[
                            "Supplier_checkbox_985".toString().toLowerCase()
                          ] = "";
                        }
                        if (
                          colsec1[
                          "Date_sample_destroyed_988".toString().toLowerCase()
                          ] == null
                        ) {
                          colsec1[
                            "Date_sample_destroyed_988".toString().toLowerCase()
                          ] = "";
                        }

                        this.fSection1.push([
                          colsec1[
                          "Date_of_Bunkering_975".toString().toLowerCase()
                          ],
                          colsec1[
                          "Bunker_Deliver_note_Ref_No_976"
                            .toString()
                            .toLowerCase()
                          ],
                          colsec1[
                          "Name_of_Supplier_979".toString().toLowerCase()
                          ],
                          colsec1[
                          "MARPOL_Sample_Seat_no_980".toString().toLowerCase()
                          ],
                          colsec1["Yes_982".toString().toLowerCase()],
                          colsec1[
                          "Supplier_checkbox_985".toString().toLowerCase()
                          ],
                          colsec1[
                          "Date_sample_destroyed_988".toString().toLowerCase()
                          ],
                        ]);
                        this.userSign.push(usersign);
                      } else if (
                        colsec1["Supplier_978".toString().toLowerCase()] !=
                        null &&
                        colsec1["no_983".toString().toLowerCase()] != ""
                      ) {
                        if (
                          colsec1[
                          "Date_of_Bunkering_975".toString().toLowerCase()
                          ] == null
                        ) {
                          colsec1[
                            "Date_of_Bunkering_975".toString().toLowerCase()
                          ] = "";
                        }
                        if (
                          colsec1[
                          "Bunker_Deliver_note_Ref_No_976"
                            .toString()
                            .toLowerCase()
                          ] == null
                        ) {
                          colsec1[
                            "Bunker_Deliver_note_Ref_No_976"
                              .toString()
                              .toLowerCase()
                          ] = "";
                        }
                        if (
                          colsec1[
                          "Name_of_Supplier_979".toString().toLowerCase()
                          ] == null
                        ) {
                          colsec1[
                            "Name_of_Supplier_979".toString().toLowerCase()
                          ] = "";
                        }
                        if (
                          colsec1["Supplier_978".toString().toLowerCase()] ==
                          null
                        ) {
                          colsec1["Supplier_978".toString().toLowerCase()] = "";
                        }
                        if (
                          colsec1[
                          "MARPOL_Sample_Seat_no_980".toString().toLowerCase()
                          ] == null
                        ) {
                          colsec1[
                            "MARPOL_Sample_Seat_no_980".toString().toLowerCase()
                          ] = "";
                        }

                        if (
                          colsec1["Yes_982".toString().toLowerCase()] == null
                        ) {
                          colsec1["Yes_982".toString().toLowerCase()] = "";
                        }
                        if (
                          colsec1["No_983".toString().toLowerCase()] == null
                        ) {
                          colsec1["No_983".toString().toLowerCase()] = "";
                        }
                        if (
                          colsec1[
                          "Supplier_checkbox_985".toString().toLowerCase()
                          ] == null
                        ) {
                          colsec1[
                            "Supplier_checkbox_985".toString().toLowerCase()
                          ] = "";
                        }
                        if (
                          colsec1[
                          "Date_sample_destroyed_988".toString().toLowerCase()
                          ] == null
                        ) {
                          colsec1[
                            "Date_sample_destroyed_988".toString().toLowerCase()
                          ] = "";
                        }

                        this.fSection1.push([
                          colsec1[
                          "Date_of_Bunkering_975".toString().toLowerCase()
                          ],
                          colsec1[
                          "Bunker_Deliver_note_Ref_No_976"
                            .toString()
                            .toLowerCase()
                          ],
                          colsec1[
                          "Name_of_Supplier_979".toString().toLowerCase()
                          ],
                          colsec1[
                          "MARPOL_Sample_Seat_no_980".toString().toLowerCase()
                          ],
                          colsec1["No_983".toString().toLowerCase()],
                          colsec1[
                          "Supplier_checkbox_985".toString().toLowerCase()
                          ],
                          colsec1[
                          "Date_sample_destroyed_988".toString().toLowerCase()
                          ],
                        ]);
                        this.userSign.push(usersign);
                      }

                      if (
                        colsec2[
                        "Bunker_Deliver_note_ref_no_990"
                          .toString()
                          .toLowerCase()
                        ] != null &&
                        colsec2[
                        "Bunker_Deliver_note_ref_no_990"
                          .toString()
                          .toLowerCase()
                        ] != ""
                      ) {
                        if (
                          colsec2[
                          "MARPOL_Sample_Seat_no_991".toString().toLowerCase()
                          ] == null
                        ) {
                          colsec2[
                            "MARPOL_Sample_Seat_no_991".toString().toLowerCase()
                          ] = "";
                        }
                        if (
                          colsec2[
                          "Port_of_custody_transfer_992"
                            .toString()
                            .toLowerCase()
                          ] == null
                        ) {
                          colsec2[
                            "Port_of_custody_transfer_992"
                              .toString()
                              .toLowerCase()
                          ] = "";
                        }
                        if (
                          colsec2[
                          "Date_of_custody_transfer_993"
                            .toString()
                            .toLowerCase()
                          ] == null
                        ) {
                          colsec2[
                            "Date_of_custody_transfer_993"
                              .toString()
                              .toLowerCase()
                          ] = "";
                        }
                        if (
                          colsec2[
                          "Reciever_name_994".toString().toLowerCase()
                          ] == null
                        ) {
                          colsec2[
                            "Reciever_name_994".toString().toLowerCase()
                          ] = "";
                        }
                        if (
                          colsec2[
                          "Reciever_Address_995".toString().toLowerCase()
                          ] == null
                        ) {
                          colsec2[
                            "Reciever_Address_995".toString().toLowerCase()
                          ] = "";
                        }
                        if (
                          colsec2[
                          "Receiver_Contact_996".toString().toLowerCase()
                          ] == null
                        ) {
                          colsec2[
                            "Receiver_Contact_996".toString().toLowerCase()
                          ] = "";
                        }

                        this.fSection2.push([
                          colsec2[
                          "Bunker_Deliver_note_ref_no_990"
                            .toString()
                            .toLowerCase()
                          ],
                          colsec2[
                          "MARPOL_Sample_Seat_no_991".toString().toLowerCase()
                          ],
                          colsec2[
                          "Port_of_custody_transfer_992"
                            .toString()
                            .toLowerCase()
                          ],
                          colsec2[
                          "Date_of_custody_transfer_993"
                            .toString()
                            .toLowerCase()
                          ],

                          colsec2["Reciever_name_994".toString().toLowerCase()],
                          colsec2[
                          "Reciever_Address_995".toString().toLowerCase()
                          ],
                          colsec2[
                          "Receiver_Contact_996".toString().toLowerCase()
                          ],
                        ]);
                        this.userSign.push(usersign);
                      }

                      if (
                        colsec3[
                        "Bunker_Delivery_Note_Ref_997"
                          .toString()
                          .toLowerCase()
                        ] != null &&
                        colsec3[
                        "Bunker_Delivery_Note_Ref_997"
                          .toString()
                          .toLowerCase()
                        ] != ""
                      ) {
                        if (
                          colsec3["Port_Name_998".toString().toLowerCase()] ==
                          null
                        ) {
                          colsec3["Port_Name_998".toString().toLowerCase()] =
                            "";
                        }
                        if (
                          colsec3[
                          "Delivery_Date_999".toString().toLowerCase()
                          ] == null
                        ) {
                          colsec3[
                            "Delivery_Date_999".toString().toLowerCase()
                          ] = "";
                        }
                        if (
                          colsec3[
                          "Fuel_specification_1000".toString().toLowerCase()
                          ] == null
                        ) {
                          colsec3[
                            "Fuel_specification_1000".toString().toLowerCase()
                          ] = "";
                        }
                        if (
                          colsec3["Fuel_Type_1001".toString().toLowerCase()] ==
                          null
                        ) {
                          colsec3["Fuel_Type_1001".toString().toLowerCase()] =
                            "";
                        }
                        if (
                          colsec3["Sulphur_1002".toString().toLowerCase()] ==
                          null
                        ) {
                          colsec3["Sulphur_1002".toString().toLowerCase()] = "";
                        }
                        if (
                          colsec3["t_1003".toString().toLowerCase()] == null
                        ) {
                          colsec3["t_1003".toString().toLowerCase()] = "";
                        }
                        if (
                          colsec3["t_1004".toString().toLowerCase()] == null
                        ) {
                          colsec3["t_1004".toString().toLowerCase()] = "";
                        }
                        if (
                          colsec3[
                          "Location_when_bunkered_1005"
                            .toString()
                            .toLowerCase()
                          ] == null
                        ) {
                          colsec3[
                            "Location_when_bunkered_1005"
                              .toString()
                              .toLowerCase()
                          ] = "";
                        }
                        if (
                          colsec3["Tank_No_1006".toString().toLowerCase()] ==
                          null
                        ) {
                          colsec3["Tank_No_1006".toString().toLowerCase()] = "";
                        }
                        if (
                          colsec3["Quantity_1007".toString().toLowerCase()] ==
                          null
                        ) {
                          colsec3["Quantity_1007".toString().toLowerCase()] =
                            "";
                        }

                        // Bunker_Delivery_Note_Ref_997,(Port_Name_998 + Delivery_Date_999),Fuel_Type_1001,t_1003,Tank_No_1006,Quantity_1007
                        this.fSection3.push([
                          colsec3[
                          "Bunker_Delivery_Note_Ref_997"
                            .toString()
                            .toLowerCase()
                          ],
                          colsec3["Port_Name_998".toString().toLowerCase()] +
                          " " +
                          colsec3[
                          "Delivery_Date_999".toString().toLowerCase()
                          ],
                          //colsec3['Fuel_specification_1000'.toString().toLowerCase()] ,
                          colsec3["Fuel_Type_1001".toString().toLowerCase()],
                          //colsec3['Sulphur_1002'.toString().toLowerCase()] ,
                          colsec3["t_1003".toString().toLowerCase()],
                          //colsec3[   't_1004'.toString().toLowerCase()] ,
                          //colsec3['Location_when_bunkered_1005'.toString().toLowerCase()] ,
                          colsec3["Tank_No_1006".toString().toLowerCase()],
                          colsec3["Quantity_1007".toString().toLowerCase()],
                        ]);
                        this.userSign.push(usersign);
                      }

                      if (
                        colsec4["Date1_1010".toString().toLowerCase()] !=
                        null &&
                        colsec4["Date1_1010".toString().toLowerCase()] != ""
                      ) {
                        if (
                          colsec4["Date1_1010".toString().toLowerCase()] == null
                        ) {
                          colsec4["Date1_1010".toString().toLowerCase()] = "";
                        }
                        if (
                          colsec4["Time1_1011".toString().toLowerCase()] == null
                        ) {
                          colsec4["Time1_1011".toString().toLowerCase()] = "";
                        }
                        if (
                          colsec4["Position_1012".toString().toLowerCase()] ==
                          null
                        ) {
                          colsec4["Position_1012".toString().toLowerCase()] =
                            "";
                        }
                        if (
                          colsec4["LAT_1013".toString().toLowerCase()] == null
                        ) {
                          colsec4["LAT_1013".toString().toLowerCase()] = "";
                        }
                        if (
                          colsec4["LONG_1014".toString().toLowerCase()] == null
                        ) {
                          colsec4["LONG_1014".toString().toLowerCase()] = "";
                        }
                        if (
                          colsec4["DATE_1016".toString().toLowerCase()] == null
                        ) {
                          colsec4["DATE_1016".toString().toLowerCase()] = "";
                        }
                        if (
                          colsec4["TIME_1017".toString().toLowerCase()] == null
                        ) {
                          colsec4["TIME_1017".toString().toLowerCase()] = "";
                        }
                        if (
                          colsec4["POSITION_1018".toString().toLowerCase()] ==
                          null
                        ) {
                          colsec4["POSITION_1018".toString().toLowerCase()] =
                            "";
                        }
                        if (
                          colsec4["LAT_1019".toString().toLowerCase()] == null
                        ) {
                          colsec4["LAT_1019".toString().toLowerCase()] = "";
                        }
                        if (
                          colsec4["LONG_1020".toString().toLowerCase()] == null
                        ) {
                          colsec4["LONG_1020".toString().toLowerCase()] = "";
                        }
                        if (
                          colsec4["Fuel_Type_1021".toString().toLowerCase()] ==
                          null
                        ) {
                          colsec4["Fuel_Type_1021".toString().toLowerCase()] =
                            "";
                        }
                        if (
                          colsec4["Tank_1022".toString().toLowerCase()] == null
                        ) {
                          colsec4["Tank_1022".toString().toLowerCase()] = "";
                        }
                        if (
                          colsec4[
                          "Volume_of_LSF_after_completion_1023"
                            .toString()
                            .toLowerCase()
                          ] == null
                        ) {
                          colsec4[
                            "Volume_of_LSF_after_completion_1023"
                              .toString()
                              .toLowerCase()
                          ] = "";
                        }
                        if (
                          colsec4[
                          "in_CO_to_LSF_1009".toString().toLowerCase()
                          ] == null
                        ) {
                          colsec4[
                            "in_CO_to_LSF_1009".toString().toLowerCase()
                          ] = "";
                        }
                        if (
                          colsec4[
                          "Regulated_Area_Entry_1025".toString().toLowerCase()
                          ] == null
                        ) {
                          colsec4[
                            "Regulated_Area_Entry_1025".toString().toLowerCase()
                          ] = "";
                        }
                        if (
                          colsec4["Date_1026".toString().toLowerCase()] == null
                        ) {
                          colsec4["Date_1026".toString().toLowerCase()] = "";
                        }
                        if (
                          colsec4["Time_1027".toString().toLowerCase()] == null
                        ) {
                          colsec4["Time_1027".toString().toLowerCase()] = "";
                        }
                        if (
                          colsec4["Position_1028".toString().toLowerCase()] ==
                          null
                        ) {
                          colsec4["Position_1028".toString().toLowerCase()] =
                            "";
                        }
                        if (
                          colsec4["LAT_1029".toString().toLowerCase()] == null
                        ) {
                          colsec4["LAT_1029".toString().toLowerCase()] = "";
                        }
                        if (
                          colsec4["LONG_1030".toString().toLowerCase()] == null
                        ) {
                          colsec4["LONG_1030".toString().toLowerCase()] = "";
                        }
                        if (
                          colsec4[
                          "Regulated_Area_Exit_1031".toString().toLowerCase()
                          ] == null
                        ) {
                          colsec4[
                            "Regulated_Area_Exit_1031".toString().toLowerCase()
                          ] = "";
                        }
                        if (
                          colsec4["Date_1032".toString().toLowerCase()] == null
                        ) {
                          colsec4["Date_1032".toString().toLowerCase()] = "";
                        }
                        if (
                          colsec4["Time_1033".toString().toLowerCase()] == null
                        ) {
                          colsec4["Time_1033".toString().toLowerCase()] = "";
                        }
                        if (
                          colsec4["Position_1034".toString().toLowerCase()] ==
                          null
                        ) {
                          colsec4["Position_1034".toString().toLowerCase()] =
                            "";
                        }
                        if (
                          colsec4["LAT_1035".toString().toLowerCase()] == null
                        ) {
                          colsec4["LAT_1035".toString().toLowerCase()] = "";
                        }
                        if (
                          colsec4["LONG_1036".toString().toLowerCase()] == null
                        ) {
                          colsec4["LONG_1036".toString().toLowerCase()] = "";
                        }
                        if (
                          colsec4[
                          "Begin_CO_to_HSF_1037".toString().toLowerCase()
                          ] == null
                        ) {
                          colsec4[
                            "Begin_CO_to_HSF_1037".toString().toLowerCase()
                          ] = "";
                        }
                        if (
                          colsec4["Date_1038".toString().toLowerCase()] == null
                        ) {
                          colsec4["Date_1038".toString().toLowerCase()] = "";
                        }
                        if (
                          colsec4["Time_1039".toString().toLowerCase()] == null
                        ) {
                          colsec4["Time_1039".toString().toLowerCase()] = "";
                        }
                        if (
                          colsec4["Position_1040".toString().toLowerCase()] ==
                          null
                        ) {
                          colsec4["Position_1040".toString().toLowerCase()] =
                            "";
                        }
                        if (
                          colsec4["LAT_1041".toString().toLowerCase()] == null
                        ) {
                          colsec4["LAT_1041".toString().toLowerCase()] = "";
                        }
                        if (
                          colsec4["LONG_1042".toString().toLowerCase()] == null
                        ) {
                          colsec4["LONG_1042".toString().toLowerCase()] = "";
                        }

                        if (
                          colsec4[
                          "Complete_CO_to_HSF_1043".toString().toLowerCase()
                          ] == null
                        ) {
                          colsec4[
                            "Complete_CO_to_HSF_1043".toString().toLowerCase()
                          ] = "";
                        }
                        if (
                          colsec4["Date_1044".toString().toLowerCase()] == null
                        ) {
                          colsec4["Date_1044".toString().toLowerCase()] = "";
                        }
                        if (
                          colsec4["Time_1045".toString().toLowerCase()] == null
                        ) {
                          colsec4["Time_1045".toString().toLowerCase()] = "";
                        }
                        if (
                          colsec4["Postion_1046".toString().toLowerCase()] ==
                          null
                        ) {
                          colsec4["Postion_1046".toString().toLowerCase()] = "";
                        }
                        if (
                          colsec4["LAT_1047".toString().toLowerCase()] == null
                        ) {
                          colsec4["LAT_1047".toString().toLowerCase()] = "";
                        }
                        if (
                          colsec4["LONG_1048".toString().toLowerCase()] == null
                        ) {
                          colsec4["LONG_1048".toString().toLowerCase()] = "";
                        }
                        if (
                          colsec4[
                          "Fuel_Type_2_1049".toString().toLowerCase()
                          ] == null
                        ) {
                          colsec4["Fuel_Type_2_1049".toString().toLowerCase()] =
                            "";
                        }
                        if (
                          colsec4["Tank2_1050".toString().toLowerCase()] == null
                        ) {
                          colsec4["Tank2_1050".toString().toLowerCase()] = "";
                        }
                        if (
                          colsec4[
                          "Volume_of_LSF_after_completion_of_CO_2_1051"
                            .toString()
                            .toLowerCase()
                          ] == null
                        ) {
                          colsec4[
                            "Volume_of_LSF_after_completion_of_CO_2_1051"
                              .toString()
                              .toLowerCase()
                          ] = "";
                        }
                        if (
                          colsec4["m3_2_1052".toString().toLowerCase()] == null
                        ) {
                          colsec4["m3_2_1052".toString().toLowerCase()] = "";
                        }

                        this.fSection4.push([
                          colsec4[
                          "in_CO_to_LSF_1009".toString().toLowerCase()
                          ] +
                          " " +
                          colsec4["Date1_1010".toString().toLowerCase()] +
                          " " +
                          colsec4["Time1_1011".toString().toLowerCase()] +
                          " " +
                          colsec4["Position_1012".toString().toLowerCase()] +
                          " " +
                          colsec4["LAT_1013".toString().toLowerCase()] +
                          " " +
                          colsec4["LONG_1014".toString().toLowerCase()],
                          //                                                                     colsec4['Complete_CO_to_LSF_1015'.toString().toLowerCase()] + ' ' +
                          colsec4["DATE_1016".toString().toLowerCase()] +
                          " " +
                          colsec4["TIME_1017".toString().toLowerCase()] +
                          " " +
                          colsec4["POSITION_1018".toString().toLowerCase()] +
                          " " +
                          colsec4["LAT_1019".toString().toLowerCase()] +
                          " " +
                          colsec4["LONG_1020".toString().toLowerCase()],
                          colsec4["Fuel_Type_1021".toString().toLowerCase()] +
                          " " +
                          colsec4["Tank_1022".toString().toLowerCase()] +
                          " " +
                          colsec4[
                          "Volume_of_LSF_after_completion_1023"
                            .toString()
                            .toLowerCase()
                          ] +
                          " " +
                          colsec4["m3_1024".toString().toLowerCase()],
                          //                                                                     colsec4['Regulated_Area_Entry_1025'.toString().toLowerCase()] + ' ' +
                          colsec4["Date_1026".toString().toLowerCase()] +
                          " " +
                          colsec4["Time_1027".toString().toLowerCase()] +
                          " " +
                          colsec4["Position_1028".toString().toLowerCase()] +
                          " " +
                          colsec4["LAT_1029".toString().toLowerCase()] +
                          " " +
                          colsec4["LONG_1030".toString().toLowerCase()],
                          "",
                          "",
                          //                                                                     colsec4['Regulated_Area_Exit_1031'.toString().toLowerCase()] + ' ' +
                          colsec4["Date_1032".toString().toLowerCase()] +
                          " " +
                          colsec4["Time_1033".toString().toLowerCase()] +
                          " " +
                          colsec4["Position_1034".toString().toLowerCase()] +
                          " " +
                          colsec4["LAT_1035".toString().toLowerCase()] +
                          " " +
                          colsec4["LONG_1036".toString().toLowerCase()],
                          //                                                                     colsec4['Begin_CO_to_HSF_1037'.toString().toLowerCase()] + ' ' +
                          colsec4["Date_1038".toString().toLowerCase()] +
                          " " +
                          colsec4["Time_1039".toString().toLowerCase()] +
                          " " +
                          colsec4["Position_1040".toString().toLowerCase()] +
                          " " +
                          colsec4["LAT_1041".toString().toLowerCase()] +
                          " " +
                          colsec4["LONG_1042".toString().toLowerCase()],
                          //                                                                     colsec4['Complete_CO_to_HSF_1043'.toString().toLowerCase()] + ' ' +
                          colsec4["Date_1044".toString().toLowerCase()] +
                          " " +
                          colsec4["Time_1045".toString().toLowerCase()] +
                          " " +
                          colsec4["Postion_1046".toString().toLowerCase()] +
                          " " +
                          colsec4["LAT_1047".toString().toLowerCase()] +
                          " " +
                          colsec4["LONG_1048".toString().toLowerCase()],
                          colsec4["Fuel_Type_2_1049".toString().toLowerCase()] +
                          " " +
                          colsec4["Tank2_1050".toString().toLowerCase()] +
                          " " +
                          colsec4[
                          "Volume_of_LSF_after_completion_of_CO_2_1051"
                            .toString()
                            .toLowerCase()
                          ] +
                          " " +
                          colsec4["m3_2_1052".toString().toLowerCase()],
                          "",
                        ]);
                        this.userSign.push(usersign);
                      }

                      if (
                        colsec5[
                        "Equipment_name_1054".toString().toLowerCase()
                        ] != null &&
                        colsec5[
                        "Equipment_name_1054".toString().toLowerCase()
                        ] != ""
                      ) {
                        if (
                          colsec5["ODS_Name_1053".toString().toLowerCase()] ==
                          null
                        ) {
                          colsec5["ODS_Name_1053".toString().toLowerCase()] =
                            "";
                        }
                        if (
                          colsec5[
                          "Equipment_name_1054".toString().toLowerCase()
                          ] == null
                        ) {
                          colsec5[
                            "Equipment_name_1054".toString().toLowerCase()
                          ] = "";
                        }
                        if (
                          colsec5["Capapcity_1055".toString().toLowerCase()] ==
                          null
                        ) {
                          colsec5["Capapcity_1055".toString().toLowerCase()] =
                            "";
                        }
                        if (
                          colsec5["kg_1056".toString().toLowerCase()] == null
                        ) {
                          colsec5["kg_1056".toString().toLowerCase()] = "";
                        }

                        if (
                          colsec5["Recharge_1057".toString().toLowerCase()] ==
                          null
                        ) {
                          colsec5["Recharge_1057".toString().toLowerCase()] =
                            "";
                        }
                        if (
                          colsec5[
                          "Full_recharge_1058".toString().toLowerCase()
                          ] == null
                        ) {
                          colsec5[
                            "Full_recharge_1058".toString().toLowerCase()
                          ] = "";
                        }
                        if (
                          colsec5[
                          "Partial_recharge_1059".toString().toLowerCase()
                          ] == null
                        ) {
                          colsec5[
                            "Partial_recharge_1059".toString().toLowerCase()
                          ] = "";
                        }
                        if (
                          colsec5[
                          "ODS_charged_mass_1060".toString().toLowerCase()
                          ] == null
                        ) {
                          colsec5[
                            "ODS_charged_mass_1060".toString().toLowerCase()
                          ] = "";
                        }
                        if (
                          colsec5["kg1_1061".toString().toLowerCase()] == null
                        ) {
                          colsec5["kg1_1061".toString().toLowerCase()] = "";
                        }

                        if (
                          colsec5[
                          "Description_Of_repair_or_maintenanace_carried_out_1062"
                            .toString()
                            .toLowerCase()
                          ] == null
                        ) {
                          colsec5[
                            "Description_Of_repair_or_maintenanace_carried_out_1062"
                              .toString()
                              .toLowerCase()
                          ] = "";
                        }
                        if (
                          colsec5[
                          "Discharge_of_ODS_to_atmosphere_1063"
                            .toString()
                            .toLowerCase()
                          ] == null
                        ) {
                          colsec5[
                            "Discharge_of_ODS_to_atmosphere_1063"
                              .toString()
                              .toLowerCase()
                          ] = "";
                        }
                        if (
                          colsec5["State_1064".toString().toLowerCase()] == null
                        ) {
                          colsec5["State_1064".toString().toLowerCase()] = "";
                        }
                        if (
                          colsec5["Deliberate_1065".toString().toLowerCase()] ==
                          null
                        ) {
                          colsec5["Deliberate_1065".toString().toLowerCase()] =
                            "";
                        }
                        if (
                          colsec5[
                          "Non-deliberate_1066".toString().toLowerCase()
                          ] == null
                        ) {
                          colsec5[
                            "Non-deliberate_1066".toString().toLowerCase()
                          ] = "";
                        }
                        if (
                          colsec5["Mass_1067".toString().toLowerCase()] == null
                        ) {
                          colsec5["Mass_1067".toString().toLowerCase()] = "";
                        }
                        if (
                          colsec5["Kg3_1068".toString().toLowerCase()] == null
                        ) {
                          colsec5["Kg3_1068".toString().toLowerCase()] = "";
                        }

                        if (
                          colsec5[
                          "Discharge_of_ods_to_shore_reception_facility_1069"
                            .toString()
                            .toLowerCase()
                          ] == null
                        ) {
                          colsec5[
                            "Discharge_of_ods_to_shore_reception_facility_1069"
                              .toString()
                              .toLowerCase()
                          ] = "";
                        }
                        if (
                          colsec5[
                          "Name_of_reception_facility_1070"
                            .toString()
                            .toLowerCase()
                          ] == null
                        ) {
                          colsec5[
                            "Name_of_reception_facility_1070"
                              .toString()
                              .toLowerCase()
                          ] = "";
                        }
                        if (
                          colsec5[
                          "Address_of_reception_facility_1071"
                            .toString()
                            .toLowerCase()
                          ] == null
                        ) {
                          colsec5[
                            "Address_of_reception_facility_1071"
                              .toString()
                              .toLowerCase()
                          ] = "";
                        }
                        if (
                          colsec5["Mass3_1072".toString().toLowerCase()] == null
                        ) {
                          colsec5["Mass3_1072".toString().toLowerCase()] = "";
                        }
                        if (
                          colsec5[
                          "ods_received_on_board_1074"
                            .toString()
                            .toLowerCase()
                          ] == null
                        ) {
                          colsec5[
                            "ods_received_on_board_1074"
                              .toString()
                              .toLowerCase()
                          ] = "";
                        }
                        if (
                          colsec5["ODS_name_1075".toString().toLowerCase()] ==
                          null
                        ) {
                          colsec5["ODS_name_1075".toString().toLowerCase()] =
                            "";
                        }
                        if (
                          colsec5["Port_name_1076".toString().toLowerCase()] ==
                          null
                        ) {
                          colsec5["Port_name_1076".toString().toLowerCase()] =
                            "";
                        }
                        if (
                          colsec5["Date_1077".toString().toLowerCase()] == null
                        ) {
                          colsec5["Date_1077".toString().toLowerCase()] = "";
                        }
                        if (
                          colsec5["Mass5_1078".toString().toLowerCase()] == null
                        ) {
                          colsec5["Mass5_1078".toString().toLowerCase()] = "";
                        }
                        if (
                          colsec5["Kg5_1079".toString().toLowerCase()] == null
                        ) {
                          colsec5["Kg5_1079".toString().toLowerCase()] = "";
                        }
                        this.fSection5.push([
                          colsec5["ODS_Name_1053".toString().toLowerCase()] +
                          " " +
                          colsec5[
                          "Equipment_name_1054".toString().toLowerCase()
                          ] +
                          " " +
                          colsec5["Capapcity_1055".toString().toLowerCase()] +
                          " " +
                          colsec5["kg_1056".toString().toLowerCase()],
                          colsec5["Recharge_1057".toString().toLowerCase()] +
                          " " +
                          colsec5[
                          "Full_recharge_1058".toString().toLowerCase()
                          ] +
                          " " +
                          colsec5[
                          "Partial_recharge_1059".toString().toLowerCase()
                          ] +
                          " " +
                          colsec5[
                          "ODS_charged_mass_1060".toString().toLowerCase()
                          ] +
                          " " +
                          colsec5["kg1_1061".toString().toLowerCase()],
                          colsec5[
                          "Description_Of_repair_or_maintenanace_carried_out_1062"
                            .toString()
                            .toLowerCase()
                          ],
                          //                                                                        colsec5['Discharge_of_ODS_to_atmosphere_1063'.toString().toLowerCase()] + ' ' +
                          colsec5["State_1064".toString().toLowerCase()] +
                          " " +
                          colsec5[
                          "Deliberate_1065".toString().toLowerCase()
                          ] +
                          " " +
                          colsec5[
                          "Non-deliberate_1066".toString().toLowerCase()
                          ] +
                          " " +
                          colsec5["Mass_1067".toString().toLowerCase()] +
                          " " +
                          colsec5["Kg3_1068".toString().toLowerCase()],
                          //                                                                        colsec5['Discharge_of_ods_to_shore_reception_facility_1069'.toString().toLowerCase()] + ' ' +
                          colsec5[
                          "Name_of_reception_facility_1070"
                            .toString()
                            .toLowerCase()
                          ] +
                          " " +
                          colsec5[
                          "Address_of_reception_facility_1071"
                            .toString()
                            .toLowerCase()
                          ] +
                          " " +
                          colsec5["Mass3_1072".toString().toLowerCase()] +
                          " " +
                          colsec5["Kg3_1073".toString().toLowerCase()],
                          //                                                                        colsec5['ods_received_on_board_1074'.toString().toLowerCase()] + ' ' +
                          colsec5["ODS_name_1075".toString().toLowerCase()] +
                          " " +
                          colsec5["Port_name_1076".toString().toLowerCase()] +
                          " " +
                          colsec5["Date_1077".toString().toLowerCase()] +
                          " " +
                          colsec5["Mass5_1078".toString().toLowerCase()] +
                          " " +
                          colsec5["Kg5_1079".toString().toLowerCase()],
                          "",
                        ]);
                        this.userSign.push(usersign);
                      }
                    }

                    if (formId == 47) {
                      if (
                        coldate["date_created"] != null &&
                        coldate["date_created"] != ""
                      ) {
                        var date = new Date(coldate["date_created"]);
                        var day = date.getDate();
                        var time = date.getHours() + ":" + date.getMinutes();
                        var month = date.getMonth() + 1;
                        var year = date.getFullYear();

                        var fullDate =
                          year + "-" + month + "-" + day + " " + time;

                        var sectionLenght = coldate["section_length"];
                        this.createdAt.push([
                          year + "-" + month + "-" + day,
                          sectionLenght,
                        ]);
                      }

                      if (
                        colsec1["lat_894"] != null &&
                        colsec1["lat_894"] != ""
                      ) {
                        if (colsec1["time_892"] == null) {
                          colsec1["time_892"] = "";
                        }
                        if (colsec1["location_893"] == null) {
                          colsec1["location_893"] = "";
                        }
                        if (colsec1["long_895"] == null) {
                          colsec1["long_895"] = "";
                        }
                        if (colsec1["estimated_volume_901"] == null) {
                          colsec1["estimated_volume_901"] = "";
                        }
                        if (colsec1["depth_900"] == null) {
                          colsec1["depth_900"] = "";
                        }
                        if (colsec1["volume_of_uptake_902"] == null) {
                          colsec1["volume_of_uptake_902"] = "";
                        }
                        if (colsec1["remark_1091"] == null) {
                          colsec1["remark_1091"] = "";
                        }

                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          "3.1",
                          colsec1["date_891"] +
                          " " +
                          colsec1["time_892"] +
                          " " +
                          colsec1["location_893"] +
                          " " +
                          colsec1["lat_894"] +
                          " " +
                          colsec1["long_895"] +
                          " " +
                          colsec1["depth_900"] +
                          " " +
                          colsec1["estimated_volume_901"] +
                          " " +
                          colsec1["volume_of_uptake_902"] +
                          " " +
                          colsec1["m3_903"] +
                          " " +
                          colsec1["remark_1091"],
                        ]);
                        this.userSign.push(usersign);
                      } else if (
                        colsec1["name_of_port_896"] != null &&
                        colsec1["name_of_port_896"] != ""
                      ) {
                        if (colsec1["time_892"] == null) {
                          colsec1["time_892"] = "";
                        }
                        if (colsec1["location_893"] == null) {
                          colsec1["location_893"] = "";
                        }
                        if (colsec1["long_895"] == null) {
                          colsec1["long_895"] = "";
                        }
                        if (colsec1["estimated_volume_901"] == null) {
                          colsec1["estimated_volume_901"] = "";
                        }
                        if (colsec1["depth_900"] == null) {
                          colsec1["depth_900"] = "";
                        }
                        if (colsec1["volume_of_uptake_902"] == null) {
                          colsec1["volume_of_uptake_902"] = "";
                        }
                        if (colsec1["remark_1091"] == null) {
                          colsec1["remark_1091"] = "";
                        }

                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          "3.1",
                          colsec1["date_891"] +
                          " " +
                          colsec1["time_892"] +
                          " " +
                          colsec1["location_893"] +
                          " " +
                          colsec1["name_of_port_896"] +
                          " " +
                          colsec1["depth_900"] +
                          " " +
                          colsec1["estimated_volume_901"] +
                          " " +
                          colsec1["volume_of_uptake_902"] +
                          " " +
                          colsec1["m3_903"] +
                          " " +
                          colsec1["remark_1091"],
                        ]);
                        this.userSign.push(usersign);
                      } else if (
                        colsec1["reception_facility_name_898"] != null &&
                        colsec1["reception_facility_name_898"] != ""
                      ) {
                        if (colsec1["time_892"] == null) {
                          colsec1["time_892"] = "";
                        }
                        if (colsec1["location_893"] == null) {
                          colsec1["location_893"] = "";
                        }
                        if (colsec1["long_895"] == null) {
                          colsec1["long_895"] = "";
                        }
                        if (colsec1["estimated_volume_901"] == null) {
                          colsec1["estimated_volume_901"] = "";
                        }
                        if (colsec1["depth_900"] == null) {
                          colsec1["depth_900"] = "";
                        }
                        if (colsec1["volume_of_uptake_902"] == null) {
                          colsec1["volume_of_uptake_902"] = "";
                        }
                        if (colsec1["remark_1091"] == null) {
                          colsec1["remark_1091"] = "";
                        }

                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          "3.1",
                          colsec1["date_891"] +
                          " " +
                          colsec1["time_892"] +
                          " " +
                          colsec1["location_893"] +
                          " " +
                          colsec1["reception_facility_name_898"] +
                          " " +
                          colsec1["depth_900"] +
                          " " +
                          colsec1["estimated_volume_901"] +
                          " " +
                          colsec1["volume_of_uptake_902"] +
                          " " +
                          colsec1["m3_903"] +
                          " " +
                          colsec1["remark_1091"],
                        ]);
                        this.userSign.push(usersign);
                      }

                      if (
                        colsec2["date_905"] != null &&
                        colsec2["date_905"] != ""
                      ) {
                        //Date_905/time_906/Volume_circulated_or_treated_908/m3_903
                        if (colsec2["date_905"] == null) {
                          colsec2["date_905"] = "";
                        }
                        if (colsec2["time_906"] == null) {
                          colsec2["time_906"] = "";
                        }
                        if (
                          colsec2["volume_circulated_or_treated_908"] == null
                        ) {
                          colsec2["volume_circulated_or_treated_908"] = "";
                        }
                        if (colsec2["m3_909"] == null) {
                          colsec2["m3_909"] = "";
                        }
                        if (colsec2["yes_911"] == null) {
                          colsec2["yes_911"] = "";
                        }
                        if (colsec2["no_912"] == null) {
                          colsec2["no_912"] = "";
                        }
                        if (colsec2["remark_1092"] == null) {
                          colsec2["remark_1092"] = "";
                        }

                        if (colsec2["no_912"] != "") {
                          this.objcolsection.push([
                            year + "-" + month + "-" + day,
                            "3.2",
                            colsec2["date_905"] +
                            " " +
                            colsec2["time_906"] +
                            " " +
                            colsec2["volume_circulated_or_treated_908"] +
                            " " +
                            colsec2["m3_909"] +
                            " " +
                            colsec2["no_912"] +
                            " " +
                            colsec2["remark_1092"],
                          ]);
                          this.userSign.push(usersign);
                        } else {
                          this.objcolsection.push([
                            year + "-" + month + "-" + day,
                            "3.2",
                            colsec2["date_905"] +
                            " " +
                            colsec2["time_906"] +
                            " " +
                            colsec2["volume_circulated_or_treated_908"] +
                            " " +
                            colsec2["m3_909"] +
                            " " +
                            colsec2["yes_911"] +
                            " " +
                            colsec2["remark_1092"],
                          ]);
                          this.userSign.push(usersign);
                        }
                      }

                      if (
                        colsec3["lat_917"] != null &&
                        colsec3["lat_917"] != ""
                      ) {
                        //alert('lat');
                        if (colsec3["date_914"] == null) {
                          colsec3["date_914"] = "";
                        }
                        if (colsec3["time_915"] == null) {
                          colsec3["time_915"] = "";
                        }
                        if (colsec3["location_916"] == null) {
                          colsec3["location_916"] = "";
                        }
                        if (colsec3["lat_917"] == null) {
                          colsec3["lat_917"] = "";
                        }
                        if (colsec3["long_918"] == null) {
                          colsec3["long_918"] = "";
                        }
                        if (colsec3["volume_discharged_924"] == null) {
                          colsec3["volume_discharged_924"] = "";
                        }
                        if (colsec3["remaining_volume_926"] == null) {
                          colsec3["remaining_volume_926"] = "";
                        }
                        if (colsec3["yes_929"] == null) {
                          colsec3["yes_929"] = "";
                        }
                        if (colsec3["no_930"] == null) {
                          colsec3["no_930"] = "";
                        }
                        if (colsec3["remark_1093"] == null) {
                          colsec3["remark_1093"] = "";
                        }

                        if (colsec3["no_930"] != "") {
                          this.objcolsection.push([
                            year + "-" + month + "-" + day,
                            "3.3",
                            colsec3["date_914"] +
                            " " +
                            colsec3["time_915"] +
                            " " +
                            colsec3["location_916"] +
                            " " +
                            colsec3["lat_917"] +
                            " " +
                            colsec3["long_918"] +
                            " " +
                            colsec3["volume_discharged_924"] +
                            " " +
                            colsec3["m3_925"] +
                            " " +
                            colsec3["remaining_volume_926"] +
                            " " +
                            colsec3["m3_927"] +
                            " " +
                            colsec3["no_930"] +
                            " " +
                            colsec3["remark_1093"],
                          ]);
                        } else {
                          this.objcolsection.push([
                            year + "-" + month + "-" + day,
                            "3.3",
                            colsec3["date_914"] +
                            " " +
                            colsec3["time_915"] +
                            " " +
                            colsec3["location_916"] +
                            " " +
                            colsec3["lat_917"] +
                            " " +
                            colsec3["long_918"] +
                            " " +
                            colsec3["volume_discharged_924"] +
                            " " +
                            colsec3["m3_925"] +
                            " " +
                            colsec3["remaining_volume_926"] +
                            " " +
                            colsec3["m3_927"] +
                            " " +
                            colsec3["yes_929"] +
                            " " +
                            colsec3["remark_1093"],
                          ]);
                        }
                        this.userSign.push(usersign);
                      } else if (
                        colsec3["name_of_port_919"] != null &&
                        colsec3["name_of_port_919"] != ""
                      ) {
                        //alert('name_of_port_919');
                        if (colsec3["date_914"] == null) {
                          colsec3["date_914"] = "";
                        }
                        if (colsec3["time_915"] == null) {
                          colsec3["time_915"] = "";
                        }
                        if (colsec3["location_916"] == null) {
                          colsec3["location_916"] = "";
                        }
                        if (colsec3["lat_917"] == null) {
                          colsec3["lat_917"] = "";
                        }
                        if (colsec3["long_918"] == null) {
                          colsec3["long_918"] = "";
                        }
                        if (colsec3["volume_discharged_924"] == null) {
                          colsec3["volume_discharged_924"] = "";
                        }
                        if (colsec3["remaining_volume_926"] == null) {
                          colsec3["remaining_volume_926"] = "";
                        }
                        if (colsec3["yes_929"] == null) {
                          colsec3["yes_929"] = "";
                        }
                        if (colsec3["no_930"] == null) {
                          colsec3["no_930"] = "";
                        }
                        if (colsec3["remark_1093"] == null) {
                          colsec3["remark_1093"] = "";
                        }

                        if (colsec3["no_930"] != "") {
                          this.objcolsection.push([
                            year + "-" + month + "-" + day,
                            "3.3",
                            colsec3["date_914"] +
                            " " +
                            colsec3["time_915"] +
                            " " +
                            colsec3["location_916"] +
                            " " +
                            colsec3["name_of_port_919"] +
                            " " +
                            colsec3["volume_discharged_924"] +
                            " " +
                            colsec3["m3_925"] +
                            " " +
                            colsec3["remaining_volume_926"] +
                            " " +
                            colsec3["m3_927"] +
                            " " +
                            colsec3["no_930"] +
                            " " +
                            colsec3["remark_1093"],
                          ]);
                        } else {
                          this.objcolsection.push([
                            year + "-" + month + "-" + day,
                            "3.3",
                            colsec3["date_914"] +
                            " " +
                            colsec3["time_915"] +
                            " " +
                            colsec3["location_916"] +
                            " " +
                            colsec3["name_of_port_919"] +
                            " " +
                            colsec3["volume_discharged_924"] +
                            " " +
                            colsec3["m3_925"] +
                            " " +
                            colsec3["remaining_volume_926"] +
                            " " +
                            colsec3["m3_927"] +
                            " " +
                            colsec3["yes_929"] +
                            " " +
                            colsec3["remark_1093"],
                          ]);
                        }
                        this.userSign.push(usersign);
                      } else if (
                        colsec3["reception_facility_name_921"] != null &&
                        colsec3["reception_facility_name_921"] != ""
                      ) {
                        if (colsec3["date_914"] == null) {
                          colsec3["date_914"] = "";
                        }
                        if (colsec3["time_915"] == null) {
                          colsec3["time_915"] = "";
                        }
                        if (colsec3["location_916"] == null) {
                          colsec3["location_916"] = "";
                        }
                        if (colsec3["lat_917"] == null) {
                          colsec3["lat_917"] = "";
                        }
                        if (colsec3["long_918"] == null) {
                          colsec3["long_918"] = "";
                        }
                        if (colsec3["volume_discharged_924"] == null) {
                          colsec3["volume_discharged_924"] = "";
                        }
                        if (colsec3["remaining_volume_926"] == null) {
                          colsec3["remaining_volume_926"] = "";
                        }
                        if (colsec3["yes_929"] == null) {
                          colsec3["yes_929"] = "";
                        }
                        if (colsec3["no_930"] == null) {
                          colsec3["no_930"] = "";
                        }
                        if (colsec3["remark_1093"] == null) {
                          colsec3["remark_1093"] = "";
                        }
                        //alert('reception_facility_name_921');

                        if (colsec3["2_estimated_volume_923"] == null) {
                          colsec3["2_estimated_volume_923"] = "";
                        }

                        if (colsec3["no_930"] != "") {
                          this.objcolsection.push([
                            year + "-" + month + "-" + day,
                            "3.3",
                            colsec3["date_914"] +
                            " " +
                            colsec3["time_915"] +
                            " " +
                            colsec3["location_916"] +
                            " " +
                            colsec3["reception_facility_name_921"] +
                            " " +
                            colsec3["volume_discharged_924"] +
                            " " +
                            colsec3["m3_925"] +
                            " " +
                            colsec3["remaining_volume_926"] +
                            " " +
                            colsec3["m3_927"] +
                            " " +
                            colsec3["no_930"] +
                            " " +
                            colsec3["remark_1093"],
                          ]);
                        } else {
                          this.objcolsection.push([
                            year + "-" + month + "-" + day,
                            "3.3",
                            colsec3["date_914"] +
                            " " +
                            colsec3["time_915"] +
                            " " +
                            colsec3["location_916"] +
                            " " +
                            colsec3["reception_facility_name_921"] +
                            " " +
                            colsec3["volume_discharged_924"] +
                            " " +
                            colsec3["m3_925"] +
                            " " +
                            colsec3["remaining_volume_926"] +
                            " " +
                            colsec3["m3_927"] +
                            " " +
                            colsec3["yes_929"] +
                            " " +
                            colsec3["remark_1093"],
                          ]);
                        }
                        this.userSign.push(usersign);
                      }

                      if (
                        colsec4["lat_935"] != null &&
                        colsec4["lat_935"] != ""
                      ) {
                        if (colsec4["time_933"] == null) {
                          colsec4["time_933"] = "";
                        }
                        if (colsec4["date_932"] == null) {
                          colsec4["date_932"] = "";
                        }
                        if (colsec4["lat_935"] == null) {
                          colsec4["lat_935"] = "";
                        }
                        if (colsec4["date _938"] == null) {
                          colsec4["date _938"] = "";
                        }
                        if (colsec4["time_939"] == null) {
                          colsec4["time_939"] = "";
                        }
                        if (colsec4["long_936"] == null) {
                          colsec4["long_936"] = "";
                        }
                        if (colsec4["port_944"] == null) {
                          colsec4["port_944"] = "";
                        }
                        if (colsec4["location_of_discharge_940"] == null) {
                          colsec4["location_of_discharge_940"] = "";
                        }
                        if (colsec4["volume_discharge_947"] == null) {
                          colsec4["volume_discharge_947"] = "";
                        }
                        if (colsec4["name_of_port_945"] == null) {
                          colsec4["name_of_port_945"] = "";
                        }
                        if (colsec4["volume_taken_up_949"] == null) {
                          colsec4["volume_taken_up_949"] = "";
                        }
                        if (colsec4["yes_952"] == null) {
                          colsec4["yes              _952"] = "";
                        }
                        if (colsec4["no_953"] == null) {
                          colsec4["no_953"] = "";
                        }
                        if (colsec4["remark_1173"] == null) {
                          colsec4["remark_1173"] = "";
                        }

                        //alert(colsec4['port_944'] + '=====' + colsec4['name_of_port_945'] )
                        if (colsec4["no_953"] != "") {
                          this.objcolsection.push([
                            year + "-" + month + "-" + day,
                            "3.4",
                            colsec4["date_932"] +
                            " " +
                            colsec4["time_933"] +
                            " Location of uptake " +
                            colsec4["lat_935"] +
                            " " +
                            colsec4["long_936"] +
                            " " +
                            colsec4["date _938"] +
                            " " +
                            colsec4["time_939"] +
                            " " +
                            colsec4["location_of_discharge_940"] +
                            " " +
                            colsec4["lat_941"] +
                            " " +
                            colsec4["long_942"] +
                            " " +
                            colsec4["port_944"] +
                            " " +
                            colsec4["name_of_port_945"] +
                            " " +
                            colsec4["volume_discharge_947"] +
                            " " +
                            colsec4["m3_948"] +
                            " " +
                            colsec4["volume_taken_up_949"] +
                            " " +
                            colsec4["m3_950"] +
                            " " +
                            colsec4["no_953"] +
                            " " +
                            colsec4["remark_1173"],
                          ]);
                        } else {
                          this.objcolsection.push([
                            year + "-" + month + "-" + day,
                            "3.4",
                            colsec4["date_932"] +
                            " " +
                            colsec4["time_933"] +
                            " Location of uptake " +
                            colsec4["lat_935"] +
                            " " +
                            colsec4["long_936"] +
                            " " +
                            colsec4["date _938"] +
                            " " +
                            colsec4["time_939"] +
                            " " +
                            colsec4["location_of_discharge_940"] +
                            " " +
                            colsec4["lat_941"] +
                            " " +
                            colsec4["long_942"] +
                            " " +
                            colsec4["port_944"] +
                            " " +
                            colsec4["name_of_port_945"] +
                            " " +
                            colsec4["volume_discharge_947"] +
                            " " +
                            colsec4["m3_948"] +
                            " " +
                            colsec4["volume_taken_up_949"] +
                            " " +
                            colsec4["m3_950"] +
                            " " +
                            colsec4["yes_952"] +
                            " " +
                            colsec4["remark_1173"],
                          ]);
                        }
                        this.userSign.push(usersign);
                      } else if (
                        colsec4["name_of_port_945"] != null &&
                        colsec4["name_of_port_945"] != ""
                      ) {
                        if (colsec4["time_933"] == null) {
                          colsec4["time_933"] = "";
                        }
                        if (colsec4["date_932"] == null) {
                          colsec4["date_932"] = "";
                        }
                        if (colsec4["lat_935"] == null) {
                          colsec4["lat_935"] = "";
                        }
                        if (colsec4["date _938"] == null) {
                          colsec4["date _938"] = "";
                        }
                        if (colsec4["time_939"] == null) {
                          colsec4["time_939"] = "";
                        }
                        if (colsec4["long_936"] == null) {
                          colsec4["long_936"] = "";
                        }
                        if (colsec4["port_944"] == null) {
                          colsec4["port_944"] = "";
                        }
                        if (colsec4["location_of_discharge_940"] == null) {
                          colsec4["location_of_discharge_940"] = "";
                        }
                        if (colsec4["volume_discharge_947"] == null) {
                          colsec4["volume_discharge_947"] = "";
                        }
                        if (colsec4["name_of_port_945"] == null) {
                          colsec4["name_of_port_945"] = "";
                        }
                        if (colsec4["volume_taken_up_949"] == null) {
                          colsec4["volume_taken_up_949"] = "";
                        }
                        if (colsec4["yes_952"] == null) {
                          colsec4["yes_952"] = "";
                        }
                        if (colsec4["no_953"] == null) {
                          colsec4["no_953"] = "";
                        }
                        if (colsec4["remark_1173"] == null) {
                          colsec4["remark_1173"] = "";
                        }

                        if (colsec4["no_953"] != "") {
                          this.objcolsection.push([
                            year + "-" + month + "-" + day,
                            "3.4",
                            colsec4["date_932"] +
                            " " +
                            colsec4["time_933"] +
                            " " +
                            colsec4["name_of_port_945"] +
                            " " +
                            colsec4["date _938"] +
                            " " +
                            colsec4["time_939"] +
                            " " +
                            colsec4["lat_941"] +
                            " " +
                            colsec4["long_942"] +
                            " " +
                            colsec4["port_944"] +
                            " " +
                            colsec4["location_of_discharge_940"] +
                            " " +
                            colsec4["volume_discharge_947"] +
                            " " +
                            colsec4["m3_948"] +
                            " " +
                            colsec4["volume_taken_up_949"] +
                            " " +
                            colsec4["m3_950"] +
                            " " +
                            colsec4["no_953"] +
                            " " +
                            colsec4["remark_1173"],
                          ]);
                        } else {
                          this.objcolsection.push([
                            year + "-" + month + "-" + day,
                            "3.4",
                            colsec4["date_932"] +
                            " " +
                            colsec4["time_933"] +
                            " " +
                            colsec4["name_of_port_945"] +
                            " " +
                            colsec4["date _938"] +
                            " " +
                            colsec4["time_939"] +
                            " " +
                            colsec4["lat_941"] +
                            " " +
                            colsec4["long_942"] +
                            " " +
                            colsec4["port_944"] +
                            " " +
                            colsec4["location_of_discharge_940"] +
                            " " +
                            colsec4["volume_discharge_947"] +
                            " " +
                            colsec4["m3_948"] +
                            " " +
                            colsec4["volume_taken_up_949"] +
                            " " +
                            colsec4["m3_950"] +
                            " " +
                            colsec4["yes_952"] +
                            " " +
                            colsec4["remark_1173"],
                          ]);
                        }
                        this.userSign.push(usersign);
                      }
                      if (
                        colsec5["lat_960"] != null &&
                        colsec5["lat_960"] != ""
                      ) {
                        if (colsec5["date_955"] == null) {
                          colsec5["date_955"] = "";
                        }
                        if (colsec5["time_956"] == null) {
                          colsec5["time_956"] = "";
                        }
                        if (colsec5["long_961"] == null) {
                          colsec5["long_961"] = "";
                        }
                        if (colsec5["volume_964"] == null) {
                          colsec5["volume_964"] = "";
                        }
                        if (colsec5["circumstances_of_uptake_967"] == null) {
                          colsec5["circumstances_of_uptake_967"] = "";
                        }
                        if (colsec5["general_remarks_968"] == null) {
                          colsec5["general_remarks_968"] = "";
                        }
                        if (colsec5["yes_970"] == null) {
                          colsec5["yes_970"] = "";
                        }
                        if (colsec5["no_971"] == null) {
                          colsec5["no_971"] = "";
                        }

                        if (colsec5["no_971"] != "") {
                          this.objcolsection.push([
                            year + "-" + month + "-" + day,
                            "3.5",
                            colsec5["date_955"] +
                            " " +
                            colsec5["time_956"] +
                            " " +
                            colsec5["lat_960"] +
                            " " +
                            colsec5["long_961"] +
                            " " +
                            colsec5["volume_964"] +
                            " " +
                            colsec5["m3_965"] +
                            " " +
                            colsec5["circumstances_of_uptake_967"] +
                            " " +
                            colsec5["general_remarks_968"] +
                            " " +
                            colsec5["no_971"],
                          ]);
                        } else {
                          this.objcolsection.push([
                            year + "-" + month + "-" + day,
                            "3.5",
                            colsec5["date_955"] +
                            " " +
                            colsec5["time_956"] +
                            " " +
                            colsec5["lat_960"] +
                            " " +
                            colsec5["long_961"] +
                            " " +
                            colsec5["volume_964"] +
                            " " +
                            colsec5["m3_965"] +
                            " " +
                            colsec5["circumstances_of_uptake_967"] +
                            " " +
                            colsec5["general_remarks_968"] +
                            " " +
                            colsec5["yes_970"],
                          ]);
                        }

                        this.userSign.push(usersign);
                      } else if (
                        colsec5["name_of_port_959"] != null &&
                        colsec5["name_of_port_959"] != ""
                      ) {
                        if (colsec5["date_955"] == null) {
                          colsec5["date_955"] = "";
                        }
                        if (colsec5["time_956"] == null) {
                          colsec5["time_956"] = "";
                        }
                        if (colsec5["long_961"] == null) {
                          colsec5["long_961"] = "";
                        }
                        if (colsec5["volume_964"] == null) {
                          colsec5["volume_964"] = "";
                        }
                        if (colsec5["circumstances_of_uptake_967"] == null) {
                          colsec5["circumstances_of_uptake_967"] = "";
                        }
                        if (colsec5["general_remarks_968"] == null) {
                          colsec5["general_remarks_968"] = "";
                        }
                        if (colsec5["port_958"] == null) {
                          colsec5["port_958"] = "";
                        }
                        if (colsec5["yes_970"] == null) {
                          colsec5["yes_970"] = "";
                        }
                        if (colsec5["no_971"] == null) {
                          colsec5["no_971"] = "";
                        }

                        if (colsec5["no_971"] != "") {
                          this.objcolsection.push([
                            year + "-" + month + "-" + day,
                            "3.5",
                            colsec5["date_955"] +
                            " " +
                            colsec5["time_956"] +
                            " " +
                            colsec5["port_958"] +
                            " " +
                            colsec5["name_of_port_959"] +
                            " " +
                            colsec5["volume_964"] +
                            " " +
                            colsec5["m3_965"] +
                            " " +
                            colsec5["circumstances_of_uptake_967"] +
                            " " +
                            colsec5["general_remarks_968"] +
                            " " +
                            colsec5["no_971"],
                          ]);
                        } else {
                          this.objcolsection.push([
                            year + "-" + month + "-" + day,
                            "3.5",
                            colsec5["date_955"] +
                            " " +
                            colsec5["time_956"] +
                            " " +
                            colsec5["port_958"] +
                            " " +
                            colsec5["name_of_port_959"] +
                            " " +
                            colsec5["volume_964"] +
                            " " +
                            colsec5["m3_965"] +
                            " " +
                            colsec5["circumstances_of_uptake_967"] +
                            " " +
                            colsec5["general_remarks_968"] +
                            " " +
                            colsec5["yes_970"],
                          ]);
                        }
                        this.userSign.push(usersign);
                      }

                      if (
                        colsec6["operational_procedure_972"] != null &&
                        colsec6["operational_procedure_972"] != ""
                      ) {
                        if (colsec6["operational_procedure_972"] == null) {
                          colsec6["operational_procedure_972"] = "";
                        }
                        if (colsec6["general_remarks_973"] == null) {
                          colsec6["general_remarks_973"] = "";
                        }

                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          "3.6",
                          colsec6["operational_procedure_972"] +
                          " " +
                          colsec6["general_remarks_973"],
                        ]);
                        this.userSign.push(usersign);
                      }
                    }

                    if (formId == 38) {
                      if (
                        coldate["date_created"] != null &&
                        coldate["date_created"] != ""
                      ) {
                        var date = new Date(coldate["date_created"]);
                        var day = date.getDate();
                        var time = date.getHours() + ":" + date.getMinutes();
                        var month = date.getMonth() + 1;
                        var year = date.getFullYear();

                        var fullDate =
                          year + "-" + month + "-" + day + " " + time;

                        var sectionLenght = coldate["section_length"];
                        this.createdAt.push([
                          year + "-" + month + "-" + day,
                          sectionLenght,
                        ]);
                      }

                      //this.in_array(colsec1,'<b>')
                      //Port_580,Facility_581,Name_of_ship_582
                      if (colsec1["long_578"] != null) {
                        if (colsec1["textbox_1_562"] == null) {
                          colsec1["textbox_1_562"] = "";
                        }
                        if (colsec1["textbox_2_563"] == null) {
                          colsec1["textbox_2_563"] = "";
                        }
                        if (colsec1["lat_576"] == null) {
                          colsec1["lat_576"] = "";
                        }
                        if (colsec1["long_578"] == null) {
                          colsec1["long_578"] = "";
                        }
                        if (colsec1["categories_585"] == null) {
                          colsec1["categories_585"] = "";
                        }
                        if (colsec1["textbox_589"] == null) {
                          colsec1["textbox_589"] = "";
                        }
                        //if(colsec1['remarks_596']==null){colsec1['remarks_596']="";}
                        if (colsec1["remarks_1094"] == null) {
                          colsec1["remarks_1094"] = "";
                        }

                        var arr = [
                          colsec1["textbox_1_562"] +
                          " " +
                          colsec1["textbox_2_563"],
                          colsec1["lat_576"] + " " + colsec1["long_578"],
                          colsec1["categories_585"],
                          "-",
                          colsec1["textbox_589"] + " " + colsec1["m3_590"],
                          "-",
                          colsec1["remarks_1094"],
                        ];
                        this.objcolsection.push(arr);

                        colsec1 = [];
                        this.userSign.push(usersign);
                      }

                      if (colsec1["port_580"] != null) {
                        if (colsec1["textbox_1_562"] == null) {
                          colsec1["textbox_1_562"] = "";
                        }
                        if (colsec1["textbox_2_563"] == null) {
                          colsec1["textbox_2_563"] = "";
                        }

                        if (colsec1["categories_585"] == null) {
                          colsec1["categories_585"] = "";
                        }
                        if (colsec1["textbox_589"] == null) {
                          colsec1["textbox_589"] = "";
                        }
                        if (colsec1["remarks_1094"] == null) {
                          colsec1["remarks_1094"] = "";
                        }

                        this.objcolsection.push([
                          colsec1["textbox_1_562"] +
                          "," +
                          colsec1["textbox_2_563"],
                          colsec1["port_580"],
                          colsec1["categories_585"],
                          "-",
                          colsec1["textbox_589"] + " " + colsec1["m3_590"],
                          "-",
                          colsec1["remarks_1094"],
                        ]);
                        colsec1 = [];
                        this.userSign.push(usersign);
                      }

                      if (colsec1["facility_581"] != null) {
                        if (colsec1["textbox_1_562"] == null) {
                          colsec1["textbox_1_562"] = "";
                        }
                        if (colsec1["textbox_2_563"] == null) {
                          colsec1["textbox_2_563"] = "";
                        }

                        if (colsec1["categories_585"] == null) {
                          colsec1["categories_585"] = "";
                        }
                        if (colsec1["textbox_589"] == null) {
                          colsec1["textbox_589"] = "";
                        }
                        if (colsec1["remarks_1094"] == null) {
                          colsec1["remarks_1094"] = "";
                        }

                        this.objcolsection.push([
                          colsec1["textbox_1_562"] +
                          "," +
                          colsec1["textbox_2_563"],
                          colsec1["facility_581"],
                          colsec1["categories_585"],
                          "-",
                          colsec1["textbox_589"] + " " + colsec1["m3_590"],
                          "-",
                          colsec1["remarks_1094"],
                        ]);
                        colsec1 = [];
                        this.userSign.push(usersign);
                      }

                      if (colsec1["name_of_ship_582"] != null) {
                        if (colsec1["textbox_1_562"] == null) {
                          colsec1["textbox_1_562"] = "";
                        }
                        if (colsec1["textbox_2_563"] == null) {
                          colsec1["textbox_2_563"] = "";
                        }

                        if (colsec1["categories_585"] == null) {
                          colsec1["categories_585"] = "";
                        }
                        if (colsec1["textbox_589"] == null) {
                          colsec1["textbox_589"] = "";
                        }
                        if (colsec1["remarks_1094"] == null) {
                          colsec1["remarks_1094"] = "";
                        }

                        this.objcolsection.push([
                          colsec1["textbox_1_562"] +
                          "," +
                          colsec1["textbox_2_563"],
                          colsec1["name_of_ship_582"],
                          colsec1["categories_585"],
                          "-",
                          colsec1["textbox_589"] + " " + colsec1["m3_590"],
                          "-",
                          colsec1["remarks_1094"],
                        ]);
                        colsec1 = [];
                        this.userSign.push(usersign);
                      }

                      if (colsec2["lat_610"] != null) {
                        if (colsec2["textbox_1_593"] == null) {
                          colsec2["textbox_1_593"] = "";
                        }
                        if (colsec2["textbox_2_594"] == null) {
                          colsec2["textbox_2_594"] = "";
                        }
                        if (colsec2["textbox_3_599"] == null) {
                          colsec2["textbox_3_599"] = "";
                        }
                        if (colsec2["textbox_4_601"] == null) {
                          colsec2["textbox_4_601"] = "";
                        }
                        if (colsec2["textbox_2_634"] == null) {
                          colsec2["textbox_2_634"] = "";
                        }
                        if (colsec2["textbox_3_695"] == null) {
                          colsec2["textbox_3_695"] = "";
                        }
                        if (colsec2["lat_610"] == null) {
                          colsec2["lat_610"] = "";
                        }
                        if (colsec2["long_612"] == null) {
                          colsec2["long_612"] = "";
                        }
                        if (colsec2["lat_616"] == null) {
                          colsec2["lat_616"] = "";
                        }
                        if (colsec2["long_617"] == null) {
                          colsec2["long_617"] = "";
                        }
                        if (colsec2["textbox_626"] == null) {
                          colsec2["textbox_626"] = "0.00";
                        }
                        // this.objcolsection.push(['Start ' + colsec2['textbox_1_593']+' '+
                        // colsec2['textbox_2_594']+' Stop '+colsec2['textbox_3_599']+' '+
                        // colsec2['textbox_4_601'],' Start ' + colsec2['lat_610']+' '+
                        // colsec2['long_612']+' Start Time '+ colsec2['textbox_2_634'] + ' Stop ' + colsec2['lat_616']+' '+colsec2['long_617'] + ' Stop Time ' + colsec2['textbox_3_695'],
                        // colsec2['categories_622'],'-','-', colsec2['textbox_626']+' '+
                        // colsec2['m3_628'],colsec2['remarks_630']]);
                        this.objcolsection.push([
                          "Start " +
                          colsec2["textbox_1_593"] +
                          " " +
                          colsec2["textbox_2_594"] +
                          " Stop " +
                          colsec2["textbox_3_599"] +
                          " " +
                          colsec2["textbox_4_601"],
                          " Start " +
                          colsec2["lat_610"] +
                          " " +
                          colsec2["long_612"] +
                          //+' Start Time '+ colsec2['textbox_2_634']
                          " Stop " +
                          colsec2["lat_616"] +
                          " " +
                          colsec2["long_617"],
                          //' Stop Time ' + colsec2['textbox_3_695'],
                          colsec2["categories_622"],
                          "-",
                          "-",
                          colsec2["textbox_626"] + " " + colsec2["m3_628"],
                          colsec2["remarks_630"],
                        ]);
                        colsec2 = [];
                        this.userSign.push(usersign);
                      }

                      if (colsec3["lat_641"] != null) {
                        if (colsec3["m3_660"] == null) {
                          colsec3["m3_660"] = "";
                        }
                        if (colsec3["textbox_1_635"] == null) {
                          colsec3["textbox_1_635"] = "";
                        }
                        if (colsec3["textbox_2_636"] == null) {
                          colsec3["textbox_2_636"] = "";
                        }
                        if (colsec3["lat_641"] == null) {
                          colsec3["lat_641"] = "";
                        }
                        if (colsec3["textbox_658"] == null) {
                          colsec3["textbox_658"] = "0.00";
                        }
                        if (colsec3["remarks_661"] == null) {
                          colsec3["remarks_661"] = "";
                        }
                        if (colsec3["long_643"] == null) {
                          colsec3["long_643"] = "";
                        }
                        if (colsec3["lat_646"] == null) {
                          colsec3["lat_646"] = "";
                        }
                        if (colsec3["long_648"] == null) {
                          colsec3["long_648"] = "";
                        }

                        this.objcolsection.push([
                          colsec3["textbox_1_635"] +
                          " " +
                          colsec3["textbox_2_636"],
                          " Start " +
                          colsec3["lat_641"] +
                          " " +
                          colsec3["long_643"] +
                          " Stop " +
                          colsec3["lat_646"] +
                          " " +
                          colsec3["long_648"],
                          colsec3["categories_653"],
                          colsec3["textbox_658"] + " " + colsec3["m3_660"],
                          "-",
                          "-",
                          colsec3["remarks_661"],
                        ]);
                        colsec3 = [];
                        this.userSign.push(usersign);
                      }

                      if (colsec4["long_674"] != null) {
                        if (colsec4["textbox_1_666"] == null) {
                          colsec4["textbox_1_666"] = "";
                        }
                        if (colsec4["textbox_2_667"] == null) {
                          colsec4["textbox_2_667"] = "";
                        }
                        if (colsec4["lat_673"] == null) {
                          colsec4["lat_673"] = "";
                        }
                        if (colsec4["long_674"] == null) {
                          colsec4["long_674"] = "";
                        }
                        if (colsec4["water_depth_676"] == null) {
                          colsec4["water_depth_676"] = "";
                        }
                        if (colsec4["textbox_680"] == null) {
                          colsec4["textbox_680"] = "";
                        }
                        if (colsec4["textarea_683"] == null) {
                          colsec4["textarea_683"] = "0.00";
                        }
                        if (colsec4["m3_681"] == null) {
                          colsec4["m3_681"] = "";
                        }

                        if (colsec4["water_depth_676"] == "") {
                          this.objcol.push([
                            colsec4["textbox_1_666"] +
                            " " +
                            colsec4["textbox_2_667"],
                            colsec4["lat_673"] + " " + colsec4["long_674"],
                            colsec4["categories_678"],
                            colsec4["textbox_680"] + " " + colsec4["m3_681"],
                            colsec4["textarea_683"],
                          ]);
                        } else {
                          this.objcol.push([
                            colsec4["textbox_1_666"] +
                            " " +
                            colsec4["textbox_2_667"],
                            colsec4["lat_673"] +
                            " " +
                            colsec4["long_674"] +
                            " " +
                            "Water Depth " +
                            colsec4["water_depth_676"],
                            colsec4["categories_678"],
                            colsec4["textbox_680"] + " " + colsec4["m3_681"],
                            colsec4["textarea_683"],
                          ]);
                        }

                        colsec4 = [];
                        this.userSign.push(usersign);
                      }

                      if (colsec4["name_of_port_675"] != null) {
                        if (colsec4["textbox_1_666"] == null) {
                          colsec4["textbox_1_666"] = "";
                        }
                        if (colsec4["textbox_2_667"] == null) {
                          colsec4["textbox_2_667"] = "";
                        }

                        if (colsec4["textbox_680"] == null) {
                          colsec4["textbox_680"] = "";
                        }
                        if (colsec4["textarea_683"] == null) {
                          colsec4["textarea_683"] = "0.00";
                        }
                        if (colsec4["m3_681"] == null) {
                          colsec4["m3_681"] = "";
                        }
                        if (colsec4["water_depth_676"] == null) {
                          colsec4["water_depth_676"] = "";
                        }

                        if (colsec4["water_depth_676"] == "") {
                          this.objcol.push([
                            colsec4["textbox_1_666"] +
                            " " +
                            colsec4["textbox_2_667"],
                            colsec4["name_of_port_675"],
                            colsec4["categories_678"],
                            colsec4["textbox_680"] + " " + colsec4["m3_681"],
                            colsec4["textarea_683"],
                          ]);
                        } else {
                          this.objcol.push([
                            colsec4["textbox_1_666"] +
                            " " +
                            colsec4["textbox_2_667"],
                            colsec4["name_of_port_675"] +
                            " " +
                            "Water Depth " +
                            colsec4["water_depth_676"],
                            colsec4["categories_678"],
                            colsec4["textbox_680"] + " " + colsec4["m3_681"],
                            colsec4["textarea_683"],
                          ]);
                        }

                        colsec4 = [];
                        this.userSign.push(usersign);
                      }
                    }
                    if (formId == 39) {
                      if (
                        coldate["date_created"] != null &&
                        coldate["date_created"] != ""
                      ) {
                        var date = new Date(coldate["date_created"]);
                        var day = date.getDate();
                        var time = date.getHours() + ":" + date.getMinutes();
                        var month = date.getMonth() + 1;
                        var year = date.getFullYear();

                        var fullDate =
                          year + "-" + month + "-" + day + " " + time;

                        var sectionLenght = coldate["section_length"];
                        this.createdAt.push([
                          year + "-" + month + "-" + day,
                          sectionLenght,
                        ]);
                      }
                      //this.in_array(colsec1,'<b>')
                      if (colsec1["j_579"] != null) {
                        var placcombintaion = "";
                        if (colsec1["textbox_1_566"] == null) {
                          colsec1["textbox_1_566"] = "";
                        }
                        if (colsec1["textbox_2_567"] == null) {
                          colsec1["textbox_2_567"] = "";
                        }
                        if (colsec1["lat_570"] == null) {
                          colsec1["lat_570"] = "";
                        }
                        if (colsec1["long_571"] == null) {
                          colsec1["long_571"] = "";
                        }
                        if (colsec1["j_579"] == null) {
                          colsec1["j_579"] = "";
                        }
                        if (colsec1["textbox_3_586"] == null) {
                          colsec1["textbox_3_586"] = "0.00";
                        }
                        this.objcolsection.push([
                          colsec1["textbox_1_566"] +
                          " " +
                          colsec1["textbox_2_567"],
                          colsec1["lat_570"] + " " + colsec1["long_571"],
                          colsec1["j_579"],
                          "-",
                          colsec1["textbox_3_586"] + " " + colsec1["m3_587"],
                          "-",
                        ]);
                        colsec1 = [];
                        this.userSign.push(usersign);
                      }

                      if (colsec2["k_697"] != null) {
                        if (colsec2["textbox_1_633"] == null) {
                          colsec2["textbox_1_633"] = "";
                        }
                        if (colsec2["textbox_2_634"] == null) {
                          colsec2["textbox_2_634"] = "";
                        }
                        if (colsec2["lat_686"] == null) {
                          colsec2["lat_686"] = "";
                        }
                        if (colsec2["long_687"] == null) {
                          colsec2["long_687"] = "";
                        }
                        if (colsec2["k_697"] == null) {
                          colsec2["k_697"] = "";
                        }
                        if (colsec2["lat_689"] == null) {
                          colsec2["lat_689"] = "";
                        }
                        if (colsec2["long_690"] == null) {
                          colsec2["long_690"] = "";
                        }
                        if (colsec2["textbox_2_634"] == null) {
                          colsec2["textbox_2_634"] = "";
                        }
                        if (colsec2["lat_692"] == null) {
                          colsec2["lat_692"] = "";
                        }
                        if (colsec2["long_693"] == null) {
                          colsec2["long_693"] = "";
                        }
                        if (colsec2["textbox_3_695"] == null) {
                          colsec2["textbox_3_695"] = "";
                        }

                        this.objcolsection.push([
                          colsec2["textbox_1_633"] +
                          " " +
                          colsec2["textbox_2_634"],
                          colsec2["lat_686"] + " " + colsec2["long_687"],
                          colsec2["k_697"],
                          colsec2["textbox_4_699"],
                          "-",
                          "start " +
                          colsec2["lat_689"] +
                          " " +
                          colsec2["long_690"] +
                          " " +
                          colsec2["textbox_2_634"] +
                          " \nstop " +
                          colsec2["lat_692"] +
                          " " +
                          colsec2["long_693"] +
                          " " +
                          colsec2["textbox_3_695"],
                        ]);
                        colsec2 = [];
                        this.userSign.push(usersign);
                      }
                    }
                  }

                  // console.log("mylog::mylog");
                  // console.log(this.objcolsection);
                  this.createCollectionLayout(this.objcolsection);
                  this.createCollectionLayout(this.objcol);
                  // console.log(this.objcol);
                  // console.log(this.userSign);
                  if (
                    this.fSection1.length > 0 ||
                    this.fSection5.length > 0 ||
                    this.fSection2.length > 0 ||
                    this.fSection3.length > 0 ||
                    this.fSection4.length > 0
                  ) {
                    this.createCollectionLayout(this.fSection1);
                    this.createCollectionLayout(this.fSection2);
                    this.createCollectionLayout(this.fSection3);
                    this.createCollectionLayout(this.fSection4);
                    this.createCollectionLayout(this.fSection5);

                    this.objcolcollection.push(this.fSection1);
                    this.objcolcollection.push(this.fSection2);
                    this.objcolcollection.push(this.fSection3);
                    this.objcolcollection.push(this.fSection4);
                    this.objcolcollection.push(this.fSection5);
                  }
                  // console.log(this.objcolcollection);
                }
                //console.log(this.formDetails);
              }
            );
          }
        }

        // console.log(this.formCount);
      }
    }
  }


  createCollectionLayout(collection) {
    // console.log("==collection==",collection);
    for (let key in collection) {
      for (let pey in collection[key]) {
        const value = collection[key][pey];

        if (value && value.includes("<b>") && !value.includes("box-edit-message")) {
          let oldValue = value;
          let newValue = value;

          // Remove all <b>...</b> contents from oldValue
          oldValue = this.removeTagsRecursive(oldValue, "b");

          // Remove all <strike>...</strike> contents from newValue
          newValue = this.removeTagsRecursive(newValue, "strike");

          if (oldValue !== newValue) {
            collection[key][pey] = `
              <div class="box-edit-top">
                ${oldValue.replace(/<strike>/gi, '<strike class="strike">')}
              </div>
              <div class="box-edit-message">
                ${newValue}<br>${this.editedBy}
              </div>`;
          }
        }
      }
      // console.log("==collection==",collection);
    }
  }

  removeTagsRecursive(input, tag) {
    let result = input;
    const tagOpen = `<${tag}>`;
    const tagClose = `</${tag}>`;

    while (result.includes(tagOpen)) {
      const start = result.indexOf(tagOpen);
      const end = result.indexOf(tagClose, start);
      if (end === -1) break;

      const inner = result.substring(start + tagOpen.length, end);
      result = result.replace(`${tagOpen}${inner}${tagClose}`, '');
    }

    return result.replace(new RegExp(`<${tag}></${tag}>`, 'g'), '');
  }


  callHTypeAudit(
    hid,
    actionDate = "",
    actionTime = "",
    fromDate = "",
    toDate = ""
  ) {
    if (hid == 42 || hid == 43) {
    } else {
      // console.log("not found");
      return;
    }

    for (var i = 0; i < this.formBuilder.length; i++) {
      if (this.formBuilder[i].hid == hid) {
        this.formCount = [];
        for (
          var r = 0;
          r < this.formBuilder[i].formbuilderresponse.length;
          r++
        ) {
          var formId = this.formBuilder[i].formbuilderresponse[r].formId;
          if ((formId == 40 && hid == 42) || (formId == 41 && hid == 43)) {
            //alert(this.formBuilder[i].formbuilderresponse[r].formName + ' form Id' + formId );
            this.formCount.push(
              this.formBuilder[i].formbuilderresponse[r].formName
            );
            this.formBuilderSections = [];
            for (
              var u = 0;
              u <
              this.formBuilder[i].formbuilderresponse[r]
                .formbuildersectionnamelist.length;
              u++
            ) {
              this.formBuilderSections.push(
                this.formBuilder[i].formbuilderresponse[r]
                  .formbuildersectionnamelist[u]
              ); //.formbuilderlist
            }

            this.objcolsection = [];
            this.objcol = [];

            this.editlogbookformsService.getFormDetailsByActionDateAndTime(
              formId,
              this.voyageNo,
              actionDate,
              actionTime,
              fromDate,
              toDate,
              (formResponse) => {
                var response = this.modifyedData(formResponse[0]);
                if (response.data != null) {
                  for (var s = 0; s < response.data.length; s++) {
                    if (response.data[s].isDelete == "1") continue;
                    var findKey = false;
                    var sectionName = "";
                    this.formDetails = [];
                    var colsec1 = [];
                    var colsec2 = [];
                    var colsec3 = [];
                    var colsec4 = [];
                    var colsec5 = [];
                    var colsec6 = [];
                    var coldate = [];
                    this.showpop1 = 0;
                    this.showpop2 = 0;
                    var usersign = "";
                    this.editedBy = "";
                    var signdate = "";
                    var masterName = "";
                    var masterSignature = "";
                    var roleId = "";
                    var roleName = "";
                    var id = "";
                    if (response.data[s].editedBy != null) {
                      this.editedBy = response.data[s].editedBy;
                    }
                    usersign = response.data[s].userSign;

                    for (let key in response.data[s]) {
                      for (
                        var p = 0;
                        p < this.formBuilderSections.length;
                        p++
                      ) {
                        for (
                          var v = 0;
                          v <
                          this.formBuilderSections[p].formbuilderlist.length;
                          v++
                        ) {
                          //alert(key.toString().toLowerCase());
                          //console.log(key.toString().toLowerCase() + '-- field--' + this.formBuilderSections[p].formbuilderlist[v].fieldName.toString().toLowerCase() + '_' + this.formBuilderSections[p].formbuilderlist[v].fieldId.toString().toLowerCase());
                          if (
                            key.toString().toLowerCase() == "created_at" &&
                            response.data[s][key] != ""
                          ) {
                            coldate["date_created"] = response.data[s][key];
                            coldate[
                              "section_length"
                            ] = this.formBuilderSections.length;
                          }
                          if (
                            key.toString().toLowerCase() ==
                            this.formBuilderSections[p].formbuilderlist[
                              v
                            ].fieldName
                              .toString()
                              .toLowerCase()
                          ) {
                            //alert(key.toString().toLowerCase() + '-- field--' + this.formBuilderSections[p].formbuilderlist[v].fieldName.toString().toLowerCase());
                            sectionName = this.formBuilderSections[p]
                              .sectionName;

                            if (formId == 41) {
                              if (
                                response.data[s].date != null &&
                                response.data[s].date != ""
                              ) {
                                signdate = response.data[s].date;
                              }

                              if (
                                response.data[s].masterName != null &&
                                response.data[s].masterName != ""
                              ) {
                                masterName = response.data[s].masterName;
                              }

                              if (
                                response.data[s].masterSignature != null &&
                                response.data[s].masterSignature != ""
                              ) {
                                masterSignature =
                                  response.data[s].masterSignature;
                              }

                              if (
                                response.data[s].roleId != null &&
                                response.data[s].roleId != ""
                              ) {
                                roleId = response.data[s].roleId;
                              }

                              if (
                                response.data[s].roleName != null &&
                                response.data[s].roleName != ""
                              ) {
                                roleName = response.data[s].roleName;
                              }
                              if (
                                response.data[s]._id.$oid != null &&
                                response.data[s]._id.$oid != ""
                              ) {
                                id = response.data[s]._id.$oid;
                              }

                              this.masterSignature = masterSignature;
                              this.signdate = signdate;
                              this.roleName = roleName;
                              this.masterName = masterName;
                              this.id = id;
                              this.formId = formId;

                              this.auditform = 2;

                              if (p == 0) {
                                if (
                                  (key.toString().toLowerCase() ==
                                    "Rank_759".toString().toLowerCase() &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Name_of_officer_760"
                                      .toString()
                                      .toLowerCase() &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Certificate_761"
                                      .toString()
                                      .toLowerCase() &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Date_of_joining_762"
                                      .toString()
                                      .toLowerCase() &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "officers_date_of_joining_763"
                                      .toString()
                                      .toLowerCase() &&
                                    response.data[s][key] != "")
                                ) {
                                  colsec1[key.toString().toLowerCase()] =
                                    response.data[s][key];
                                }
                                //
                              }

                              if (p == 1) {
                                if (
                                  (key.toString().toLowerCase() ==
                                    "code_no_764".toString().toLowerCase() &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "name_765".toString().toLowerCase() &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "SIB_No_766".toString().toLowerCase() &&
                                    response.data[s][key] != "")
                                ) {
                                  colsec2[key.toString().toLowerCase()] =
                                    response.data[s][key];
                                }
                                //
                              }

                              if (p == 2) {
                                if (
                                  (key.toString().toLowerCase() ==
                                    "crew_name_767".toString().toLowerCase() &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "crew_rank_768".toString().toLowerCase() &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "crew_place_769".toString().toLowerCase() &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "crew_date_770".toString().toLowerCase() &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "crew_reason_771"
                                      .toString()
                                      .toLowerCase() &&
                                    response.data[s][key] != "")
                                ) {
                                  colsec3[key.toString().toLowerCase()] =
                                    response.data[s][key];
                                }
                                //
                              }
                            }

                            if (formId == 40) {
                              if (
                                response.data[s].date != null &&
                                response.data[s].date != ""
                              ) {
                                signdate = response.data[s].date;
                              }

                              if (
                                response.data[s].masterName != null &&
                                response.data[s].masterName != ""
                              ) {
                                masterName = response.data[s].masterName;
                              }

                              if (
                                response.data[s].masterSignature != null &&
                                response.data[s].masterSignature != ""
                              ) {
                                masterSignature =
                                  response.data[s].masterSignature;
                              }

                              if (
                                response.data[s].roleId != null &&
                                response.data[s].roleId != ""
                              ) {
                                roleId = response.data[s].roleId;
                              }

                              if (
                                response.data[s].roleName != null &&
                                response.data[s].roleName != ""
                              ) {
                                roleName = response.data[s].roleName;
                              }
                              if (
                                response.data[s]._id.$oid != null &&
                                response.data[s]._id.$oid != ""
                              ) {
                                id = response.data[s]._id.$oid;
                              }

                              this.masterSignature = masterSignature;
                              this.signdate = signdate;
                              this.roleName = roleName;
                              this.masterName = masterName;
                              this.id = id;
                              this.formId = formId;

                              this.auditform = 1;
                              //alert('hi')

                              if (p == 0) {
                                if (
                                  (key.toString().toLowerCase() ==
                                    "Participants_704"
                                      .toString()
                                      .toLowerCase() &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Drill_Date_702".toString().toLowerCase() &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Drill_Description_703"
                                      .toString()
                                      .toLowerCase() &&
                                    response.data[s][key] != "")
                                ) {
                                  colsec1[key.toString().toLowerCase()] =
                                    response.data[s][key];
                                }
                                //
                              }

                              if (p == 1) {
                                if (
                                  (key.toString().toLowerCase() ==
                                    "Date_Time_of_Departure_705"
                                      .toString()
                                      .toLowerCase() &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Date_of_Departure_706"
                                      .toString()
                                      .toLowerCase() &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Time_of_departure_707"
                                      .toString()
                                      .toLowerCase() &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Port_708".toString().toLowerCase() &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Name_of_Port_709"
                                      .toString()
                                      .toLowerCase() &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Draft_710".toString().toLowerCase() &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Draft_Fwd_711".toString().toLowerCase() &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Draft_Alt_712".toString().toLowerCase() &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Actual_Freeboard_Amidships_713"
                                      .toString()
                                      .toLowerCase() &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Amidship_port_714"
                                      .toString()
                                      .toLowerCase() &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Amidship_stbd_715"
                                      .toString()
                                      .toLowerCase() &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Amidships_mean_716"
                                      .toString()
                                      .toLowerCase() &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Density_of_water_717"
                                      .toString()
                                      .toLowerCase() &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Allowance_for_density_718"
                                      .toString()
                                      .toLowerCase() &&
                                    response.data[s][key] != "")
                                ) {
                                  colsec2[key.toString().toLowerCase()] =
                                    response.data[s][key];
                                }
                              }
                              //
                              if (p == 2) {
                                if (
                                  (key.toString().toLowerCase() ==
                                    "Inspections_have_been_carried_out_719"
                                      .toString()
                                      .toLowerCase() &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Equipment_720".toString().toLowerCase() &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Date_of_equipment_721"
                                      .toString()
                                      .toLowerCase() &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Firemens_outfits_722"
                                      .toString()
                                      .toLowerCase() &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Fire_extinguishers_723"
                                      .toString()
                                      .toLowerCase() &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Fire_hydrants_724"
                                      .toString()
                                      .toLowerCase() &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Hoses_and_nozzles_725"
                                      .toString()
                                      .toLowerCase() &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "correct_position_726"
                                      .toString()
                                      .toLowerCase() &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "position_date_727"
                                      .toString()
                                      .toLowerCase() &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "fire_pumps_operated_728"
                                      .toString()
                                      .toLowerCase() &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "pumps_729".toString().toLowerCase() &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "free_from_leakage_730"
                                      .toString()
                                      .toLowerCase() &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "fire_extinguishing_installation_731"
                                      .toString()
                                      .toLowerCase() &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "General_Remarks_732"
                                      .toString()
                                      .toLowerCase() &&
                                    response.data[s][key] != "")
                                ) {
                                  colsec3[key.toString().toLowerCase()] =
                                    response.data[s][key];
                                }
                                //
                              }

                              if (p == 3) {
                                if (
                                  (key.toString().toLowerCase() ==
                                    "Test_and_inspections_733"
                                      .toString()
                                      .toLowerCase() &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "survival_craft_734"
                                      .toString()
                                      .toLowerCase() &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "survival_craft_date_735"
                                      .toString()
                                      .toLowerCase() &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "lifeboats_and_rescue_boats_736"
                                      .toString()
                                      .toLowerCase() &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "lifeboats_and_rescue_boats_date_737"
                                      .toString()
                                      .toLowerCase() &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Lifeboats_moved_738"
                                      .toString()
                                      .toLowerCase() &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Lifeboats_moved_date_739"
                                      .toString()
                                      .toLowerCase() &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "emergency_alarm_740"
                                      .toString()
                                      .toLowerCase() &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "emergency_alarm_date_741"
                                      .toString()
                                      .toLowerCase() &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "General_Remarks_742"
                                      .toString()
                                      .toLowerCase() &&
                                    response.data[s][key] != "")
                                ) {
                                  colsec4[key.toString().toLowerCase()] =
                                    response.data[s][key];
                                }
                                //
                              }

                              if (p == 4) {
                                if (
                                  (key.toString().toLowerCase() ==
                                    "test_and_inspections_743"
                                      .toString()
                                      .toLowerCase() &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "lifeboats_turned_744"
                                      .toString()
                                      .toLowerCase() &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "lifeboats_turned_date_745"
                                      .toString()
                                      .toLowerCase() &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "ispection_of_immersion_746"
                                      .toString()
                                      .toLowerCase() &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "ispection_of_immersion_date_747"
                                      .toString()
                                      .toLowerCase() &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "General_Remarks_748"
                                      .toString()
                                      .toLowerCase() &&
                                    response.data[s][key] != "")
                                ) {
                                  colsec5[key.toString().toLowerCase()] =
                                    response.data[s][key];
                                }
                                //
                              }

                              if (p == 5) {
                                if (
                                  (key.toString().toLowerCase() ==
                                    "inspections_examinations_749"
                                      .toString()
                                      .toLowerCase() &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Internation_shore_connection_750"
                                      .toString()
                                      .toLowerCase() &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "shore_connection_date_751"
                                      .toString()
                                      .toLowerCase() &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "fire_fighting_equipment_752"
                                      .toString()
                                      .toLowerCase() &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "fire_fighting_equipment_date_753"
                                      .toString()
                                      .toLowerCase() &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "fire_doors_and_dampers_754"
                                      .toString()
                                      .toLowerCase() &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "doors_dampers_date_755"
                                      .toString()
                                      .toLowerCase() &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Bottle_connections_756"
                                      .toString()
                                      .toLowerCase() &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Bottle_connections_date_757"
                                      .toString()
                                      .toLowerCase() &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "examination_and_inspection_remarks_758"
                                      .toString()
                                      .toLowerCase() &&
                                    response.data[s][key] != "")
                                ) {
                                  colsec6[key.toString().toLowerCase()] =
                                    response.data[s][key];
                                }
                                //
                              }
                            }
                          }
                        }
                      }
                    }

                    if (formId == 41) {
                      if (
                        coldate["date_created"] != null &&
                        coldate["date_created"] != ""
                      ) {
                        var date = new Date(coldate["date_created"]);
                        var day = date.getDate();
                        var month = date.getMonth() + 1;
                        var year = date.getFullYear();

                        var sectionLenght = coldate["section_length"];
                        this.createdAt.push([
                          year + "-" + month + "-" + day,
                          sectionLenght,
                        ]);
                      }

                      if (
                        colsec1["Rank_759".toString().toLowerCase()] != null &&
                        colsec1["Rank_759".toString().toLowerCase()] != ""
                      ) {
                        if (
                          colsec1[
                          "Name_of_officer_760".toString().toLowerCase()
                          ] == null
                        ) {
                          colsec1[
                            "Name_of_officer_760".toString().toLowerCase()
                          ] = "";
                        }
                        if (
                          colsec1["Certificate_761".toString().toLowerCase()] ==
                          null
                        ) {
                          colsec1["Certificate_761".toString().toLowerCase()] =
                            "";
                        }
                        if (
                          colsec1[
                          "Date_of_joining_762".toString().toLowerCase()
                          ] == null
                        ) {
                          colsec1[
                            "Date_of_joining_762".toString().toLowerCase()
                          ] = "";
                        }
                        if (
                          colsec1[
                          "officers_date_of_joining_763"
                            .toString()
                            .toLowerCase()
                          ] == null
                        ) {
                          colsec1[
                            "officers_date_of_joining_763"
                              .toString()
                              .toLowerCase()
                          ] = "";
                        }

                        this.fSection1.push([
                          colsec1["Rank_759".toString().toLowerCase()],
                          colsec1[
                          "Name_of_officer_760".toString().toLowerCase()
                          ],
                          colsec1["Certificate_761".toString().toLowerCase()],
                          colsec1[
                          "officers_date_of_joining_763"
                            .toString()
                            .toLowerCase()
                          ],
                          colsec1[
                          "officers_date_of_joining_763"
                            .toString()
                            .toLowerCase()
                          ],
                        ]);
                        this.userSign.push(usersign);
                      }

                      if (
                        colsec2["code_no_764".toString().toLowerCase()] !=
                        null &&
                        colsec2["code_no_764".toString().toLowerCase()] != ""
                      ) {
                        if (
                          colsec2["name_765".toString().toLowerCase()] == null
                        ) {
                          colsec2["name_765".toString().toLowerCase()] = "";
                        }
                        if (
                          colsec2["SIB_No_766".toString().toLowerCase()] == null
                        ) {
                          colsec2["SIB_No_766".toString().toLowerCase()] = "";
                        }

                        this.fSection2.push([
                          colsec2["code_no_764".toString().toLowerCase()],
                          colsec2["name_765".toString().toLowerCase()],
                          colsec2["SIB_No_766".toString().toLowerCase()],
                        ]);
                        this.userSign.push(usersign);
                      }

                      if (
                        colsec3["crew_name_767".toString().toLowerCase()] !=
                        null &&
                        colsec3["crew_name_767".toString().toLowerCase()] != ""
                      ) {
                        if (
                          colsec3["crew_rank_768".toString().toLowerCase()] ==
                          null
                        ) {
                          colsec3["crew_rank_768".toString().toLowerCase()] =
                            "";
                        }
                        if (
                          colsec3["crew_place_769".toString().toLowerCase()] ==
                          null
                        ) {
                          colsec3["crew_place_769".toString().toLowerCase()] =
                            "";
                        }
                        if (
                          colsec3["crew_date_770".toString().toLowerCase()] ==
                          null
                        ) {
                          colsec3["crew_date_770".toString().toLowerCase()] =
                            "";
                        }
                        if (
                          colsec3["crew_reason_771".toString().toLowerCase()] ==
                          null
                        ) {
                          colsec3["crew_reason_771".toString().toLowerCase()] =
                            "";
                        }

                        this.fSection3.push([
                          colsec3["crew_name_767".toString().toLowerCase()],
                          colsec3["crew_rank_768".toString().toLowerCase()],
                          colsec3["crew_place_769".toString().toLowerCase()],
                          colsec3["crew_date_770".toString().toLowerCase()],
                          colsec3["crew_reason_771".toString().toLowerCase()],
                        ]);
                        this.userSign.push(usersign);
                      }
                    }

                    if (formId == 40) {
                      if (
                        coldate["date_created"] != null &&
                        coldate["date_created"] != ""
                      ) {
                        var date = new Date(coldate["date_created"]);
                        var day = date.getDate();
                        var month = date.getMonth() + 1;
                        var year = date.getFullYear();

                        var sectionLenght = coldate["section_length"];
                        this.createdAt.push([
                          year + "-" + month + "-" + day,
                          sectionLenght,
                        ]);
                      }

                      if (
                        colsec1["Drill_Date_702".toString().toLowerCase()] !=
                        null &&
                        colsec1["Drill_Date_702".toString().toLowerCase()] != ""
                      ) {
                        if (
                          colsec1[
                          "Participants_704".toString().toLowerCase()
                          ] == null
                        ) {
                          colsec1["Participants_704".toString().toLowerCase()] =
                            "";
                        }
                        if (
                          colsec1["Drill_Date_702".toString().toLowerCase()] ==
                          null
                        ) {
                          colsec1["Drill_Date_702".toString().toLowerCase()] =
                            "";
                        }
                        if (
                          colsec1[
                          "Drill_Description_703".toString().toLowerCase()
                          ] == null
                        ) {
                          colsec1[
                            "Drill_Description_703".toString().toLowerCase()
                          ] = "";
                        }

                        this.fSection1.push([
                          colsec1["Drill_Date_702".toString().toLowerCase()],
                          colsec1[
                          "Drill_Description_703".toString().toLowerCase()
                          ],
                          colsec1["Participants_704".toString().toLowerCase()],
                        ]);
                        this.userSign.push(usersign);
                      }

                      if (
                        colsec2[
                        "Date_Time_of_Departure_705".toString().toLowerCase()
                        ] != null &&
                        colsec2["no_983".toString().toLowerCase()] != ""
                      ) {
                        if (
                          colsec2[
                          "Date_Time_of_Departure_705"
                            .toString()
                            .toLowerCase()
                          ] == null
                        ) {
                          colsec2[
                            "Date_Time_of_Departure_705"
                              .toString()
                              .toLowerCase()
                          ] = "";
                        }
                        if (
                          colsec2[
                          "Date_of_Departure_706".toString().toLowerCase()
                          ] == null
                        ) {
                          colsec2[
                            "Date_of_Departure_706".toString().toLowerCase()
                          ] = "";
                        }
                        if (
                          colsec2[
                          "Time_of_departure_707".toString().toLowerCase()
                          ] == null
                        ) {
                          colsec2[
                            "Time_of_departure_707".toString().toLowerCase()
                          ] = "";
                        }
                        if (
                          colsec2[
                          "Name_of_Port_709".toString().toLowerCase()
                          ] == null
                        ) {
                          colsec2["Name_of_Port_709".toString().toLowerCase()] =
                            "";
                        }
                        if (
                          colsec2["Draft_Fwd_711".toString().toLowerCase()] ==
                          null
                        ) {
                          colsec2["Draft_Fwd_711".toString().toLowerCase()] =
                            "";
                        }
                        if (
                          colsec2["Draft_Alt_712".toString().toLowerCase()] ==
                          null
                        ) {
                          colsec2["Draft_Alt_712".toString().toLowerCase()] =
                            "";
                        }
                        if (
                          colsec2[
                          "Actual_Freeboard_Amidships_713"
                            .toString()
                            .toLowerCase()
                          ] == null
                        ) {
                          colsec2[
                            "Actual_Freeboard_Amidships_713"
                              .toString()
                              .toLowerCase()
                          ] = "";
                        }
                        if (
                          colsec2[
                          "Amidship_port_714".toString().toLowerCase()
                          ] == null
                        ) {
                          colsec2[
                            "Amidship_port_714".toString().toLowerCase()
                          ] = "";
                        }
                        if (
                          colsec2[
                          "Amidship_stbd_715".toString().toLowerCase()
                          ] == null
                        ) {
                          colsec2[
                            "Amidship_stbd_715".toString().toLowerCase()
                          ] = "";
                        }
                        if (
                          colsec2[
                          "Amidships_mean_716".toString().toLowerCase()
                          ] == null
                        ) {
                          colsec2[
                            "Amidships_mean_716".toString().toLowerCase()
                          ] = "";
                        }
                        if (
                          colsec2[
                          "Density_of_water_717".toString().toLowerCase()
                          ] == null
                        ) {
                          colsec2[
                            "Density_of_water_717".toString().toLowerCase()
                          ] = "";
                        }
                        if (
                          colsec2[
                          "Allowance_for_density_718".toString().toLowerCase()
                          ] == null
                        ) {
                          colsec2[
                            "Allowance_for_density_718".toString().toLowerCase()
                          ] = "";
                        }

                        this.fSection2.push([
                          colsec2[
                          "Date_of_Departure_706".toString().toLowerCase()
                          ] +
                          " " +
                          colsec2[
                          "Time_of_departure_707".toString().toLowerCase()
                          ],
                          colsec2["Port_708".toString().toLowerCase()],
                          //colsec2['Name_of_Port_709'.toString().toLowerCase()] ,
                          colsec2["Draft_Fwd_711".toString().toLowerCase()],
                          colsec2["Draft_Alt_712".toString().toLowerCase()],
                          //colsec2['Actual_Freeboard_Amidships_713'.toString().toLowerCase()]  ,
                          colsec2["Amidship_port_714".toString().toLowerCase()],
                          colsec2["Amidship_stbd_715".toString().toLowerCase()],
                          colsec2[
                          "Amidships_mean_716".toString().toLowerCase()
                          ],
                          colsec2[
                          "Density_of_water_717".toString().toLowerCase()
                          ],
                          colsec2[
                          "Allowance_for_density_718".toString().toLowerCase()
                          ],
                        ]);
                        this.userSign.push(usersign);
                      }

                      if (
                        colsec3[
                        "Inspections_have_been_carried_out_719"
                          .toString()
                          .toLowerCase()
                        ] != null &&
                        colsec3[
                        "Inspections_have_been_carried_out_719"
                          .toString()
                          .toLowerCase()
                        ] != ""
                      ) {
                        if (
                          colsec3["Equipment_720".toString().toLowerCase()] ==
                          null
                        ) {
                          colsec3["Equipment_720".toString().toLowerCase()] =
                            "";
                        }
                        if (
                          colsec3[
                          "Date_of_equipment_721".toString().toLowerCase()
                          ] == null
                        ) {
                          colsec3[
                            "Date_of_equipment_721".toString().toLowerCase()
                          ] = "";
                        }
                        if (
                          colsec3[
                          "Firemens_outfits_722".toString().toLowerCase()
                          ] == null
                        ) {
                          colsec3[
                            "Firemens_outfits_722".toString().toLowerCase()
                          ] = "";
                        }
                        if (
                          colsec3[
                          "Fire_extinguishers_723".toString().toLowerCase()
                          ] == null
                        ) {
                          colsec3[
                            "Fire_extinguishers_723".toString().toLowerCase()
                          ] = "";
                        }
                        if (
                          colsec3[
                          "Fire_hydrants_724".toString().toLowerCase()
                          ] == null
                        ) {
                          colsec3[
                            "Fire_hydrants_724".toString().toLowerCase()
                          ] = "";
                        }
                        if (
                          colsec3[
                          "Hoses_and_nozzles_725".toString().toLowerCase()
                          ] == null
                        ) {
                          colsec3[
                            "Hoses_and_nozzles_725".toString().toLowerCase()
                          ] = "";
                        }
                        if (
                          colsec3[
                          "correct_position_726".toString().toLowerCase()
                          ] == null
                        ) {
                          colsec3[
                            "correct_position_726".toString().toLowerCase()
                          ] = "";
                        }
                        if (
                          colsec3[
                          "position_date_727".toString().toLowerCase()
                          ] == null
                        ) {
                          colsec3[
                            "Location_when_bunkered_1005"
                              .toString()
                              .toLowerCase()
                          ] = "";
                        }
                        if (
                          colsec3[
                          "fire_pumps_operated_728".toString().toLowerCase()
                          ] == null
                        ) {
                          colsec3[
                            "fire_pumps_operated_728".toString().toLowerCase()
                          ] = "";
                        }
                        if (
                          colsec3["pumps_729".toString().toLowerCase()] == null
                        ) {
                          colsec3["pumps_729".toString().toLowerCase()] = "";
                        }
                        if (
                          colsec3[
                          "free_from_leakage_730".toString().toLowerCase()
                          ] == null
                        ) {
                          colsec3[
                            "free_from_leakage_730".toString().toLowerCase()
                          ] = "";
                        }
                        if (
                          colsec3[
                          "fire_extinguishing_installation_731"
                            .toString()
                            .toLowerCase()
                          ] == null
                        ) {
                          colsec3[
                            "fire_extinguishing_installation_731"
                              .toString()
                              .toLowerCase()
                          ] = "";
                        }
                        if (
                          colsec3[
                          "General_Remarks_732".toString().toLowerCase()
                          ] == null
                        ) {
                          colsec3[
                            "General_Remarks_732".toString().toLowerCase()
                          ] = "";
                        }

                        // Bunker_Delivery_Note_Ref_997,(Port_Name_998 + Delivery_Date_999),Fuel_Type_1001,t_1003,Tank_No_1006,Quantity_1007
                        this.fSection3.push([
                          colsec3["Equipment_720".toString().toLowerCase()] +
                          " " +
                          colsec3[
                          "Firemens_outfits_722".toString().toLowerCase()
                          ] +
                          " " +
                          colsec3[
                          "Fire_extinguishers_723".toString().toLowerCase()
                          ] +
                          " " +
                          colsec3[
                          "Fire_hydrants_724".toString().toLowerCase()
                          ] +
                          " " +
                          colsec3[
                          "Hoses_and_nozzles_725".toString().toLowerCase()
                          ],
                          colsec3[
                          "Date_of_equipment_721".toString().toLowerCase()
                          ],
                        ]);

                        this.userSign.push(usersign);
                        this.fSection3.push([
                          +" " +
                          colsec3[
                          "correct_position_726".toString().toLowerCase()
                          ],
                          colsec3["position_date_727".toString().toLowerCase()],
                        ]);

                        this.userSign.push(usersign);
                        this.fSection3.push([
                          colsec3[
                          "fire_pumps_operated_728".toString().toLowerCase()
                          ],
                          colsec3["pumps_729".toString().toLowerCase()],
                        ]);

                        this.userSign.push(usersign);
                        this.fSection3.push([
                          colsec3[
                          "free_from_leakage_730".toString().toLowerCase()
                          ],
                          //+ ' ' + colsec3['fire_extinguishing_installation_731'.toString().toLowerCase()]
                          //+ ' ' +  colsec3['General_Remarks_732'.toString().toLowerCase()]
                          colsec3[
                          "fire_extinguishing_installation_731"
                            .toString()
                            .toLowerCase()
                          ],
                        ]);

                        this.userSign.push(usersign);
                        this.fSection3.push([
                          "Remarks: " +
                          colsec3[
                          "General_Remarks_732".toString().toLowerCase()
                          ],
                          " ",
                        ]);

                        this.userSign.push(usersign);
                      }

                      if (
                        colsec4[
                        "Test_and_inspections_733".toString().toLowerCase()
                        ] != null &&
                        colsec4[
                        "Test_and_inspections_733".toString().toLowerCase()
                        ] != ""
                      ) {
                        if (
                          colsec4[
                          "survival_craft_734".toString().toLowerCase()
                          ] == null
                        ) {
                          colsec4[
                            "survival_craft_734".toString().toLowerCase()
                          ] = "";
                        }
                        if (
                          colsec4[
                          "survival_craft_date_735".toString().toLowerCase()
                          ] == null
                        ) {
                          colsec4[
                            "survival_craft_date_735".toString().toLowerCase()
                          ] = "";
                        }
                        if (
                          colsec4[
                          "lifeboats_and_rescue_boats_736"
                            .toString()
                            .toLowerCase()
                          ] == null
                        ) {
                          colsec4[
                            "lifeboats_and_rescue_boats_736"
                              .toString()
                              .toLowerCase()
                          ] = "";
                        }
                        if (
                          colsec4[
                          "lifeboats_and_rescue_boats_date_737"
                            .toString()
                            .toLowerCase()
                          ] == null
                        ) {
                          colsec4[
                            "lifeboats_and_rescue_boats_date_737"
                              .toString()
                              .toLowerCase()
                          ] = "";
                        }
                        if (
                          colsec4[
                          "Lifeboats_moved_738".toString().toLowerCase()
                          ] == null
                        ) {
                          colsec4[
                            "Lifeboats_moved_738".toString().toLowerCase()
                          ] = "";
                        }
                        if (
                          colsec4[
                          "Lifeboats_moved_date_739".toString().toLowerCase()
                          ] == null
                        ) {
                          colsec4[
                            "Lifeboats_moved_date_739".toString().toLowerCase()
                          ] = "";
                        }
                        if (
                          colsec4[
                          "emergency_alarm_740".toString().toLowerCase()
                          ] == null
                        ) {
                          colsec4[
                            "emergency_alarm_740".toString().toLowerCase()
                          ] = "";
                        }
                        if (
                          colsec4[
                          "emergency_alarm_date_741".toString().toLowerCase()
                          ] == null
                        ) {
                          colsec4[
                            "emergency_alarm_date_741".toString().toLowerCase()
                          ] = "";
                        }
                        if (
                          colsec4[
                          "General_Remarks_742".toString().toLowerCase()
                          ] == null
                        ) {
                          colsec4[
                            "General_Remarks_742".toString().toLowerCase()
                          ] = "";
                        }

                        // Bunker_Delivery_Note_Ref_997,(Port_Name_998 + Delivery_Date_999),Fuel_Type_1001,t_1003,Tank_No_1006,Quantity_1007
                        this.fSection4.push([
                          colsec4[
                          "survival_craft_734".toString().toLowerCase()
                          ],
                          colsec4[
                          "survival_craft_date_735".toString().toLowerCase()
                          ],
                        ]);
                        this.userSign.push(usersign);
                        this.fSection4.push([
                          colsec4[
                          "lifeboats_and_rescue_boats_736"
                            .toString()
                            .toLowerCase()
                          ],
                          colsec4[
                          "lifeboats_and_rescue_boats_date_737"
                            .toString()
                            .toLowerCase()
                          ],
                        ]);
                        this.userSign.push(usersign);
                        this.fSection4.push([
                          colsec4[
                          "Lifeboats_moved_738".toString().toLowerCase()
                          ],
                          colsec4[
                          "Lifeboats_moved_date_739".toString().toLowerCase()
                          ],
                        ]);
                        this.userSign.push(usersign);
                        this.fSection4.push([
                          colsec4[
                          "emergency_alarm_740".toString().toLowerCase()
                          ],
                          colsec4[
                          "emergency_alarm_date_741".toString().toLowerCase()
                          ],
                        ]);
                        this.userSign.push(usersign);
                        this.fSection4.push([
                          "Remarks: " +
                          colsec4[
                          "General_Remarks_742".toString().toLowerCase()
                          ],
                          "",
                        ]);

                        this.userSign.push(usersign);
                      }

                      if (
                        colsec5[
                        "test_and_inspections_743".toString().toLowerCase()
                        ] != null &&
                        colsec5[
                        "test_and_inspections_743".toString().toLowerCase()
                        ] != ""
                      ) {
                        if (
                          colsec5[
                          "lifeboats_turned_744".toString().toLowerCase()
                          ] == null
                        ) {
                          colsec5[
                            "lifeboats_turned_744".toString().toLowerCase()
                          ] = "";
                        }
                        if (
                          colsec5[
                          "lifeboats_turned_date_745".toString().toLowerCase()
                          ] == null
                        ) {
                          colsec5[
                            "lifeboats_turned_date_745".toString().toLowerCase()
                          ] = "";
                        }
                        if (
                          colsec5[
                          "ispection_of_immersion_746"
                            .toString()
                            .toLowerCase()
                          ] == null
                        ) {
                          colsec5[
                            "ispection_of_immersion_746"
                              .toString()
                              .toLowerCase()
                          ] = "";
                        }
                        if (
                          colsec5[
                          "ispection_of_immersion_date_747"
                            .toString()
                            .toLowerCase()
                          ] == null
                        ) {
                          colsec5[
                            "ispection_of_immersion_date_747"
                              .toString()
                              .toLowerCase()
                          ] = "";
                        }
                        if (
                          colsec5[
                          "General_Remarks_748".toString().toLowerCase()
                          ] == null
                        ) {
                          colsec5[
                            "General_Remarks_748".toString().toLowerCase()
                          ] = "";
                        }

                        //  this.fSection5.push(
                        //      //[colsec5['test_and_inspections_743'.toString().toLowerCase()] + ' ' +
                        //  [colsec5['lifeboats_turned_744'.toString().toLowerCase()] + ' ' +
                        //  colsec5['lifeboats_turned_date_745'.toString().toLowerCase()]+ ' ' +
                        //  colsec5['ispection_of_immersion_746'.toString().toLowerCase()]+ ' ' +
                        //  colsec5['ispection_of_immersion_date_747'.toString().toLowerCase()]+ ' ' +
                        //  colsec5['General_Remarks_748'.toString().toLowerCase()],
                        //  colsec5['lifeboats_turned_date_745'.toString().toLowerCase()]

                        // ]);
                        //  this.userSign.push(usersign);

                        this.fSection5.push([
                          colsec5[
                          "lifeboats_turned_744".toString().toLowerCase()
                          ],
                          colsec5[
                          "lifeboats_turned_date_745".toString().toLowerCase()
                          ],
                        ]);
                        this.userSign.push(usersign);
                        this.fSection5.push([
                          colsec5[
                          "ispection_of_immersion_746"
                            .toString()
                            .toLowerCase()
                          ],
                          colsec5[
                          "ispection_of_immersion_date_747"
                            .toString()
                            .toLowerCase()
                          ],
                        ]);
                        this.userSign.push(usersign);
                        this.fSection5.push([
                          "General Remarks: " +
                          colsec5[
                          "General_Remarks_748".toString().toLowerCase()
                          ],
                          "",
                        ]);

                        this.userSign.push(usersign);
                      }

                      if (
                        colsec6[
                        "inspections_examinations_749"
                          .toString()
                          .toLowerCase()
                        ] != null &&
                        colsec6[
                        "inspections_examinations_749"
                          .toString()
                          .toLowerCase()
                        ] != ""
                      ) {
                        if (
                          colsec6[
                          "Internation_shore_connection_750"
                            .toString()
                            .toLowerCase()
                          ] == null
                        ) {
                          colsec6[
                            "Internation_shore_connection_750"
                              .toString()
                              .toLowerCase()
                          ] = "";
                        }
                        if (
                          colsec6[
                          "shore_connection_date_751".toString().toLowerCase()
                          ] == null
                        ) {
                          colsec6[
                            "shore_connection_date_751".toString().toLowerCase()
                          ] = "";
                        }
                        if (
                          colsec6[
                          "fire_fighting_equipment_752"
                            .toString()
                            .toLowerCase()
                          ] == null
                        ) {
                          colsec6[
                            "fire_fighting_equipment_752"
                              .toString()
                              .toLowerCase()
                          ] = "";
                        }
                        if (
                          colsec6[
                          "fire_fighting_equipment_date_753"
                            .toString()
                            .toLowerCase()
                          ] == null
                        ) {
                          colsec6[
                            "fire_fighting_equipment_date_753"
                              .toString()
                              .toLowerCase()
                          ] = "";
                        }
                        if (
                          colsec6[
                          "fire_doors_and_dampers_754"
                            .toString()
                            .toLowerCase()
                          ] == null
                        ) {
                          colsec6[
                            "fire_doors_and_dampers_754"
                              .toString()
                              .toLowerCase()
                          ] = "";
                        }
                        if (
                          colsec6[
                          "doors_dampers_date_755".toString().toLowerCase()
                          ] == null
                        ) {
                          colsec6[
                            "doors_dampers_date_755".toString().toLowerCase()
                          ] = "";
                        }
                        if (
                          colsec6[
                          "Bottle_connections_756".toString().toLowerCase()
                          ] == null
                        ) {
                          colsec6[
                            "Bottle_connections_756".toString().toLowerCase()
                          ] = "";
                        }
                        if (
                          colsec6[
                          "Bottle_connections_date_757"
                            .toString()
                            .toLowerCase()
                          ] == null
                        ) {
                          colsec6[
                            "Bottle_connections_date_757"
                              .toString()
                              .toLowerCase()
                          ] = "";
                        }
                        if (
                          colsec6[
                          "examination_and_inspection_remarks_758"
                            .toString()
                            .toLowerCase()
                          ] == null
                        ) {
                          colsec6[
                            "examination_and_inspection_remarks_758"
                              .toString()
                              .toLowerCase()
                          ] = "";
                        }

                        this.fSection6.push([
                          colsec6[
                          "Internation_shore_connection_750"
                            .toString()
                            .toLowerCase()
                          ],
                          colsec6[
                          "shore_connection_date_751".toString().toLowerCase()
                          ],
                        ]);
                        this.userSign.push(usersign);
                        this.fSection6.push([
                          colsec6[
                          "fire_fighting_equipment_752"
                            .toString()
                            .toLowerCase()
                          ],
                          colsec6[
                          "fire_fighting_equipment_date_753"
                            .toString()
                            .toLowerCase()
                          ],
                        ]);
                        this.userSign.push(usersign);
                        this.fSection6.push([
                          colsec6[
                          "fire_doors_and_dampers_754"
                            .toString()
                            .toLowerCase()
                          ],
                          colsec6[
                          "doors_dampers_date_755".toString().toLowerCase()
                          ],
                        ]);
                        this.userSign.push(usersign);
                        this.fSection6.push([
                          colsec6[
                          "Bottle_connections_756".toString().toLowerCase()
                          ],
                          colsec6[
                          "Bottle_connections_date_757"
                            .toString()
                            .toLowerCase()
                          ],
                        ]);
                        this.userSign.push(usersign);
                        this.fSection6.push([
                          "Remarks: " +
                          colsec6[
                          "examination_and_inspection_remarks_758"
                            .toString()
                            .toLowerCase()
                          ],
                          " ",
                        ]);
                        this.userSign.push(usersign);
                        //                                                                     colsec6['fire_fighting_equipment_752'.toString().toLowerCase()]+ ' ' +
                        //                                                                     colsec6['fire_fighting_equipment_date_753'.toString().toLowerCase()]+ ' ' +
                        //                                                                     colsec6['fire_doors_and_dampers_754'.toString().toLowerCase()] + ' ' +
                        //                                                                     colsec6['doors_dampers_date_755'.toString().toLowerCase()] + ' ' +
                        //                                                                     colsec6['Bottle_connections_756'.toString().toLowerCase()] + ' ' +
                        //                                                                     colsec6['Bottle_connections_date_757'.toString().toLowerCase()] + ' ' +
                        //                                                                     colsec6['examination_and_inspection_remarks_758'.toString().toLowerCase()] + ' ' +
                        //                                                                     colsec6['doors_dampers_date_755'.toString().toLowerCase()] ,
                        //                                                                     colsec6['doors_dampers_date_755'.toString().toLowerCase()]

                        // ]);
                      }
                    }
                  }

                  // console.log("mylog::mylog");
                  this.createCollectionLayout(this.objcolsection);
                  // console.log(this.objcolsection);

                  if (
                    this.fSection1.length > 0 ||
                    this.fSection5.length > 0 ||
                    this.fSection2.length > 0 ||
                    this.fSection6.length > 0 ||
                    this.fSection3.length > 0 ||
                    this.fSection4.length > 0
                  ) {
                    this.createCollectionLayout(this.fSection1);
                    this.createCollectionLayout(this.fSection2);
                    this.createCollectionLayout(this.fSection3);
                    this.createCollectionLayout(this.fSection4);
                    this.createCollectionLayout(this.fSection5);
                    this.createCollectionLayout(this.fSection6);

                    this.objcolcollection.push(this.fSection1);
                    this.objcolcollection.push(this.fSection2);
                    this.objcolcollection.push(this.fSection3);
                    this.objcolcollection.push(this.fSection4);
                    this.objcolcollection.push(this.fSection5);
                    this.objcolcollection.push(this.fSection6);
                  }
                  // console.log(this.objcolcollection);
                }
                //console.log(this.formDetails);
              }
            );
          }
        }

        // console.log(this.formCount);
      }
    }
  }

  getFormdataAllformsDeckBook(
    hid,
    dateValue,
    timeValue = "",
    fromDate = "",
    toDate = ""
  ) {
    this.deckLogActionDate = dateValue;
    //console.log("Action Dates:" + dateValue +'--'+ timeValue +'--'+ fromDate +'--'+ toDate); return;

    //      if(btn==1 && dateValue!=null){
    //         this.searchDeckLog(dateValue);
    //      }else if(btn==1 && dateValue==null){alert("Please select a date to filter details"); return false;
    //      }
    //alert(this.createdDate);
    for (var i = 0; i < this.formBuilder.length; i++) {
      if (this.formBuilder[i].hid == hid) {
        this.formCount = [];
        this.objcolsection = [];
        var result = [];
        var strFormId = "";
        for (
          var r = 0;
          r < this.formBuilder[i].formbuilderresponse.length;
          r++
        ) {
          strFormId += this.formBuilder[i].formbuilderresponse[r].formId + ",";
          this.formCount.push(this.formBuilder[i].formbuilderresponse[r]);
        }

        var fineStringFormsId = strFormId.replace(/(^,)|(,$)/g, "");

        this.editlogbookformsService.getFormDetailsByActionDateAndTime(
          fineStringFormsId,
          this.voyageNo,
          dateValue,
          timeValue,
          fromDate,
          toDate,
          (multiresponse) => {
            this.objcolsection = [];
            var cnt1 = 0;
            var cnt2 = 0;
            var cnt3 = 0;
            var cnt4 = 0;
            var cnt5 = 0;
            var cnt6 = 0;
            var colsec1 = [];
            var colsec2 = [];
            var colsec3 = [];
            var colsec4 = [];
            var colsec5 = [];
            var colsec6 = [];
            var colsec7 = []; 4
            var colsec8 = [];
            var coldate = [];
            //multiresponse = [{"responsecode":200,"data":[{"_id":{"$oid":"5e94073ea3744d47ef6f50c9"},"created_at":"2020-04-12 23:31:26","updated_at":"2020-04-12 23:31:26","watchId":1481,"voyageId":522,"voyageNo":"12345","vesselId":64,"formId":43,"rowId":"rowId1586697162972","is_sync":false,"is_mobile_sync":false,"sectionId":"117.0,117.0,117.0,117.0,117.0,117.0,117.0,117.0,117.0,117.0,117.0,117.0,117.0,117.0,117.0,117.0,117.0,117.0,117.0,117.0,117.0","changeFields":null,"userId":11,"userName":"K ROHIT GUPTA","userSign":"UQBAAAAAACALSEK%0AAAAAAAAAbAlRAAAAAAAAYEuIAgAAAAAAAFtCFAAAAAAAANgSogAAAAAAAMCWEAUAAAAAAAC2hCgA%0AAAAAAACwJUQBAAAAAACALSEKAAAAAAAAbAlRAAAAAAAAYEuIAgAAAAAAAFtCFAAAAAAAANgSogAA%0AAAAAAMCWEAUAAAAAAAC2hCgAAAAAAACwJUQBAAAAAACALSEKAAAAAAAAbAlRAAAAAAAAYEuIAgAA%0AAAAAAFtCFAAAAAAAANgSogAAAAAAAMCWEAUAAAAAAAC2hCgAAAAAAACwJUQBAAAAAACALSEKAAAA%0AAAAAbAlRAAAAAAAAYEuIAgAAAAAAAFtCFAAAAAAAANgSogAAAAAAAMCWEAUAAAAAAAC2hCgAAAAA%0AAACwJUQBAAAAAACALSEKAAAAAAAAbAlRAAAAAAAAYEuIAgAAAAAAAFtCFAAAAAAAANgSogAAAAAA%0AAMCWEAUAAAAAAAC2hCgAAAAAAACwJUQBAAAAAACALSEKAAAAAAAAbAlRAAAAAAAAYEuIAgAAAAAA%0AAFtCFAAAAAAAANgSogAAAAAAAMCWEAUAAAAAAAC2hCgAAAAAAACwJUQBAAAAAACALSEKAAAAAAAA%0AbAlRAAAAAAAAYEuIAgAAAAAAAFtCFAAAAAAAANgSogAAAAAAAMCWEAUAAAAAAAC2hCgAAAAAAACw%0AJUQBAAAAAACALSEKAAAAAAAAbAlRAAAAAAAAYEuIAgAAAAAAAFtCFAAAAAAAANgSogAAAAAAAMCW%0AEAUAAAAAAAC2hCgAAAAAAACwJUQBAAAAAACALSEKAAAAAAAAbAlRAAAAAAAAYEuIAgAAAAAAAFtC%0AFAAAAAAAANgSogAAAAAAAMCWEAUAAAAAAAC2hCgAAAAAAACwJUQBAAAAAACALSEKAAAAAAAAbAlR%0AAAAAAAAAYEuIAgAAAAAAAFtCFAAAAAAAANgSogAAAAAAAMCWEAUAAAAAAAC2hCgAAAAAAACwJUQB%0AAAAAAACALSEKAAAAAAAAbAlRAAAAAAAAYEuIAgAAAAAAAFtCFAAAAAAAANgSogAAAAAAAMCWEAUA%0AAAAAAAC2hCgAAAAAAACwJUQBAAAAAACALSEKAAAAAAAAbAlRAAAAAAAAYEuIAgAAAAAAAFtCFAAA%0AAAAAANgSogAAAAAAAMCWEAUAAAAAAAC2hCgAAAAAAACwJUQBAAAAAACALSEKAAAAAAAAbAlRAAAA%0AAAAAYEuIAgAAAAAAADU1nUYAAACSSURBVFtCFAAAAAAAANgSogAAAAAAAMCWEAUAAAAAAAC2hCgA%0AAAAAAACwJUQBAAAAAACALSEKAAAAAAAAbAlRAAAAAAAAYEuIAgAAAAAAAFtCFAAAAAAAANgSogAA%0AAAAAAMCWEAUAAAAAAAC2hCgAAAAAAACwJUQBAAAAAACALSEKAAAAAAAAbAlRAAAAAAAAYCuyN3rJ%0ACyVu2AAAAABJRU5ErkJggg%3D%3D%0A","timeStamp":1586627950289,"actionDate":"11-Apr-2020","actionDateFormat":{"$date":"2020-04-11T07:00:00.000Z"},"actionTime":"08-12","Log_Reading_772":"","Course_773":"Log Reading","Course_True_774":"","Course_Gyro_775":"022","Course_Standard_776":"025","Gyro_Error_777":"","Wind_778":"Log Reading","Wind_Direction_779":"s","Wind_Force_780":"2","Sea_Height_781":"","Weather_and_visibility_782":"BCx7","Baro_Meter_783":"1010","Temperature_784":"Log Reading","Temerature_Dry_785":"33","Temperature_Wet_786":"30","Temperature_Sea_787":"","IG_Press_788":"","Look_Out_789":"1&3","Watch_Entry_Remarks_790":"0700LT-1200LT\n0700-watch taken over from 2 off.complied with company and port regulation.vsl moored at corinto port,berth no 3 port side alongside with 4+2 lines F&A.\ncrane NO 3 rounds taken.physical conditions checked.all in order.\nwaters around vessel checked no traces of pollution found.\nF-6.72,M-7.41,A-8.06. density -1.022","Watch_Entry_General_Comments_791":"cont discharging of fertilizers in progress from no 3 cargo hold by ships crane and shore grab.gangway and mooring attented at all times.fire safety rounds taken. security patrol rounds maintained ,no breach noticed.scupprrs and rat guards in place.no delay on vsl account.\ncalm harbour waters,partly cloudy sky and good visibility.\n1200-watch handed over to 2nd off","Watch_Entry_Crew_Work_792":""}]}];
            var signdate = "";
            var masterName = "";
            var masterSignature = "";
            var roleId = "";
            var roleName = "";
            var id = "";
            var chiefOfficersigndate = "";
            var chiefOfficerName = "";
            var chiefOfficerSignature = "";
            var chiefOfficerroleId = "";
            var chiefOfficerroleName = "";

            if (multiresponse != null && multiresponse.length > 0) {
              let response = [];
              for (let ky in multiresponse) {
                response.push(this.modifyedData(multiresponse[ky]));
              }

              // console.log("====response111====");
              // console.log(response);
              // console.log("====response222====");
              // all form response loop
              for (let ky in response) {
                if (
                  response[ky].data != null &&
                  response[ky].data != undefined
                ) {
                  var sectionName = "";
                  for (var s = 0; s < response[ky].data.length; s++) {
                    if (response[ky].data[s].isDelete == "1") continue;
                    var formId = response[ky].data[s].formId;
                    var actionTime = response[ky].data[s].actionTime;

                    this.formBuilderSections = [];
                    for (
                      var r = 0;
                      r < this.formBuilder[i].formbuilderresponse.length;
                      r++
                    ) {
                      if (
                        this.formBuilder[i].formbuilderresponse[r].formId ==
                        formId
                      ) {
                        sectionName = this.formBuilder[i].formbuilderresponse[
                          r
                        ].formName.charAt(
                          this.formBuilder[i].formbuilderresponse[r].formName
                            .length - 1
                        );
                        for (
                          var u = 0;
                          u <
                          this.formBuilder[i].formbuilderresponse[r]
                            .formbuildersectionnamelist.length;
                          u++
                        ) {
                          this.formBuilderSections.push(
                            this.formBuilder[i].formbuilderresponse[r]
                              .formbuildersectionnamelist[u]
                          ); //.formbuilderlist
                        }
                      }
                    }

                    var p = 0;

                    this.showpop = 0;
                    this.editedBy = "";
                    if (response[ky].data[s].editedBy != null) {
                      this.editedBy = response[ky].data[s].editedBy;
                    }
                    var usersign = response[ky].data[s].userSign;

                    if (
                      response[ky].data[s].masterDate != null &&
                      response[ky].data[s].masterDate != ""
                    ) {
                      signdate = response[ky].data[s].masterDate;
                    }

                    if (
                      response[ky].data[s].masterName != null &&
                      response[ky].data[s].masterName != ""
                    ) {
                      masterName = response[ky].data[s].masterName;
                    }

                    if (
                      response[ky].data[s].masterSignature != null &&
                      response[ky].data[s].masterSignature != ""
                    ) {
                      masterSignature = response[ky].data[s].masterSignature;
                    }

                    if (
                      response[ky].data[s].masterRoleId != null &&
                      response[ky].data[s].masterRoleId != ""
                    ) {
                      roleId = response[ky].data[s].masterRoleId;
                    }

                    if (
                      response[ky].data[s].masterRoleName != null &&
                      response[ky].data[s].masterRoleName != ""
                    ) {
                      roleName = response[ky].data[s].masterRoleName;
                    }
                    if (
                      response[ky].data[s]._id.$oid != null &&
                      response[ky].data[s]._id.$oid != ""
                    ) {
                      id = response[ky].data[s]._id.$oid;
                    }

                    if (
                      response[ky].data[s].chiefOfficerDate != null &&
                      response[ky].data[s].chiefOfficerDate != ""
                    ) {
                      chiefOfficersigndate =
                        response[ky].data[s].chiefOfficerDate;
                    }

                    if (
                      response[ky].data[s].chiefOfficerName != null &&
                      response[ky].data[s].chiefOfficerName != ""
                    ) {
                      chiefOfficerName = response[ky].data[s].chiefOfficerName;
                    }

                    if (
                      response[ky].data[s].chiefOfficerSignature != null &&
                      response[ky].data[s].chiefOfficerSignature != ""
                    ) {
                      chiefOfficerSignature =
                        response[ky].data[s].chiefOfficerSignature;
                    }

                    if (
                      response[ky].data[s].chiefOfficerRoleId != null &&
                      response[ky].data[s].chiefOfficerRoleId != ""
                    ) {
                      chiefOfficerroleId =
                        response[ky].data[s].chiefOfficerRoleId;
                    }

                    if (
                      response[ky].data[s].chiefOfficerRoleName != null &&
                      response[ky].data[s].chiefOfficerRoleName != ""
                    ) {
                      chiefOfficerroleName =
                        response[ky].data[s].chiefOfficerRoleName;
                    }

                    this.masterSignature = masterSignature;
                    this.masterName = masterName;
                    this.signdate = signdate;
                    this.roleName = roleName;
                    //this.roleid = roleId;
                    this.id = id;
                    this.formId = formId;
                    this.chiefOfficerSignature = chiefOfficerSignature;
                    this.chiefOfficerName = chiefOfficerName;
                    this.chiefOfficersigndate = chiefOfficersigndate;
                    //this.chiefOfficerroleId = chiefOfficerroleId;
                    this.chiefOfficerroleName = chiefOfficerroleName;

                    for (let key in response[ky].data[s]) {
                      for (p = 0; p < this.formBuilderSections.length; p++) {
                        for (
                          var v = 0;
                          v <
                          this.formBuilderSections[p].formbuilderlist.length;
                          v++
                        ) {
                          //alert(key.toString().toLowerCase());
                          //alert(key.toString().toLowerCase() + '-- field--' + this.formBuilderSections[p].formbuilderlist[v].fieldName.toString().toLowerCase() + '_' + this.formBuilderSections[p].formbuilderlist[v].fieldId.toString().toLowerCase());

                          if (
                            key.toString().toLowerCase() == "created_at" &&
                            response[ky].data[s][key] != ""
                          ) {
                            coldate["date_created"] = response[ky].data[s][key];
                            coldate[
                              "section_length"
                            ] = this.formBuilderSections.length;
                          }

                          //(dateValue!=0 && this.createdDate == dateCheck) &&
                          if (
                            key.toString().toLowerCase() ==
                            this.formBuilderSections[p].formbuilderlist[
                              v
                            ].fieldName
                              .toString()
                              .toLowerCase() ||
                            key.toString().toLowerCase() == "watchid"
                          ) {
                            if (formId == 43) {
                              this.deckLogBook = 1;
                              if (p == 0) {
                                if (
                                  (key.toString().toLowerCase() ==
                                    "Log_Reading_772".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Course_773".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Course_True_774".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Course_Gyro_775".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Course_Standard_776".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Gyro_Error_777".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Wind_778".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Wind_Direction_779".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Wind_Force_780".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Sea_Height_781".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Weather_and_visibility_782".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Baro_Meter_783".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Temperature_784".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Temerature_Dry_785".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Temperature_Wet_786".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Temperature_Sea_787".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "IG_Press_788".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Look_Out_789".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Watch_Entry_Remarks_790".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Watch_Entry_General_Comments_791".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "watchId".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Watch_Entry_Crew_Work_792".toLowerCase() &&
                                    response[ky].data[s][key] != "")
                                ) {
                                  colsec1[key.toString().toLowerCase()] =
                                    response[ky].data[s][key];
                                }
                              }
                            }

                            if (formId == 44) {
                              this.deckLogBook = 1;

                              if (p == 0) {
                                if (
                                  (key.toString().toLowerCase() ==
                                    "Noon_Position_793".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Noon_LAT_794".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Noon_LONG_795".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Next_Port_796".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "ETA_797".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "miles_run_in_last_24_hrs_798".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "HRS_STMG_799".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "AV_SPD_800".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Wind_Force_801".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Consumption_For_Propulsion_802".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "propulsion_HFO_803".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "propulsion_MDO_804".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "heating_HFO_806".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "heating_MDO_807".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Consumption_for_cleaning_808".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Cleaning_HFO_809".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Cleaning_MDO_810".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Slow_Speed_811".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "N_Miles_812".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "speed_hrs_813".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "AV_RPM_814".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Slip_815".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Sea_Conditions_816".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "ROB_817".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "ROB_HFO_818".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "ROB_MDO_819".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "ROB_LSFO_820".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "ROB_MGO_821".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "ROB_FW_822".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "General_Comments_823".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Crew_Work_824".toLowerCase() &&
                                    response[ky].data[s][key] != "")
                                ) {
                                  colsec1[key.toString().toLowerCase()] =
                                    response[ky].data[s][key];
                                }
                              }
                            }
                          }
                        }
                      }
                    }

                    // end getting response data into array

                    if (formId == 43) {
                      if (
                        coldate["date_created"] != null &&
                        coldate["date_created"] != ""
                      ) {
                        var dataPart = coldate["date_created"]
                          .toString()
                          .split(" ");

                        var dateSplit = dataPart[0].toString().split("-");
                        var day = dateSplit[2];
                        var month = dateSplit[1];
                        var year = dateSplit[0];
                        this.createdDate = day + "-" + month + "-" + year;
                        var sectionLenght = coldate["section_length"];
                        this.createdAt.push([
                          year + "-" + month + "-" + day,
                          sectionLenght,
                          sectionName,
                          cnt1++,
                        ]);
                      }

                      if (colsec1["watchId".toString().toLowerCase()] != null) {
                        if (
                          colsec1["watchId".toString().toLowerCase()] == null
                        ) {
                          colsec1["watchId".toString().toLowerCase()] = "";
                        }
                        if (
                          colsec1["Course_773".toString().toLowerCase()] == null
                        ) {
                          colsec1["Course_773".toString().toLowerCase()] = "";
                        }
                        if (
                          colsec1["Course_Gyro_775".toString().toLowerCase()] ==
                          null
                        ) {
                          colsec1["Course_Gyro_775".toString().toLowerCase()] =
                            "";
                        }
                        if (
                          colsec1[
                          "Course_Standard_776".toString().toLowerCase()
                          ] == null
                        ) {
                          colsec1[
                            "Course_Standard_776".toString().toLowerCase()
                          ] = "";
                        }
                        if (
                          colsec1["Gyro_Error_777".toString().toLowerCase()] ==
                          null
                        ) {
                          colsec1["Gyro_Error_777".toString().toLowerCase()] =
                            "";
                        }

                        if (
                          colsec1["Wind_778".toString().toLowerCase()] == null
                        ) {
                          colsec1["Wind_778".toString().toLowerCase()] = "";
                        }
                        if (
                          colsec1[
                          "Wind_Direction_779".toString().toLowerCase()
                          ] == null
                        ) {
                          colsec1[
                            "Wind_Direction_779".toString().toLowerCase()
                          ] = "";
                        }
                        if (
                          colsec1["Wind_Force_780".toString().toLowerCase()] ==
                          null
                        ) {
                          colsec1["Wind_Force_780".toString().toLowerCase()] =
                            "";
                        }
                        if (
                          colsec1["Sea_Height_781".toString().toLowerCase()] ==
                          null
                        ) {
                          colsec1["Sea_Height_781".toString().toLowerCase()] =
                            "";
                        }

                        if (
                          colsec1[
                          "Weather_and_visibility_782"
                            .toString()
                            .toLowerCase()
                          ] == null
                        ) {
                          colsec1[
                            "Weather_and_visibility_782"
                              .toString()
                              .toLowerCase()
                          ] = "";
                        }
                        if (
                          colsec1["Temperature_784".toString().toLowerCase()] ==
                          null
                        ) {
                          colsec1["Temperature_784".toString().toLowerCase()] =
                            "";
                        }
                        if (
                          colsec1[
                          "Temerature_Dry_785".toString().toLowerCase()
                          ] == null
                        ) {
                          colsec1[
                            "Temerature_Dry_785".toString().toLowerCase()
                          ] = "";
                        }
                        if (
                          colsec1[
                          "Temperature_Wet_786".toString().toLowerCase()
                          ] == null
                        ) {
                          colsec1[
                            "Temperature_Wet_786".toString().toLowerCase()
                          ] = "";
                        }
                        if (
                          colsec1[
                          "Temperature_Sea_787".toString().toLowerCase()
                          ] == null
                        ) {
                          colsec1[
                            "Temperature_Sea_787".toString().toLowerCase()
                          ] = "";
                        }
                        if (
                          colsec1["IG_Press_788".toString().toLowerCase()] ==
                          null
                        ) {
                          colsec1["IG_Press_788".toString().toLowerCase()] = "";
                        }
                        if (
                          colsec1["Look_Out_789".toString().toLowerCase()] ==
                          null
                        ) {
                          colsec1["Look_Out_789".toString().toLowerCase()] = "";
                        }
                        if (
                          colsec1[
                          "Watch_Entry_Remarks_790".toString().toLowerCase()
                          ] == null
                        ) {
                          colsec1[
                            "Watch_Entry_Remarks_790".toString().toLowerCase()
                          ] = "";
                        }
                        if (
                          colsec1[
                          "Watch_Entry_General_Comments_791"
                            .toString()
                            .toLowerCase()
                          ] == null
                        ) {
                          colsec1[
                            "Watch_Entry_General_Comments_791"
                              .toString()
                              .toLowerCase()
                          ] = "";
                        }
                        if (
                          colsec1[
                          "Watch_Entry_Crew_Work_792".toString().toLowerCase()
                          ] == null
                        ) {
                          colsec1[
                            "Watch_Entry_Crew_Work_792".toString().toLowerCase()
                          ] = "";
                        }

                        var watchHr = actionTime;
                        //

                        this.fSection1.push([
                          watchHr,
                          colsec1["Log_Reading_772".toString().toLowerCase()],
                          colsec1["Course_True_774".toString().toLowerCase()],
                          colsec1["Course_Gyro_775".toString().toLowerCase()],
                          colsec1[
                          "Course_Standard_776".toString().toLowerCase()
                          ],
                          colsec1["Gyro_Error_777".toString().toLowerCase()],
                          colsec1[
                          "Wind_Direction_779".toString().toLowerCase()
                          ],
                          colsec1["Wind_Force_780".toString().toLowerCase()],
                          colsec1["Sea_Height_781".toString().toLowerCase()],
                          colsec1[
                          "Weather_and_visibility_782"
                            .toString()
                            .toLowerCase()
                          ],
                          colsec1["Baro_Meter_783".toString().toLowerCase()],
                          colsec1[
                          "Temerature_Dry_785".toString().toLowerCase()
                          ],
                          colsec1[
                          "Temperature_Wet_786".toString().toLowerCase()
                          ],
                          colsec1[
                          "Temperature_Sea_787".toString().toLowerCase()
                          ],
                          colsec1["IG_Press_788".toString().toLowerCase()],
                          colsec1["Look_Out_789".toString().toLowerCase()],
                        ]);

                        this.fSection3.push([
                          colsec1[
                          "Watch_Entry_Remarks_790".toString().toLowerCase()
                          ],
                        ]);
                        this.fSection4.push([
                          colsec1[
                          "Watch_Entry_General_Comments_791"
                            .toString()
                            .toLowerCase()
                          ],
                        ]);
                        this.fSection5.push([
                          colsec1[
                          "Watch_Entry_Crew_Work_792".toString().toLowerCase()
                          ],
                        ]);

                        this.userSign.push(usersign);
                        this.userSign.push(usersign);
                        this.userSign.push(usersign);
                        this.userSign.push(usersign);
                      }
                    }

                    if (formId == 44) {
                      if (
                        coldate["date_created"] != null &&
                        coldate["date_created"] != ""
                      ) {
                        var date = new Date(coldate["date_created"]);
                        var day = date.getDate();
                        var month = date.getMonth() + 1;
                        var year = date.getFullYear();

                        var sectionLenght = coldate["section_length"];
                        this.createdAt.push([
                          year + "-" + month + "-" + day,
                          sectionLenght,
                          sectionName,
                          cnt1++,
                        ]);
                      }

                      if (
                        colsec1[
                        "Consumption_For_Propulsion_802"
                          .toString()
                          .toLowerCase()
                        ] != null
                      ) {
                        if (
                          colsec1["watchId".toString().toLowerCase()] == null
                        ) {
                          colsec1["watchId".toString().toLowerCase()] = "";
                        }
                        if (
                          colsec1[
                          "Noon_Position_793".toString().toLowerCase()
                          ] == null
                        ) {
                          colsec1[
                            "Noon_Position_793".toString().toLowerCase()
                          ] = "";
                        }
                        if (
                          colsec1["Noon_LAT_794".toString().toLowerCase()] ==
                          null
                        ) {
                          colsec1["Noon_LAT_794".toString().toLowerCase()] = "";
                        }
                        if (
                          colsec1["Noon_LONG_795".toString().toLowerCase()] ==
                          null
                        ) {
                          colsec1["Noon_LONG_795".toString().toLowerCase()] =
                            "";
                        }
                        if (
                          colsec1["Next_Port_796".toString().toLowerCase()] ==
                          null
                        ) {
                          colsec1["Next_Port_796".toString().toLowerCase()] =
                            "";
                        }

                        if (
                          colsec1["ETA_797".toString().toLowerCase()] == null
                        ) {
                          colsec1["ETA_797".toString().toLowerCase()] = "";
                        }
                        if (
                          colsec1[
                          "miles_run_in_last_24_hrs_798"
                            .toString()
                            .toLowerCase()
                          ] == null
                        ) {
                          colsec1[
                            "miles_run_in_last_24_hrs_798"
                              .toString()
                              .toLowerCase()
                          ] = "";
                        }
                        if (
                          colsec1["AV_SPD_800".toString().toLowerCase()] == null
                        ) {
                          colsec1["AV_SPD_800".toString().toLowerCase()] = "";
                        }
                        if (
                          colsec1["Wind_Force_801".toString().toLowerCase()] ==
                          null
                        ) {
                          colsec1["Wind_Force_801".toString().toLowerCase()] =
                            "";
                        }

                        if (
                          colsec1[
                          "Consumption_For_Propulsion_802"
                            .toString()
                            .toLowerCase()
                          ] == null
                        ) {
                          colsec1[
                            "Consumption_For_Propulsion_802"
                              .toString()
                              .toLowerCase()
                          ] = "";
                        }
                        if (
                          colsec1[
                          "propulsion_HFO_803".toString().toLowerCase()
                          ] == null
                        ) {
                          colsec1[
                            "propulsion_HFO_803".toString().toLowerCase()
                          ] = "";
                        }
                        if (
                          colsec1[
                          "propulsion_MDO_804".toString().toLowerCase()
                          ] == null
                        ) {
                          colsec1[
                            "propulsion_MDO_804".toString().toLowerCase()
                          ] = "";
                        }
                        if (
                          colsec1[
                          "Cosumption_for_heating_805"
                            .toString()
                            .toLowerCase()
                          ] == null
                        ) {
                          colsec1[
                            "Cosumption_for_heating_805"
                              .toString()
                              .toLowerCase()
                          ] = "";
                        }
                        if (
                          colsec1["heating_HFO_806".toString().toLowerCase()] ==
                          null
                        ) {
                          colsec1["heating_HFO_806".toString().toLowerCase()] =
                            "";
                        }
                        if (
                          colsec1["heating_MDO_807".toString().toLowerCase()] ==
                          null
                        ) {
                          colsec1["heating_MDO_807".toString().toLowerCase()] =
                            "";
                        }
                        if (
                          colsec1[
                          "Consumption_for_cleaning_808"
                            .toString()
                            .toLowerCase()
                          ] == null
                        ) {
                          colsec1[
                            "Consumption_for_cleaning_808"
                              .toString()
                              .toLowerCase()
                          ] = "";
                        }
                        if (
                          colsec1[
                          "Cleaning_HFO_809".toString().toLowerCase()
                          ] == null
                        ) {
                          colsec1["Cleaning_HFO_809".toString().toLowerCase()] =
                            "";
                        }
                        if (
                          colsec1[
                          "Cleaning_MDO_810".toString().toLowerCase()
                          ] == null
                        ) {
                          colsec1["Cleaning_MDO_810".toString().toLowerCase()] =
                            "";
                        }
                        if (
                          colsec1["Slow_Speed_811".toString().toLowerCase()] ==
                          null
                        ) {
                          colsec1["Slow_Speed_811".toString().toLowerCase()] =
                            "";
                        }
                        if (
                          colsec1["N_Miles_812".toString().toLowerCase()] ==
                          null
                        ) {
                          colsec1["N_Miles_812".toString().toLowerCase()] = "";
                        }
                        if (
                          colsec1["speed_hrs_813".toString().toLowerCase()] ==
                          null
                        ) {
                          colsec1["speed_hrs_813".toString().toLowerCase()] =
                            "";
                        }
                        if (
                          colsec1["AV_RPM_814".toString().toLowerCase()] == null
                        ) {
                          colsec1["AV_RPM_814".toString().toLowerCase()] = "";
                        }
                        if (
                          colsec1["Slip_815".toString().toLowerCase()] == null
                        ) {
                          colsec1["Slip_815".toString().toLowerCase()] = "";
                        }
                        if (
                          colsec1[
                          "Sea_Conditions_816".toString().toLowerCase()
                          ] == null
                        ) {
                          colsec1[
                            "Sea_Conditions_816".toString().toLowerCase()
                          ] = "";
                        }
                        if (
                          colsec1["ROB_817".toString().toLowerCase()] == null
                        ) {
                          colsec1["ROB_817".toString().toLowerCase()] = "";
                        }
                        if (
                          colsec1["ROB_HFO_818".toString().toLowerCase()] ==
                          null
                        ) {
                          colsec1["ROB_HFO_818".toString().toLowerCase()] = "";
                        }
                        if (
                          colsec1["ROB_MDO_819".toString().toLowerCase()] ==
                          null
                        ) {
                          colsec1["ROB_MDO_819".toString().toLowerCase()] = "";
                        }
                        if (
                          colsec1["ROB_LSFO_820".toString().toLowerCase()] ==
                          null
                        ) {
                          colsec1["ROB_LSFO_820".toString().toLowerCase()] = "";
                        }
                        if (
                          colsec1["ROB_MGO_821".toString().toLowerCase()] ==
                          null
                        ) {
                          colsec1["ROB_MGO_821".toString().toLowerCase()] = "";
                        }
                        if (
                          colsec1["ROB_FW_822".toString().toLowerCase()] == null
                        ) {
                          colsec1["ROB_FW_822".toString().toLowerCase()] = "";
                        }
                        if (
                          colsec1[
                          "General_Comments_823".toString().toLowerCase()
                          ] == null
                        ) {
                          colsec1[
                            "General_Comments_823".toString().toLowerCase()
                          ] = "";
                        }
                        if (
                          colsec1["Crew_Work_824".toString().toLowerCase()] ==
                          null
                        ) {
                          colsec1["Crew_Work_824".toString().toLowerCase()] =
                            "";
                        }

                        this.fSection2.push([
                          colsec1["Noon_LAT_794".toString().toLowerCase()],
                          colsec1["Noon_LONG_795".toString().toLowerCase()],
                          colsec1["Next_Port_796".toString().toLowerCase()] +
                          "-" +
                          colsec1["ETA_797".toString().toLowerCase()],
                          colsec1[
                          "miles_run_in_last_24_hrs_798"
                            .toString()
                            .toLowerCase()
                          ],
                          colsec1["HRS_STMG_799".toString().toLowerCase()],
                          colsec1["AV_SPD_800".toString().toLowerCase()],
                          colsec1["Wind_Force_801".toString().toLowerCase()],
                          colsec1[
                          "propulsion_HFO_803".toString().toLowerCase()
                          ] +
                          "-" +
                          colsec1[
                          "propulsion_MDO_804".toString().toLowerCase()
                          ],
                          colsec1["heating_HFO_806".toString().toLowerCase()] +
                          "-" +
                          colsec1["heating_MDO_807".toString().toLowerCase()],
                          colsec1["Cleaning_HFO_809".toString().toLowerCase()] +
                          "-" +
                          colsec1[
                          "Cleaning_MDO_810".toString().toLowerCase()
                          ],
                          colsec1["N_Miles_812".toString().toLowerCase()] +
                          "-" +
                          colsec1["speed_hrs_813".toString().toLowerCase()],
                          colsec1["AV_RPM_814".toString().toLowerCase()],
                          colsec1["Slip_815".toString().toLowerCase()],
                          colsec1[
                          "Sea_Conditions_816".toString().toLowerCase()
                          ],
                          //colsec1['Sea_Conditions_816'.toString().toLowerCase()] ,
                          colsec1["ROB_HFO_818".toString().toLowerCase()] +
                          " " +
                          colsec1["ROB_MDO_819".toString().toLowerCase()] +
                          " " +
                          colsec1["ROB_LSFO_820".toString().toLowerCase()] +
                          " " +
                          colsec1["ROB_MGO_821".toString().toLowerCase()] +
                          " " +
                          colsec1["ROB_FW_822".toString().toLowerCase()],
                        ]);

                        this.fSection6.push([
                          colsec1[
                          "General_Comments_823".toString().toLowerCase()
                          ],
                        ]);
                        this.fSection7.push([
                          colsec1["Crew_Work_824".toString().toLowerCase()],
                        ]);

                        this.userSign.push(usersign);
                        this.userSign.push(usersign);
                        this.userSign.push(usersign);
                      }
                    }

                    // end collection column data to make it tabular
                  }

                  // collection of data into seperate array to be used in html
                  // console.log("mylog::mylog123");
                  this.objcolcollection = [];

                  if (
                    this.fSection1.length > 0 ||
                    (this.fSection3.length > 0 &&
                      this.fSection5.length > 0 &&
                      this.fSection4.length > 0) ||
                    (this.fSection2.length > 0 &&
                      this.fSection6.length > 0 &&
                      this.fSection7.length > 0)
                  ) {
                    if (this.fSection1.length > 0)
                      this.createCollectionLayout(this.fSection1);

                    this.createCollectionLayout(this.fSection2);
                    this.createCollectionLayout(this.fSection3);
                    this.createCollectionLayout(this.fSection4);
                    this.createCollectionLayout(this.fSection5);
                    this.createCollectionLayout(this.fSection6);
                    this.createCollectionLayout(this.fSection7);

                    this.objcolcollection.push(this.fSection1);
                    this.objcolcollection.push(this.fSection2);
                    this.objcolcollection.push(this.fSection3);
                    this.objcolcollection.push(this.fSection4);
                    this.objcolcollection.push(this.fSection5);
                    this.objcolcollection.push(this.fSection6);
                    this.objcolcollection.push(this.fSection7);
                  }

                  // console.log(this.objcolcollection);
                }
              }
            }
          }
        );

        break;
      }
    }
  }

  counter(i: number) {
    return new Array(i);
  }

  onReportClick(index: number, id: number, event: Event) {
    if (!this.selectedVoyage) {
      this.showErrorMsg('Wait...', this.companyList.length > 0
        ? "Please select a company, vessel and voyage before proceeding."
        : "Please select a vessel and voyage before proceeding.")
      return;
    }


    this.currentBook = index;
    this.cleanReports();
    if (id !== 56) {
      for (let book1 of this.bookType[this.currentBook].children) {
        this.callHTypeGarbeg(book1.hName, book1.id, 0, 0);
        return 1;
      }
    }

    if (id == 56) {
      this.showEngineBook = 'RECORD OF ENGINE PARAMETERS';
    }
  }

  cleanReports() {
    this.garbegForm1 = 0;
    this.garbegForm2 = 0;
    this.blstForm = 0;
    this.orbForm = 0;
    this.auditform = 0;
    this.oilnozoneForm = 0;
    this.showpop = 0;
    this.showpop2 = 0;
    this.showpop3 = 0;
    this.showpop4 = 0;
    this.showpop1 = 0;
    this.showpop5 = 0;
    this.showpop6 = 0;
    this.showpop7 = 0;
    this.showpop8 = 0;
    this.showpop9 = 0;
    this.deckLogBook = 0;
    this.orbpart2 = 0;
    this.objcolcollection = [];
    this.fSection1 = [];
    this.fSection2 = [];
    this.fSection3 = [];
    this.fSection4 = [];
    this.fSection5 = [];
    this.fSection6 = [];
    this.gmdss = 0;
    this.bookdata = '';
    this.showEngineBook = '';
  }

  onSubReport(id, event: Event) {
    this.logbookid = id;
  }

  searchDeckLog(val) {
    var mydate = new Date(val);
    var month = mydate.getMonth() + 1;
    var year = mydate.getFullYear();
    var date = mydate.getDate();
    var strmon = month.toString();
    if (month != 10 && month != 11 && month != 12) {
      strmon = "0" + month;
    }
    this.createdDate = date + "-" + strmon + "-" + year;
    this.showpop = 0;
    this.objcolcollection = [];
  }

  checkDeckLogDateWise(date, watchId) {
    if (watchId != "") {
      for (var wh = 0; wh < this.watchHours.length; wh++) {
        if (date == this.watchHours[wh].date) {
          for (var hrs = 0; hrs < this.watchHours[wh].watchHour.length; hrs++) {
            if (this.watchHours[wh].watchHour[hrs].id == watchId) {
              return true;
            }
          }
        }
      }
    }

    return false;
  }

  in_array(array, id) {
    return array.some(function (o) {
      return o["section"] === id;
    });
  }

  onSubReportPop(id) {
    if (id == "49-3") {
      this.showpop9 = 1;
      var fineStringFormsId = "67,68";
      this.editlogbookformsService.getFormDetailsByIds(
        fineStringFormsId,
        this.voyageNo,
        (response) => {
          this.loading=false;
          var combindResponse = [];
          for (let key in response) {
            for (let ky in response[key].data) {
              combindResponse.push(response[key].data[ky]);
            }
          }
          combindResponse = _.sortBy(combindResponse, "timeStamp");
          // console.log(combindResponse);
          this.getFormRecordsList = _.groupBy(combindResponse, "actionDate");
          // console.log(this.getFormRecordsList);
          var constructArray = [];
          for (const [key, value] of Object.entries(this.getFormRecordsList)) {
            constructArray.push({ actionDate: key, actionTime: "" });
          }

          this.getFormRecordsList = constructArray;
        }
      );
    } else if (id == 37) {
      this.showpop4 = 1;
      var fineStringFormsId =
        "49,50,51,52,53,54,55,56,57,58,59,60,61,62,63,64,65,66";
      this.editlogbookformsService.getFormDetailsByIds(
        fineStringFormsId,
        this.voyageNo,
        (response) => {
          this.loading=false;
          var combindResponse = [];
          for (let key in response) {
            for (let ky in response[key].data) {
              combindResponse.push(response[key].data[ky]);
            }
          }
          combindResponse = _.sortBy(combindResponse, "timeStamp");
          // console.log(combindResponse);
          this.getFormRecordsList = _.groupBy(combindResponse, "actionDate");
          // console.log(this.getFormRecordsList);
          var constructArray = [];
          for (const [key, value] of Object.entries(this.getFormRecordsList)) {
            constructArray.push({ actionDate: key, actionTime: "" });
          }

          this.getFormRecordsList = constructArray;
        }
      );
    } else if (id == 36) {
      this.showpop3 = 1;
      var fineStringFormsId = "32,33,34,35,36,37";
      this.editlogbookformsService.getFormDetailsByIds(
        fineStringFormsId,
        this.voyageNo,
        (response) => {
          this.loading=false;
          var combindResponse = [];
          for (let key in response) {
            for (let ky in response[key].data) {
              combindResponse.push(response[key].data[ky]);
            }
          }
          combindResponse = _.sortBy(combindResponse, "timeStamp");
          // console.log(combindResponse);
          this.getFormRecordsList = _.groupBy(combindResponse, "actionDate");
          // console.log(this.getFormRecordsList);
          var constructArray = [];
          for (const [key, value] of Object.entries(this.getFormRecordsList)) {
            constructArray.push({ actionDate: key, actionTime: "" });
          }

          this.getFormRecordsList = constructArray;
        }
      );
    } else if (id == 42) {
      this.showpop1 = 1;
      var fineStringFormsId = "40";
      this.editlogbookformsService.getFormDetailsByIds(
        fineStringFormsId,
        this.voyageNo,
        (response) => {
          this.loading=false;
          // console.log(response[0].data);
          this.getFormRecordsList = response;
        }
      );
    } else if (id == 43) {
      this.showpop2 = 1;
      var fineStringFormsId = "41";
      this.editlogbookformsService.getFormDetailsByIds(
        fineStringFormsId,
        this.voyageNo,
        (response) => {
          this.loading=false;
          // console.log(response[0].data);
          this.getFormRecordsList = response;
        }
      );
    } else if (id == 47) {
      this.showpop5 = 1;
      var fineStringFormsId = "47";
      this.editlogbookformsService.getFormDetailsByIds(
        fineStringFormsId,
        this.voyageNo,
        (response) => {
          this.loading=false;
          // console.log(response[0].data);
          this.getFormRecordsList = response;
        }
      );
    } else if (id == 48) {
      this.showpop6 = 1;
      var fineStringFormsId = "48";
      this.editlogbookformsService.getFormDetailsByIds(
        fineStringFormsId,
        this.voyageNo,
        (response) => {
          this.loading=false;
          // console.log(response[0].data);
          this.getFormRecordsList = response;
        }
      );
    } else if (id == 40) {
      this.showpop8 = 1;
      var fineStringFormsId = "39";
      this.editlogbookformsService.getFormDetailsByIds(
        fineStringFormsId,
        this.voyageNo,
        (response) => {
          this.loading=false;
          // console.log(response[0].data);
          this.getFormRecordsList = response;
        }
      );
    } else if (id == 39) {
      //alert('hi');
      this.showpop7 = 1;
      var fineStringFormsId = "38";
      this.editlogbookformsService.getFormDetailsByIds(
        fineStringFormsId,
        this.voyageNo,
        (response) => {
          this.loading=false;
          // console.log(response[0].data);
          this.getFormRecordsList = response;
        }
      );
    } else if (id == 44) {
      this.showpop = 1;
      var fineStringFormsId = "43,44";
      this.editlogbookformsService.getFormDetailsByIds(
        fineStringFormsId,
        this.voyageNo,
        (response) => {
          this.loading=false;
          var combindResponse = [];
          for (let key in response) {
            for (let ky in response[key].data) {
              combindResponse.push(response[key].data[ky]);
            }
          }
          combindResponse = _.sortBy(combindResponse, "timeStamp");
          // console.log(combindResponse);
          this.allDeckLogBookGroupByDate = _.groupBy(
            combindResponse,
            "actionDate"
          );
        }
      );
    }else{
      this.loading=false;
    }
  }

  gmdss_log_book(hid) {
    this.loading=true;
    if (hid == 49) {
      this.gmdss = 1;
    } else if (hid == "49-1") {
      this.gmdss = 2;
    } else if (hid == "49-2") {
      this.gmdss = 3;
    } else if (hid == "49-3") {
      this.gmdss = 4;
    }
    hid = 49;

    for (var i = 0; i < this.formBuilder.length; i++) {
      if (this.formBuilder[i].hid == hid) {
        this.formCount = [];
        this.objcolsection = [];
        var result = [];
        var strFormId = "";
        this.showpop9 = 0;

        for (
          var r = 0;
          r < this.formBuilder[i].formbuilderresponse.length;
          r++
        ) {
          if (
            this.formBuilder[i].formbuilderresponse[r].formId == 67 ||
            this.formBuilder[i].formbuilderresponse[r].formId == 68
          ) {
            strFormId +=
              this.formBuilder[i].formbuilderresponse[r].formId + ",";
            this.formCount.push(this.formBuilder[i].formbuilderresponse[r]);
          }
        }

        var fineStringFormsId = strFormId.replace(/(^,)|(,$)/g, "");
        //alert(fineStringFormsId);
        //  this.editlogbookformsService.getFormDetailsByActionDateAndTime(fineStringFormsId,this.voyageNo,actionDate,actionTime,fromDate,toDate,(multiresponse) => {
        this.editlogbookformsService.getFormDetails(
          fineStringFormsId,
          this.voyageNo,
          (multiresponse) => {
            this.loading=false;
            this.objcolsection = [];
            var cnt1 = 0;
            var cnt2 = 0;
            var cnt3 = 0;
            var cnt4 = 0;
            var cnt5 = 0;
            var cnt6 = 0;
            var cnt7 = 0;
            var colsec1 = [];
            var colsec2 = [];
            var colsec3 = [];
            var colsec4 = [];
            var colsec5 = [];
            var colsec6 = [];
            var colsec7 = [];
            var colsec8 = [];
            var coldate = [];
            var colsec9 = [];
            if (multiresponse != null && multiresponse.length > 0) {
              let response = [];
              for (let ky in multiresponse) {
                response.push(this.modifyedData(multiresponse[ky]));
              }
              // all form response loop
              // console.log("response");
              for (let ky in response) {
                if (response[ky].data != null) {
                  var sectionName = "";

                  for (var s = 0; s < response[ky].data.length; s++) {
                    if (response[ky].data[s].isDelete == "1") continue;
                    var formId = response[ky].data[s].formId;

                    this.editedBy = "";
                    var usersign = "";
                    // console.log("===chanage value checking====");
                    if (response[ky].data[s].editedBy != null) {
                      this.editedBy = response[ky].data[s].editedBy;
                    }

                    //alert(this.editedBy); return;

                    usersign = response[ky].data[s].userSign;

                    this.formBuilderSections = [];
                    for (
                      var r = 0;
                      r < this.formBuilder[i].formbuilderresponse.length;
                      r++
                    ) {
                      if (
                        this.formBuilder[i].formbuilderresponse[r].formId ==
                        formId
                      ) {
                        sectionName = this.formBuilder[i].formbuilderresponse[
                          r
                        ].formName
                          .replace(/Code/gi, "")
                          .replace(/ORB2/gi, "")
                          .replace(/ORB/gi, ""); //.charAt(this.formBuilder[i].formbuilderresponse[r].formName.length-1);
                        for (
                          var u = 0;
                          u <
                          this.formBuilder[i].formbuilderresponse[r]
                            .formbuildersectionnamelist.length;
                          u++
                        ) {
                          this.formBuilderSections.push(
                            this.formBuilder[i].formbuilderresponse[r]
                              .formbuildersectionnamelist[u]
                          ); //.formbuilderlist
                        }
                      }
                    }

                    //console.log();
                    for (let key in response[ky].data[s]) {
                      var sectionlength = this.formBuilderSections.length;
                      if (sectionlength == 4) {
                        sectionlength = 3;
                      }

                      for (var p = 0; p < sectionlength; p++) {
                        //alert(p)
                        for (
                          var v = 0;
                          v <
                          this.formBuilderSections[p].formbuilderlist.length;
                          v++
                        ) {
                          if (
                            key.toString().toLowerCase() == "created_at" &&
                            response[ky].data[s][key] != ""
                          ) {
                            coldate["date_created"] = response[ky].data[s][key];
                            coldate["section_length"] = sectionlength;
                          }
                          //if(key.toString().toLowerCase()==this.formBuilderSections[p].formbuilderlist[v].fieldName.toString().toLowerCase()){
                          if (formId == 67) {
                            //this.gmdss = 1;
                            if (p == 0) {
                              if (
                                (key.toString().toLowerCase() ==
                                  "Name_of_ship_1622".toLowerCase() &&
                                  response[ky].data[s][key] != "") ||
                                (key.toString().toLowerCase() ==
                                  "call_sign_1623".toLowerCase() &&
                                  response[ky].data[s][key] != "") ||
                                (key.toString().toLowerCase() ==
                                  "MMSI_1624".toLowerCase() &&
                                  response[ky].data[s][key] != "") ||
                                (key.toString().toLowerCase() ==
                                  "Port_of_registry_1625".toLowerCase() &&
                                  response[ky].data[s][key] != "") ||
                                (key.toString().toLowerCase() ==
                                  "IMO_number_1626".toLowerCase() &&
                                  response[ky].data[s][key] != "") ||
                                (key.toString().toLowerCase() ==
                                  "Gross_tonage_1627".toLowerCase() &&
                                  response[ky].data[s][key] != "") ||
                                (key.toString().toLowerCase() ==
                                  "Date_kneel_laid_1628".toLowerCase() &&
                                  response[ky].data[s][key] != "") ||
                                (key.toString().toLowerCase() ==
                                  "Date_1629".toLowerCase() &&
                                  response[ky].data[s][key] != "") ||
                                (key.toString().toLowerCase() ==
                                  "sea_area_1630".toLowerCase() &&
                                  response[ky].data[s][key] != "") ||
                                (key.toString().toLowerCase() ==
                                  "Date_of_expiry_1631".toLowerCase() &&
                                  response[ky].data[s][key] != "") ||
                                (key.toString().toLowerCase() ==
                                  "Date_1632".toLowerCase() &&
                                  response[ky].data[s][key] != "") ||
                                (key.toString().toLowerCase() ==
                                  "indicate_methods_1633".toLowerCase() &&
                                  response[ky].data[s][key] != "") ||
                                (key.toString().toLowerCase() ==
                                  "duplication_of_equipment_1534".toLowerCase() &&
                                  response[ky].data[s][key] != "") ||
                                (key.toString().toLowerCase() ==
                                  "yes_1635".toLowerCase() &&
                                  response[ky].data[s][key] != "") ||
                                (key.toString().toLowerCase() ==
                                  "No_1636".toLowerCase() &&
                                  response[ky].data[s][key] != "") ||
                                (key.toString().toLowerCase() ==
                                  "shore_1637".toLowerCase() &&
                                  response[ky].data[s][key] != "") ||
                                (key.toString().toLowerCase() ==
                                  "yes_1638".toLowerCase() &&
                                  response[ky].data[s][key] != "") ||
                                (key.toString().toLowerCase() ==
                                  "no_1639".toLowerCase() &&
                                  response[ky].data[s][key] != "") ||
                                (key.toString().toLowerCase() ==
                                  "Details_of_service_company_1640".toLowerCase() &&
                                  response[ky].data[s][key] != "") ||
                                (key.toString().toLowerCase() ==
                                  "Name_1641".toLowerCase() &&
                                  response[ky].data[s][key] != "") ||
                                (key.toString().toLowerCase() ==
                                  "Adress_1642".toLowerCase() &&
                                  response[ky].data[s][key] != "") ||
                                (key.toString().toLowerCase() ==
                                  "maintanence_capability_1643".toLowerCase() &&
                                  response[ky].data[s][key] != "") ||
                                (key.toString().toLowerCase() ==
                                  "yes_1644".toLowerCase() &&
                                  response[ky].data[s][key] != "") ||
                                (key.toString().toLowerCase() ==
                                  "No_1645".toLowerCase() &&
                                  response[ky].data[s][key] != "") ||
                                (key.toString().toLowerCase() ==
                                  "owner_name_1646".toLowerCase() &&
                                  response[ky].data[s][key] != "") ||
                                (key.toString().toLowerCase() ==
                                  "Name_1647".toLowerCase() &&
                                  response[ky].data[s][key] != "") ||
                                (key.toString().toLowerCase() ==
                                  "Address_1648".toLowerCase() &&
                                  response[ky].data[s][key] != "") ||
                                (key.toString().toLowerCase() ==
                                  "Managing_owner_1649".toLowerCase() &&
                                  response[ky].data[s][key] != "") ||
                                (key.toString().toLowerCase() ==
                                  "Name_1650".toLowerCase() &&
                                  response[ky].data[s][key] != "") ||
                                (key.toString().toLowerCase() ==
                                  "Address_1651".toLowerCase() &&
                                  response[ky].data[s][key] != "")
                              ) {
                                colsec1[key.toString().toLowerCase()] =
                                  response[ky].data[s][key];
                              }
                            }

                            if (p == 1) {
                              //                                                                                      if((key.toString().toLowerCase()=='Name_1653'.toLowerCase() && response[ky].data[s][key]!='') ){
                              //                                                                                          alert(response[ky].data[s][key])
                              //                                                                                          colsec2[key.toString().toLowerCase()] = response[ky].data[s][key];
                              //                                                                                      }

                              if (
                                (key.toString().toLowerCase() ==
                                  "Name_1631".toLowerCase() &&
                                  response[ky].data[s][key] != "") ||
                                (key.toString().toLowerCase() ==
                                  "Name_1653".toLowerCase() &&
                                  response[ky].data[s][key] != "") ||
                                (key.toString().toLowerCase() ==
                                  "dates_1654".toLowerCase() &&
                                  response[ky].data[s][key] != "") ||
                                (key.toString().toLowerCase() ==
                                  "from_1655".toLowerCase() &&
                                  response[ky].data[s][key] != "") ||
                                (key.toString().toLowerCase() ==
                                  "DATE_1656".toLowerCase() &&
                                  response[ky].data[s][key] != "") ||
                                (key.toString().toLowerCase() ==
                                  "To_1657".toLowerCase() &&
                                  response[ky].data[s][key] != "") ||
                                (key.toString().toLowerCase() ==
                                  "Date_1658".toLowerCase() &&
                                  response[ky].data[s][key] != "") ||
                                (key.toString().toLowerCase() ==
                                  "classes_1659".toLowerCase() &&
                                  response[ky].data[s][key] != "") ||
                                (key.toString().toLowerCase() ==
                                  "class_1660".toLowerCase() &&
                                  response[ky].data[s][key] != "") ||
                                (key.toString().toLowerCase() ==
                                  "date_1661".toLowerCase() &&
                                  response[ky].data[s][key] != "") ||
                                (key.toString().toLowerCase() ==
                                  "certificate_1662".toLowerCase() &&
                                  response[ky].data[s][key] != "") ||
                                (key.toString().toLowerCase() ==
                                  "certi_1663".toLowerCase() &&
                                  response[ky].data[s][key] != "") ||
                                (key.toString().toLowerCase() ==
                                  "responsibility_1664".toLowerCase() &&
                                  response[ky].data[s][key] != "") ||
                                (key.toString().toLowerCase() ==
                                  "Name_1665".toLowerCase() &&
                                  response[ky].data[s][key] != "") ||
                                (key.toString().toLowerCase() ==
                                  "Ranks_1666".toLowerCase() &&
                                  response[ky].data[s][key] != "") ||
                                (key.toString().toLowerCase() ==
                                  "entries_1667".toLowerCase() &&
                                  response[ky].data[s][key] != "") ||
                                (key.toString().toLowerCase() ==
                                  "Name_1668".toLowerCase() &&
                                  response[ky].data[s][key] != "") ||
                                (key.toString().toLowerCase() ==
                                  "ranks_1669".toLowerCase() &&
                                  response[ky].data[s][key] != "")
                              ) {
                                colsec2[key.toString().toLowerCase()] =
                                  response[ky].data[s][key];
                              }
                            }

                            if (p == 2) {
                              //this.gmdss = 3;
                              if (
                                (key.toString().toLowerCase() ==
                                  "Name_of_ship_1670".toLowerCase() &&
                                  response[ky].data[s][key] != "") ||
                                (key.toString().toLowerCase() ==
                                  "number_1671".toLowerCase() &&
                                  response[ky].data[s][key] != "") ||
                                (key.toString().toLowerCase() ==
                                  "period_1672".toLowerCase() &&
                                  response[ky].data[s][key] != "") ||
                                (key.toString().toLowerCase() ==
                                  "from_1673".toLowerCase() &&
                                  response[ky].data[s][key] != "") ||
                                (key.toString().toLowerCase() ==
                                  "date_1674".toLowerCase() &&
                                  response[ky].data[s][key] != "") ||
                                (key.toString().toLowerCase() ==
                                  "to_1675".toLowerCase() &&
                                  response[ky].data[s][key] != "") ||
                                (key.toString().toLowerCase() ==
                                  "Date_1676".toLowerCase() &&
                                  response[ky].data[s][key] != "") ||
                                (key.toString().toLowerCase() ==
                                  "Delivered_1677".toLowerCase() &&
                                  response[ky].data[s][key] != "") ||
                                (key.toString().toLowerCase() ==
                                  "Port_1678".toLowerCase() &&
                                  response[ky].data[s][key] != "") ||
                                (key.toString().toLowerCase() ==
                                  "text_1679".toLowerCase() &&
                                  response[ky].data[s][key] != "") ||
                                (key.toString().toLowerCase() ==
                                  "port_1680".toLowerCase() &&
                                  response[ky].data[s][key] != "") ||
                                (key.toString().toLowerCase() ==
                                  "day_1681".toLowerCase() &&
                                  response[ky].data[s][key] != "") ||
                                (key.toString().toLowerCase() ==
                                  "date_1682".toLowerCase() &&
                                  response[ky].data[s][key] != "") ||
                                (key.toString().toLowerCase() ==
                                  "sign_1683".toLowerCase() &&
                                  response[ky].data[s][key] != "") ||
                                (key.toString().toLowerCase() ==
                                  "signature_1684".toLowerCase() &&
                                  response[ky].data[s][key] != "") ||
                                (key.toString().toLowerCase() ==
                                  "Counter_sign_1685".toLowerCase() &&
                                  response[ky].data[s][key] != "") ||
                                (key.toString().toLowerCase() ==
                                  "signature_1686".toLowerCase() &&
                                  response[ky].data[s][key] != "")
                              ) {
                                colsec3[key.toString().toLowerCase()] =
                                  response[ky].data[s][key];
                              }
                            }
                          }

                          if (formId == 68) {
                            if (p == 0) {
                              // this.gmdss = 4;
                              if (
                                (key.toString().toLowerCase() ==
                                  "vessel_name_1700".toLowerCase() &&
                                  response[ky].data[s][key] != "") ||
                                (key.toString().toLowerCase() ==
                                  "name_1701".toLowerCase() &&
                                  response[ky].data[s][key] != "") ||
                                (key.toString().toLowerCase() ==
                                  "calisign_1702".toLowerCase() &&
                                  response[ky].data[s][key] != "") ||
                                (key.toString().toLowerCase() ==
                                  "textbox_1703".toLowerCase() &&
                                  response[ky].data[s][key] != "") ||
                                (key.toString().toLowerCase() ==
                                  "date_1704".toLowerCase() &&
                                  response[ky].data[s][key] != "") ||
                                (key.toString().toLowerCase() ==
                                  "utc_1705".toLowerCase() &&
                                  response[ky].data[s][key] != "") ||
                                (key.toString().toLowerCase() ==
                                  "time_1706".toLowerCase() &&
                                  response[ky].data[s][key] != "") ||
                                (key.toString().toLowerCase() ==
                                  "utc_1707".toLowerCase() &&
                                  response[ky].data[s][key] != "") ||
                                (key.toString().toLowerCase() ==
                                  "station_from_1708".toLowerCase() &&
                                  response[ky].data[s][key] != "") ||
                                (key.toString().toLowerCase() ==
                                  "station_to_1709".toLowerCase() &&
                                  response[ky].data[s][key] != "") ||
                                (key.toString().toLowerCase() ==
                                  "remarks_1710".toLowerCase() &&
                                  response[ky].data[s][key] != "") ||
                                (key.toString().toLowerCase() ==
                                  "channel_1711".toLowerCase() &&
                                  response[ky].data[s][key] != "") ||
                                (key.toString().toLowerCase() ==
                                  "sign_1712".toLowerCase() &&
                                  response[ky].data[s][key] != "")
                              ) {
                                colsec1[key.toString().toLowerCase()] =
                                  response[ky].data[s][key];
                                if (
                                  key.toString().toLowerCase() ==
                                  "name_1701".toLowerCase()
                                ) {
                                  this.mvsv = response[ky].data[s][key];
                                }
                                if (
                                  key.toString().toLowerCase() ==
                                  "calisign_1702".toLowerCase()
                                ) {
                                  this.calsign = response[ky].data[s][key];
                                }
                                if (
                                  key.toString().toLowerCase() ==
                                  "textbox_1703".toLowerCase()
                                ) {
                                  this.mmsi = response[ky].data[s][key];
                                }
                              }
                            }
                          }

                          //j}
                        }
                      }
                    }

                    //add form values
                    if (formId == 67) {
                      if (
                        coldate["date_created"] != null &&
                        coldate["date_created"] != ""
                      ) {
                        var dataPart = coldate["date_created"]
                          .toString()
                          .split(" ");

                        var dateSplit = dataPart[0].toString().split("-");
                        var day = dateSplit[2];
                        var month = dateSplit[1];
                        var year = dateSplit[0];
                        this.createdDate = day + "-" + month + "-" + year;
                        var sectionLenght = coldate["section_length"];
                        this.createdAt.push([
                          year + "-" + month + "-" + day,
                          sectionLenght,
                          sectionName,
                          cnt1++,
                        ]);
                      }

                      if (
                        colsec1["IMO_number_1626".toString().toLowerCase()] !=
                        null
                      ) {
                        if (
                          colsec1[
                          "Name_of_ship_1622".toString().toLowerCase()
                          ] == null
                        ) {
                          colsec1[
                            "Name_of_ship_1622".toString().toLowerCase()
                          ] = "";
                        }
                        if (
                          colsec1["call_sign_1623".toString().toLowerCase()] ==
                          null
                        ) {
                          colsec1["call_sign_1623".toString().toLowerCase()] =
                            "";
                        }
                        if (
                          colsec1["MMSI_1624".toString().toLowerCase()] == null
                        ) {
                          colsec1["MMSI_1624".toString().toLowerCase()] = "";
                        }
                        if (
                          colsec1[
                          "Port_of_registry_1625".toString().toLowerCase()
                          ] == null
                        ) {
                          colsec1[
                            "Port_of_registry_1625".toString().toLowerCase()
                          ] = "";
                        }
                        if (
                          colsec1["IMO_number_1626".toString().toLowerCase()] ==
                          null
                        ) {
                          colsec1["IMO_number_1626".toString().toLowerCase()] =
                            "";
                        }
                        if (
                          colsec1[
                          "Gross_tonage_1627".toString().toLowerCase()
                          ] == null
                        ) {
                          colsec1[
                            "Gross_tonage_1627".toString().toLowerCase()
                          ] = "";
                        }
                        if (
                          colsec1[
                          "Date_kneel_laid_1628".toString().toLowerCase()
                          ] == null
                        ) {
                          colsec1[
                            "Date_kneel_laid_1628".toString().toLowerCase()
                          ] = "";
                        }
                        if (
                          colsec1["Date_1629".toString().toLowerCase()] == null
                        ) {
                          colsec1["Date_1629".toString().toLowerCase()] = "";
                        }
                        if (
                          colsec1["sea_area_1630".toString().toLowerCase()] ==
                          null
                        ) {
                          colsec1["sea_area_1630".toString().toLowerCase()] =
                            "";
                        }
                        if (
                          colsec1[
                          "Date_of_expiry_1631".toString().toLowerCase()
                          ] == null
                        ) {
                          colsec1[
                            "Date_of_expiry_1631".toString().toLowerCase()
                          ] = "";
                        }
                        if (
                          colsec1["Date_1632".toString().toLowerCase()] == null
                        ) {
                          colsec1["Date_1632".toString().toLowerCase()] = "";
                        }
                        if (
                          colsec1[
                          "indicate_methods_1633".toString().toLowerCase()
                          ] == null
                        ) {
                          colsec1[
                            "indicate_methods_1633".toString().toLowerCase()
                          ] = "";
                        }
                        if (
                          colsec1[
                          "duplication_of_equipment_1534"
                            .toString()
                            .toLowerCase()
                          ] == null
                        ) {
                          colsec1[
                            "duplication_of_equipment_1534"
                              .toString()
                              .toLowerCase()
                          ] = "";
                        }
                        if (
                          colsec1["yes_1635".toString().toLowerCase()] == null
                        ) {
                          colsec1["yes_1635".toString().toLowerCase()] = "";
                        }
                        if (
                          colsec1["No_1636".toString().toLowerCase()] == null
                        ) {
                          colsec1["No_1636".toString().toLowerCase()] = "";
                        }
                        if (
                          colsec1["shore_1637".toString().toLowerCase()] == null
                        ) {
                          colsec1["shore_1637".toString().toLowerCase()] = "";
                        }
                        if (
                          colsec1["yes_1638".toString().toLowerCase()] == null
                        ) {
                          colsec1["yes_1638".toString().toLowerCase()] = "";
                        }
                        if (
                          colsec1["no_1639".toString().toLowerCase()] == null
                        ) {
                          colsec1["no_1639".toString().toLowerCase()] = "";
                        }
                        if (
                          colsec1[
                          "Details_of_service_company_1640"
                            .toString()
                            .toLowerCase()
                          ] == null
                        ) {
                          colsec1[
                            "Details_of_service_company_1640"
                              .toString()
                              .toLowerCase()
                          ] = "";
                        }
                        if (
                          colsec1["Name_1641".toString().toLowerCase()] == null
                        ) {
                          colsec1["Name_1641".toString().toLowerCase()] = "";
                        }
                        if (
                          colsec1["Adress_1642".toString().toLowerCase()] ==
                          null
                        ) {
                          colsec1["Adress_1642".toString().toLowerCase()] = "";
                        }
                        if (
                          colsec1[
                          "maintanence_capability_1643"
                            .toString()
                            .toLowerCase()
                          ] == null
                        ) {
                          colsec1[
                            "maintanence_capability_1643"
                              .toString()
                              .toLowerCase()
                          ] = "";
                        }
                        if (
                          colsec1["yes_1644".toString().toLowerCase()] == null
                        ) {
                          colsec1["yes_1644".toString().toLowerCase()] = "";
                        }
                        if (
                          colsec1["No_1645".toString().toLowerCase()] == null
                        ) {
                          colsec1["No_1645".toString().toLowerCase()] = "";
                        }
                        if (
                          colsec1["owner_name_1646".toString().toLowerCase()] ==
                          null
                        ) {
                          colsec1["owner_name_1646".toString().toLowerCase()] =
                            "";
                        }
                        if (
                          colsec1["Name_1647".toString().toLowerCase()] == null
                        ) {
                          colsec1["Name_1647".toString().toLowerCase()] = "";
                        }
                        if (
                          colsec1["Address_1648".toString().toLowerCase()] ==
                          null
                        ) {
                          colsec1["Address_1648".toString().toLowerCase()] = "";
                        }
                        if (
                          colsec1[
                          "Managing_owner_1649".toString().toLowerCase()
                          ] == null
                        ) {
                          colsec1[
                            "Managing_owner_1649".toString().toLowerCase()
                          ] = "";
                        }
                        if (
                          colsec1["Name_1650".toString().toLowerCase()] == null
                        ) {
                          colsec1["Name_1650".toString().toLowerCase()] = "";
                        }
                        if (
                          colsec1["Address_1651".toString().toLowerCase()] ==
                          null
                        ) {
                          colsec1["Address_1651".toString().toLowerCase()] = "";
                        }

                        this.fSection1.push(colsec1);
                      }

                      if (
                        colsec2["Name_1653".toString().toLowerCase()] != null
                      ) {
                        if (
                          colsec2["Name_1631".toString().toLowerCase()] == null
                        ) {
                          colsec2["Name_1631".toString().toLowerCase()] = "";
                        }
                        if (
                          colsec2["Name_1653".toString().toLowerCase()] == null
                        ) {
                          colsec2["Name_1653".toString().toLowerCase()] = "";
                        }
                        if (
                          colsec2["dates_1654".toString().toLowerCase()] == null
                        ) {
                          colsec2["dates_1654".toString().toLowerCase()] = "";
                        }
                        if (
                          colsec2["from_1655".toString().toLowerCase()] == null
                        ) {
                          colsec2["from_1655".toString().toLowerCase()] = "";
                        }
                        if (
                          colsec2["DATE_1656".toString().toLowerCase()] == null
                        ) {
                          colsec2["DATE_1656".toString().toLowerCase()] = "";
                        }
                        if (
                          colsec2["To_1657".toString().toLowerCase()] == null
                        ) {
                          colsec2["To_1657".toString().toLowerCase()] = "";
                        }
                        if (
                          colsec2["Date_1658".toString().toLowerCase()] == null
                        ) {
                          colsec2["Date_1658".toString().toLowerCase()] = "";
                        }
                        if (
                          colsec2["classes_1659".toString().toLowerCase()] ==
                          null
                        ) {
                          colsec2["classes_1659".toString().toLowerCase()] = "";
                        }
                        if (
                          colsec2["class_1660".toString().toLowerCase()] == null
                        ) {
                          colsec2["class_1660".toString().toLowerCase()] = "";
                        }
                        if (
                          colsec2["date_1661".toString().toLowerCase()] == null
                        ) {
                          colsec2["date_1661".toString().toLowerCase()] = "";
                        }
                        if (
                          colsec2[
                          "certificate_1662".toString().toLowerCase()
                          ] == null
                        ) {
                          colsec2["certificate_1662".toString().toLowerCase()] =
                            "";
                        }
                        if (
                          colsec2["certi_1663".toString().toLowerCase()] == null
                        ) {
                          colsec2["certi_1663".toString().toLowerCase()] = "";
                        }
                        if (
                          colsec2[
                          "responsibility_1664".toString().toLowerCase()
                          ] == null
                        ) {
                          colsec2[
                            "responsibility_1664".toString().toLowerCase()
                          ] = "";
                        }
                        if (
                          colsec2["Name_1665".toString().toLowerCase()] == null
                        ) {
                          colsec2["Name_1665".toString().toLowerCase()] = "";
                        }
                        if (
                          colsec2["Ranks_1666".toString().toLowerCase()] == null
                        ) {
                          colsec2["Ranks_1666".toString().toLowerCase()] = "";
                        }
                        if (
                          colsec2["entries_1667".toString().toLowerCase()] ==
                          null
                        ) {
                          colsec2["entries_1667".toString().toLowerCase()] = "";
                        }
                        if (
                          colsec2["Name_1668".toString().toLowerCase()] == null
                        ) {
                          colsec2["Name_1668".toString().toLowerCase()] = "";
                        }
                        if (
                          colsec2["ranks_1669".toString().toLowerCase()] == null
                        ) {
                          colsec2["ranks_1669".toString().toLowerCase()] = "";
                        }
                        //console.log("second data:");
                        //console.log(colsec2);
                        this.fSection2.push(response[ky].data[s]);
                      }

                      if (
                        colsec3["from_1673".toString().toLowerCase()] != null
                      ) {
                        if (
                          colsec3[
                          "Name_of_ship_1670".toString().toLowerCase()
                          ] == null
                        ) {
                          colsec1[
                            "Name_of_ship_1670".toString().toLowerCase()
                          ] = "";
                        }
                        if (
                          colsec3["number_1671".toString().toLowerCase()] ==
                          null
                        ) {
                          colsec3["number_1671".toString().toLowerCase()] = "";
                        }
                        if (
                          colsec3["period_1672".toString().toLowerCase()] ==
                          null
                        ) {
                          colsec3["period_1672".toString().toLowerCase()] = "";
                        }
                        if (
                          colsec3["from_1673".toString().toLowerCase()] == null
                        ) {
                          colsec3["from_1673".toString().toLowerCase()] = "";
                        }
                        if (
                          colsec3["date_1674".toString().toLowerCase()] == null
                        ) {
                          colsec3["date_1674".toString().toLowerCase()] = "";
                        }
                        if (
                          colsec3["to_1675".toString().toLowerCase()] == null
                        ) {
                          colsec3["to_1675".toString().toLowerCase()] = "";
                        }
                        if (
                          colsec3["Date_1676".toString().toLowerCase()] == null
                        ) {
                          colsec3["Date_1676".toString().toLowerCase()] = "";
                        }
                        if (
                          colsec3["Delivered_1677".toString().toLowerCase()] ==
                          null
                        ) {
                          colsec3["Delivered_1677".toString().toLowerCase()] =
                            "";
                        }
                        if (
                          colsec3["Port_1678".toString().toLowerCase()] == null
                        ) {
                          colsec3["Port_1678".toString().toLowerCase()] = "";
                        }
                        if (
                          colsec3["text_1679".toString().toLowerCase()] == null
                        ) {
                          colsec3["text_1679".toString().toLowerCase()] = "";
                        }
                        if (
                          colsec3["port_1680".toString().toLowerCase()] == null
                        ) {
                          colsec3["port_1680".toString().toLowerCase()] = "";
                        }
                        if (
                          colsec3["day_1681".toString().toLowerCase()] == null
                        ) {
                          colsec3["day_1681".toString().toLowerCase()] = "";
                        }
                        if (
                          colsec3["date_1682".toString().toLowerCase()] == null
                        ) {
                          colsec3["date_1682".toString().toLowerCase()] = "";
                        }
                        if (
                          colsec3["sign_1683".toString().toLowerCase()] == null
                        ) {
                          colsec3["sign_1683".toString().toLowerCase()] = "";
                        }
                        if (
                          colsec3["signature_1684".toString().toLowerCase()] ==
                          null
                        ) {
                          colsec3["signature_1684".toString().toLowerCase()] =
                            "";
                        }
                        if (
                          colsec3[
                          "Counter_sign_1685".toString().toLowerCase()
                          ] == null
                        ) {
                          colsec3[
                            "Counter_sign_1685".toString().toLowerCase()
                          ] = "";
                        }
                        if (
                          colsec3["signature_1686".toString().toLowerCase()] ==
                          null
                        ) {
                          colsec3["signature_1686".toString().toLowerCase()] =
                            "";
                        }
                        this.fSection3.push(colsec3);
                      }
                    }

                    if (formId == 68) {
                      if (
                        coldate["date_created"] != null &&
                        coldate["date_created"] != ""
                      ) {
                        var dataPart = coldate["date_created"]
                          .toString()
                          .split(" ");

                        var dateSplit = dataPart[0].toString().split("-");
                        var day = dateSplit[2];
                        var month = dateSplit[1];
                        var year = dateSplit[0];
                        this.createdDate = day + "-" + month + "-" + year;
                        var sectionLenght = coldate["section_length"];
                        this.createdAt.push([
                          year + "-" + month + "-" + day,
                          sectionLenght,
                          sectionName,
                          cnt1++,
                        ]);
                      }

                      if (
                        colsec1["utc_1707".toString().toLowerCase()] != null
                      ) {
                        if (
                          colsec1[
                          "vessel_name_1700".toString().toLowerCase()
                          ] == null
                        ) {
                          colsec1["vessel_name_1700".toString().toLowerCase()] =
                            "";
                        }
                        if (
                          colsec1["name_1701".toString().toLowerCase()] == null
                        ) {
                          colsec1["name_1701".toString().toLowerCase()] = "";
                        }
                        if (
                          colsec1["calisign_1702".toString().toLowerCase()] ==
                          null
                        ) {
                          colsec1["calisign_1702".toString().toLowerCase()] =
                            "";
                        }
                        if (
                          colsec1["textbox_1703".toString().toLowerCase()] ==
                          null
                        ) {
                          colsec1["textbox_1703".toString().toLowerCase()] = "";
                        }
                        if (
                          colsec1["date_1704".toString().toLowerCase()] == null
                        ) {
                          colsec1["date_1704".toString().toLowerCase()] = "";
                        }
                        if (
                          colsec1["utc_1705".toString().toLowerCase()] == null
                        ) {
                          colsec1["utc_1705".toString().toLowerCase()] = "";
                        }
                        if (
                          colsec1["time_1706".toString().toLowerCase()] == null
                        ) {
                          colsec1["time_1706".toString().toLowerCase()] = "";
                        }
                        if (
                          colsec1["utc_1707".toString().toLowerCase()] == null
                        ) {
                          colsec1[
                            "station_from_1708".toString().toLowerCase()
                          ] = "";
                        }
                        if (
                          colsec1[
                          "station_from_1708".toString().toLowerCase()
                          ] == null
                        ) {
                          colsec1[
                            "station_from_1695".toString().toLowerCase()
                          ] = "";
                        }
                        if (
                          colsec1["station_to_1709".toString().toLowerCase()] ==
                          null
                        ) {
                          colsec1["station_to_1709".toString().toLowerCase()] =
                            "";
                        }
                        if (
                          colsec1["remarks_1710".toString().toLowerCase()] ==
                          null
                        ) {
                          colsec1["remarks_1710".toString().toLowerCase()] = "";
                        }
                        if (
                          colsec1["channel_1711".toString().toLowerCase()] ==
                          null
                        ) {
                          colsec1["channel_1711".toString().toLowerCase()] = "";
                        }
                        if (
                          colsec1["sign_1712".toString().toLowerCase()] == null
                        ) {
                          colsec1["sign_1712".toString().toLowerCase()] = "";
                        }

                        //date_1691 time_1693 , station_to_1696 ,station_from_1695, remarks_1697 ,channel_1698

                        this.fSection4.push([
                          colsec1["date_1704".toString().toLowerCase()] +
                          " " +
                          colsec1["time_1706".toString().toLowerCase()],
                          colsec1["station_to_1709".toString().toLowerCase()],
                          colsec1["station_from_1708".toString().toLowerCase()],
                          colsec1["remarks_1710".toString().toLowerCase()],
                          colsec1["channel_1711".toString().toLowerCase()],
                        ]);
                        this.userSign.push(usersign);
                      }
                    }
                    // end collection column data to make it tabular
                  }
                }

                // collection of data into seperate array to be used in html
                // console.log("mylog::mylognewreport");
                this.objcolcollection = [];
                if (
                  this.fSection1.length > 0 ||
                  this.fSection2.length > 0 ||
                  this.fSection3.length > 0 ||
                  this.fSection4.length > 0
                ) {
                  this.objcolcollection.push(
                    this.fSection1[this.fSection1.length - 1]
                  );
                  this.objcolcollection.push(this.fSection2);
                  this.objcolcollection.push(
                    this.fSection3[this.fSection3.length - 1]
                  );
                  this.createCollectionLayout(this.fSection4);
                  this.objcolcollection.push(this.fSection4);
                }

                // console.log(this.objcolcollection);
              }
            }
          }
        );

        break;
      }
    }
  }

  gmdss_log_book_list(
    hid,
    actionDate = "",
    actionTime = "",
    fromDate = "",
    toDate = ""
  ) {
    if (hid == 49) {
      this.gmdss = 1;
    } else if (hid == "49-1") {
      this.gmdss = 2;
    } else if (hid == "49-2") {
      this.gmdss = 3;
    } else if (hid == "49-3") {
      this.gmdss = 4;
    }
    hid = 49;

    for (var i = 0; i < this.formBuilder.length; i++) {
      if (this.formBuilder[i].hid == hid) {
        this.formCount = [];
        this.objcolsection = [];
        var result = [];
        var strFormId = "";
        this.showpop9 = 0;

        for (
          var r = 0;
          r < this.formBuilder[i].formbuilderresponse.length;
          r++
        ) {
          if (
            this.formBuilder[i].formbuilderresponse[r].formId == 67 ||
            this.formBuilder[i].formbuilderresponse[r].formId == 68
          ) {
            strFormId +=
              this.formBuilder[i].formbuilderresponse[r].formId + ",";
            this.formCount.push(this.formBuilder[i].formbuilderresponse[r]);
          }
        }

        var fineStringFormsId = strFormId.replace(/(^,)|(,$)/g, "");
        //alert(fineStringFormsId);
        this.editlogbookformsService.getFormDetailsByActionDateAndTime(
          fineStringFormsId,
          this.voyageNo,
          actionDate,
          actionTime,
          fromDate,
          toDate,
          (multiresponse) => {
            // this.editlogbookformsService.getFormDetails(fineStringFormsId,this.voyageNo,(multiresponse) => {
            this.objcolsection = [];
            var cnt1 = 0;
            var cnt2 = 0;
            var cnt3 = 0;
            var cnt4 = 0;
            var cnt5 = 0;
            var cnt6 = 0;
            var cnt7 = 0;
            var colsec1 = [];
            var colsec2 = [];
            var colsec3 = [];
            var colsec4 = [];
            var colsec5 = [];
            var colsec6 = [];
            var colsec7 = [];
            var colsec8 = [];
            var coldate = [];
            var colsec9 = [];
            if (multiresponse != null && multiresponse.length > 0) {
              let response = [];
              for (let ky in multiresponse) {
                response.push(this.modifyedData(multiresponse[ky]));
              }
              // all form response loop
              // console.log("response");
              for (let ky in response) {
                if (response[ky].data != null) {
                  var sectionName = "";

                  for (var s = 0; s < response[ky].data.length; s++) {
                    if (response[ky].data[s].isDelete == "1") continue;
                    var formId = response[ky].data[s].formId;

                    this.editedBy = "";
                    var usersign = "";
                    // console.log("===chanage value checking====");
                    if (response[ky].data[s].editedBy != null) {
                      this.editedBy = response[ky].data[s].editedBy;
                    }

                    //alert(this.editedBy); return;

                    usersign = response[ky].data[s].userSign;

                    this.formBuilderSections = [];
                    for (
                      var r = 0;
                      r < this.formBuilder[i].formbuilderresponse.length;
                      r++
                    ) {
                      if (
                        this.formBuilder[i].formbuilderresponse[r].formId ==
                        formId
                      ) {
                        sectionName = this.formBuilder[i].formbuilderresponse[
                          r
                        ].formName
                          .replace(/Code/gi, "")
                          .replace(/ORB2/gi, "")
                          .replace(/ORB/gi, ""); //.charAt(this.formBuilder[i].formbuilderresponse[r].formName.length-1);
                        for (
                          var u = 0;
                          u <
                          this.formBuilder[i].formbuilderresponse[r]
                            .formbuildersectionnamelist.length;
                          u++
                        ) {
                          this.formBuilderSections.push(
                            this.formBuilder[i].formbuilderresponse[r]
                              .formbuildersectionnamelist[u]
                          ); //.formbuilderlist
                        }
                      }
                    }

                    //console.log();
                    for (let key in response[ky].data[s]) {
                      var sectionlength = this.formBuilderSections.length;
                      if (sectionlength == 4) {
                        sectionlength = 3;
                      }

                      for (var p = 0; p < sectionlength; p++) {
                        //alert(p)
                        for (
                          var v = 0;
                          v <
                          this.formBuilderSections[p].formbuilderlist.length;
                          v++
                        ) {
                          if (
                            key.toString().toLowerCase() == "created_at" &&
                            response[ky].data[s][key] != ""
                          ) {
                            coldate["date_created"] = response[ky].data[s][key];
                            coldate["section_length"] = sectionlength;
                          }
                          //if(key.toString().toLowerCase()==this.formBuilderSections[p].formbuilderlist[v].fieldName.toString().toLowerCase()){
                          if (formId == 67) {
                            //this.gmdss = 1;
                            if (p == 0) {
                              if (
                                (key.toString().toLowerCase() ==
                                  "Name_of_ship_1622".toLowerCase() &&
                                  response[ky].data[s][key] != "") ||
                                (key.toString().toLowerCase() ==
                                  "call_sign_1623".toLowerCase() &&
                                  response[ky].data[s][key] != "") ||
                                (key.toString().toLowerCase() ==
                                  "MMSI_1624".toLowerCase() &&
                                  response[ky].data[s][key] != "") ||
                                (key.toString().toLowerCase() ==
                                  "Port_of_registry_1625".toLowerCase() &&
                                  response[ky].data[s][key] != "") ||
                                (key.toString().toLowerCase() ==
                                  "IMO_number_1626".toLowerCase() &&
                                  response[ky].data[s][key] != "") ||
                                (key.toString().toLowerCase() ==
                                  "Gross_tonage_1627".toLowerCase() &&
                                  response[ky].data[s][key] != "") ||
                                (key.toString().toLowerCase() ==
                                  "Date_kneel_laid_1628".toLowerCase() &&
                                  response[ky].data[s][key] != "") ||
                                (key.toString().toLowerCase() ==
                                  "Date_1629".toLowerCase() &&
                                  response[ky].data[s][key] != "") ||
                                (key.toString().toLowerCase() ==
                                  "sea_area_1630".toLowerCase() &&
                                  response[ky].data[s][key] != "") ||
                                (key.toString().toLowerCase() ==
                                  "Date_of_expiry_1631".toLowerCase() &&
                                  response[ky].data[s][key] != "") ||
                                (key.toString().toLowerCase() ==
                                  "Date_1632".toLowerCase() &&
                                  response[ky].data[s][key] != "") ||
                                (key.toString().toLowerCase() ==
                                  "indicate_methods_1633".toLowerCase() &&
                                  response[ky].data[s][key] != "") ||
                                (key.toString().toLowerCase() ==
                                  "duplication_of_equipment_1534".toLowerCase() &&
                                  response[ky].data[s][key] != "") ||
                                (key.toString().toLowerCase() ==
                                  "yes_1635".toLowerCase() &&
                                  response[ky].data[s][key] != "") ||
                                (key.toString().toLowerCase() ==
                                  "No_1636".toLowerCase() &&
                                  response[ky].data[s][key] != "") ||
                                (key.toString().toLowerCase() ==
                                  "shore_1637".toLowerCase() &&
                                  response[ky].data[s][key] != "") ||
                                (key.toString().toLowerCase() ==
                                  "yes_1638".toLowerCase() &&
                                  response[ky].data[s][key] != "") ||
                                (key.toString().toLowerCase() ==
                                  "no_1639".toLowerCase() &&
                                  response[ky].data[s][key] != "") ||
                                (key.toString().toLowerCase() ==
                                  "Details_of_service_company_1640".toLowerCase() &&
                                  response[ky].data[s][key] != "") ||
                                (key.toString().toLowerCase() ==
                                  "Name_1641".toLowerCase() &&
                                  response[ky].data[s][key] != "") ||
                                (key.toString().toLowerCase() ==
                                  "Adress_1642".toLowerCase() &&
                                  response[ky].data[s][key] != "") ||
                                (key.toString().toLowerCase() ==
                                  "maintanence_capability_1643".toLowerCase() &&
                                  response[ky].data[s][key] != "") ||
                                (key.toString().toLowerCase() ==
                                  "yes_1644".toLowerCase() &&
                                  response[ky].data[s][key] != "") ||
                                (key.toString().toLowerCase() ==
                                  "No_1645".toLowerCase() &&
                                  response[ky].data[s][key] != "") ||
                                (key.toString().toLowerCase() ==
                                  "owner_name_1646".toLowerCase() &&
                                  response[ky].data[s][key] != "") ||
                                (key.toString().toLowerCase() ==
                                  "Name_1647".toLowerCase() &&
                                  response[ky].data[s][key] != "") ||
                                (key.toString().toLowerCase() ==
                                  "Address_1648".toLowerCase() &&
                                  response[ky].data[s][key] != "") ||
                                (key.toString().toLowerCase() ==
                                  "Managing_owner_1649".toLowerCase() &&
                                  response[ky].data[s][key] != "") ||
                                (key.toString().toLowerCase() ==
                                  "Name_1650".toLowerCase() &&
                                  response[ky].data[s][key] != "") ||
                                (key.toString().toLowerCase() ==
                                  "Address_1651".toLowerCase() &&
                                  response[ky].data[s][key] != "")
                              ) {
                                colsec1[key.toString().toLowerCase()] =
                                  response[ky].data[s][key];
                              }
                            }

                            if (p == 1) {
                              //                                                                                      if((key.toString().toLowerCase()=='Name_1653'.toLowerCase() && response[ky].data[s][key]!='') ){
                              //                                                                                          alert(response[ky].data[s][key])
                              //                                                                                          colsec2[key.toString().toLowerCase()] = response[ky].data[s][key];
                              //                                                                                      }

                              if (
                                (key.toString().toLowerCase() ==
                                  "Name_1631".toLowerCase() &&
                                  response[ky].data[s][key] != "") ||
                                (key.toString().toLowerCase() ==
                                  "Name_1653".toLowerCase() &&
                                  response[ky].data[s][key] != "") ||
                                (key.toString().toLowerCase() ==
                                  "dates_1654".toLowerCase() &&
                                  response[ky].data[s][key] != "") ||
                                (key.toString().toLowerCase() ==
                                  "from_1655".toLowerCase() &&
                                  response[ky].data[s][key] != "") ||
                                (key.toString().toLowerCase() ==
                                  "DATE_1656".toLowerCase() &&
                                  response[ky].data[s][key] != "") ||
                                (key.toString().toLowerCase() ==
                                  "To_1657".toLowerCase() &&
                                  response[ky].data[s][key] != "") ||
                                (key.toString().toLowerCase() ==
                                  "Date_1658".toLowerCase() &&
                                  response[ky].data[s][key] != "") ||
                                (key.toString().toLowerCase() ==
                                  "classes_1659".toLowerCase() &&
                                  response[ky].data[s][key] != "") ||
                                (key.toString().toLowerCase() ==
                                  "class_1660".toLowerCase() &&
                                  response[ky].data[s][key] != "") ||
                                (key.toString().toLowerCase() ==
                                  "date_1661".toLowerCase() &&
                                  response[ky].data[s][key] != "") ||
                                (key.toString().toLowerCase() ==
                                  "certificate_1662".toLowerCase() &&
                                  response[ky].data[s][key] != "") ||
                                (key.toString().toLowerCase() ==
                                  "certi_1663".toLowerCase() &&
                                  response[ky].data[s][key] != "") ||
                                (key.toString().toLowerCase() ==
                                  "responsibility_1664".toLowerCase() &&
                                  response[ky].data[s][key] != "") ||
                                (key.toString().toLowerCase() ==
                                  "Name_1665".toLowerCase() &&
                                  response[ky].data[s][key] != "") ||
                                (key.toString().toLowerCase() ==
                                  "Ranks_1666".toLowerCase() &&
                                  response[ky].data[s][key] != "") ||
                                (key.toString().toLowerCase() ==
                                  "entries_1667".toLowerCase() &&
                                  response[ky].data[s][key] != "") ||
                                (key.toString().toLowerCase() ==
                                  "Name_1668".toLowerCase() &&
                                  response[ky].data[s][key] != "") ||
                                (key.toString().toLowerCase() ==
                                  "ranks_1669".toLowerCase() &&
                                  response[ky].data[s][key] != "")
                              ) {
                                colsec2[key.toString().toLowerCase()] =
                                  response[ky].data[s][key];
                              }
                            }

                            if (p == 2) {
                              //this.gmdss = 3;
                              if (
                                (key.toString().toLowerCase() ==
                                  "Name_of_ship_1670".toLowerCase() &&
                                  response[ky].data[s][key] != "") ||
                                (key.toString().toLowerCase() ==
                                  "number_1671".toLowerCase() &&
                                  response[ky].data[s][key] != "") ||
                                (key.toString().toLowerCase() ==
                                  "period_1672".toLowerCase() &&
                                  response[ky].data[s][key] != "") ||
                                (key.toString().toLowerCase() ==
                                  "from_1673".toLowerCase() &&
                                  response[ky].data[s][key] != "") ||
                                (key.toString().toLowerCase() ==
                                  "date_1674".toLowerCase() &&
                                  response[ky].data[s][key] != "") ||
                                (key.toString().toLowerCase() ==
                                  "to_1675".toLowerCase() &&
                                  response[ky].data[s][key] != "") ||
                                (key.toString().toLowerCase() ==
                                  "Date_1676".toLowerCase() &&
                                  response[ky].data[s][key] != "") ||
                                (key.toString().toLowerCase() ==
                                  "Delivered_1677".toLowerCase() &&
                                  response[ky].data[s][key] != "") ||
                                (key.toString().toLowerCase() ==
                                  "Port_1678".toLowerCase() &&
                                  response[ky].data[s][key] != "") ||
                                (key.toString().toLowerCase() ==
                                  "text_1679".toLowerCase() &&
                                  response[ky].data[s][key] != "") ||
                                (key.toString().toLowerCase() ==
                                  "port_1680".toLowerCase() &&
                                  response[ky].data[s][key] != "") ||
                                (key.toString().toLowerCase() ==
                                  "day_1681".toLowerCase() &&
                                  response[ky].data[s][key] != "") ||
                                (key.toString().toLowerCase() ==
                                  "date_1682".toLowerCase() &&
                                  response[ky].data[s][key] != "") ||
                                (key.toString().toLowerCase() ==
                                  "sign_1683".toLowerCase() &&
                                  response[ky].data[s][key] != "") ||
                                (key.toString().toLowerCase() ==
                                  "signature_1684".toLowerCase() &&
                                  response[ky].data[s][key] != "") ||
                                (key.toString().toLowerCase() ==
                                  "Counter_sign_1685".toLowerCase() &&
                                  response[ky].data[s][key] != "") ||
                                (key.toString().toLowerCase() ==
                                  "signature_1686".toLowerCase() &&
                                  response[ky].data[s][key] != "")
                              ) {
                                colsec3[key.toString().toLowerCase()] =
                                  response[ky].data[s][key];
                              }
                            }
                          }

                          if (formId == 68) {
                            if (p == 0) {
                              // this.gmdss = 4;
                              if (
                                (key.toString().toLowerCase() ==
                                  "vessel_name_1700".toLowerCase() &&
                                  response[ky].data[s][key] != "") ||
                                (key.toString().toLowerCase() ==
                                  "name_1701".toLowerCase() &&
                                  response[ky].data[s][key] != "") ||
                                (key.toString().toLowerCase() ==
                                  "calisign_1702".toLowerCase() &&
                                  response[ky].data[s][key] != "") ||
                                (key.toString().toLowerCase() ==
                                  "textbox_1703".toLowerCase() &&
                                  response[ky].data[s][key] != "") ||
                                (key.toString().toLowerCase() ==
                                  "date_1704".toLowerCase() &&
                                  response[ky].data[s][key] != "") ||
                                (key.toString().toLowerCase() ==
                                  "utc_1705".toLowerCase() &&
                                  response[ky].data[s][key] != "") ||
                                (key.toString().toLowerCase() ==
                                  "time_1706".toLowerCase() &&
                                  response[ky].data[s][key] != "") ||
                                (key.toString().toLowerCase() ==
                                  "utc_1707".toLowerCase() &&
                                  response[ky].data[s][key] != "") ||
                                (key.toString().toLowerCase() ==
                                  "station_from_1708".toLowerCase() &&
                                  response[ky].data[s][key] != "") ||
                                (key.toString().toLowerCase() ==
                                  "station_to_1709".toLowerCase() &&
                                  response[ky].data[s][key] != "") ||
                                (key.toString().toLowerCase() ==
                                  "remarks_1710".toLowerCase() &&
                                  response[ky].data[s][key] != "") ||
                                (key.toString().toLowerCase() ==
                                  "channel_1711".toLowerCase() &&
                                  response[ky].data[s][key] != "") ||
                                (key.toString().toLowerCase() ==
                                  "sign_1712".toLowerCase() &&
                                  response[ky].data[s][key] != "")
                              ) {
                                colsec1[key.toString().toLowerCase()] =
                                  response[ky].data[s][key];
                              }
                            }
                          }

                          //j}
                        }
                      }
                    }

                    //add form values
                    if (formId == 67) {
                      if (
                        coldate["date_created"] != null &&
                        coldate["date_created"] != ""
                      ) {
                        var dataPart = coldate["date_created"]
                          .toString()
                          .split(" ");

                        var dateSplit = dataPart[0].toString().split("-");
                        var day = dateSplit[2];
                        var month = dateSplit[1];
                        var year = dateSplit[0];
                        this.createdDate = day + "-" + month + "-" + year;
                        var sectionLenght = coldate["section_length"];
                        this.createdAt.push([
                          year + "-" + month + "-" + day,
                          sectionLenght,
                          sectionName,
                          cnt1++,
                        ]);
                      }

                      if (
                        colsec1["Name_of_ship_1622".toString().toLowerCase()] !=
                        null
                      ) {
                        if (
                          colsec1[
                          "Name_of_ship_1622".toString().toLowerCase()
                          ] == null
                        ) {
                          colsec1[
                            "Name_of_ship_1622".toString().toLowerCase()
                          ] = "";
                        }
                        if (
                          colsec1["call_sign_1623".toString().toLowerCase()] ==
                          null
                        ) {
                          colsec1["call_sign_1623".toString().toLowerCase()] =
                            "";
                        }
                        if (
                          colsec1["MMSI_1624".toString().toLowerCase()] == null
                        ) {
                          colsec1["MMSI_1624".toString().toLowerCase()] = "";
                        }
                        if (
                          colsec1[
                          "Port_of_registry_1625".toString().toLowerCase()
                          ] == null
                        ) {
                          colsec1[
                            "Port_of_registry_1625".toString().toLowerCase()
                          ] = "";
                        }
                        if (
                          colsec1["IMO_number_1626".toString().toLowerCase()] ==
                          null
                        ) {
                          colsec1["IMO_number_1626".toString().toLowerCase()] =
                            "";
                        }
                        if (
                          colsec1[
                          "Gross_tonage_1627".toString().toLowerCase()
                          ] == null
                        ) {
                          colsec1[
                            "Gross_tonage_1627".toString().toLowerCase()
                          ] = "";
                        }
                        if (
                          colsec1[
                          "Date_kneel_laid_1628".toString().toLowerCase()
                          ] == null
                        ) {
                          colsec1[
                            "Date_kneel_laid_1628".toString().toLowerCase()
                          ] = "";
                        }
                        if (
                          colsec1["Date_1629".toString().toLowerCase()] == null
                        ) {
                          colsec1["Date_1629".toString().toLowerCase()] = "";
                        }
                        if (
                          colsec1["sea_area_1630".toString().toLowerCase()] ==
                          null
                        ) {
                          colsec1["sea_area_1630".toString().toLowerCase()] =
                            "";
                        }
                        if (
                          colsec1[
                          "Date_of_expiry_1631".toString().toLowerCase()
                          ] == null
                        ) {
                          colsec1[
                            "Date_of_expiry_1631".toString().toLowerCase()
                          ] = "";
                        }
                        if (
                          colsec1["Date_1632".toString().toLowerCase()] == null
                        ) {
                          colsec1["Date_1632".toString().toLowerCase()] = "";
                        }
                        if (
                          colsec1[
                          "indicate_methods_1633".toString().toLowerCase()
                          ] == null
                        ) {
                          colsec1[
                            "indicate_methods_1633".toString().toLowerCase()
                          ] = "";
                        }
                        if (
                          colsec1[
                          "duplication_of_equipment_1534"
                            .toString()
                            .toLowerCase()
                          ] == null
                        ) {
                          colsec1[
                            "duplication_of_equipment_1534"
                              .toString()
                              .toLowerCase()
                          ] = "";
                        }
                        if (
                          colsec1["yes_1635".toString().toLowerCase()] == null
                        ) {
                          colsec1["yes_1635".toString().toLowerCase()] = "";
                        }
                        if (
                          colsec1["No_1636".toString().toLowerCase()] == null
                        ) {
                          colsec1["No_1636".toString().toLowerCase()] = "";
                        }
                        if (
                          colsec1["shore_1637".toString().toLowerCase()] == null
                        ) {
                          colsec1["shore_1637".toString().toLowerCase()] = "";
                        }
                        if (
                          colsec1["yes_1638".toString().toLowerCase()] == null
                        ) {
                          colsec1["yes_1638".toString().toLowerCase()] = "";
                        }
                        if (
                          colsec1["no_1639".toString().toLowerCase()] == null
                        ) {
                          colsec1["no_1639".toString().toLowerCase()] = "";
                        }
                        if (
                          colsec1[
                          "Details_of_service_company_1640"
                            .toString()
                            .toLowerCase()
                          ] == null
                        ) {
                          colsec1[
                            "Details_of_service_company_1640"
                              .toString()
                              .toLowerCase()
                          ] = "";
                        }
                        if (
                          colsec1["Name_1641".toString().toLowerCase()] == null
                        ) {
                          colsec1["Name_1641".toString().toLowerCase()] = "";
                        }
                        if (
                          colsec1["Adress_1642".toString().toLowerCase()] ==
                          null
                        ) {
                          colsec1["Adress_1642".toString().toLowerCase()] = "";
                        }
                        if (
                          colsec1[
                          "maintanence_capability_1643"
                            .toString()
                            .toLowerCase()
                          ] == null
                        ) {
                          colsec1[
                            "maintanence_capability_1643"
                              .toString()
                              .toLowerCase()
                          ] = "";
                        }
                        if (
                          colsec1["yes_1644".toString().toLowerCase()] == null
                        ) {
                          colsec1["yes_1644".toString().toLowerCase()] = "";
                        }
                        if (
                          colsec1["No_1645".toString().toLowerCase()] == null
                        ) {
                          colsec1["No_1645".toString().toLowerCase()] = "";
                        }
                        if (
                          colsec1["owner_name_1646".toString().toLowerCase()] ==
                          null
                        ) {
                          colsec1["owner_name_1646".toString().toLowerCase()] =
                            "";
                        }
                        if (
                          colsec1["Name_1647".toString().toLowerCase()] == null
                        ) {
                          colsec1["Name_1647".toString().toLowerCase()] = "";
                        }
                        if (
                          colsec1["Address_1648".toString().toLowerCase()] ==
                          null
                        ) {
                          colsec1["Address_1648".toString().toLowerCase()] = "";
                        }
                        if (
                          colsec1[
                          "Managing_owner_1649".toString().toLowerCase()
                          ] == null
                        ) {
                          colsec1[
                            "Managing_owner_1649".toString().toLowerCase()
                          ] = "";
                        }
                        if (
                          colsec1["Name_1650".toString().toLowerCase()] == null
                        ) {
                          colsec1["Name_1650".toString().toLowerCase()] = "";
                        }
                        if (
                          colsec1["Address_1651".toString().toLowerCase()] ==
                          null
                        ) {
                          colsec1["Address_1651".toString().toLowerCase()] = "";
                        }

                        this.fSection1.push(colsec1);
                      }

                      if (
                        colsec2["Name_1653".toString().toLowerCase()] != null
                      ) {
                        if (
                          colsec2["Name_1631".toString().toLowerCase()] == null
                        ) {
                          colsec2["Name_1631".toString().toLowerCase()] = "";
                        }
                        if (
                          colsec2["Name_1653".toString().toLowerCase()] == null
                        ) {
                          colsec2["Name_1653".toString().toLowerCase()] = "";
                        }
                        if (
                          colsec2["dates_1654".toString().toLowerCase()] == null
                        ) {
                          colsec2["dates_1654".toString().toLowerCase()] = "";
                        }
                        if (
                          colsec2["from_1655".toString().toLowerCase()] == null
                        ) {
                          colsec2["from_1655".toString().toLowerCase()] = "";
                        }
                        if (
                          colsec2["DATE_1656".toString().toLowerCase()] == null
                        ) {
                          colsec2["DATE_1656".toString().toLowerCase()] = "";
                        }
                        if (
                          colsec2["To_1657".toString().toLowerCase()] == null
                        ) {
                          colsec2["To_1657".toString().toLowerCase()] = "";
                        }
                        if (
                          colsec2["Date_1658".toString().toLowerCase()] == null
                        ) {
                          colsec2["Date_1658".toString().toLowerCase()] = "";
                        }
                        if (
                          colsec2["classes_1659".toString().toLowerCase()] ==
                          null
                        ) {
                          colsec2["classes_1659".toString().toLowerCase()] = "";
                        }
                        if (
                          colsec2["class_1660".toString().toLowerCase()] == null
                        ) {
                          colsec2["class_1660".toString().toLowerCase()] = "";
                        }
                        if (
                          colsec2["date_1661".toString().toLowerCase()] == null
                        ) {
                          colsec2["date_1661".toString().toLowerCase()] = "";
                        }
                        if (
                          colsec2[
                          "certificate_1662".toString().toLowerCase()
                          ] == null
                        ) {
                          colsec2["certificate_1662".toString().toLowerCase()] =
                            "";
                        }
                        if (
                          colsec2["certi_1663".toString().toLowerCase()] == null
                        ) {
                          colsec2["certi_1663".toString().toLowerCase()] = "";
                        }
                        if (
                          colsec2[
                          "responsibility_1664".toString().toLowerCase()
                          ] == null
                        ) {
                          colsec2[
                            "responsibility_1664".toString().toLowerCase()
                          ] = "";
                        }
                        if (
                          colsec2["Name_1665".toString().toLowerCase()] == null
                        ) {
                          colsec2["Name_1665".toString().toLowerCase()] = "";
                        }
                        if (
                          colsec2["Ranks_1666".toString().toLowerCase()] == null
                        ) {
                          colsec2["Ranks_1666".toString().toLowerCase()] = "";
                        }
                        if (
                          colsec2["entries_1667".toString().toLowerCase()] ==
                          null
                        ) {
                          colsec2["entries_1667".toString().toLowerCase()] = "";
                        }
                        if (
                          colsec2["Name_1668".toString().toLowerCase()] == null
                        ) {
                          colsec2["Name_1668".toString().toLowerCase()] = "";
                        }
                        if (
                          colsec2["ranks_1669".toString().toLowerCase()] == null
                        ) {
                          colsec2["ranks_1669".toString().toLowerCase()] = "";
                        }
                        //console.log("second data:");
                        //console.log(colsec2);
                        this.fSection2.push(response[ky].data[s]);
                      }

                      if (
                        colsec3["Name_of_ship_1670".toString().toLowerCase()] !=
                        null
                      ) {
                        if (
                          colsec3[
                          "Name_of_ship_1670".toString().toLowerCase()
                          ] == null
                        ) {
                          colsec1[
                            "Name_of_ship_1670".toString().toLowerCase()
                          ] = "";
                        }
                        if (
                          colsec3["number_1671".toString().toLowerCase()] ==
                          null
                        ) {
                          colsec3["number_1671".toString().toLowerCase()] = "";
                        }
                        if (
                          colsec3["period_1672".toString().toLowerCase()] ==
                          null
                        ) {
                          colsec3["period_1672".toString().toLowerCase()] = "";
                        }
                        if (
                          colsec3["from_1673".toString().toLowerCase()] == null
                        ) {
                          colsec3["from_1673".toString().toLowerCase()] = "";
                        }
                        if (
                          colsec3["date_1674".toString().toLowerCase()] == null
                        ) {
                          colsec3["date_1674".toString().toLowerCase()] = "";
                        }
                        if (
                          colsec3["to_1675".toString().toLowerCase()] == null
                        ) {
                          colsec3["to_1675".toString().toLowerCase()] = "";
                        }
                        if (
                          colsec3["Date_1676".toString().toLowerCase()] == null
                        ) {
                          colsec3["Date_1676".toString().toLowerCase()] = "";
                        }
                        if (
                          colsec3["Delivered_1677".toString().toLowerCase()] ==
                          null
                        ) {
                          colsec3["Delivered_1677".toString().toLowerCase()] =
                            "";
                        }
                        if (
                          colsec3["Port_1678".toString().toLowerCase()] == null
                        ) {
                          colsec3["Port_1678".toString().toLowerCase()] = "";
                        }
                        if (
                          colsec3["text_1679".toString().toLowerCase()] == null
                        ) {
                          colsec3["text_1679".toString().toLowerCase()] = "";
                        }
                        if (
                          colsec3["port_1680".toString().toLowerCase()] == null
                        ) {
                          colsec3["port_1680".toString().toLowerCase()] = "";
                        }
                        if (
                          colsec3["day_1681".toString().toLowerCase()] == null
                        ) {
                          colsec3["day_1681".toString().toLowerCase()] = "";
                        }
                        if (
                          colsec3["date_1682".toString().toLowerCase()] == null
                        ) {
                          colsec3["date_1682".toString().toLowerCase()] = "";
                        }
                        if (
                          colsec3["sign_1683".toString().toLowerCase()] == null
                        ) {
                          colsec3["sign_1683".toString().toLowerCase()] = "";
                        }
                        if (
                          colsec3["signature_1684".toString().toLowerCase()] ==
                          null
                        ) {
                          colsec3["signature_1684".toString().toLowerCase()] =
                            "";
                        }
                        if (
                          colsec3[
                          "Counter_sign_1685".toString().toLowerCase()
                          ] == null
                        ) {
                          colsec3[
                            "Counter_sign_1685".toString().toLowerCase()
                          ] = "";
                        }
                        if (
                          colsec3["signature_1686".toString().toLowerCase()] ==
                          null
                        ) {
                          colsec3["signature_1686".toString().toLowerCase()] =
                            "";
                        }
                        this.fSection3.push(colsec3);
                      }
                    }

                    if (formId == 68) {
                      if (
                        coldate["date_created"] != null &&
                        coldate["date_created"] != ""
                      ) {
                        var dataPart = coldate["date_created"]
                          .toString()
                          .split(" ");

                        var dateSplit = dataPart[0].toString().split("-");
                        var day = dateSplit[2];
                        var month = dateSplit[1];
                        var year = dateSplit[0];
                        this.createdDate = day + "-" + month + "-" + year;
                        var sectionLenght = coldate["section_length"];
                        this.createdAt.push([
                          year + "-" + month + "-" + day,
                          sectionLenght,
                          sectionName,
                          cnt1++,
                        ]);
                      }

                      if (
                        colsec1["vessel_name_1700".toString().toLowerCase()] !=
                        null
                      ) {
                        if (
                          colsec1[
                          "vessel_name_1700".toString().toLowerCase()
                          ] == null
                        ) {
                          colsec1["vessel_name_1700".toString().toLowerCase()] =
                            "";
                        }
                        if (
                          colsec1["name_1701".toString().toLowerCase()] == null
                        ) {
                          colsec1["name_1701".toString().toLowerCase()] = "";
                        }
                        if (
                          colsec1["calisign_1702".toString().toLowerCase()] ==
                          null
                        ) {
                          colsec1["calisign_1702".toString().toLowerCase()] =
                            "";
                        }
                        if (
                          colsec1["textbox_1703".toString().toLowerCase()] ==
                          null
                        ) {
                          colsec1["textbox_1703".toString().toLowerCase()] = "";
                        }
                        if (
                          colsec1["date_1704".toString().toLowerCase()] == null
                        ) {
                          colsec1["date_1704".toString().toLowerCase()] = "";
                        }
                        if (
                          colsec1["utc_1705".toString().toLowerCase()] == null
                        ) {
                          colsec1["utc_1705".toString().toLowerCase()] = "";
                        }
                        if (
                          colsec1["time_1706".toString().toLowerCase()] == null
                        ) {
                          colsec1["time_1706".toString().toLowerCase()] = "";
                        }
                        if (
                          colsec1["utc_1707".toString().toLowerCase()] == null
                        ) {
                          colsec1[
                            "station_from_1708".toString().toLowerCase()
                          ] = "";
                        }
                        if (
                          colsec1[
                          "station_from_1708".toString().toLowerCase()
                          ] == null
                        ) {
                          colsec1[
                            "station_from_1695".toString().toLowerCase()
                          ] = "";
                        }
                        if (
                          colsec1["station_to_1709".toString().toLowerCase()] ==
                          null
                        ) {
                          colsec1["station_to_1709".toString().toLowerCase()] =
                            "";
                        }
                        if (
                          colsec1["remarks_1710".toString().toLowerCase()] ==
                          null
                        ) {
                          colsec1["remarks_1710".toString().toLowerCase()] = "";
                        }
                        if (
                          colsec1["channel_1711".toString().toLowerCase()] ==
                          null
                        ) {
                          colsec1["channel_1711".toString().toLowerCase()] = "";
                        }
                        if (
                          colsec1["sign_1712".toString().toLowerCase()] == null
                        ) {
                          colsec1["sign_1712".toString().toLowerCase()] = "";
                        }

                        //date_1691 time_1693 , station_to_1696 ,station_from_1695, remarks_1697 ,channel_1698

                        this.fSection4.push([
                          colsec1["date_1704".toString().toLowerCase()] +
                          " " +
                          colsec1["time_1706".toString().toLowerCase()],
                          colsec1["station_to_1709".toString().toLowerCase()],
                          colsec1["station_from_1708".toString().toLowerCase()],
                          colsec1["remarks_1710".toString().toLowerCase()],
                          colsec1["channel_1711".toString().toLowerCase()],
                        ]);
                        this.userSign.push(usersign);
                      }
                    }
                    // end collection column data to make it tabular
                  }
                }

                // collection of data into seperate array to be used in html
                // console.log("mylog::mylognewreport");
                this.objcolcollection = [];
                if (
                  this.fSection1.length > 0 ||
                  this.fSection2.length > 0 ||
                  this.fSection3.length > 0 ||
                  this.fSection4.length > 0
                ) {
                  this.objcolcollection.push(
                    this.fSection1[this.fSection1.length - 1]
                  );
                  this.objcolcollection.push(this.fSection2);
                  this.objcolcollection.push(
                    this.fSection3[this.fSection3.length - 1]
                  );
                  this.createCollectionLayout(this.fSection4);
                  this.objcolcollection.push(this.fSection4);
                }

                // console.log(this.objcolcollection);
              }
            }
          }
        );

        break;
      }
    }
  }

  showErrorMsg(title: string, text: string) {
    this.errorbox.title = title;
    this.errorbox.text = text;
    this.errorbox.show()
  }

  showSuccessMsg(title: string, text: string) {
    this.successbox.title = title;
    this.successbox.text = text;
    this.successbox.show()
  }

  startDrag(event: MouseEvent) {
    const popup = document.getElementById('popup');
    if (!popup) return;

    this.isDragging = true;
    this.offset = {
      x: event.clientX - popup.offsetLeft,
      y: event.clientY - popup.offsetTop
    };

    const mouseMoveHandler = (moveEvent: MouseEvent) => {
      if (this.isDragging) {
        popup.style.left = (moveEvent.clientX - this.offset.x) + 'px';
        popup.style.top = (moveEvent.clientY - this.offset.y) + 'px';
      }
    };

    const mouseUpHandler = () => {
      this.isDragging = false;
      document.removeEventListener('mousemove', mouseMoveHandler);
      document.removeEventListener('mouseup', mouseUpHandler);
    };

    document.addEventListener('mousemove', mouseMoveHandler);
    document.addEventListener('mouseup', mouseUpHandler);
  }


}






